var oldDefine = define;
define = null;
delete define;
/* ========================================================================
 * Bootstrap: transition.js v3.0.3
 * http://getbootstrap.com/javascript/#transitions
 * ========================================================================
 * Copyright 2011-2014 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // CSS TRANSITION SUPPORT (Shoutout: http://www.modernizr.com/)
  // ============================================================

  function transitionEnd() {
    var el = document.createElement('bootstrap')

    var transEndEventNames = {
      'WebkitTransition' : 'webkitTransitionEnd',
      'MozTransition'    : 'transitionend',
      'OTransition'      : 'oTransitionEnd otransitionend',
      'transition'       : 'transitionend'
    }

    for (var name in transEndEventNames) {
      if (el.style[name] !== undefined) {
        return { end: transEndEventNames[name] }
      }
    }

    return false // explicit for ie8 (  ._.)
  }

  // http://blog.alexmaccaw.com/css-transitions
  $.fn.emulateTransitionEnd = function (duration) {
    var called = false, $el = this
    $(this).one($.support.transition.end, function () { called = true })
    var callback = function () { if (!called) $($el).trigger($.support.transition.end) }
    setTimeout(callback, duration)
    return this
  }

  $(function () {
    $.support.transition = transitionEnd()
  })

}(jq111);

/* ========================================================================
 * Bootstrap: alert.js v3.0.3
 * http://getbootstrap.com/javascript/#alerts
 * ========================================================================
 * Copyright 2011-2014 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // ALERT CLASS DEFINITION
  // ======================

  var dismiss = '[data-dismiss="alert"]'
  var Alert   = function (el) {
    $(el).on('click', dismiss, this.close)
  }

  Alert.prototype.close = function (e) {
    var $this    = $(this)
    var selector = $this.attr('data-target')

    if (!selector) {
      selector = $this.attr('href')
      selector = selector && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
    }

    var $parent = $(selector)

    if (e) e.preventDefault()

    if (!$parent.length) {
      $parent = $this.hasClass('alert') ? $this : $this.parent()
    }

    $parent.trigger(e = $.Event('close.bs.alert'))

    if (e.isDefaultPrevented()) return

    $parent.removeClass('in')

    function removeElement() {
      $parent.trigger('closed.bs.alert').remove()
    }

    $.support.transition && $parent.hasClass('fade') ?
      $parent
        .one($.support.transition.end, removeElement)
        .emulateTransitionEnd(150) :
      removeElement()
  }


  // ALERT PLUGIN DEFINITION
  // =======================

  var old = $.fn.alert

  $.fn.alert = function (option) {
    return this.each(function () {
      var $this = $(this)
      var data  = $this.data('bs.alert')

      if (!data) $this.data('bs.alert', (data = new Alert(this)))
      if (typeof option == 'string') data[option].call($this)
    })
  }

  $.fn.alert.Constructor = Alert


  // ALERT NO CONFLICT
  // =================

  $.fn.alert.noConflict = function () {
    $.fn.alert = old
    return this
  }


  // ALERT DATA-API
  // ==============

  $(document).on('click.bs.alert.data-api', dismiss, Alert.prototype.close)

}(jq111);

/* ========================================================================
 * Bootstrap: button.js v3.0.3
 * http://getbootstrap.com/javascript/#buttons
 * ========================================================================
 * Copyright 2011-2014 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // BUTTON PUBLIC CLASS DEFINITION
  // ==============================

  var Button = function (element, options) {
    this.$element  = $(element)
    this.options   = $.extend({}, Button.DEFAULTS, options)
    this.isLoading = false
  }

  Button.DEFAULTS = {
    loadingText: 'loading...'
  }

  Button.prototype.setState = function (state) {
    var d    = 'disabled'
    var $el  = this.$element
    var val  = $el.is('input') ? 'val' : 'html'
    var data = $el.data()

    state = state + 'Text'

    if (!data.resetText) $el.data('resetText', $el[val]())

    $el[val](data[state] || this.options[state])

    // push to event loop to allow forms to submit
    setTimeout($.proxy(function () {
      if (state == 'loadingText') {
        this.isLoading = true
        $el.addClass(d).attr(d, d)
      } else if (this.isLoading) {
        this.isLoading = false
        $el.removeClass(d).removeAttr(d)
      }
    }, this), 0)
  }

  Button.prototype.toggle = function () {
    var changed = true
    var $parent = this.$element.closest('[data-toggle="buttons"]')

    if ($parent.length) {
      var $input = this.$element.find('input')
      if ($input.prop('type') == 'radio') {
        if ($input.prop('checked') && this.$element.hasClass('active')) changed = false
        else $parent.find('.active').removeClass('active')
      }
      if (changed) $input.prop('checked', !this.$element.hasClass('active')).trigger('change')
    }

    if (changed) this.$element.toggleClass('active')
  }


  // BUTTON PLUGIN DEFINITION
  // ========================

  var old = $.fn.button

  $.fn.button = function (option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.button')
      var options = typeof option == 'object' && option

      if (!data) $this.data('bs.button', (data = new Button(this, options)))

      if (option == 'toggle') data.toggle()
      else if (option) data.setState(option)
    })
  }

  $.fn.button.Constructor = Button


  // BUTTON NO CONFLICT
  // ==================

  $.fn.button.noConflict = function () {
    $.fn.button = old
    return this
  }


  // BUTTON DATA-API
  // ===============

  $(document).on('click.bs.button.data-api', '[data-toggle^=button]', function (e) {
    var $btn = $(e.target)
    if (!$btn.hasClass('btn')) $btn = $btn.closest('.btn')
    $btn.button('toggle')
    e.preventDefault()
  })

}(jq111);

/* ========================================================================
 * Bootstrap: carousel.js v3.0.3
 * http://getbootstrap.com/javascript/#carousel
 * ========================================================================
 * Copyright 2011-2014 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // CAROUSEL CLASS DEFINITION
  // =========================

  var Carousel = function (element, options) {
    this.$element    = $(element)
    this.$indicators = this.$element.find('.carousel-indicators')
    this.options     = options
    this.paused      =
    this.sliding     =
    this.interval    =
    this.$active     =
    this.$items      = null

    this.options.pause == 'hover' && this.$element
      .on('mouseenter', $.proxy(this.pause, this))
      .on('mouseleave', $.proxy(this.cycle, this))
  }

  Carousel.DEFAULTS = {
    interval: 5000,
    pause: 'hover',
    wrap: true
  }

  Carousel.prototype.cycle =  function (e) {
    e || (this.paused = false)

    this.interval && clearInterval(this.interval)

    this.options.interval
      && !this.paused
      && (this.interval = setInterval($.proxy(this.next, this), this.options.interval))

    return this
  }

  Carousel.prototype.getActiveIndex = function () {
    this.$active = this.$element.find('.item.active')
    this.$items  = this.$active.parent().children()

    return this.$items.index(this.$active)
  }

  Carousel.prototype.to = function (pos) {
    var that        = this
    var activeIndex = this.getActiveIndex()

    if (pos > (this.$items.length - 1) || pos < 0) return

    if (this.sliding)       return this.$element.one('slid.bs.carousel', function () { that.to(pos) })
    if (activeIndex == pos) return this.pause().cycle()

    return this.slide(pos > activeIndex ? 'next' : 'prev', $(this.$items[pos]))
  }

  Carousel.prototype.pause = function (e) {
    e || (this.paused = true)

    if (this.$element.find('.next, .prev').length && $.support.transition.end) {
      this.$element.trigger($.support.transition.end)
      this.cycle(true)
    }

    this.interval = clearInterval(this.interval)

    return this
  }

  Carousel.prototype.next = function () {
    if (this.sliding) return
    return this.slide('next')
  }

  Carousel.prototype.prev = function () {
    if (this.sliding) return
    return this.slide('prev')
  }

  Carousel.prototype.slide = function (type, next) {
    var $active   = this.$element.find('.item.active')
    var $next     = next || $active[type]()
    var isCycling = this.interval
    var direction = type == 'next' ? 'left' : 'right'
    var fallback  = type == 'next' ? 'first' : 'last'
    var that      = this

    if (!$next.length) {
      if (!this.options.wrap) return
      $next = this.$element.find('.item')[fallback]()
    }

    if ($next.hasClass('active')) return this.sliding = false

    var e = $.Event('slide.bs.carousel', { relatedTarget: $next[0], direction: direction })
    this.$element.trigger(e)
    if (e.isDefaultPrevented()) return

    this.sliding = true

    isCycling && this.pause()

    if (this.$indicators.length) {
      this.$indicators.find('.active').removeClass('active')
      this.$element.one('slid.bs.carousel', function () {
        var $nextIndicator = $(that.$indicators.children()[that.getActiveIndex()])
        $nextIndicator && $nextIndicator.addClass('active')
      })
    }

    if ($.support.transition && this.$element.hasClass('slide')) {
      $next.addClass(type)
      $next[0].offsetWidth // force reflow
      $active.addClass(direction)
      $next.addClass(direction)
      $active
        .one($.support.transition.end, function () {
          $next.removeClass([type, direction].join(' ')).addClass('active')
          $active.removeClass(['active', direction].join(' '))
          that.sliding = false
          setTimeout(function () { that.$element.trigger('slid.bs.carousel') }, 0)
        })
        .emulateTransitionEnd($active.css('transition-duration').slice(0, -1) * 1000)
    } else {
      $active.removeClass('active')
      $next.addClass('active')
      this.sliding = false
      this.$element.trigger('slid.bs.carousel')
    }

    isCycling && this.cycle()

    return this
  }


  // CAROUSEL PLUGIN DEFINITION
  // ==========================

  var old = $.fn.carousel

  $.fn.carousel = function (option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.carousel')
      var options = $.extend({}, Carousel.DEFAULTS, $this.data(), typeof option == 'object' && option)
      var action  = typeof option == 'string' ? option : options.slide

      if (!data) $this.data('bs.carousel', (data = new Carousel(this, options)))
      if (typeof option == 'number') data.to(option)
      else if (action) data[action]()
      else if (options.interval) data.pause().cycle()
    })
  }

  $.fn.carousel.Constructor = Carousel


  // CAROUSEL NO CONFLICT
  // ====================

  $.fn.carousel.noConflict = function () {
    $.fn.carousel = old
    return this
  }


  // CAROUSEL DATA-API
  // =================

  $(document).on('click.bs.carousel.data-api', '[data-slide], [data-slide-to]', function (e) {
    var $this   = $(this), href
    var $target = $($this.attr('data-target') || (href = $this.attr('href')) && href.replace(/.*(?=#[^\s]+$)/, '')) //strip for ie7
    var options = $.extend({}, $target.data(), $this.data())
    var slideIndex = $this.attr('data-slide-to')
    if (slideIndex) options.interval = false

    $target.carousel(options)

    if (slideIndex = $this.attr('data-slide-to')) {
      $target.data('bs.carousel').to(slideIndex)
    }

    e.preventDefault()
  })

  $(window).on('load', function () {
    $('[data-ride="carousel"]').each(function () {
      var $carousel = $(this)
      $carousel.carousel($carousel.data())
    })
  })

}(jq111);

/* ========================================================================
 * Bootstrap: collapse.js v3.0.3
 * http://getbootstrap.com/javascript/#collapse
 * ========================================================================
 * Copyright 2011-2014 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // COLLAPSE PUBLIC CLASS DEFINITION
  // ================================

  var Collapse = function (element, options) {
    this.$element      = $(element)
    this.options       = $.extend({}, Collapse.DEFAULTS, options)
    this.transitioning = null

    if (this.options.parent) this.$parent = $(this.options.parent)
    if (this.options.toggle) this.toggle()
  }

  Collapse.DEFAULTS = {
    toggle: true
  }

  Collapse.prototype.dimension = function () {
    var hasWidth = this.$element.hasClass('width')
    return hasWidth ? 'width' : 'height'
  }

  Collapse.prototype.show = function () {
    if (this.transitioning || this.$element.hasClass('in')) return

    var startEvent = $.Event('show.bs.collapse')
    this.$element.trigger(startEvent)
    if (startEvent.isDefaultPrevented()) return

    var actives = this.$parent && this.$parent.find('> .panel > .in')

    if (actives && actives.length) {
      var hasData = actives.data('bs.collapse')
      if (hasData && hasData.transitioning) return
      actives.collapse('hide')
      hasData || actives.data('bs.collapse', null)
    }

    var dimension = this.dimension()

    this.$element
      .removeClass('collapse')
      .addClass('collapsing')
      [dimension](0)

    this.transitioning = 1

    var complete = function () {
      this.$element
        .removeClass('collapsing')
        .addClass('collapse in')
        [dimension]('auto')
      this.transitioning = 0
      this.$element.trigger('shown.bs.collapse')
    }

    if (!$.support.transition) return complete.call(this)

    var scrollSize = $.camelCase(['scroll', dimension].join('-'))

    this.$element
      .one($.support.transition.end, $.proxy(complete, this))
      .emulateTransitionEnd(350)
      [dimension](this.$element[0][scrollSize])
  }

  Collapse.prototype.hide = function () {
    if (this.transitioning || !this.$element.hasClass('in')) return

    var startEvent = $.Event('hide.bs.collapse')
    this.$element.trigger(startEvent)
    if (startEvent.isDefaultPrevented()) return

    var dimension = this.dimension()

    this.$element
      [dimension](this.$element[dimension]())
      [0].offsetHeight

    this.$element
      .addClass('collapsing')
      .removeClass('collapse')
      .removeClass('in')

    this.transitioning = 1

    var complete = function () {
      this.transitioning = 0
      this.$element
        .trigger('hidden.bs.collapse')
        .removeClass('collapsing')
        .addClass('collapse')
    }

    if (!$.support.transition) return complete.call(this)

    this.$element
      [dimension](0)
      .one($.support.transition.end, $.proxy(complete, this))
      .emulateTransitionEnd(350)
  }

  Collapse.prototype.toggle = function () {
    this[this.$element.hasClass('in') ? 'hide' : 'show']()
  }


  // COLLAPSE PLUGIN DEFINITION
  // ==========================

  var old = $.fn.collapse

  $.fn.collapse = function (option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.collapse')
      var options = $.extend({}, Collapse.DEFAULTS, $this.data(), typeof option == 'object' && option)

      if (!data) $this.data('bs.collapse', (data = new Collapse(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  $.fn.collapse.Constructor = Collapse


  // COLLAPSE NO CONFLICT
  // ====================

  $.fn.collapse.noConflict = function () {
    $.fn.collapse = old
    return this
  }


  // COLLAPSE DATA-API
  // =================

  $(document).on('click.bs.collapse.data-api', '[data-toggle=collapse]', function (e) {
    var $this   = $(this), href
    var target  = $this.attr('data-target')
        || e.preventDefault()
        || (href = $this.attr('href')) && href.replace(/.*(?=#[^\s]+$)/, '') //strip for ie7
    var $target = $(target)
    var data    = $target.data('bs.collapse')
    var option  = data ? 'toggle' : $this.data()
    var parent  = $this.attr('data-parent')
    var $parent = parent && $(parent)

    if (!data || !data.transitioning) {
      if ($parent) $parent.find('[data-toggle=collapse][data-parent="' + parent + '"]').not($this).addClass('collapsed')
      $this[$target.hasClass('in') ? 'addClass' : 'removeClass']('collapsed')
    }

    $target.collapse(option)
  })

}(jq111);

/* ========================================================================
 * Bootstrap: dropdown.js v3.0.3
 * http://getbootstrap.com/javascript/#dropdowns
 * ========================================================================
 * Copyright 2011-2014 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // DROPDOWN CLASS DEFINITION
  // =========================

  var backdrop = '.dropdown-backdrop'
  var toggle   = '[data-toggle=dropdown]'
  var Dropdown = function (element) {
    $(element).on('click.bs.dropdown', this.toggle)
  }

  Dropdown.prototype.toggle = function (e) {
    var $this = $(this)

    if ($this.is('.disabled, :disabled')) return

    var $parent  = getParent($this)
    var isActive = $parent.hasClass('open')

    clearMenus()

    if (!isActive) {
      if ('ontouchstart' in document.documentElement && !$parent.closest('.navbar-nav').length) {
        // if mobile we use a backdrop because click events don't delegate
        $('<div class="dropdown-backdrop"/>').insertAfter($(this)).on('click', clearMenus)
      }

      var relatedTarget = { relatedTarget: this }
      $parent.trigger(e = $.Event('show.bs.dropdown', relatedTarget))

      if (e.isDefaultPrevented()) return

      $parent
        .toggleClass('open')
        .trigger('shown.bs.dropdown', relatedTarget)

      $this.focus()
    }

    return false
  }

  Dropdown.prototype.keydown = function (e) {
    if (!/(38|40|27)/.test(e.keyCode)) return

    var $this = $(this)

    e.preventDefault()
    e.stopPropagation()

    if ($this.is('.disabled, :disabled')) return

    var $parent  = getParent($this)
    var isActive = $parent.hasClass('open')

    if (!isActive || (isActive && e.keyCode == 27)) {
      if (e.which == 27) $parent.find(toggle).focus()
      return $this.click()
    }

    var desc = ' li:not(.divider):visible a'
    var $items = $parent.find('[role=menu]' + desc + ', [role=listbox]' + desc)

    if (!$items.length) return

    var index = $items.index($items.filter(':focus'))

    if (e.keyCode == 38 && index > 0)                 index--                        // up
    if (e.keyCode == 40 && index < $items.length - 1) index++                        // down
    if (!~index)                                      index = 0

    $items.eq(index).focus()
  }

  function clearMenus(e) {
    $(backdrop).remove()
    $(toggle).each(function () {
      var $parent = getParent($(this))
      var relatedTarget = { relatedTarget: this }
      if (!$parent.hasClass('open')) return
      $parent.trigger(e = $.Event('hide.bs.dropdown', relatedTarget))
      if (e.isDefaultPrevented()) return
      $parent.removeClass('open').trigger('hidden.bs.dropdown', relatedTarget)
    })
  }

  function getParent($this) {
    var selector = $this.attr('data-target')

    if (!selector) {
      selector = $this.attr('href')
      selector = selector && /#[A-Za-z]/.test(selector) && selector.replace(/.*(?=#[^\s]*$)/, '') //strip for ie7
    }

    var $parent = selector && $(selector)

    return $parent && $parent.length ? $parent : $this.parent()
  }


  // DROPDOWN PLUGIN DEFINITION
  // ==========================

  var old = $.fn.dropdown

  $.fn.dropdown = function (option) {
    return this.each(function () {
      var $this = $(this)
      var data  = $this.data('bs.dropdown')

      if (!data) $this.data('bs.dropdown', (data = new Dropdown(this)))
      if (typeof option == 'string') data[option].call($this)
    })
  }

  $.fn.dropdown.Constructor = Dropdown


  // DROPDOWN NO CONFLICT
  // ====================

  $.fn.dropdown.noConflict = function () {
    $.fn.dropdown = old
    return this
  }


  // APPLY TO STANDARD DROPDOWN ELEMENTS
  // ===================================

  $(document)
    .on('click.bs.dropdown.data-api', clearMenus)
    .on('click.bs.dropdown.data-api', '.dropdown form', function (e) { e.stopPropagation() })
    .on('click.bs.dropdown.data-api', toggle, Dropdown.prototype.toggle)
    .on('keydown.bs.dropdown.data-api', toggle + ', [role=menu], [role=listbox]', Dropdown.prototype.keydown)

}(jq111);

/* ========================================================================
 * Bootstrap: modal.js v3.0.3
 * http://getbootstrap.com/javascript/#modals
 * ========================================================================
 * Copyright 2011-2014 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // MODAL CLASS DEFINITION
  // ======================

  var Modal = function (element, options) {
    this.options   = options
    this.$element  = $(element)
    this.$backdrop =
    this.isShown   = null

    if (this.options.remote) {
      this.$element
        .find('.modal-content')
        .load(this.options.remote, $.proxy(function () {
          this.$element.trigger('loaded.bs.modal')
        }, this))
    }
  }

  Modal.DEFAULTS = {
    backdrop: true,
    keyboard: true,
    show: true
  }

  Modal.prototype.toggle = function (_relatedTarget) {
    return this[!this.isShown ? 'show' : 'hide'](_relatedTarget)
  }

  Modal.prototype.show = function (_relatedTarget) {
    var that = this
    var e    = $.Event('show.bs.modal', { relatedTarget: _relatedTarget })

    this.$element.trigger(e)

    if (this.isShown || e.isDefaultPrevented()) return

    this.isShown = true

    this.escape()

    this.$element.on('click.dismiss.modal', '[data-dismiss="modal"]', $.proxy(this.hide, this))

    this.backdrop(function () {
      var transition = $.support.transition && that.$element.hasClass('fade')

      if (!that.$element.parent().length) {
        that.$element.appendTo(document.body) // don't move modals dom position
      }

      that.$element
        .show()
        .scrollTop(0)

      if (transition) {
        that.$element[0].offsetWidth // force reflow
      }

      that.$element
        .addClass('in')
        .attr('aria-hidden', false)

      that.enforceFocus()

      var e = $.Event('shown.bs.modal', { relatedTarget: _relatedTarget })

      transition ?
        that.$element.find('.modal-dialog') // wait for modal to slide in
          .one($.support.transition.end, function () {
            that.$element.focus().trigger(e)
          })
          .emulateTransitionEnd(300) :
        that.$element.focus().trigger(e)
    })
  }

  Modal.prototype.hide = function (e) {
    if (e) e.preventDefault()

    e = $.Event('hide.bs.modal')

    this.$element.trigger(e)

    if (!this.isShown || e.isDefaultPrevented()) return

    this.isShown = false

    this.escape()

    $(document).off('focusin.bs.modal')

    this.$element
      .removeClass('in')
      .attr('aria-hidden', true)
      .off('click.dismiss.modal')

    $.support.transition && this.$element.hasClass('fade') ?
      this.$element
        .one($.support.transition.end, $.proxy(this.hideModal, this))
        .emulateTransitionEnd(300) :
      this.hideModal()
  }

  Modal.prototype.enforceFocus = function () {
    $(document)
      .off('focusin.bs.modal') // guard against infinite focus loop
      .on('focusin.bs.modal', $.proxy(function (e) {
        if (this.$element[0] !== e.target && !this.$element.has(e.target).length) {
          this.$element.focus()
        }
      }, this))
  }

  Modal.prototype.escape = function () {
    if (this.isShown && this.options.keyboard) {
      this.$element.on('keyup.dismiss.bs.modal', $.proxy(function (e) {
        e.which == 27 && this.hide()
      }, this))
    } else if (!this.isShown) {
      this.$element.off('keyup.dismiss.bs.modal')
    }
  }

  Modal.prototype.hideModal = function () {
    var that = this
    this.$element.hide()
    this.backdrop(function () {
      that.removeBackdrop()
      that.$element.trigger('hidden.bs.modal')
    })
  }

  Modal.prototype.removeBackdrop = function () {
    this.$backdrop && this.$backdrop.remove()
    this.$backdrop = null
  }

  Modal.prototype.backdrop = function (callback) {
    var animate = this.$element.hasClass('fade') ? 'fade' : ''

    if (this.isShown && this.options.backdrop) {
      var doAnimate = $.support.transition && animate

      this.$backdrop = $('<div class="modal-backdrop ' + animate + '" />')
        .appendTo(document.body)

      this.$element.on('click.dismiss.modal', $.proxy(function (e) {
        if (e.target !== e.currentTarget) return
        this.options.backdrop == 'static'
          ? this.$element[0].focus.call(this.$element[0])
          : this.hide.call(this)
      }, this))

      if (doAnimate) this.$backdrop[0].offsetWidth // force reflow

      this.$backdrop.addClass('in')

      if (!callback) return

      doAnimate ?
        this.$backdrop
          .one($.support.transition.end, callback)
          .emulateTransitionEnd(150) :
        callback()

    } else if (!this.isShown && this.$backdrop) {
      this.$backdrop.removeClass('in')

      $.support.transition && this.$element.hasClass('fade') ?
        this.$backdrop
          .one($.support.transition.end, callback)
          .emulateTransitionEnd(150) :
        callback()

    } else if (callback) {
      callback()
    }
  }


  // MODAL PLUGIN DEFINITION
  // =======================

  var old = $.fn.modal

  $.fn.modal = function (option, _relatedTarget) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.modal')
      var options = $.extend({}, Modal.DEFAULTS, $this.data(), typeof option == 'object' && option)

      if (!data) $this.data('bs.modal', (data = new Modal(this, options)))
      if (typeof option == 'string') data[option](_relatedTarget)
      else if (options.show) data.show(_relatedTarget)
    })
  }

  $.fn.modal.Constructor = Modal


  // MODAL NO CONFLICT
  // =================

  $.fn.modal.noConflict = function () {
    $.fn.modal = old
    return this
  }


  // MODAL DATA-API
  // ==============

  $(document).on('click.bs.modal.data-api', '[data-toggle="modal"]', function (e) {
    var $this   = $(this)
    var href    = $this.attr('href')
    var $target = $($this.attr('data-target') || (href && href.replace(/.*(?=#[^\s]+$)/, ''))) //strip for ie7
    var option  = $target.data('bs.modal') ? 'toggle' : $.extend({ remote: !/#/.test(href) && href }, $target.data(), $this.data())

    if ($this.is('a')) e.preventDefault()

    $target
      .modal(option, this)
      .one('hide', function () {
        $this.is(':visible') && $this.focus()
      })
  })

  $(document)
    .on('show.bs.modal',  '.modal', function () { $(document.body).addClass('modal-open') })
    .on('hidden.bs.modal', '.modal', function () { $(document.body).removeClass('modal-open') })

}(jq111);

/* ========================================================================
 * Bootstrap: tooltip.js v3.0.3
 * http://getbootstrap.com/javascript/#tooltip
 * Inspired by the original jQuery.tipsy by Jason Frame
 * ========================================================================
 * Copyright 2011-2014 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // TOOLTIP PUBLIC CLASS DEFINITION
  // ===============================

  var Tooltip = function (element, options) {
    this.type       =
    this.options    =
    this.enabled    =
    this.timeout    =
    this.hoverState =
    this.$element   = null

    this.init('tooltip', element, options)
  }

  Tooltip.DEFAULTS = {
    animation: true,
    placement: 'top',
    selector: false,
    template: '<div class="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
    trigger: 'hover focus',
    title: '',
    delay: 0,
    html: false,
    container: false
  }

  Tooltip.prototype.init = function (type, element, options) {
    this.enabled  = true
    this.type     = type
    this.$element = $(element)
    this.options  = this.getOptions(options)

    var triggers = this.options.trigger.split(' ')

    for (var i = triggers.length; i--;) {
      var trigger = triggers[i]

      if (trigger == 'click') {
        this.$element.on('click.' + this.type, this.options.selector, $.proxy(this.toggle, this))
      } else if (trigger != 'manual') {
        var eventIn  = trigger == 'hover' ? 'mouseenter' : 'focusin'
        var eventOut = trigger == 'hover' ? 'mouseleave' : 'focusout'

        this.$element.on(eventIn  + '.' + this.type, this.options.selector, $.proxy(this.enter, this))
        this.$element.on(eventOut + '.' + this.type, this.options.selector, $.proxy(this.leave, this))
      }
    }

    this.options.selector ?
      (this._options = $.extend({}, this.options, { trigger: 'manual', selector: '' })) :
      this.fixTitle()
  }

  Tooltip.prototype.getDefaults = function () {
    return Tooltip.DEFAULTS
  }

  Tooltip.prototype.getOptions = function (options) {
    options = $.extend({}, this.getDefaults(), this.$element.data(), options)

    if (options.delay && typeof options.delay == 'number') {
      options.delay = {
        show: options.delay,
        hide: options.delay
      }
    }

    return options
  }

  Tooltip.prototype.getDelegateOptions = function () {
    var options  = {}
    var defaults = this.getDefaults()

    this._options && $.each(this._options, function (key, value) {
      if (defaults[key] != value) options[key] = value
    })

    return options
  }

  Tooltip.prototype.enter = function (obj) {
    var self = obj instanceof this.constructor ?
      obj : $(obj.currentTarget)[this.type](this.getDelegateOptions()).data('bs.' + this.type)

    clearTimeout(self.timeout)

    self.hoverState = 'in'

    if (!self.options.delay || !self.options.delay.show) return self.show()

    self.timeout = setTimeout(function () {
      if (self.hoverState == 'in') self.show()
    }, self.options.delay.show)
  }

  Tooltip.prototype.leave = function (obj) {
    var self = obj instanceof this.constructor ?
      obj : $(obj.currentTarget)[this.type](this.getDelegateOptions()).data('bs.' + this.type)

    clearTimeout(self.timeout)

    self.hoverState = 'out'

    if (!self.options.delay || !self.options.delay.hide) return self.hide()

    self.timeout = setTimeout(function () {
      if (self.hoverState == 'out') self.hide()
    }, self.options.delay.hide)
  }

  Tooltip.prototype.show = function () {
    var e = $.Event('show.bs.' + this.type)

    if (this.hasContent() && this.enabled) {
      this.$element.trigger(e)

      if (e.isDefaultPrevented()) return
      var that = this;

      var $tip = this.tip()

      this.setContent()

      if (this.options.animation) $tip.addClass('fade')

      var placement = typeof this.options.placement == 'function' ?
        this.options.placement.call(this, $tip[0], this.$element[0]) :
        this.options.placement

      var autoToken = /\s?auto?\s?/i
      var autoPlace = autoToken.test(placement)
      if (autoPlace) placement = placement.replace(autoToken, '') || 'top'

      $tip
        .detach()
        .css({ top: 0, left: 0, display: 'block' })
        .addClass(placement)

      this.options.container ? $tip.appendTo(this.options.container) : $tip.insertAfter(this.$element)

      var pos          = this.getPosition()
      var actualWidth  = $tip[0].offsetWidth
      var actualHeight = $tip[0].offsetHeight

      if (autoPlace) {
        var $parent = this.$element.parent()

        var orgPlacement = placement
        var docScroll    = document.documentElement.scrollTop || document.body.scrollTop
        var parentWidth  = this.options.container == 'body' ? window.innerWidth  : $parent.outerWidth()
        var parentHeight = this.options.container == 'body' ? window.innerHeight : $parent.outerHeight()
        var parentLeft   = this.options.container == 'body' ? 0 : $parent.offset().left

        placement = placement == 'bottom' && pos.top   + pos.height  + actualHeight - docScroll > parentHeight  ? 'top'    :
                    placement == 'top'    && pos.top   - docScroll   - actualHeight < 0                         ? 'bottom' :
                    placement == 'right'  && pos.right + actualWidth > parentWidth                              ? 'left'   :
                    placement == 'left'   && pos.left  - actualWidth < parentLeft                               ? 'right'  :
                    placement

        $tip
          .removeClass(orgPlacement)
          .addClass(placement)
      }

      var calculatedOffset = this.getCalculatedOffset(placement, pos, actualWidth, actualHeight)

      this.applyPlacement(calculatedOffset, placement)
      this.hoverState = null

      var complete = function() {
        that.$element.trigger('shown.bs.' + that.type)
      }

      $.support.transition && this.$tip.hasClass('fade') ?
        $tip
          .one($.support.transition.end, complete)
          .emulateTransitionEnd(150) :
        complete()
    }
  }

  Tooltip.prototype.applyPlacement = function (offset, placement) {
    var replace
    var $tip   = this.tip()
    var width  = $tip[0].offsetWidth
    var height = $tip[0].offsetHeight

    // manually read margins because getBoundingClientRect includes difference
    var marginTop = parseInt($tip.css('margin-top'), 10)
    var marginLeft = parseInt($tip.css('margin-left'), 10)

    // we must check for NaN for ie 8/9
    if (isNaN(marginTop))  marginTop  = 0
    if (isNaN(marginLeft)) marginLeft = 0

    offset.top  = offset.top  + marginTop
    offset.left = offset.left + marginLeft

    // $.fn.offset doesn't round pixel values
    // so we use setOffset directly with our own function B-0
    $.offset.setOffset($tip[0], $.extend({
      using: function (props) {
        $tip.css({
          top: Math.round(props.top),
          left: Math.round(props.left)
        })
      }
    }, offset), 0)

    $tip.addClass('in')

    // check to see if placing tip in new offset caused the tip to resize itself
    var actualWidth  = $tip[0].offsetWidth
    var actualHeight = $tip[0].offsetHeight

    if (placement == 'top' && actualHeight != height) {
      replace = true
      offset.top = offset.top + height - actualHeight
    }

    if (/bottom|top/.test(placement)) {
      var delta = 0

      if (offset.left < 0) {
        delta       = offset.left * -2
        offset.left = 0

        $tip.offset(offset)

        actualWidth  = $tip[0].offsetWidth
        actualHeight = $tip[0].offsetHeight
      }

      this.replaceArrow(delta - width + actualWidth, actualWidth, 'left')
    } else {
      this.replaceArrow(actualHeight - height, actualHeight, 'top')
    }

    if (replace) $tip.offset(offset)
  }

  Tooltip.prototype.replaceArrow = function (delta, dimension, position) {
    this.arrow().css(position, delta ? (50 * (1 - delta / dimension) + '%') : '')
  }

  Tooltip.prototype.setContent = function () {
    var $tip  = this.tip()
    var title = this.getTitle()

    $tip.find('.tooltip-inner')[this.options.html ? 'html' : 'text'](title)
    $tip.removeClass('fade in top bottom left right')
  }

  Tooltip.prototype.hide = function () {
    var that = this
    var $tip = this.tip()
    var e    = $.Event('hide.bs.' + this.type)

    function complete() {
      if (that.hoverState != 'in') $tip.detach()
      that.$element.trigger('hidden.bs.' + that.type)
    }

    this.$element.trigger(e)

    if (e.isDefaultPrevented()) return

    $tip.removeClass('in')

    $.support.transition && this.$tip.hasClass('fade') ?
      $tip
        .one($.support.transition.end, complete)
        .emulateTransitionEnd(150) :
      complete()

    this.hoverState = null

    return this
  }

  Tooltip.prototype.fixTitle = function () {
    var $e = this.$element
    if ($e.attr('title') || typeof($e.attr('data-original-title')) != 'string') {
      $e.attr('data-original-title', $e.attr('title') || '').attr('title', '')
    }
  }

  Tooltip.prototype.hasContent = function () {
    return this.getTitle()
  }

  Tooltip.prototype.getPosition = function () {
    var el = this.$element[0]
    return $.extend({}, (typeof el.getBoundingClientRect == 'function') ? el.getBoundingClientRect() : {
      width: el.offsetWidth,
      height: el.offsetHeight
    }, this.$element.offset())
  }

  Tooltip.prototype.getCalculatedOffset = function (placement, pos, actualWidth, actualHeight) {
    return placement == 'bottom' ? { top: pos.top + pos.height,   left: pos.left + pos.width / 2 - actualWidth / 2  } :
           placement == 'top'    ? { top: pos.top - actualHeight, left: pos.left + pos.width / 2 - actualWidth / 2  } :
           placement == 'left'   ? { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left - actualWidth } :
        /* placement == 'right' */ { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left + pos.width   }
  }

  Tooltip.prototype.getTitle = function () {
    var title
    var $e = this.$element
    var o  = this.options

    title = $e.attr('data-original-title')
      || (typeof o.title == 'function' ? o.title.call($e[0]) :  o.title)

    return title
  }

  Tooltip.prototype.tip = function () {
    return this.$tip = this.$tip || $(this.options.template)
  }

  Tooltip.prototype.arrow = function () {
    return this.$arrow = this.$arrow || this.tip().find('.tooltip-arrow')
  }

  Tooltip.prototype.validate = function () {
    if (!this.$element[0].parentNode) {
      this.hide()
      this.$element = null
      this.options  = null
    }
  }

  Tooltip.prototype.enable = function () {
    this.enabled = true
  }

  Tooltip.prototype.disable = function () {
    this.enabled = false
  }

  Tooltip.prototype.toggleEnabled = function () {
    this.enabled = !this.enabled
  }

  Tooltip.prototype.toggle = function (e) {
    var self = e ? $(e.currentTarget)[this.type](this.getDelegateOptions()).data('bs.' + this.type) : this
    self.tip().hasClass('in') ? self.leave(self) : self.enter(self)
  }

  Tooltip.prototype.destroy = function () {
    clearTimeout(this.timeout)
    this.hide().$element.off('.' + this.type).removeData('bs.' + this.type)
  }


  // TOOLTIP PLUGIN DEFINITION
  // =========================

  var old = $.fn.tooltip

  $.fn.tooltip = function (option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.tooltip')
      var options = typeof option == 'object' && option

      if (!data && option == 'destroy') return
      if (!data) $this.data('bs.tooltip', (data = new Tooltip(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  $.fn.tooltip.Constructor = Tooltip


  // TOOLTIP NO CONFLICT
  // ===================

  $.fn.tooltip.noConflict = function () {
    $.fn.tooltip = old
    return this
  }

}(jq111);

/* ========================================================================
 * Bootstrap: popover.js v3.0.3
 * http://getbootstrap.com/javascript/#popovers
 * ========================================================================
 * Copyright 2011-2014 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // POPOVER PUBLIC CLASS DEFINITION
  // ===============================

  var Popover = function (element, options) {
    this.init('popover', element, options)
  }

  if (!$.fn.tooltip) throw new Error('Popover requires tooltip.js')

  Popover.DEFAULTS = $.extend({}, $.fn.tooltip.Constructor.DEFAULTS, {
    placement: 'right',
    trigger: 'click',
    content: '',
    template: '<div class="popover"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>'
  })


  // NOTE: POPOVER EXTENDS tooltip.js
  // ================================

  Popover.prototype = $.extend({}, $.fn.tooltip.Constructor.prototype)

  Popover.prototype.constructor = Popover

  Popover.prototype.getDefaults = function () {
    return Popover.DEFAULTS
  }

  Popover.prototype.setContent = function () {
    var $tip    = this.tip()
    var title   = this.getTitle()
    var content = this.getContent()

    $tip.find('.popover-title')[this.options.html ? 'html' : 'text'](title)
    $tip.find('.popover-content')[ // we use append for html objects to maintain js events
      this.options.html ? (typeof content == 'string' ? 'html' : 'append') : 'text'
    ](content)

    $tip.removeClass('fade top bottom left right in')

    // IE8 doesn't accept hiding via the `:empty` pseudo selector, we have to do
    // this manually by checking the contents.
    if (!$tip.find('.popover-title').html()) $tip.find('.popover-title').hide()
  }

  Popover.prototype.hasContent = function () {
    return this.getTitle() || this.getContent()
  }

  Popover.prototype.getContent = function () {
    var $e = this.$element
    var o  = this.options

    return $e.attr('data-content')
      || (typeof o.content == 'function' ?
            o.content.call($e[0]) :
            o.content)
  }

  Popover.prototype.arrow = function () {
    return this.$arrow = this.$arrow || this.tip().find('.arrow')
  }

  Popover.prototype.tip = function () {
    if (!this.$tip) this.$tip = $(this.options.template)
    return this.$tip
  }


  // POPOVER PLUGIN DEFINITION
  // =========================

  var old = $.fn.popover

  $.fn.popover = function (option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.popover')
      var options = typeof option == 'object' && option

      if (!data && option == 'destroy') return
      if (!data) $this.data('bs.popover', (data = new Popover(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  $.fn.popover.Constructor = Popover


  // POPOVER NO CONFLICT
  // ===================

  $.fn.popover.noConflict = function () {
    $.fn.popover = old
    return this
  }

}(jq111);

/* ========================================================================
 * Bootstrap: scrollspy.js v3.0.3
 * http://getbootstrap.com/javascript/#scrollspy
 * ========================================================================
 * Copyright 2011-2014 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // SCROLLSPY CLASS DEFINITION
  // ==========================

  function ScrollSpy(element, options) {
    var href
    var process  = $.proxy(this.process, this)

    this.$element       = $(element).is('body') ? $(window) : $(element)
    this.$body          = $('body')
    this.$scrollElement = this.$element.on('scroll.bs.scroll-spy.data-api', process)
    this.options        = $.extend({}, ScrollSpy.DEFAULTS, options)
    this.selector       = (this.options.target
      || ((href = $(element).attr('href')) && href.replace(/.*(?=#[^\s]+$)/, '')) //strip for ie7
      || '') + ' .nav li > a'
    this.offsets        = $([])
    this.targets        = $([])
    this.activeTarget   = null

    this.refresh()
    this.process()
  }

  ScrollSpy.DEFAULTS = {
    offset: 10
  }

  ScrollSpy.prototype.refresh = function () {
    var offsetMethod = this.$element[0] == window ? 'offset' : 'position'

    this.offsets = $([])
    this.targets = $([])

    var self     = this
    var $targets = this.$body
      .find(this.selector)
      .map(function () {
        var $el   = $(this)
        var href  = $el.data('target') || $el.attr('href')
        var $href = /^#./.test(href) && $(href)

        return ($href
          && $href.length
          && $href.is(':visible')
          && [[ $href[offsetMethod]().top + (!$.isWindow(self.$scrollElement.get(0)) && self.$scrollElement.scrollTop()), href ]]) || null
      })
      .sort(function (a, b) { return a[0] - b[0] })
      .each(function () {
        self.offsets.push(this[0])
        self.targets.push(this[1])
      })
  }

  ScrollSpy.prototype.process = function () {
    var scrollTop    = this.$scrollElement.scrollTop() + this.options.offset
    var scrollHeight = this.$scrollElement[0].scrollHeight || this.$body[0].scrollHeight
    var maxScroll    = scrollHeight - this.$scrollElement.height()
    var offsets      = this.offsets
    var targets      = this.targets
    var activeTarget = this.activeTarget
    var i

    if (scrollTop >= maxScroll) {
      return activeTarget != (i = targets.last()[0]) && this.activate(i)
    }

    if (activeTarget && scrollTop <= offsets[0]) {
      return activeTarget != (i = targets[0]) && this.activate(i)
    }

    for (i = offsets.length; i--;) {
      activeTarget != targets[i]
        && scrollTop >= offsets[i]
        && (!offsets[i + 1] || scrollTop <= offsets[i + 1])
        && this.activate( targets[i] )
    }
  }

  ScrollSpy.prototype.activate = function (target) {
    this.activeTarget = target

    $(this.selector)
      .parentsUntil(this.options.target, '.active')
      .removeClass('active')

    var selector = this.selector +
        '[data-target="' + target + '"],' +
        this.selector + '[href="' + target + '"]'

    var active = $(selector)
      .parents('li')
      .addClass('active')

    if (active.parent('.dropdown-menu').length) {
      active = active
        .closest('li.dropdown')
        .addClass('active')
    }

    active.trigger('activate.bs.scrollspy')
  }


  // SCROLLSPY PLUGIN DEFINITION
  // ===========================

  var old = $.fn.scrollspy

  $.fn.scrollspy = function (option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.scrollspy')
      var options = typeof option == 'object' && option

      if (!data) $this.data('bs.scrollspy', (data = new ScrollSpy(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  $.fn.scrollspy.Constructor = ScrollSpy


  // SCROLLSPY NO CONFLICT
  // =====================

  $.fn.scrollspy.noConflict = function () {
    $.fn.scrollspy = old
    return this
  }


  // SCROLLSPY DATA-API
  // ==================

  $(window).on('load', function () {
    $('[data-spy="scroll"]').each(function () {
      var $spy = $(this)
      $spy.scrollspy($spy.data())
    })
  })

}(jq111);

/* ========================================================================
 * Bootstrap: tab.js v3.0.3
 * http://getbootstrap.com/javascript/#tabs
 * ========================================================================
 * Copyright 2011-2014 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // TAB CLASS DEFINITION
  // ====================

  var Tab = function (element) {
    this.element = $(element)
  }

  Tab.prototype.show = function () {
    var $this    = this.element
    var $ul      = $this.closest('ul:not(.dropdown-menu)')
    var selector = $this.data('target')

    if (!selector) {
      selector = $this.attr('href')
      selector = selector && selector.replace(/.*(?=#[^\s]*$)/, '') //strip for ie7
    }

    if ($this.parent('li').hasClass('active')) return

    var previous = $ul.find('.active:last a')[0]
    var e        = $.Event('show.bs.tab', {
      relatedTarget: previous
    })

    $this.trigger(e)

    if (e.isDefaultPrevented()) return

    var $target = $(selector)

    this.activate($this.parent('li'), $ul)
    this.activate($target, $target.parent(), function () {
      $this.trigger({
        type: 'shown.bs.tab',
        relatedTarget: previous
      })
    })
  }

  Tab.prototype.activate = function (element, container, callback) {
    var $active    = container.find('> .active')
    var transition = callback
      && $.support.transition
      && $active.hasClass('fade')

    function next() {
      $active
        .removeClass('active')
        .find('> .dropdown-menu > .active')
        .removeClass('active')

      element.addClass('active')

      if (transition) {
        element[0].offsetWidth // reflow for transition
        element.addClass('in')
      } else {
        element.removeClass('fade')
      }

      if (element.parent('.dropdown-menu')) {
        element.closest('li.dropdown').addClass('active')
      }

      callback && callback()
    }

    transition ?
      $active
        .one($.support.transition.end, next)
        .emulateTransitionEnd(150) :
      next()

    $active.removeClass('in')
  }


  // TAB PLUGIN DEFINITION
  // =====================

  var old = $.fn.tab

  $.fn.tab = function ( option ) {
    return this.each(function () {
      var $this = $(this)
      var data  = $this.data('bs.tab')

      if (!data) $this.data('bs.tab', (data = new Tab(this)))
      if (typeof option == 'string') data[option]()
    })
  }

  $.fn.tab.Constructor = Tab


  // TAB NO CONFLICT
  // ===============

  $.fn.tab.noConflict = function () {
    $.fn.tab = old
    return this
  }


  // TAB DATA-API
  // ============

  $(document).on('click.bs.tab.data-api', '[data-toggle="tab"], [data-toggle="pill"]', function (e) {
    e.preventDefault()
    $(this).tab('show')
  })

}(jq111);

/* ========================================================================
 * Bootstrap: affix.js v3.0.3
 * http://getbootstrap.com/javascript/#affix
 * ========================================================================
 * Copyright 2011-2014 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // AFFIX CLASS DEFINITION
  // ======================

  var Affix = function (element, options) {
    this.options = $.extend({}, Affix.DEFAULTS, options)
    this.$window = $(window)
      .on('scroll.bs.affix.data-api', $.proxy(this.checkPosition, this))
      .on('click.bs.affix.data-api',  $.proxy(this.checkPositionWithEventLoop, this))

    this.$element     = $(element)
    this.affixed      =
    this.unpin        =
    this.pinnedOffset = null

    this.checkPosition()
  }

  Affix.RESET = 'affix affix-top affix-bottom'

  Affix.DEFAULTS = {
    offset: 0
  }

  Affix.prototype.getPinnedOffset = function () {
    if (this.pinnedOffset) return this.pinnedOffset
    this.$element.removeClass(Affix.RESET).addClass('affix')
    var scrollTop = this.$window.scrollTop()
    var position  = this.$element.offset()
    return (this.pinnedOffset = position.top - scrollTop)
  }

  Affix.prototype.checkPositionWithEventLoop = function () {
    setTimeout($.proxy(this.checkPosition, this), 1)
  }

  Affix.prototype.checkPosition = function () {
    if (!this.$element.is(':visible')) return

    var scrollHeight = $(document).height()
    var scrollTop    = this.$window.scrollTop()
    var position     = this.$element.offset()
    var offset       = this.options.offset
    var offsetTop    = offset.top
    var offsetBottom = offset.bottom

    if (this.affixed == 'top') position.top += scrollTop

    if (typeof offset != 'object')         offsetBottom = offsetTop = offset
    if (typeof offsetTop == 'function')    offsetTop    = offset.top(this.$element)
    if (typeof offsetBottom == 'function') offsetBottom = offset.bottom(this.$element)

    var affix = this.unpin   != null && (scrollTop + this.unpin <= position.top) ? false :
                offsetBottom != null && (position.top + this.$element.height() >= scrollHeight - offsetBottom) ? 'bottom' :
                offsetTop    != null && (scrollTop <= offsetTop) ? 'top' : false

    if (this.affixed === affix) return
    if (this.unpin) this.$element.css('top', '')

    var affixType = 'affix' + (affix ? '-' + affix : '')
    var e         = $.Event(affixType + '.bs.affix')

    this.$element.trigger(e)

    if (e.isDefaultPrevented()) return

    this.affixed = affix
    this.unpin = affix == 'bottom' ? this.getPinnedOffset() : null

    this.$element
      .removeClass(Affix.RESET)
      .addClass(affixType)
      .trigger($.Event(affixType.replace('affix', 'affixed')))

    if (affix == 'bottom') {
      this.$element.offset({ top: scrollHeight - offsetBottom - this.$element.height() })
    }
  }


  // AFFIX PLUGIN DEFINITION
  // =======================

  var old = $.fn.affix

  $.fn.affix = function (option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.affix')
      var options = typeof option == 'object' && option

      if (!data) $this.data('bs.affix', (data = new Affix(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  $.fn.affix.Constructor = Affix


  // AFFIX NO CONFLICT
  // =================

  $.fn.affix.noConflict = function () {
    $.fn.affix = old
    return this
  }


  // AFFIX DATA-API
  // ==============

  $(window).on('load', function () {
    $('[data-spy="affix"]').each(function () {
      var $spy = $(this)
      var data = $spy.data()

      data.offset = data.offset || {}

      if (data.offsetBottom) data.offset.bottom = data.offsetBottom
      if (data.offsetTop)    data.offset.top    = data.offsetTop

      $spy.affix(data)
    })
  })

}(jq111);

//http://www.sitepoint.com/safe-console-log/
//Console.logs were causing errors in IE. This hack will just disregard the console.logs if the console object has not been instantiated (IE dev tools not opened)
(function(a){function b(){}for(var c="assert,count,debug,dir,dirxml,error,exception,group,groupCollapsed,groupEnd,info,log,markTimeline,profile,profileEnd,time,timeEnd,trace,warn".split(","),d;!!(d=c.pop());){a[d]=a[d]||b;}})
(function(){try{console.log();return window.console;}catch(a){return (window.console={});}}()); 
// From http://stackoverflow.com/questions/1537848/jquery-plugin-namespace/11441340#11441340

(function ($) {
    $.namespace = function (namespaceName, closures) {

        if ($.fn[namespaceName] === undefined) {
            $.fn[namespaceName] = function executor(context) {
                if (this instanceof executor) {
                    this.__context__ = context;
                }
                else {
                    return new executor(this);
                }
            };
        }

        $.each(closures, function (closureName, closure) {
            $.fn[namespaceName].prototype[closureName] = function () {

                // Don't act on absent elements -via Paul Irish's advice
                if (!this.__context__.length)
                    return;

                closure.apply(this.__context__, arguments);
            };
        });

    };
})(jq111);
/*
* EventBroadcast - Enable Pub/Sub pattern in $, event broadcasting
* v. 1.2.1
*
* Created by Guido Bellomo (http://javascript-jedi.com)
* Licensed under the GPL (http://www.opensource.org/licenses/gpl-license.php).
*
* Author: Guido Bellomo (guido.bellomo@gmail.com)
*
* Example:
*
* Example
* $('#imageList')
*	.bind('hideImageList',function(evt) {
*		console.log(evt.data);
*		$(this).hide();
*		})
*
* $.trigger('hideImageList');
*
* Cast the "hideImageList" message to all objects listening
* It's possible to include optional arguments the the message, will be available
* in the "data" property of event object.
*
*/
+function($) {

	var _bind = $.fn.bind;
	var _on = $.fn.on;
	var _unbind = $.fn.unbind;
	var _one = $.fn.one;
	var listeners = {};

	// cleanup
	/*$(function() {
		$(window).bind('unload',function() {
			//delete listeners;
			});
		});*/


	// Find a object inside a collection
	function findListener(strEvent,obj) {
		var result = -1;
		var i = 0;
		if (listeners[strEvent] != null)
			for (i = 0; i < listeners[strEvent].length; i++) {
				if (listeners[strEvent][i] == obj) result = i;
				}
		return result;
		}

	// Register a node to an event
	function registerListener(strEvent,obj) {
		// Check if the array exists
		if (listeners[strEvent] == null)
			listeners[strEvent] = [];
		// If not exists then append
		if (findListener(strEvent,obj) == -1) {
			listeners[strEvent].push(obj);
			}
		}

	function unregisterListener(strEvent,obj) {
		var idx =  findListener(strEvent,obj);
		// Remove element if exists
		if (idx != -1) {
			listeners[strEvent] = listeners[strEvent].slice(0,idx-1).concat(listeners[strEvent].slice(idx+1));
			}
		}


	function _broadcast(strEvent,params) {
		//if (params === undefined) params = null;
		// If listeners are present
		if (listeners[strEvent] != null) {
			// Trigger on each
			$(listeners[strEvent]).each(function() {
				$(this).trigger(strEvent,params);
				});
			}
		}


	$.extend({

		broadcast: function(strEvent,params) {
			_broadcast(strEvent,params);
			},
		trigger: function(strEvent,params) {
			_broadcast(strEvent,params);
			},
		listeners: function(strEvent) {
			console.log('Listeners for '+strEvent);
			console.log(listeners[strEvent]);
			}

		});


	$.fn.extend({

		unbind: function(strEvent,callback) {
			unregisterListener(strEvent,this);
			_unbind.apply(this,arguments);
			return this;
			},

		one: function(strEvent,data,callBack) {
			// Register the listener
			$(this).each(function() {
				// Register the listener
				registerListener(strEvent,this);
				});
			_one.apply(this,arguments);
			return this;
			},


		bind:function(strEvent,data,callback) {
			// Register the listener
			$(this).each(function() {
				// Register the listener
				registerListener(strEvent,this);
				});

			_bind.apply(this,arguments);

			return this;
			},

		on:function(strEvent,data,callback) {
			// Register the listener
			$(this).each(function() {
				// Register the listener
				registerListener(strEvent,this);
				});

			_on.apply(this,arguments);

			return this;
			}

		});

}(jq111);
/*
 * jQuery FlexSlider v2.2.0
 * Copyright 2012 WooThemes
 * Contributing Author: Tyler Smith
 */
+function ($) {

  //FlexSlider: Object Instance
  $.flexslider = function(el, options) {
    var slider = $(el);

    // making variables public
    slider.vars = $.extend({}, $.flexslider.defaults, options);

    var namespace = slider.vars.namespace,
        msGesture = window.navigator && window.navigator.msPointerEnabled && window.MSGesture,
        touch = (( "ontouchstart" in window ) || msGesture || window.DocumentTouch && document instanceof DocumentTouch) && slider.vars.touch,
        // depricating this idea, as devices are being released with both of these events
        //eventType = (touch) ? "touchend" : "click",
        eventType = "click touchend MSPointerUp",
        watchedEvent = "",
        watchedEventClearTimer,
        vertical = slider.vars.direction === "vertical",
        reverse = slider.vars.reverse,
        carousel = (slider.vars.itemWidth > 0),
        fade = slider.vars.animation === "fade",
        asNav = slider.vars.asNavFor !== "",
        methods = {},
        focused = true;

    // Store a reference to the slider object
    $.data(el, "flexslider", slider);

    // Private slider methods
    methods = {
      init: function() {
        slider.animating = false;
        // Get current slide and make sure it is a number
        slider.currentSlide = parseInt( ( slider.vars.startAt ? slider.vars.startAt : 0) );
        if ( isNaN( slider.currentSlide ) ) slider.currentSlide = 0;
        slider.animatingTo = slider.currentSlide;
        slider.atEnd = (slider.currentSlide === 0 || slider.currentSlide === slider.last);
        slider.containerSelector = slider.vars.selector.substr(0,slider.vars.selector.search(' '));
        slider.slides = $(slider.vars.selector, slider);
        slider.container = $(slider.containerSelector, slider);
        slider.count = slider.slides.length;
        // SYNC:
        slider.syncExists = $(slider.vars.sync).length > 0;
        // SLIDE:
        if (slider.vars.animation === "slide") slider.vars.animation = "swing";
        slider.prop = (vertical) ? "top" : "marginLeft";
        slider.args = {};
        // SLIDESHOW:
        slider.manualPause = false;
        slider.stopped = false;
        //PAUSE WHEN INVISIBLE
        slider.started = false;
        slider.startTimeout = null;
        // TOUCH/USECSS:
        slider.transitions = !slider.vars.video && !fade && slider.vars.useCSS && (function() {
          var obj = document.createElement('div'),
              props = ['perspective', 'perspectiveProperty', 'WebkitPerspective', 'MozPerspective', 'OPerspective', 'msPerspective'];
          for (var i in props) {
            if ( obj.style[ props[i] ] !== undefined ) {
              if ( 'perspective' !== props[i] && 'perspectiveProperty' !== props[i] ) {
                slider.pfx = "-" + props[i].replace('Perspective','').toLowerCase() + "-";
              } else {
                slider.pfx = "";
              }
              slider.prop = slider.pfx + "transform";
              return true;
            }
          }
          return false;
        }());
        // CONTROLSCONTAINER:
        if (slider.vars.controlsContainer !== "") slider.controlsContainer = $(slider.vars.controlsContainer).length > 0 && $(slider.vars.controlsContainer);
        // MANUAL:
        if (slider.vars.manualControls !== "") slider.manualControls = $(slider.vars.manualControls).length > 0 && $(slider.vars.manualControls);

        // RANDOMIZE:
        if (slider.vars.randomize) {
          slider.slides.sort(function() { return (Math.round(Math.random())-0.5); });
          slider.container.empty().append(slider.slides);
        }

        slider.doMath();

        // INIT
        slider.setup("init");

        // CONTROLNAV:
        if (slider.vars.controlNav) methods.controlNav.setup();

        // DIRECTIONNAV:
        if (slider.vars.directionNav) methods.directionNav.setup();

        // KEYBOARD:
        if (slider.vars.keyboard && ($(slider.containerSelector).length === 1 || slider.vars.multipleKeyboard)) {
          $(document).bind('keyup', function(event) {
            var keycode = event.keyCode;
            if (!slider.animating && (keycode === 39 || keycode === 37)) {
              var target = (keycode === 39) ? slider.getTarget('next') :
                           (keycode === 37) ? slider.getTarget('prev') : false;
              slider.flexAnimate(target, slider.vars.pauseOnAction);
            }
          });
        }
        // MOUSEWHEEL:
        if (slider.vars.mousewheel) {
          slider.bind('mousewheel', function(event, delta, deltaX, deltaY) {
            event.preventDefault();
            var target = (delta < 0) ? slider.getTarget('next') : slider.getTarget('prev');
            slider.flexAnimate(target, slider.vars.pauseOnAction);
          });
        }

        // PAUSEPLAY
        if (slider.vars.pausePlay) methods.pausePlay.setup();

        //PAUSE WHEN INVISIBLE
        if (slider.vars.slideshow && slider.vars.pauseInvisible) methods.pauseInvisible.init();

        // SLIDSESHOW
        if (slider.vars.slideshow) {
          if (slider.vars.pauseOnHover) {
            slider.hover(function() {
              if (!slider.manualPlay && !slider.manualPause) slider.pause();
            }, function() {
              if (!slider.manualPause && !slider.manualPlay && !slider.stopped) slider.play();
            });
          }
          // initialize animation
          //If we're visible, or we don't use PageVisibility API
          if(!slider.vars.pauseInvisible || !methods.pauseInvisible.isHidden()) {
            (slider.vars.initDelay > 0) ? slider.startTimeout = setTimeout(slider.play, slider.vars.initDelay) : slider.play();
          }
        }

        // ASNAV:
        if (asNav) methods.asNav.setup();

        // TOUCH
        if (touch && slider.vars.touch) methods.touch();

        // FADE&&SMOOTHHEIGHT || SLIDE:
        if (!fade || (fade && slider.vars.smoothHeight)) $(window).bind("resize orientationchange focus", methods.resize);

        slider.find("img").attr("draggable", "false");

        // API: start() Callback
        setTimeout(function(){
          slider.vars.start(slider);
        }, 200);
      },
      asNav: {
        setup: function() {
          slider.asNav = true;
          slider.animatingTo = Math.floor(slider.currentSlide/slider.move);
          slider.currentItem = slider.currentSlide;
          slider.slides.removeClass(namespace + "active-slide").eq(slider.currentItem).addClass(namespace + "active-slide");
          if(!msGesture){
              slider.slides.click(function(e){
                e.preventDefault();
                var $slide = $(this),
                    target = $slide.index();
                var posFromLeft = $slide.offset().left - $(slider).scrollLeft(); // Find position of slide relative to left of slider container
                if( posFromLeft <= 0 && $slide.hasClass( namespace + 'active-slide' ) ) {
                  slider.flexAnimate(slider.getTarget("prev"), true);
                } else if (!$(slider.vars.asNavFor).data('flexslider').animating && !$slide.hasClass(namespace + "active-slide")) {
                  slider.direction = (slider.currentItem < target) ? "next" : "prev";
                  slider.flexAnimate(target, slider.vars.pauseOnAction, false, true, true);
                }
              });
          }else{
              el._slider = slider;
              slider.slides.each(function (){
                  var that = this;
                  that._gesture = new MSGesture();
                  that._gesture.target = that;
                  that.addEventListener("MSPointerDown", function (e){
                      e.preventDefault();
                      if(e.currentTarget._gesture)
                          e.currentTarget._gesture.addPointer(e.pointerId);
                  }, false);
                  that.addEventListener("MSGestureTap", function (e){
                      e.preventDefault();
                      var $slide = $(this),
                          target = $slide.index();
                      if (!$(slider.vars.asNavFor).data('flexslider').animating && !$slide.hasClass('active')) {
                          slider.direction = (slider.currentItem < target) ? "next" : "prev";
                          slider.flexAnimate(target, slider.vars.pauseOnAction, false, true, true);
                      }
                  });
              });
          }
        }
      },
      controlNav: {
        setup: function() {
          if (!slider.manualControls) {
            methods.controlNav.setupPaging();
          } else { // MANUALCONTROLS:
            methods.controlNav.setupManual();
          }
        },
        setupPaging: function() {
          var type = (slider.vars.controlNav === "thumbnails") ? 'control-thumbs' : 'control-paging',
              j = 1,
              item,
              slide;

          slider.controlNavScaffold = $('<ol class="'+ namespace + 'control-nav ' + namespace + type + '"></ol>');

          if (slider.pagingCount > 1) {
            for (var i = 0; i < slider.pagingCount; i++) {
              slide = slider.slides.eq(i);
              item = (slider.vars.controlNav === "thumbnails") ? '<img src="' + slide.attr( 'data-thumb' ) + '"/>' : '<a>' + j + '</a>';
              if ( 'thumbnails' === slider.vars.controlNav && true === slider.vars.thumbCaptions ) {
                var captn = slide.attr( 'data-thumbcaption' );
                if ( '' != captn && undefined != captn ) item += '<span class="' + namespace + 'caption">' + captn + '</span>';
              }
              slider.controlNavScaffold.append('<li>' + item + '</li>');
              j++;
            }
          }

          // CONTROLSCONTAINER:
          (slider.controlsContainer) ? $(slider.controlsContainer).append(slider.controlNavScaffold) : slider.append(slider.controlNavScaffold);
          methods.controlNav.set();

          methods.controlNav.active();

          slider.controlNavScaffold.delegate('a, img', eventType, function(event) {
            event.preventDefault();

            if (watchedEvent === "" || watchedEvent === event.type) {
              var $this = $(this),
                  target = slider.controlNav.index($this);

              if (!$this.hasClass(namespace + 'active')) {
                slider.direction = (target > slider.currentSlide) ? "next" : "prev";
                slider.flexAnimate(target, slider.vars.pauseOnAction);
              }
            }

            // setup flags to prevent event duplication
            if (watchedEvent === "") {
              watchedEvent = event.type;
            }
            methods.setToClearWatchedEvent();

          });
        },
        setupManual: function() {
          slider.controlNav = slider.manualControls;
          methods.controlNav.active();

          slider.controlNav.bind(eventType, function(event) {
            event.preventDefault();

            if (watchedEvent === "" || watchedEvent === event.type) {
              var $this = $(this),
                  target = slider.controlNav.index($this);

              if (!$this.hasClass(namespace + 'active')) {
                (target > slider.currentSlide) ? slider.direction = "next" : slider.direction = "prev";
                slider.flexAnimate(target, slider.vars.pauseOnAction);
              }
            }

            // setup flags to prevent event duplication
            if (watchedEvent === "") {
              watchedEvent = event.type;
            }
            methods.setToClearWatchedEvent();
          });
        },
        set: function() {
          var selector = (slider.vars.controlNav === "thumbnails") ? 'img' : 'a';
          slider.controlNav = $('.' + namespace + 'control-nav li ' + selector, (slider.controlsContainer) ? slider.controlsContainer : slider);
        },
        active: function() {
          slider.controlNav.removeClass(namespace + "active").eq(slider.animatingTo).addClass(namespace + "active");
        },
        update: function(action, pos) {
          if (slider.pagingCount > 1 && action === "add") {
            slider.controlNavScaffold.append($('<li><a>' + slider.count + '</a></li>'));
          } else if (slider.pagingCount === 1) {
            slider.controlNavScaffold.find('li').remove();
          } else {
            slider.controlNav.eq(pos).closest('li').remove();
          }
          methods.controlNav.set();
          (slider.pagingCount > 1 && slider.pagingCount !== slider.controlNav.length) ? slider.update(pos, action) : methods.controlNav.active();
        }
      },
      directionNav: {
        setup: function() {
          var directionNavScaffold = $('<ul class="' + namespace + 'direction-nav"><li><a class="' + namespace + 'prev" href="#">' + slider.vars.prevText + '</a></li><li><a class="' + namespace + 'next" href="#">' + slider.vars.nextText + '</a></li></ul>');

          // CONTROLSCONTAINER:
          if (slider.controlsContainer) {
            $(slider.controlsContainer).append(directionNavScaffold);
            slider.directionNav = $('.' + namespace + 'direction-nav li a', slider.controlsContainer);
          } else {
            slider.append(directionNavScaffold);
            slider.directionNav = $('.' + namespace + 'direction-nav li a', slider);
          }

          methods.directionNav.update();

          slider.directionNav.bind(eventType, function(event) {
            event.preventDefault();
            var target;

            if (watchedEvent === "" || watchedEvent === event.type) {
              target = ($(this).hasClass(namespace + 'next')) ? slider.getTarget('next') : slider.getTarget('prev');
              slider.flexAnimate(target, slider.vars.pauseOnAction);
            }

            // setup flags to prevent event duplication
            if (watchedEvent === "") {
              watchedEvent = event.type;
            }
            methods.setToClearWatchedEvent();
          });
        },
        update: function() {
          var disabledClass = namespace + 'disabled';
          if (slider.pagingCount === 1) {
            slider.directionNav.addClass(disabledClass).attr('tabindex', '-1');
          } else if (!slider.vars.animationLoop) {
            if (slider.animatingTo === 0) {
              slider.directionNav.removeClass(disabledClass).filter('.' + namespace + "prev").addClass(disabledClass).attr('tabindex', '-1');
            } else if (slider.animatingTo === slider.last) {
              slider.directionNav.removeClass(disabledClass).filter('.' + namespace + "next").addClass(disabledClass).attr('tabindex', '-1');
            } else {
              slider.directionNav.removeClass(disabledClass).removeAttr('tabindex');
            }
          } else {
            slider.directionNav.removeClass(disabledClass).removeAttr('tabindex');
          }
        }
      },
      pausePlay: {
        setup: function() {
          var pausePlayScaffold = $('<div class="' + namespace + 'pauseplay"><a></a></div>');

          // CONTROLSCONTAINER:
          if (slider.controlsContainer) {
            slider.controlsContainer.append(pausePlayScaffold);
            slider.pausePlay = $('.' + namespace + 'pauseplay a', slider.controlsContainer);
          } else {
            slider.append(pausePlayScaffold);
            slider.pausePlay = $('.' + namespace + 'pauseplay a', slider);
          }

          methods.pausePlay.update((slider.vars.slideshow) ? namespace + 'pause' : namespace + 'play');

          slider.pausePlay.bind(eventType, function(event) {
            event.preventDefault();

            if (watchedEvent === "" || watchedEvent === event.type) {
              if ($(this).hasClass(namespace + 'pause')) {
                slider.manualPause = true;
                slider.manualPlay = false;
                slider.pause();
              } else {
                slider.manualPause = false;
                slider.manualPlay = true;
                slider.play();
              }
            }

            // setup flags to prevent event duplication
            if (watchedEvent === "") {
              watchedEvent = event.type;
            }
            methods.setToClearWatchedEvent();
          });
        },
        update: function(state) {
          (state === "play") ? slider.pausePlay.removeClass(namespace + 'pause').addClass(namespace + 'play').html(slider.vars.playText) : slider.pausePlay.removeClass(namespace + 'play').addClass(namespace + 'pause').html(slider.vars.pauseText);
        }
      },
      touch: function() {
        var startX,
          startY,
          offset,
          cwidth,
          dx = null,
          startT,
          scrolling = false,
          localX = 0,
          localY = 0,
          accDx = 0;

        if(!msGesture){
            el.addEventListener('touchstart', onTouchStart, false);

            function onTouchStart(e) {
              if (slider.animating) {
                e.preventDefault();
              } else if ( ( window.navigator.msPointerEnabled ) || e.touches.length === 1 ) {
                slider.pause();
                // CAROUSEL:
                cwidth = (vertical) ? slider.h : slider. w;
                startT = Number(new Date());
                // CAROUSEL:

                // Local vars for X and Y points.
                localX = e.touches[0].pageX;
                localY = e.touches[0].pageY;

                offset = (carousel && reverse && slider.animatingTo === slider.last) ? 0 :
                         (carousel && reverse) ? slider.limit - (((slider.itemW + slider.vars.itemMargin) * slider.move) * slider.animatingTo) :
                         (carousel && slider.currentSlide === slider.last) ? slider.limit :
                         (carousel) ? ((slider.itemW + slider.vars.itemMargin) * slider.move) * slider.currentSlide :
                         (reverse) ? (slider.last - slider.currentSlide + slider.cloneOffset) * cwidth : (slider.currentSlide + slider.cloneOffset) * cwidth;
                startX = (vertical) ? localY : localX;
                startY = (vertical) ? localX : localY;

                el.addEventListener('touchmove', onTouchMove, false);
                el.addEventListener('touchend', onTouchEnd, false);
              }
            }

            function onTouchMove(e) {
              // Local vars for X and Y points.

              localX = e.touches[0].pageX;
              localY = e.touches[0].pageY;

              dx = (vertical) ? startX - localY : startX - localX;
              scrolling = (vertical) ? (Math.abs(dx) < Math.abs(localX - startY)) : (Math.abs(dx) < Math.abs(localY - startY));

              var fxms = 500;

              if ( ! scrolling || Number( new Date() ) - startT > fxms ) {
                e.preventDefault();
                if (!fade && slider.transitions) {
                  if (!slider.vars.animationLoop) {
                    dx = dx/((slider.currentSlide === 0 && dx < 0 || slider.currentSlide === slider.last && dx > 0) ? (Math.abs(dx)/cwidth+2) : 1);
                  }
                  slider.setProps(offset + dx, "setTouch");
                }
              } else {

                // Gesture is not related to slider direction, ignore it
                el.removeEventListener('touchmove', onTouchMove, false);
              }
            }

            function onTouchEnd(e) {
              // finish the touch by undoing the touch session
              el.removeEventListener('touchmove', onTouchMove, false);

              if (slider.animatingTo === slider.currentSlide && !scrolling && !(dx === null)) {
                var updateDx = (reverse) ? -dx : dx,
                    target = (updateDx > 0) ? slider.getTarget('next') : slider.getTarget('prev');

                if (slider.canAdvance(target) && (Number(new Date()) - startT < 550 && Math.abs(updateDx) > 50 || Math.abs(updateDx) > cwidth/2)) {
                  slider.flexAnimate(target, slider.vars.pauseOnAction);
                } else {
                  if (!fade) slider.flexAnimate(slider.currentSlide, slider.vars.pauseOnAction, true);
                }
              }
              el.removeEventListener('touchend', onTouchEnd, false);

              startX = null;
              startY = null;
              dx = null;
              offset = null;
            }
        }else{
            el.style.msTouchAction = "pan-y";
            el._gesture = new MSGesture();
            el._gesture.target = el;
            el.addEventListener("MSPointerDown", onMSPointerDown, false);
            el._slider = slider;
            el.addEventListener("MSGestureChange", onMSGestureChange, false);
            el.addEventListener("MSGestureEnd", onMSGestureEnd, false);

            function onMSPointerDown(e){
                e.stopPropagation();
                if (slider.animating) {
                    e.preventDefault();
                }else{
                    slider.pause();
                    el._gesture.addPointer(e.pointerId);
                    accDx = 0;
                    cwidth = (vertical) ? slider.h : slider. w;
                    startT = Number(new Date());
                    // CAROUSEL:

                    offset = (carousel && reverse && slider.animatingTo === slider.last) ? 0 :
                        (carousel && reverse) ? slider.limit - (((slider.itemW + slider.vars.itemMargin) * slider.move) * slider.animatingTo) :
                            (carousel && slider.currentSlide === slider.last) ? slider.limit :
                                (carousel) ? ((slider.itemW + slider.vars.itemMargin) * slider.move) * slider.currentSlide :
                                    (reverse) ? (slider.last - slider.currentSlide + slider.cloneOffset) * cwidth : (slider.currentSlide + slider.cloneOffset) * cwidth;
                }
            }

            function onMSGestureChange(e) {
                e.stopPropagation();
                var slider = e.target._slider;
                if(!slider){
                    return;
                }
                var transX = -e.translationX,
                    transY = -e.translationY;

                //Accumulate translations.
                accDx = accDx + ((vertical) ? transY : transX);
                dx = accDx;
                scrolling = (vertical) ? (Math.abs(accDx) < Math.abs(-transX)) : (Math.abs(accDx) < Math.abs(-transY));

                if(e.detail === e.MSGESTURE_FLAG_INERTIA){
                    setImmediate(function (){
                        el._gesture.stop();
                    });

                    return;
                }

                if (!scrolling || Number(new Date()) - startT > 500) {
                    e.preventDefault();
                    if (!fade && slider.transitions) {
                        if (!slider.vars.animationLoop) {
                            dx = accDx / ((slider.currentSlide === 0 && accDx < 0 || slider.currentSlide === slider.last && accDx > 0) ? (Math.abs(accDx) / cwidth + 2) : 1);
                        }
                        slider.setProps(offset + dx, "setTouch");
                    }
                }
            }

            function onMSGestureEnd(e) {
                e.stopPropagation();
                var slider = e.target._slider;
                if(!slider){
                    return;
                }
                if (slider.animatingTo === slider.currentSlide && !scrolling && !(dx === null)) {
                    var updateDx = (reverse) ? -dx : dx,
                        target = (updateDx > 0) ? slider.getTarget('next') : slider.getTarget('prev');

                    if (slider.canAdvance(target) && (Number(new Date()) - startT < 550 && Math.abs(updateDx) > 50 || Math.abs(updateDx) > cwidth/2)) {
                        slider.flexAnimate(target, slider.vars.pauseOnAction);
                    } else {
                        if (!fade) slider.flexAnimate(slider.currentSlide, slider.vars.pauseOnAction, true);
                    }
                }

                startX = null;
                startY = null;
                dx = null;
                offset = null;
                accDx = 0;
            }
        }
      },
      resize: function() {
        if (!slider.animating && slider.is(':visible')) {
          if (!carousel) slider.doMath();

          if (fade) {
            // SMOOTH HEIGHT:
            methods.smoothHeight();
          } else if (carousel) { //CAROUSEL:
            slider.slides.width(slider.computedW);
            slider.update(slider.pagingCount);
            slider.setProps();
          }
          else if (vertical) { //VERTICAL:
            slider.viewport.height(slider.h);
            slider.setProps(slider.h, "setTotal");
          } else {
            // SMOOTH HEIGHT:
            if (slider.vars.smoothHeight) methods.smoothHeight();
            slider.newSlides.width(slider.computedW);
            slider.setProps(slider.computedW, "setTotal");
          }
        }
      },
      smoothHeight: function(dur) {
        if (!vertical || fade) {
          var $obj = (fade) ? slider : slider.viewport;
          (dur) ? $obj.animate({"height": slider.slides.eq(slider.animatingTo).height()}, dur) : $obj.height(slider.slides.eq(slider.animatingTo).height());
        }
      },
      sync: function(action) {
        var $obj = $(slider.vars.sync).data("flexslider"),
            target = slider.animatingTo;

        switch (action) {
          case "animate": $obj.flexAnimate(target, slider.vars.pauseOnAction, false, true); break;
          case "play": if (!$obj.playing && !$obj.asNav) { $obj.play(); } break;
          case "pause": $obj.pause(); break;
        }
      },
      pauseInvisible: {
        visProp: null,
        init: function() {
          var prefixes = ['webkit','moz','ms','o'];

          if ('hidden' in document) return 'hidden';
          for (var i = 0; i < prefixes.length; i++) {
            if ((prefixes[i] + 'Hidden') in document)
            methods.pauseInvisible.visProp = prefixes[i] + 'Hidden';
          }
          if (methods.pauseInvisible.visProp) {
            var evtname = methods.pauseInvisible.visProp.replace(/[H|h]idden/,'') + 'visibilitychange';
            document.addEventListener(evtname, function() {
              if (methods.pauseInvisible.isHidden()) {
                if(slider.startTimeout) clearTimeout(slider.startTimeout); //If clock is ticking, stop timer and prevent from starting while invisible
                else slider.pause(); //Or just pause
              }
              else {
                if(slider.started) slider.play(); //Initiated before, just play
                else (slider.vars.initDelay > 0) ? setTimeout(slider.play, slider.vars.initDelay) : slider.play(); //Didn't init before: simply init or wait for it
              }
            });
          }
        },
        isHidden: function() {
          return document[methods.pauseInvisible.visProp] || false;
        }
      },
      setToClearWatchedEvent: function() {
        clearTimeout(watchedEventClearTimer);
        watchedEventClearTimer = setTimeout(function() {
          watchedEvent = "";
        }, 3000);
      }
    }

    // public methods
    slider.flexAnimate = function(target, pause, override, withSync, fromNav) {
      if (!slider.vars.animationLoop && target !== slider.currentSlide) {
        slider.direction = (target > slider.currentSlide) ? "next" : "prev";
      }

      if (asNav && slider.pagingCount === 1) slider.direction = (slider.currentItem < target) ? "next" : "prev";

      if (!slider.animating && (slider.canAdvance(target, fromNav) || override) && slider.is(":visible")) {
        if (asNav && withSync) {
          var master = $(slider.vars.asNavFor).data('flexslider');
          slider.atEnd = target === 0 || target === slider.count - 1;
          master.flexAnimate(target, true, false, true, fromNav);
          slider.direction = (slider.currentItem < target) ? "next" : "prev";
          master.direction = slider.direction;

          if (Math.ceil((target + 1)/slider.visible) - 1 !== slider.currentSlide && target !== 0) {
            slider.currentItem = target;
            slider.slides.removeClass(namespace + "active-slide").eq(target).addClass(namespace + "active-slide");
            target = Math.floor(target/slider.visible);
          } else {
            slider.currentItem = target;
            slider.slides.removeClass(namespace + "active-slide").eq(target).addClass(namespace + "active-slide");
            return false;
          }
        }

        slider.animating = true;
        slider.animatingTo = target;

        // SLIDESHOW:
        if (pause) slider.pause();

        // API: before() animation Callback
        slider.vars.before(slider);

        // SYNC:
        if (slider.syncExists && !fromNav) methods.sync("animate");

        // CONTROLNAV
        if (slider.vars.controlNav) methods.controlNav.active();

        // !CAROUSEL:
        // CANDIDATE: slide active class (for add/remove slide)
        if (!carousel) slider.slides.removeClass(namespace + 'active-slide').eq(target).addClass(namespace + 'active-slide');

        // INFINITE LOOP:
        // CANDIDATE: atEnd
        slider.atEnd = target === 0 || target === slider.last;

        // DIRECTIONNAV:
        if (slider.vars.directionNav) methods.directionNav.update();

        if (target === slider.last) {
          // API: end() of cycle Callback
          slider.vars.end(slider);
          // SLIDESHOW && !INFINITE LOOP:
          if (!slider.vars.animationLoop) slider.pause();
        }

        // SLIDE:
        if (!fade) {
          var dimension = (vertical) ? slider.slides.filter(':first').height() : slider.computedW,
              margin, slideString, calcNext, called = false;

          // INFINITE LOOP / REVERSE:
          if (carousel) {
            //margin = (slider.vars.itemWidth > slider.w) ? slider.vars.itemMargin * 2 : slider.vars.itemMargin;
            margin = slider.vars.itemMargin;
            calcNext = ((slider.itemW + margin) * slider.move) * slider.animatingTo;
            slideString = (calcNext > slider.limit && slider.visible !== 1) ? slider.limit : calcNext;
          } else if (slider.currentSlide === 0 && target === slider.count - 1 && slider.vars.animationLoop && slider.direction !== "next") {
            slideString = (reverse) ? (slider.count + slider.cloneOffset) * dimension : 0;
          } else if (slider.currentSlide === slider.last && target === 0 && slider.vars.animationLoop && slider.direction !== "prev") {
            slideString = (reverse) ? 0 : (slider.count + 1) * dimension;
          } else {
            slideString = (reverse) ? ((slider.count - 1) - target + slider.cloneOffset) * dimension : (target + slider.cloneOffset) * dimension;
          }
          slider.setProps(slideString, "", slider.vars.animationSpeed);
          if (slider.transitions) {
            if (!slider.vars.animationLoop || !slider.atEnd) {
              slider.animating = false;
              slider.currentSlide = slider.animatingTo;
            }
            slider.container.unbind("webkitTransitionEnd transitionend");
            slider.container.bind("webkitTransitionEnd transitionend", function() {
              called = true;
              slider.wrapup(dimension);
            });

            // Workaround for inconsistent triggering
            setTimeout(function(){
              if (!called) {
                slider.container.trigger('webkitTransitionEnd');
                slider.container.trigger('transitionend');
              }
            }, slider.vars.animationSpeed+200);
          } else {
            slider.container.animate(slider.args, slider.vars.animationSpeed, slider.vars.easing, function(){
              slider.wrapup(dimension);
            });
          }
        } else { // FADE:
          if (!touch) {
            //slider.slides.eq(slider.currentSlide).fadeOut(slider.vars.animationSpeed, slider.vars.easing);
            //slider.slides.eq(target).fadeIn(slider.vars.animationSpeed, slider.vars.easing, slider.wrapup);

            slider.slides.eq(slider.currentSlide).css({"zIndex": 1}).animate({"opacity": 0}, slider.vars.animationSpeed, slider.vars.easing);
            slider.slides.eq(target).css({"zIndex": 2}).animate({"opacity": 1}, slider.vars.animationSpeed, slider.vars.easing, slider.wrapup);

          } else {
            slider.slides.eq(slider.currentSlide).css({ "opacity": 0, "zIndex": 1 });
            slider.slides.eq(target).css({ "opacity": 1, "zIndex": 2 });
            slider.wrapup(dimension);
          }
        }
        // SMOOTH HEIGHT:
        if (slider.vars.smoothHeight) methods.smoothHeight(slider.vars.animationSpeed);
      }
    }
    slider.wrapup = function(dimension) {
      // SLIDE:
      if (!fade && !carousel) {
        if (slider.currentSlide === 0 && slider.animatingTo === slider.last && slider.vars.animationLoop) {
          slider.setProps(dimension, "jumpEnd");
        } else if (slider.currentSlide === slider.last && slider.animatingTo === 0 && slider.vars.animationLoop) {
          slider.setProps(dimension, "jumpStart");
        }
      }
      slider.animating = false;
      slider.currentSlide = slider.animatingTo;
      // API: after() animation Callback
      slider.vars.after(slider);
    }

    // SLIDESHOW:
    slider.animateSlides = function() {
      if (!slider.animating && focused ) slider.flexAnimate(slider.getTarget("next"));
    }
    // SLIDESHOW:
    slider.pause = function() {
      clearInterval(slider.animatedSlides);
      slider.animatedSlides = null;
      slider.playing = false;
      // PAUSEPLAY:
      if (slider.vars.pausePlay) methods.pausePlay.update("play");
      // SYNC:
      if (slider.syncExists) methods.sync("pause");
    }
    // SLIDESHOW:
    slider.play = function() {
      if (slider.playing) clearInterval(slider.animatedSlides);
      slider.animatedSlides = slider.animatedSlides || setInterval(slider.animateSlides, slider.vars.slideshowSpeed);
      slider.started = slider.playing = true;
      // PAUSEPLAY:
      if (slider.vars.pausePlay) methods.pausePlay.update("pause");
      // SYNC:
      if (slider.syncExists) methods.sync("play");
    }
    // STOP:
    slider.stop = function () {
      slider.pause();
      slider.stopped = true;
    }
    slider.canAdvance = function(target, fromNav) {
      // ASNAV:
      var last = (asNav) ? slider.pagingCount - 1 : slider.last;
      return (fromNav) ? true :
             (asNav && slider.currentItem === slider.count - 1 && target === 0 && slider.direction === "prev") ? true :
             (asNav && slider.currentItem === 0 && target === slider.pagingCount - 1 && slider.direction !== "next") ? false :
             (target === slider.currentSlide && !asNav) ? false :
             (slider.vars.animationLoop) ? true :
             (slider.atEnd && slider.currentSlide === 0 && target === last && slider.direction !== "next") ? false :
             (slider.atEnd && slider.currentSlide === last && target === 0 && slider.direction === "next") ? false :
             true;
    }
    slider.getTarget = function(dir) {
      slider.direction = dir;
      if (dir === "next") {
        return (slider.currentSlide === slider.last) ? 0 : slider.currentSlide + 1;
      } else {
        return (slider.currentSlide === 0) ? slider.last : slider.currentSlide - 1;
      }
    }

    // SLIDE:
    slider.setProps = function(pos, special, dur) {
      var target = (function() {
        var posCheck = (pos) ? pos : ((slider.itemW + slider.vars.itemMargin) * slider.move) * slider.animatingTo,
            posCalc = (function() {
              if (carousel) {
                return (special === "setTouch") ? pos :
                       (reverse && slider.animatingTo === slider.last) ? 0 :
                       (reverse) ? slider.limit - (((slider.itemW + slider.vars.itemMargin) * slider.move) * slider.animatingTo) :
                       (slider.animatingTo === slider.last) ? slider.limit : posCheck;
              } else {
                switch (special) {
                  case "setTotal": return (reverse) ? ((slider.count - 1) - slider.currentSlide + slider.cloneOffset) * pos : (slider.currentSlide + slider.cloneOffset) * pos;
                  case "setTouch": return (reverse) ? pos : pos;
                  case "jumpEnd": return (reverse) ? pos : slider.count * pos;
                  case "jumpStart": return (reverse) ? slider.count * pos : pos;
                  default: return pos;
                }
              }
            }());

            return (posCalc * -1) + "px";
          }());

      if (slider.transitions) {
        target = (vertical) ? "translate3d(0," + target + ",0)" : "translate3d(" + target + ",0,0)";
        dur = (dur !== undefined) ? (dur/1000) + "s" : "0s";
        slider.container.css(slider.pfx + "transition-duration", dur);
      }

      slider.args[slider.prop] = target;
      if (slider.transitions || dur === undefined) slider.container.css(slider.args);
    }

    slider.setup = function(type) {
      // SLIDE:
      if (!fade) {
        var sliderOffset, arr;

        if (type === "init") {
          slider.viewport = $('<div class="' + namespace + 'viewport"></div>').css({"overflow": "hidden", "position": "relative"}).appendTo(slider).append(slider.container);
          // INFINITE LOOP:
          slider.cloneCount = 0;
          slider.cloneOffset = 0;
          // REVERSE:
          if (reverse) {
            arr = $.makeArray(slider.slides).reverse();
            slider.slides = $(arr);
            slider.container.empty().append(slider.slides);
          }
        }
        // INFINITE LOOP && !CAROUSEL:
        if (slider.vars.animationLoop && !carousel) {
          slider.cloneCount = 2;
          slider.cloneOffset = 1;
          // clear out old clones
          if (type !== "init") slider.container.find('.clone').remove();
          slider.container.append(slider.slides.first().clone().addClass('clone').attr('aria-hidden', 'true')).prepend(slider.slides.last().clone().addClass('clone').attr('aria-hidden', 'true'));
        }
        slider.newSlides = $(slider.vars.selector, slider);

        sliderOffset = (reverse) ? slider.count - 1 - slider.currentSlide + slider.cloneOffset : slider.currentSlide + slider.cloneOffset;
        // VERTICAL:
        if (vertical && !carousel) {
          slider.container.height((slider.count + slider.cloneCount) * 200 + "%").css("position", "absolute").width("100%");
          setTimeout(function(){
            slider.newSlides.css({"display": "block"});
            slider.doMath();
            slider.viewport.height(slider.h);
            slider.setProps(sliderOffset * slider.h, "init");
          }, (type === "init") ? 100 : 0);
        } else {
          slider.container.width((slider.count + slider.cloneCount) * 200 + "%");
          slider.setProps(sliderOffset * slider.computedW, "init");
          setTimeout(function(){
            slider.doMath();
            slider.newSlides.css({"width": slider.computedW, "float": "left", "display": "block"});
            // SMOOTH HEIGHT:
            if (slider.vars.smoothHeight) methods.smoothHeight();
          }, (type === "init") ? 100 : 0);
        }
      } else { // FADE:
        slider.slides.css({"width": "100%", "float": "left", "marginRight": "-100%", "position": "relative"});
        if (type === "init") {
          if (!touch) {
            //slider.slides.eq(slider.currentSlide).fadeIn(slider.vars.animationSpeed, slider.vars.easing);
            slider.slides.css({ "opacity": 0, "display": "block", "zIndex": 1 }).eq(slider.currentSlide).css({"zIndex": 2}).animate({"opacity": 1},slider.vars.animationSpeed,slider.vars.easing);
          } else {
            slider.slides.css({ "opacity": 0, "display": "block", "webkitTransition": "opacity " + slider.vars.animationSpeed / 1000 + "s ease", "zIndex": 1 }).eq(slider.currentSlide).css({ "opacity": 1, "zIndex": 2});
          }
        }
        // SMOOTH HEIGHT:
        if (slider.vars.smoothHeight) methods.smoothHeight();
      }
      // !CAROUSEL:
      // CANDIDATE: active slide
      if (!carousel) slider.slides.removeClass(namespace + "active-slide").eq(slider.currentSlide).addClass(namespace + "active-slide");
    }


    slider.doMath = function() {
      var slide = slider.slides.first(),
          slideMargin = slider.vars.itemMargin,
          minItems = slider.vars.minItems,
          maxItems = slider.vars.maxItems;

      slider.w = (slider.viewport===undefined) ? slider.width() : slider.viewport.width();
      slider.h = slide.height();
      slider.boxPadding = slide.outerWidth() - slide.width();

      // CAROUSEL:
      if (carousel) {
        slider.itemT = slider.vars.itemWidth + slideMargin;
        slider.minW = (minItems) ? minItems * slider.itemT : slider.w;
        slider.maxW = (maxItems) ? (maxItems * slider.itemT) - slideMargin : slider.w;
        slider.itemW = (slider.minW > slider.w) ? (slider.w - (slideMargin * (minItems - 1)))/minItems :
                       (slider.maxW < slider.w) ? (slider.w - (slideMargin * (maxItems - 1)))/maxItems :
                       (slider.vars.itemWidth > slider.w) ? slider.w : slider.vars.itemWidth;

        slider.visible = Math.floor(slider.w/(slider.itemW));
        slider.move = (slider.vars.move > 0 && slider.vars.move < slider.visible ) ? slider.vars.move : slider.visible;
        slider.pagingCount = Math.ceil(((slider.count - slider.visible)/slider.move) + 1);
        slider.last =  slider.pagingCount - 1;
        slider.limit = (slider.pagingCount === 1) ? 0 :
                       (slider.vars.itemWidth > slider.w) ? (slider.itemW * (slider.count - 1)) + (slideMargin * (slider.count - 1)) : ((slider.itemW + slideMargin) * slider.count) - slider.w - slideMargin;
      } else {
        slider.itemW = slider.w;
        slider.pagingCount = slider.count;
        slider.last = slider.count - 1;
      }
      slider.computedW = slider.itemW - slider.boxPadding;
    }


    slider.update = function(pos, action) {
      slider.doMath();

      // update currentSlide and slider.animatingTo if necessary
      if (!carousel) {
        if (pos < slider.currentSlide) {
          slider.currentSlide += 1;
        } else if (pos <= slider.currentSlide && pos !== 0) {
          slider.currentSlide -= 1;
        }
        slider.animatingTo = slider.currentSlide;
      }

      // update controlNav
      if (slider.vars.controlNav && !slider.manualControls) {
        if ((action === "add" && !carousel) || slider.pagingCount > slider.controlNav.length) {
          methods.controlNav.update("add");
        } else if ((action === "remove" && !carousel) || slider.pagingCount < slider.controlNav.length) {
          if (carousel && slider.currentSlide > slider.last) {
            slider.currentSlide -= 1;
            slider.animatingTo -= 1;
          }
          methods.controlNav.update("remove", slider.last);
        }
      }
      // update directionNav
      if (slider.vars.directionNav) methods.directionNav.update();

    }

    slider.addSlide = function(obj, pos) {
      var $obj = $(obj);

      slider.count += 1;
      slider.last = slider.count - 1;

      // append new slide
      if (vertical && reverse) {
        (pos !== undefined) ? slider.slides.eq(slider.count - pos).after($obj) : slider.container.prepend($obj);
      } else {
        (pos !== undefined) ? slider.slides.eq(pos).before($obj) : slider.container.append($obj);
      }

      // update currentSlide, animatingTo, controlNav, and directionNav
      slider.update(pos, "add");

      // update slider.slides
      slider.slides = $(slider.vars.selector + ':not(.clone)', slider);
      // re-setup the slider to accomdate new slide
      slider.setup();

      //FlexSlider: added() Callback
      slider.vars.added(slider);
    }
    slider.removeSlide = function(obj) {
      var pos = (isNaN(obj)) ? slider.slides.index($(obj)) : obj;

      // update count
      slider.count -= 1;
      slider.last = slider.count - 1;

      // remove slide
      if (isNaN(obj)) {
        $(obj, slider.slides).remove();
      } else {
        (vertical && reverse) ? slider.slides.eq(slider.last).remove() : slider.slides.eq(obj).remove();
      }

      // update currentSlide, animatingTo, controlNav, and directionNav
      slider.doMath();
      slider.update(pos, "remove");

      // update slider.slides
      slider.slides = $(slider.vars.selector + ':not(.clone)', slider);
      // re-setup the slider to accomdate new slide
      slider.setup();

      // FlexSlider: removed() Callback
      slider.vars.removed(slider);
    }

    //FlexSlider: Initialize
    methods.init();
  }

  // Ensure the slider isn't focussed if the window loses focus.
  $( window ).blur( function ( e ) {
    focused = false;
  }).focus( function ( e ) {
    focused = true;
  });

  //FlexSlider: Default Settings
  $.flexslider.defaults = {
    namespace: "flex-",             //{NEW} String: Prefix string attached to the class of every element generated by the plugin
    selector: ".slides > li",       //{NEW} Selector: Must match a simple pattern. '{container} > {slide}' -- Ignore pattern at your own peril
    animation: "fade",              //String: Select your animation type, "fade" or "slide"
    easing: "swing",                //{NEW} String: Determines the easing method used in jQuery transitions. jQuery easing plugin is supported!
    direction: "horizontal",        //String: Select the sliding direction, "horizontal" or "vertical"
    reverse: false,                 //{NEW} Boolean: Reverse the animation direction
    animationLoop: true,            //Boolean: Should the animation loop? If false, directionNav will received "disable" classes at either end
    smoothHeight: false,            //{NEW} Boolean: Allow height of the slider to animate smoothly in horizontal mode
    startAt: 0,                     //Integer: The slide that the slider should start on. Array notation (0 = first slide)
    slideshow: true,                //Boolean: Animate slider automatically
    slideshowSpeed: 7000,           //Integer: Set the speed of the slideshow cycling, in milliseconds
    animationSpeed: 600,            //Integer: Set the speed of animations, in milliseconds
    initDelay: 0,                   //{NEW} Integer: Set an initialization delay, in milliseconds
    randomize: false,               //Boolean: Randomize slide order
    thumbCaptions: false,           //Boolean: Whether or not to put captions on thumbnails when using the "thumbnails" controlNav.

    // Usability features
    pauseOnAction: true,            //Boolean: Pause the slideshow when interacting with control elements, highly recommended.
    pauseOnHover: false,            //Boolean: Pause the slideshow when hovering over slider, then resume when no longer hovering
    pauseInvisible: true,       //{NEW} Boolean: Pause the slideshow when tab is invisible, resume when visible. Provides better UX, lower CPU usage.
    useCSS: true,                   //{NEW} Boolean: Slider will use CSS3 transitions if available
    touch: true,                    //{NEW} Boolean: Allow touch swipe navigation of the slider on touch-enabled devices
    video: false,                   //{NEW} Boolean: If using video in the slider, will prevent CSS3 3D Transforms to avoid graphical glitches

    // Primary Controls
    controlNav: true,               //Boolean: Create navigation for paging control of each clide? Note: Leave true for manualControls usage
    directionNav: true,             //Boolean: Create navigation for previous/next navigation? (true/false)
    prevText: "Previous",           //String: Set the text for the "previous" directionNav item
    nextText: "Next",               //String: Set the text for the "next" directionNav item

    // Secondary Navigation
    keyboard: true,                 //Boolean: Allow slider navigating via keyboard left/right keys
    multipleKeyboard: false,        //{NEW} Boolean: Allow keyboard navigation to affect multiple sliders. Default behavior cuts out keyboard navigation with more than one slider present.
    mousewheel: false,              //{UPDATED} Boolean: Requires jquery.mousewheel.js (https://github.com/brandonaaron/jquery-mousewheel) - Allows slider navigating via mousewheel
    pausePlay: false,               //Boolean: Create pause/play dynamic element
    pauseText: "Pause",             //String: Set the text for the "pause" pausePlay item
    playText: "Play",               //String: Set the text for the "play" pausePlay item

    // Special properties
    controlsContainer: "",          //{UPDATED} jQuery Object/Selector: Declare which container the navigation elements should be appended too. Default container is the FlexSlider element. Example use would be $(".flexslider-container"). Property is ignored if given element is not found.
    manualControls: "",             //{UPDATED} jQuery Object/Selector: Declare custom control navigation. Examples would be $(".flex-control-nav li") or "#tabs-nav li img", etc. The number of elements in your controlNav should match the number of slides/tabs.
    sync: "",                       //{NEW} Selector: Mirror the actions performed on this slider with another slider. Use with care.
    asNavFor: "",                   //{NEW} Selector: Internal property exposed for turning the slider into a thumbnail navigation for another slider

    // Carousel Options
    itemWidth: 0,                   //{NEW} Integer: Box-model width of individual carousel items, including horizontal borders and padding.
    itemMargin: 0,                  //{NEW} Integer: Margin between carousel items.
    minItems: 1,                    //{NEW} Integer: Minimum number of carousel items that should be visible. Items will resize fluidly when below this.
    maxItems: 0,                    //{NEW} Integer: Maxmimum number of carousel items that should be visible. Items will resize fluidly when above this limit.
    move: 0,                        //{NEW} Integer: Number of carousel items that should move on animation. If 0, slider will move all visible items.
    allowOneSlide: true,           //{NEW} Boolean: Whether or not to allow a slider comprised of a single slide

    // Callback API
    start: function(){},            //Callback: function(slider) - Fires when the slider loads the first slide
    before: function(){},           //Callback: function(slider) - Fires asynchronously with each slider animation
    after: function(){},            //Callback: function(slider) - Fires after each slider animation completes
    end: function(){},              //Callback: function(slider) - Fires when the slider reaches the last slide (asynchronous)
    added: function(){},            //{NEW} Callback: function(slider) - Fires after a slide is added
    removed: function(){}           //{NEW} Callback: function(slider) - Fires after a slide is removed
  }


  //FlexSlider: Plugin Function
  $.fn.flexslider = function(options) {
    if (options === undefined) options = {};

    if (typeof options === "object") {
      return this.each(function() {
        var $this = $(this),
            selector = (options.selector) ? options.selector : ".slides > li",
            $slides = $this.find(selector);

      if ( ( $slides.length === 1 && options.allowOneSlide === true ) || $slides.length === 0 ) {
          $slides.fadeIn(400);
          if (options.start) options.start($this);
        } else if ($this.data('flexslider') === undefined) {
          new $.flexslider(this, options);
        }
      });
    } else {
      // Helper strings to quickly perform functions on the slider
      var $slider = $(this).data('flexslider');
      switch (options) {
        case "play": $slider.play(); break;
        case "pause": $slider.pause(); break;
        case "stop": $slider.stop(); break;
        case "next": $slider.flexAnimate($slider.getTarget("next"), true); break;
        case "prev":
        case "previous": $slider.flexAnimate($slider.getTarget("prev"), true); break;
        default: if (typeof options === "number") $slider.flexAnimate(options, true);
      }
    }
  }
}(jq111);
/*!
 * jQuery Cookie Plugin v1.4.1
 * https://github.com/carhartl/jquery-cookie
 *
 * Copyright 2013 Klaus Hartl
 * Released under the MIT license
 */
(function ($) {

	var pluses = /\+/g;

	function encode(s) {
		return config.raw ? s : encodeURIComponent(s);
	}

	function decode(s) {
		return config.raw ? s : decodeURIComponent(s);
	}

	function stringifyCookieValue(value) {
		return encode(config.json ? JSON.stringify(value) : String(value));
	}

	function parseCookieValue(s) {
		if (s.indexOf('"') === 0) {
			// This is a quoted cookie as according to RFC2068, unescape...
			s = s.slice(1, -1).replace(/\\"/g, '"').replace(/\\\\/g, '\\');
		}

		try {
			// Replace server-side written pluses with spaces.
			// If we can't decode the cookie, ignore it, it's unusable.
			// If we can't parse the cookie, ignore it, it's unusable.
			s = decodeURIComponent(s.replace(pluses, ' '));
			return config.json ? JSON.parse(s) : s;
		} catch(e) {}
	}

	function read(s, converter) {
		var value = config.raw ? s : parseCookieValue(s);
		return $.isFunction(converter) ? converter(value) : value;
	}

	var config = $.cookie = function (key, value, options) {

		// Write

		if (value !== undefined && !$.isFunction(value)) {
			options = $.extend({}, config.defaults, options);

			if (typeof options.expires === 'number') {
				var days = options.expires, t = options.expires = new Date();
				t.setTime(+t + days * 864e+5);
			}

			return (document.cookie = [
				encode(key), '=', stringifyCookieValue(value),
				options.expires ? '; expires=' + options.expires.toUTCString() : '', // use expires attribute, max-age is not supported by IE
				options.path    ? '; path=' + options.path : '',
				options.domain  ? '; domain=' + options.domain : '',
				options.secure  ? '; secure' : ''
			].join(''));
		}

		// Read

		var result = key ? undefined : {};

		// To prevent the for loop in the first place assign an empty array
		// in case there are no cookies at all. Also prevents odd result when
		// calling $.cookie().
		var cookies = document.cookie ? document.cookie.split('; ') : [];

		for (var i = 0, l = cookies.length; i < l; i++) {
			var parts = cookies[i].split('=');
			var name = decode(parts.shift());
			var cookie = parts.join('=');

			if (key && key === name) {
				// If second argument (value) is a function it's a converter...
				result = read(cookie, value);
				break;
			}

			// Prevent storing a cookie that we couldn't decode.
			if (!key && (cookie = read(cookie)) !== undefined) {
				result[name] = cookie;
			}
		}

		return result;
	};

	config.defaults = {};

	$.removeCookie = function (key, options) {
		if ($.cookie(key) === undefined) {
			return false;
		}

		// Must not alter options, thus extending a fresh object...
		$.cookie(key, '', $.extend({}, options, { expires: -1 }));
		return !$.cookie(key);
	};
    
})(jq111);
/*! Copyright (c) 2013 Brandon Aaron (http://brandon.aaron.sh)
 * Licensed under the MIT License (LICENSE.txt).
 *
 * Version: 3.1.11
 *
 * Requires: jQuery 1.2.2+
 */

(function (factory) {
    if ( typeof define === 'function' && define.amd ) {
        // AMD. Register as an anonymous module.
        define(['jquery'], factory);
    } else if (typeof exports === 'object') {
        // Node/CommonJS style for Browserify
        module.exports = factory;
    } else {
        // Browser globals
        factory(jq111);
    }
}(function ($) {

    var toFix  = ['wheel', 'mousewheel', 'DOMMouseScroll', 'MozMousePixelScroll'],
        toBind = ( 'onwheel' in document || document.documentMode >= 9 ) ?
                    ['wheel'] : ['mousewheel', 'DomMouseScroll', 'MozMousePixelScroll'],
        slice  = Array.prototype.slice,
        nullLowestDeltaTimeout, lowestDelta;

    if ( $.event.fixHooks ) {
        for ( var i = toFix.length; i; ) {
            $.event.fixHooks[ toFix[--i] ] = $.event.mouseHooks;
        }
    }

    var special = $.event.special.mousewheel = {
        version: '3.1.11',

        setup: function() {
            if ( this.addEventListener ) {
                for ( var i = toBind.length; i; ) {
                    this.addEventListener( toBind[--i], handler, false );
                }
            } else {
                this.onmousewheel = handler;
            }
            // Store the line height and page height for this particular element
            $.data(this, 'mousewheel-line-height', special.getLineHeight(this));
            $.data(this, 'mousewheel-page-height', special.getPageHeight(this));
        },

        teardown: function() {
            if ( this.removeEventListener ) {
                for ( var i = toBind.length; i; ) {
                    this.removeEventListener( toBind[--i], handler, false );
                }
            } else {
                this.onmousewheel = null;
            }
            // Clean up the data we added to the element
            $.removeData(this, 'mousewheel-line-height');
            $.removeData(this, 'mousewheel-page-height');
        },

        getLineHeight: function(elem) {
            var $parent = $(elem)['offsetParent' in $.fn ? 'offsetParent' : 'parent']();
            if (!$parent.length) {
                $parent = $('body');
            }
            return parseInt($parent.css('fontSize'), 10);
        },

        getPageHeight: function(elem) {
            return $(elem).height();
        },

        settings: {
            adjustOldDeltas: true, // see shouldAdjustOldDeltas() below
            normalizeOffset: true  // calls getBoundingClientRect for each event
        }
    };

    $.fn.extend({
        mousewheel: function(fn) {
            return fn ? this.bind('mousewheel', fn) : this.trigger('mousewheel');
        },

        unmousewheel: function(fn) {
            return this.unbind('mousewheel', fn);
        }
    });


    function handler(event) {
        var orgEvent   = event || window.event,
            args       = slice.call(arguments, 1),
            delta      = 0,
            deltaX     = 0,
            deltaY     = 0,
            absDelta   = 0,
            offsetX    = 0,
            offsetY    = 0;
        event = $.event.fix(orgEvent);
        event.type = 'mousewheel';

        // Old school scrollwheel delta
        if ( 'detail'      in orgEvent ) { deltaY = orgEvent.detail * -1;      }
        if ( 'wheelDelta'  in orgEvent ) { deltaY = orgEvent.wheelDelta;       }
        if ( 'wheelDeltaY' in orgEvent ) { deltaY = orgEvent.wheelDeltaY;      }
        if ( 'wheelDeltaX' in orgEvent ) { deltaX = orgEvent.wheelDeltaX * -1; }

        // Firefox < 17 horizontal scrolling related to DOMMouseScroll event
        if ( 'axis' in orgEvent && orgEvent.axis === orgEvent.HORIZONTAL_AXIS ) {
            deltaX = deltaY * -1;
            deltaY = 0;
        }

        // Set delta to be deltaY or deltaX if deltaY is 0 for backwards compatabilitiy
        delta = deltaY === 0 ? deltaX : deltaY;

        // New school wheel delta (wheel event)
        if ( 'deltaY' in orgEvent ) {
            deltaY = orgEvent.deltaY * -1;
            delta  = deltaY;
        }
        if ( 'deltaX' in orgEvent ) {
            deltaX = orgEvent.deltaX;
            if ( deltaY === 0 ) { delta  = deltaX * -1; }
        }

        // No change actually happened, no reason to go any further
        if ( deltaY === 0 && deltaX === 0 ) { return; }

        // Need to convert lines and pages to pixels if we aren't already in pixels
        // There are three delta modes:
        //   * deltaMode 0 is by pixels, nothing to do
        //   * deltaMode 1 is by lines
        //   * deltaMode 2 is by pages
        if ( orgEvent.deltaMode === 1 ) {
            var lineHeight = $.data(this, 'mousewheel-line-height');
            delta  *= lineHeight;
            deltaY *= lineHeight;
            deltaX *= lineHeight;
        } else if ( orgEvent.deltaMode === 2 ) {
            var pageHeight = $.data(this, 'mousewheel-page-height');
            delta  *= pageHeight;
            deltaY *= pageHeight;
            deltaX *= pageHeight;
        }

        // Store lowest absolute delta to normalize the delta values
        absDelta = Math.max( Math.abs(deltaY), Math.abs(deltaX) );

        if ( !lowestDelta || absDelta < lowestDelta ) {
            lowestDelta = absDelta;

            // Adjust older deltas if necessary
            if ( shouldAdjustOldDeltas(orgEvent, absDelta) ) {
                lowestDelta /= 40;
            }
        }

        // Adjust older deltas if necessary
        if ( shouldAdjustOldDeltas(orgEvent, absDelta) ) {
            // Divide all the things by 40!
            delta  /= 40;
            deltaX /= 40;
            deltaY /= 40;
        }

        // Get a whole, normalized value for the deltas
        delta  = Math[ delta  >= 1 ? 'floor' : 'ceil' ](delta  / lowestDelta);
        deltaX = Math[ deltaX >= 1 ? 'floor' : 'ceil' ](deltaX / lowestDelta);
        deltaY = Math[ deltaY >= 1 ? 'floor' : 'ceil' ](deltaY / lowestDelta);

        // Normalise offsetX and offsetY properties
        if ( special.settings.normalizeOffset && this.getBoundingClientRect ) {
            var boundingRect = this.getBoundingClientRect();
            offsetX = event.clientX - boundingRect.left;
            offsetY = event.clientY - boundingRect.top;
        }

        // Add information to the event object
        event.deltaX = deltaX;
        event.deltaY = deltaY;
        event.deltaFactor = lowestDelta;
        event.offsetX = offsetX;
        event.offsetY = offsetY;
        // Go ahead and set deltaMode to 0 since we converted to pixels
        // Although this is a little odd since we overwrite the deltaX/Y
        // properties with normalized deltas.
        event.deltaMode = 0;

        // Add event and delta to the front of the arguments
        args.unshift(event, delta, deltaX, deltaY);

        // Clearout lowestDelta after sometime to better
        // handle multiple device types that give different
        // a different lowestDelta
        // Ex: trackpad = 3 and mouse wheel = 120
        if (nullLowestDeltaTimeout) { clearTimeout(nullLowestDeltaTimeout); }
        nullLowestDeltaTimeout = setTimeout(nullLowestDelta, 200);

        return ($.event.dispatch || $.event.handle).apply(this, args);
    }

    function nullLowestDelta() {
        lowestDelta = null;
    }

    function shouldAdjustOldDeltas(orgEvent, absDelta) {
        // If this is an older event and the delta is divisable by 120,
        // then we are assuming that the browser is treating this as an
        // older mouse wheel event and that we should divide the deltas
        // by 40 to try and get a more usable deltaFactor.
        // Side note, this actually impacts the reported scroll distance
        // in older browsers and can cause scrolling to be slower than native.
        // Turn this off by setting $.event.special.mousewheel.settings.adjustOldDeltas to false.
        return special.settings.adjustOldDeltas && orgEvent.type === 'mousewheel' && absDelta % 120 === 0;
    }

}));

/*
== malihu jquery custom scrollbar plugin ==
Version: 3.0.2
Plugin URI: http://manos.malihu.gr/jquery-custom-content-scroller
Author: malihu
Author URI: http://manos.malihu.gr
License: MIT License (MIT)
*/

/*
Copyright 2010 Manos Malihutsakis (email: manos@malihu.gr)

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE.
*/

/*
The code below is fairly long, fully commented and should be normally used in development.
For production, use either the minified jquery.mCustomScrollbar.min.js script or
the production-ready jquery.mCustomScrollbar.concat.min.js which contains the plugin
and dependencies (minified).
*/

+function($,window,document,undefined){

	/*
	----------------------------------------
	PLUGIN NAMESPACE, PREFIX, DEFAULT SELECTOR(S)
	----------------------------------------
	*/

	var pluginNS="mCustomScrollbar",
		pluginPfx="mCS",
		defaultSelector=".mCustomScrollbar",





	/*
	----------------------------------------
	DEFAULT OPTIONS
	----------------------------------------
	*/

		defaults={
			/*
			set element/content width programmatically
			values: boolean, pixels, percentage
			*/
			setWidth:false,
			/*
			set element/content height programmatically
			values: boolean, pixels, percentage
			*/
			setHeight:false,
			/*
			set the initial css top property of content
			values: string (e.g. "-100px", "10%" etc.)
			*/
			setTop:0,
			/*
			set the initial css left property of content
			values: string (e.g. "-100px", "10%" etc.)
			*/
			setLeft:0,
			/*
			scrollbar axis (vertical and/or horizontal scrollbars)
			values (string): "y", "x", "yx"
			*/
			axis:"y",
			/*
			position of scrollbar relative to content
			values (string): "inside", "outside" ("outside" requires elements with position:relative)
			*/
			scrollbarPosition:"inside",
			/*
			scrolling inertia
			values: integer (milliseconds)
			*/
			scrollInertia:950,
			/*
			auto-adjust scrollbar dragger length
			values: boolean
			*/
			autoDraggerLength:true,
			/*
			auto-hide scrollbar when idle
			values: boolean
			*/
			autoHideScrollbar:false,
			/*
			auto-expands scrollbar on mouse-over and dragging
			*/
			autoExpandScrollbar:false,
			/*
			always show scrollbar, even when there's nothing to scroll
			values: integer (0=disable, 1=always show dragger rail, 2=always show dragger rail, dragger and buttons), boolean
			*/
			alwaysShowScrollbar:0,
			/*
			scrolling always snaps to a multiple of this number in pixels
			values: integer
			*/
			snapAmount:null,
			/*
			when snapping, snap with this number in pixels as an offset
			values: integer
			*/
			snapOffset:0,
			/*
			mouse-wheel scrolling
			*/
			mouseWheel:{
				/*
				enable mouse-wheel scrolling
				values: boolean
				*/
				enable:true,
				/*
				scrolling amount in pixels
				values: "auto", integer
				*/
				scrollAmount:"auto",
				/*
				mouse-wheel scrolling axis
				the default scrolling direction when both vertical and horizontal scrollbars are present
				values (string): "y", "x"
				*/
				axis:"y",
				/*
				prevent the default behaviour which automatically scrolls the parent element(s)
				when end of scrolling is reached
				values: boolean
				*/
				preventDefault:false,
				/*
				the reported mouse-wheel delta value. The number of lines (translated to pixels) one wheel notch scrolls.
				values: "auto", integer
				"auto" uses the default OS/browser value
				*/
				deltaFactor:"auto",
				/*
				normalize mouse-wheel delta to -1 or 1 (disables mouse-wheel acceleration)
				values: boolean
				*/
				normalizeDelta:false,
				/*
				invert mouse-wheel scrolling direction
				values: boolean
				*/
				invert:false,
				/*
				the tags that disable mouse-wheel when cursor is over them
				*/
				disableOver:["select","option","keygen","datalist","textarea"]
			},
			/*
			scrollbar buttons
			*/
			scrollButtons:{
				/*
				enable scrollbar buttons
				values: boolean
				*/
				enable:false,
				/*
				scrollbar buttons scrolling type
				values (string): "stepless", "stepped"
				*/
				scrollType:"stepless",
				/*
				scrolling amount in pixels
				values: "auto", integer
				*/
				scrollAmount:"auto"
			},
			/*
			keyboard scrolling
			*/
			keyboard:{
				/*
				enable scrolling via keyboard
				values: boolean
				*/
				enable:true,
				/*
				keyboard scrolling type
				values (string): "stepless", "stepped"
				*/
				scrollType:"stepless",
				/*
				scrolling amount in pixels
				values: "auto", integer
				*/
				scrollAmount:"auto"
			},
			/*
			enable content touch-swipe scrolling
			values: boolean, integer, string (number)
			integer values define the axis-specific minimum amount required for scrolling momentum
			*/
			contentTouchScroll:25,
			/*
			advanced option parameters
			*/
			advanced:{
				/*
				auto-expand content horizontally (for "x" or "yx" axis)
				values: boolean
				*/
				autoExpandHorizontalScroll:false,
				/*
				auto-scroll to elements with focus
				*/
				autoScrollOnFocus:"input,textarea,select,button,datalist,keygen,a[tabindex],area,object,[contenteditable='true']",
				/*
				auto-update scrollbars on content, element or viewport resize
				should be true for fluid layouts/elements, adding/removing content dynamically, hiding/showing elements, content with images etc.
				values: boolean
				*/
				updateOnContentResize:true,
				/*
				auto-update scrollbars each time each image inside the element is fully loaded
				values: boolean
				*/
				updateOnImageLoad:true,
				/*
				auto-update scrollbars based on the amount and size changes of specific selectors
				useful when you need to update the scrollbar(s) automatically, each time a type of element is added, removed or changes its size
				values: boolean, string (e.g. "ul li" will auto-update scrollbars each time list-items inside the element are changed)
				a value of true (boolean) will auto-update scrollbars each time any element is changed
				*/
				updateOnSelectorChange:false
			},
			/*
			scrollbar theme
			values: string
			ready-to-use themes: "light", "dark", "light-2", "dark-2", "light-3", "dark-3", "light-thick", "dark-thick", "light-thin", "dark-thin",
			"rounded", "rounded-dark", "rounded-dots", "rounded-dots-dark", "3d", "3d-dark", "3d-thick", "3d-thick-dark", "minimal", "minimal-dark",
			"inset", "inset-dark", "inset-2", "inset-2-dark", "inset-3", "inset-3-dark"
			*/
			theme:"light",
			/*
			user defined callback functions
			*/
			callbacks:{
				/*
				function to call when a scroll event starts
				values (function): function(){}
				*/
				onScrollStart:false,
				/*
				function to call when a scroll event is complete
				values (function): function(){}
				*/
				onScroll:false,
				/*
				function to call when a scroll event is complete and content is scrolled all the way to the end (bottom/right)
				values (function): function(){}
				*/
				onTotalScroll:false,
				/*
				function to call when a scroll event is complete and content is scrolled back to the beginning (top/left)
				values (function): function(){}
				*/
				onTotalScrollBack:false,
				/*
				function to call when a scroll event is running
				values (function): function(){}
				*/
				whileScrolling:false,
				/*
				onTotalScroll offset value
				values: integer (pixels)
				*/
				onTotalScrollOffset:0,
				/*
				onTotalScrollBack offset value
				values: integer (pixels)
				*/
				onTotalScrollBackOffset:0,
				/*
				callback offsets will trigger even if content is already scrolled to the end or beginning
				values: boolean
				*/
				alwaysTriggerOffsets:true
			},
			/*
			add scrollbar(s) on all elements matching the current selector, now and in the future
			values: boolean, string
			string values: "on" (enable), "once" (disable after first invocation), "off" (disable)
			*/
			live:false,
			/*
			the matching set of elements (instead of the current selector) to add scrollbar(s), now and in the future
			values: string (selector)
			*/
			liveSelector:null
		},





	/*
	----------------------------------------
	VARS, CONSTANTS
	----------------------------------------
	*/

		totalInstances=0, /* plugin instances amount */
		liveTimers={}, /* live option timers */
		/* live option timers removal */
		removeLiveTimers=function(selector){
			if(liveTimers[selector]){
				clearTimeout(liveTimers[selector]);
				functions._delete.call(null,liveTimers[selector]);
			}
		},
		oldIE=(window.attachEvent && !window.addEventListener) ? 1 : 0, /* detect IE < 9 */
		touchActive=false, /* global touch state (for touch and pointer events) */





	/*
	----------------------------------------
	METHODS
	----------------------------------------
	*/

		methods={

			/*
			plugin initialization method
			creates the scrollbar(s), plugin data object and options
			----------------------------------------
			*/

			init:function(options){

				var options=$.extend(true,{},defaults,options),
					selector=functions._selector.call(this); /* validate selector */

				/*
				if live option is enabled, monitor for elements matching the current selector and
				apply scrollbar(s) when found (now and in the future)
				*/
				if(options.live){
					var liveSelector=options.liveSelector || this.selector || defaultSelector, /* live selector(s) */
						$liveSelector=$(liveSelector); /* live selector(s) as jquery object */
					if(options.live==="off"){
						/*
						disable live if requested
						usage: $(selector).mCustomScrollbar({live:"off"});
						*/
						removeLiveTimers(liveSelector);
						return;
					}
					liveTimers[liveSelector]=setTimeout(function(){
						/* call mCustomScrollbar fn on live selector(s) every half-second */
						$liveSelector.mCustomScrollbar(options);
						if(options.live==="once" && $liveSelector.length){
							/* disable live after first invocation */
							removeLiveTimers(liveSelector);
						}
					},500);
				}else{
					removeLiveTimers(liveSelector);
				}

				/* options backward compatibility (for versions < 3.0.0) and normalization */
				options.setWidth=(options.set_width) ? options.set_width : options.setWidth;
				options.setHeight=(options.set_height) ? options.set_height : options.setHeight;
				options.axis=(options.horizontalScroll) ? "x" : functions._findAxis.call(null,options.axis);
				options.scrollInertia=options.scrollInertia<17 ? 17 : options.scrollInertia;
				if(typeof options.mouseWheel!=="object" &&  options.mouseWheel==true){ /* old school mouseWheel option (non-object) */
					options.mouseWheel={enable:true,scrollAmount:"auto",axis:"y",preventDefault:false,deltaFactor:"auto",normalizeDelta:false,invert:false}
				}
				options.mouseWheel.scrollAmount=!options.mouseWheelPixels ? options.mouseWheel.scrollAmount : options.mouseWheelPixels;
				options.mouseWheel.normalizeDelta=!options.advanced.normalizeMouseWheelDelta ? options.mouseWheel.normalizeDelta : options.advanced.normalizeMouseWheelDelta;
				options.scrollButtons.scrollType=functions._findScrollButtonsType.call(null,options.scrollButtons.scrollType);

				functions._theme.call(null,options); /* theme-specific options */

				/* plugin constructor */
				return $(selector).each(function(){

					var $this=$(this);

					if(!$this.data(pluginPfx)){ /* prevent multiple instantiations */

						/* store options and create objects in jquery data */
						$this.data(pluginPfx,{
							idx:++totalInstances, /* instance index */
							opt:options, /* options */
							scrollRatio:{y:null,x:null}, /* scrollbar to content ratio */
							overflowed:null, /* overflowed axis */
							bindEvents:false, /* object to check if events are bound */
							tweenRunning:false, /* object to check if tween is running */
							sequential:{}, /* sequential scrolling object */
							langDir:$this.css("direction"), /* detect/store direction (ltr or rtl) */
							cbOffsets:null, /* object to check whether callback offsets always trigger */
							/*
							object to check how scrolling events where last triggered
							"internal" (default - triggered by this script), "external" (triggered by other scripts, e.g. via scrollTo method)
							usage: object.data("mCS").trigger
							*/
							trigger:null
						});

						/* HTML data attributes */
						var o=$this.data(pluginPfx).opt,
							htmlDataAxis=$this.data("mcs-axis"),htmlDataSbPos=$this.data("mcs-scrollbar-position"),htmlDataTheme=$this.data("mcs-theme");
						if(htmlDataAxis){o.axis=htmlDataAxis;} /* usage example: data-mcs-axis="y" */
						if(htmlDataSbPos){o.scrollbarPosition=htmlDataSbPos;} /* usage example: data-mcs-scrollbar-position="outside" */
						if(htmlDataTheme){ /* usage example: data-mcs-theme="minimal" */
							o.theme=htmlDataTheme;
							functions._theme.call(null,o); /* theme-specific options */
						}

						functions._pluginMarkup.call(this); /* add plugin markup */

						methods.update.call(null,$this); /* call the update method */

					}

				});

			},
			/* ---------------------------------------- */



			/*
			plugin update method
			updates content and scrollbar(s) values, events and status
			----------------------------------------
			usage: $(selector).mCustomScrollbar("update");
			*/

			update:function(el){

				var selector=el || functions._selector.call(this); /* validate selector */

				return $(selector).each(function(){

					var $this=$(this);

					if($this.data(pluginPfx)){ /* check if plugin has initialized */

						var d=$this.data(pluginPfx),o=d.opt,
							mCSB_container=$("#mCSB_"+d.idx+"_container"),
							mCSB_dragger=[$("#mCSB_"+d.idx+"_dragger_vertical"),$("#mCSB_"+d.idx+"_dragger_horizontal")];

						if(!mCSB_container.length){return;}

						if(d.tweenRunning){functions._stop.call(null,$this);} /* stop any running tweens while updating */

						/* if element was disabled or destroyed, remove class(es) */
						if($this.hasClass("mCS_disabled")){$this.removeClass("mCS_disabled");}
						if($this.hasClass("mCS_destroyed")){$this.removeClass("mCS_destroyed");}

						functions._maxHeight.call(this); /* detect/set css max-height value */

						functions._expandContentHorizontally.call(this); /* expand content horizontally */

						if(o.axis!=="y" && !o.advanced.autoExpandHorizontalScroll){
							mCSB_container.css("width",functions._contentWidth(mCSB_container.children()));
						}

						d.overflowed=functions._overflowed.call(this); /* determine if scrolling is required */

						functions._scrollbarVisibility.call(this); /* show/hide scrollbar(s) */

						/* auto-adjust scrollbar dragger length analogous to content */
						if(o.autoDraggerLength){functions._setDraggerLength.call(this);}

						functions._scrollRatio.call(this); /* calculate and store scrollbar to content ratio */

						functions._bindEvents.call(this); /* bind scrollbar events */

						/* reset scrolling position and/or events */
						var to=[Math.abs(mCSB_container[0].offsetTop),Math.abs(mCSB_container[0].offsetLeft)];
						if(o.axis!=="x"){ /* y/yx axis */
							if(!d.overflowed[0]){ /* y scrolling is not required */
								functions._resetContentPosition.call(this); /* reset content position */
								if(o.axis==="y"){
									functions._unbindEvents.call(this);
								}else if(o.axis==="yx" && d.overflowed[1]){
									functions._scrollTo.call(this,$this,to[1].toString(),{dir:"x",dur:0,overwrite:"none"});
								}
							}else if(mCSB_dragger[0].height()>mCSB_dragger[0].parent().height()){
								functions._resetContentPosition.call(this); /* reset content position */
							}else{ /* y scrolling is required */
								functions._scrollTo.call(this,$this,to[0].toString(),{dir:"y",dur:0,overwrite:"none"});
							}
						}
						if(o.axis!=="y"){ /* x/yx axis */
							if(!d.overflowed[1]){ /* x scrolling is not required */
								functions._resetContentPosition.call(this); /* reset content position */
								if(o.axis==="x"){
									functions._unbindEvents.call(this);
								}else if(o.axis==="yx" && d.overflowed[0]){
									functions._scrollTo.call(this,$this,to[0].toString(),{dir:"y",dur:0,overwrite:"none"});
								}
							}else if(mCSB_dragger[1].width()>mCSB_dragger[1].parent().width()){
								functions._resetContentPosition.call(this); /* reset content position */
							}else{ /* x scrolling is required */
								functions._scrollTo.call(this,$this,to[1].toString(),{dir:"x",dur:0,overwrite:"none"});
							}
						}

						functions._autoUpdate.call(this); /* initialize automatic updating (for dynamic content, fluid layouts etc.) */

					}

				});

			},
			/* ---------------------------------------- */



			/*
			plugin scrollTo method
			triggers a scrolling event to a specific value
			----------------------------------------
			usage: $(selector).mCustomScrollbar("scrollTo",value,options);
			*/

			scrollTo:function(val,options){

				/* prevent silly things like $(selector).mCustomScrollbar("scrollTo",undefined); */
				if(typeof val=="undefined" || val==null){return;}

				var selector=functions._selector.call(this); /* validate selector */

				return $(selector).each(function(){

					var $this=$(this);

					if($this.data(pluginPfx)){ /* check if plugin has initialized */

						var d=$this.data(pluginPfx),o=d.opt,
							/* method default options */
							methodDefaults={
								trigger:"external", /* method is by default triggered externally (e.g. from other scripts) */
								scrollInertia:o.scrollInertia, /* scrolling inertia (animation duration) */
								scrollEasing:"mcsEaseInOut", /* animation easing */
								moveDragger:false, /* move dragger instead of content */
								callbacks:true, /* enable/disable callbacks */
								onStart:true,
								onUpdate:true,
								onComplete:true
							},
							methodOptions=$.extend(true,{},methodDefaults,options),
							to=functions._arr.call(this,val),dur=methodOptions.scrollInertia < 17 ? 17 : methodOptions.scrollInertia;

						/* translate yx values to actual scroll-to positions */
						to[0]=functions._to.call(this,to[0],"y");
						to[1]=functions._to.call(this,to[1],"x");

						/*
						check if scroll-to value moves the dragger instead of content.
						Only pixel values apply on dragger (e.g. 100, "100px", "-=100" etc.)
						*/
						if(methodOptions.moveDragger){
							to[0]*=d.scrollRatio.y;
							to[1]*=d.scrollRatio.x;
						}

						methodOptions.dur=dur;

						setTimeout(function(){
							/* do the scrolling */
							if(to[0]!==null && typeof to[0]!=="undefined" && o.axis!=="x" && d.overflowed[0]){ /* scroll y */
								methodOptions.dir="y";
								methodOptions.overwrite="all";
								functions._scrollTo.call(this,$this,to[0].toString(),methodOptions);
							}
							if(to[1]!==null && typeof to[1]!=="undefined" && o.axis!=="y" && d.overflowed[1]){ /* scroll x */
								methodOptions.dir="x";
								methodOptions.overwrite="none";
								functions._scrollTo.call(this,$this,to[1].toString(),methodOptions);
							}
						},60);

					}

				});

			},
			/* ---------------------------------------- */



			/*
			plugin stop method
			stops scrolling animation
			----------------------------------------
			usage: $(selector).mCustomScrollbar("stop");
			*/
			stop:function(){

				var selector=functions._selector.call(this); /* validate selector */

				return $(selector).each(function(){

					var $this=$(this);

					if($this.data(pluginPfx)){ /* check if plugin has initialized */

						functions._stop.call(null,$this);

					}

				});

			},
			/* ---------------------------------------- */



			/*
			plugin disable method
			temporarily disables the scrollbar(s)
			----------------------------------------
			usage: $(selector).mCustomScrollbar("disable",reset);
			reset (boolean): resets content position to 0
			*/
			disable:function(r){

				var selector=functions._selector.call(this); /* validate selector */

				return $(selector).each(function(){

					var $this=$(this);

					if($this.data(pluginPfx)){ /* check if plugin has initialized */

						var d=$this.data(pluginPfx),o=d.opt;

						functions._autoUpdate.call(this,"remove"); /* remove automatic updating */

						functions._unbindEvents.call(this); /* unbind events */

						if(r){functions._resetContentPosition.call(this);} /* reset content position */

						functions._scrollbarVisibility.call(this,true); /* show/hide scrollbar(s) */

						$this.addClass("mCS_disabled"); /* add disable class */

					}

				});

			},
			/* ---------------------------------------- */



			/*
			plugin destroy method
			completely removes the scrollbar(s) and returns the element to its original state
			----------------------------------------
			usage: $(selector).mCustomScrollbar("destroy");
			*/
			destroy:function(){

				var selector=functions._selector.call(this); /* validate selector */

				return $(selector).each(function(){

					var $this=$(this);

					if($this.data(pluginPfx)){ /* check if plugin has initialized */

						var d=$this.data(pluginPfx),o=d.opt,
							mCustomScrollBox=$("#mCSB_"+d.idx),
							mCSB_container=$("#mCSB_"+d.idx+"_container"),
							scrollbar=$(".mCSB_"+d.idx+"_scrollbar");

						if(o.live){removeLiveTimers(selector);} /* remove live timer */

						functions._autoUpdate.call(this,"remove"); /* remove automatic updating */

						functions._unbindEvents.call(this); /* unbind events */

						functions._resetContentPosition.call(this); /* reset content position */

						$this.removeData(pluginPfx); /* remove plugin data object */

						functions._delete.call(null,this.mcs); /* delete callbacks object */

						/* remove plugin markup */
						scrollbar.remove(); /* remove scrollbar(s) first (those can be either inside or outside plugin's inner wrapper) */
						mCustomScrollBox.replaceWith(mCSB_container.contents()); /* replace plugin's inner wrapper with the original content */
						/* remove plugin classes from the element and add destroy class */
						$this.removeClass(pluginNS+" _"+pluginPfx+"_"+d.idx+" mCS-autoHide mCS-dir-rtl mCS_no_scrollbar mCS_disabled").addClass("mCS_destroyed");

					}

				});

			}
			/* ---------------------------------------- */

		},





	/*
	----------------------------------------
	FUNCTIONS
	----------------------------------------
	*/

		functions={

			/* validates selector (if selector is invalid or undefined uses the default one) */
			_selector:function(){
				return (typeof $(this)!=="object" || $(this).length<1) ? defaultSelector : this;
			},
			/* -------------------- */

			/* changes options according to theme */
			_theme:function(obj){
				var fixedSizeScrollbarThemes=["rounded","rounded-dark","rounded-dots","rounded-dots-dark"],
					nonExpandedScrollbarThemes=["rounded-dots","rounded-dots-dark","3d","3d-dark","3d-thick","3d-thick-dark","inset","inset-dark","inset-2","inset-2-dark","inset-3","inset-3-dark"],
					disabledScrollButtonsThemes=["minimal","minimal-dark"],
					enabledAutoHideScrollbarThemes=["minimal","minimal-dark"],
					scrollbarPositionOutsideThemes=["minimal","minimal-dark"];
				obj.autoDraggerLength=$.inArray(obj.theme,fixedSizeScrollbarThemes) > -1 ? false : obj.autoDraggerLength;
				obj.autoExpandScrollbar=$.inArray(obj.theme,nonExpandedScrollbarThemes) > -1 ? false : obj.autoExpandScrollbar;
				obj.scrollButtons.enable=$.inArray(obj.theme,disabledScrollButtonsThemes) > -1 ? false : obj.scrollButtons.enable;
				obj.autoHideScrollbar=$.inArray(obj.theme,enabledAutoHideScrollbarThemes) > -1 ? true : obj.autoHideScrollbar;
				obj.scrollbarPosition=$.inArray(obj.theme,scrollbarPositionOutsideThemes) > -1 ? "outside" : obj.scrollbarPosition;
			},
			/* -------------------- */


			/* normalizes axis option to valid values: "y", "x", "yx" */
			_findAxis:function(val){
				return (val==="yx" || val==="xy" || val==="auto") ? "yx" : (val==="x" || val==="horizontal") ? "x" : "y";
			},
			/* -------------------- */


			/* normalizes scrollButtons.scrollType option to valid values: "stepless", "stepped" */
			_findScrollButtonsType:function(val){
				return (val==="stepped" || val==="pixels" || val==="step" || val==="click") ? "stepped" : "stepless";
			},
			/* -------------------- */


			/* generates plugin markup */
			_pluginMarkup:function(){
				var $this=$(this),d=$this.data(pluginPfx),o=d.opt,
					expandClass=o.autoExpandScrollbar ? " mCSB_scrollTools_onDrag_expand" : "",
					scrollbar=["<div id='mCSB_"+d.idx+"_scrollbar_vertical' class='mCSB_scrollTools mCSB_"+d.idx+"_scrollbar mCS-"+o.theme+" mCSB_scrollTools_vertical"+expandClass+"'><div class='mCSB_draggerContainer'><div id='mCSB_"+d.idx+"_dragger_vertical' class='mCSB_dragger' style='position:absolute;' oncontextmenu='return false;'><div class='mCSB_dragger_bar' /></div><div class='mCSB_draggerRail' /></div></div>","<div id='mCSB_"+d.idx+"_scrollbar_horizontal' class='mCSB_scrollTools mCSB_"+d.idx+"_scrollbar mCS-"+o.theme+" mCSB_scrollTools_horizontal"+expandClass+"'><div class='mCSB_draggerContainer'><div id='mCSB_"+d.idx+"_dragger_horizontal' class='mCSB_dragger' style='position:absolute;' oncontextmenu='return false;'><div class='mCSB_dragger_bar' /></div><div class='mCSB_draggerRail' /></div></div>"],
					wrapperClass=o.axis==="yx" ? "mCSB_vertical_horizontal" : o.axis==="x" ? "mCSB_horizontal" : "mCSB_vertical",
					scrollbars=o.axis==="yx" ? scrollbar[0]+scrollbar[1] : o.axis==="x" ? scrollbar[1] : scrollbar[0],
					contentWrapper=o.axis==="yx" ? "<div id='mCSB_"+d.idx+"_container_wrapper' class='mCSB_container_wrapper' />" : "",
					autoHideClass=o.autoHideScrollbar ? " mCS-autoHide" : "",
					scrollbarDirClass=(o.axis!=="x" && d.langDir==="rtl") ? " mCS-dir-rtl" : "";
				if(o.setWidth){$this.css("width",o.setWidth);} /* set element width */
				if(o.setHeight){$this.css("height",o.setHeight);} /* set element height */
				o.setLeft=(o.axis!=="y" && d.langDir==="rtl") ? "989999px" : o.setLeft; /* adjust left position for rtl direction */
				$this.addClass(pluginNS+" _"+pluginPfx+"_"+d.idx+autoHideClass+scrollbarDirClass).wrapInner("<div id='mCSB_"+d.idx+"' class='mCustomScrollBox mCS-"+o.theme+" "+wrapperClass+"'><div id='mCSB_"+d.idx+"_container' class='mCSB_container' style='position:relative; top:"+o.setTop+"; left:"+o.setLeft+";' dir="+d.langDir+" /></div>");
				var mCustomScrollBox=$("#mCSB_"+d.idx),
					mCSB_container=$("#mCSB_"+d.idx+"_container");
				if(o.axis!=="y" && !o.advanced.autoExpandHorizontalScroll){
					mCSB_container.css("width",functions._contentWidth(mCSB_container.children()));
				}
				if(o.scrollbarPosition==="outside"){
					if($this.css("position")==="static"){ /* requires elements with non-static position */
						$this.css("position","relative");
					}
					$this.css("overflow","visible");
					mCustomScrollBox.addClass("mCSB_outside").after(scrollbars);
				}else{
					mCustomScrollBox.addClass("mCSB_inside").append(scrollbars);
					mCSB_container.wrap(contentWrapper);
				}
				functions._scrollButtons.call(this); /* add scrollbar buttons */
				/* minimum dragger length */
				var mCSB_dragger=[$("#mCSB_"+d.idx+"_dragger_vertical"),$("#mCSB_"+d.idx+"_dragger_horizontal")];
				mCSB_dragger[0].css("min-height",mCSB_dragger[0].height());
				mCSB_dragger[1].css("min-width",mCSB_dragger[1].width());
			},
			/* -------------------- */


			/* calculates content width */
			_contentWidth:function(el){
				return Math.max.apply(Math,el.map(function(){return $(this).outerWidth(true);}).get());
			},
			/* -------------------- */


			/* expands content horizontally */
			_expandContentHorizontally:function(){
				var $this=$(this),d=$this.data(pluginPfx),o=d.opt,
					mCSB_container=$("#mCSB_"+d.idx+"_container");
				if(o.advanced.autoExpandHorizontalScroll && o.axis!=="y"){
					/*
					wrap content with an infinite width div and set its position to absolute and width to auto.
					Setting width to auto before calculating the actual width is important!
					We must let the browser set the width as browser zoom values are impossible to calculate.
					*/
					mCSB_container.css({"position":"absolute","width":"auto"})
						.wrap("<div class='mCSB_h_wrapper' style='position:relative; left:0; width:999999px;' />")
						.css({ /* set actual width, original position and un-wrap */
							/*
							get the exact width (with decimals) and then round-up.
							Using jquery outerWidth() will round the width value which will mess up with inner elements that have non-integer width
							*/
							"width":(Math.ceil(mCSB_container[0].getBoundingClientRect().right+0.4)-Math.floor(mCSB_container[0].getBoundingClientRect().left)),
							"position":"relative"
						}).unwrap();
				}
			},
			/* -------------------- */


			/* adds scrollbar buttons */
			_scrollButtons:function(){
				var $this=$(this),d=$this.data(pluginPfx),o=d.opt,
					mCSB_scrollTools=$(".mCSB_"+d.idx+"_scrollbar:first"),
					btnHTML=[
						"<a href='#' class='mCSB_buttonUp' oncontextmenu='return false;' />","<a href='#' class='mCSB_buttonDown' oncontextmenu='return false;' />",
						"<a href='#' class='mCSB_buttonLeft' oncontextmenu='return false;' />","<a href='#' class='mCSB_buttonRight' oncontextmenu='return false;' />"
					],
					btn=[(o.axis==="x" ? btnHTML[2] : btnHTML[0]),(o.axis==="x" ? btnHTML[3] : btnHTML[1]),btnHTML[2],btnHTML[3]];
				if(o.scrollButtons.enable){
					mCSB_scrollTools.prepend(btn[0]).append(btn[1]).next(".mCSB_scrollTools").prepend(btn[2]).append(btn[3]);
				}
			},
			/* -------------------- */


			/* detects/sets css max-height value */
			_maxHeight:function(){
				var $this=$(this),d=$this.data(pluginPfx),o=d.opt,
					mCustomScrollBox=$("#mCSB_"+d.idx),
					mh=$this.css("max-height"),pct=mh.indexOf("%")!==-1,
					bs=$this.css("box-sizing");
				if(mh!=="none"){
					var val=pct ? $this.parent().height()*parseInt(mh)/100 : parseInt(mh);
					/* if element's css box-sizing is "border-box", subtract any paddings and/or borders from max-height value */
					if(bs==="border-box"){val-=(($this.innerHeight()-$this.height())+($this.outerHeight()-$this.innerHeight()));}
					mCustomScrollBox.css("max-height",Math.round(val));
				}
			},
			/* -------------------- */


			/* auto-adjusts scrollbar dragger length */
			_setDraggerLength:function(){
				var $this=$(this),d=$this.data(pluginPfx),
					mCustomScrollBox=$("#mCSB_"+d.idx),
					mCSB_container=$("#mCSB_"+d.idx+"_container"),
					mCSB_dragger=[$("#mCSB_"+d.idx+"_dragger_vertical"),$("#mCSB_"+d.idx+"_dragger_horizontal")],
					ratio=[mCustomScrollBox.height()/mCSB_container.outerHeight(false),mCustomScrollBox.width()/mCSB_container.outerWidth(false)],
					l=[
						parseInt(mCSB_dragger[0].css("min-height")),Math.round(ratio[0]*mCSB_dragger[0].parent().height()),
						parseInt(mCSB_dragger[1].css("min-width")),Math.round(ratio[1]*mCSB_dragger[1].parent().width())
					],
					h=oldIE && (l[1]<l[0]) ? l[0] : l[1],w=oldIE && (l[3]<l[2]) ? l[2] : l[3];
				mCSB_dragger[0].css({
					"height":h,"max-height":(mCSB_dragger[0].parent().height()-10)
				}).find(".mCSB_dragger_bar").css({"line-height":l[0]+"px"});
				mCSB_dragger[1].css({
					"width":w,"max-width":(mCSB_dragger[1].parent().width()-10)
				});
			},
			/* -------------------- */


			/* calculates scrollbar to content ratio */
			_scrollRatio:function(){
				var $this=$(this),d=$this.data(pluginPfx),
					mCustomScrollBox=$("#mCSB_"+d.idx),
					mCSB_container=$("#mCSB_"+d.idx+"_container"),
					mCSB_dragger=[$("#mCSB_"+d.idx+"_dragger_vertical"),$("#mCSB_"+d.idx+"_dragger_horizontal")],
					scrollAmount=[mCSB_container.outerHeight(false)-mCustomScrollBox.height(),mCSB_container.outerWidth(false)-mCustomScrollBox.width()],
					ratio=[
						scrollAmount[0]/(mCSB_dragger[0].parent().height()-mCSB_dragger[0].height()),
						scrollAmount[1]/(mCSB_dragger[1].parent().width()-mCSB_dragger[1].width())
					];
				d.scrollRatio={y:ratio[0],x:ratio[1]};
			},
			/* -------------------- */


			/* toggles scrolling classes */
			_onDragClasses:function(el,action,xpnd){
				var expandClass=xpnd ? "mCSB_dragger_onDrag_expanded" : "",classes=["mCSB_dragger_onDrag","mCSB_scrollTools_onDrag"],
					scrollbar=el.closest(".mCSB_scrollTools");
				if(action==="active"){
					el.toggleClass(classes[0]+" "+expandClass); scrollbar.toggleClass(classes[1]);
					el[0]._draggable=el[0]._draggable ? 0 : 1;
				}else{
					if(!el[0]._draggable){
						if(action==="hide"){
							el.removeClass(classes[0]); scrollbar.removeClass(classes[1]);
						}else{
							el.addClass(classes[0]); scrollbar.addClass(classes[1]);
						}
					}
				}
			},
			/* -------------------- */


			/* checks if content overflows its container to determine if scrolling is required */
			_overflowed:function(){
				var $this=$(this),d=$this.data(pluginPfx),
					mCustomScrollBox=$("#mCSB_"+d.idx),
					mCSB_container=$("#mCSB_"+d.idx+"_container"),
					contentHeight=d.overflowed==null ? mCSB_container.height() : mCSB_container.outerHeight(false),
					contentWidth=d.overflowed==null ? mCSB_container.width() : mCSB_container.outerWidth(false);
				return [contentHeight>mCustomScrollBox.height(),contentWidth>mCustomScrollBox.width()];
			},
			/* -------------------- */


			/* resets content position to 0 */
			_resetContentPosition:function(){
				var $this=$(this),d=$this.data(pluginPfx),o=d.opt,
					mCustomScrollBox=$("#mCSB_"+d.idx),
					mCSB_container=$("#mCSB_"+d.idx+"_container"),
					mCSB_dragger=[$("#mCSB_"+d.idx+"_dragger_vertical"),$("#mCSB_"+d.idx+"_dragger_horizontal")];
				functions._stop($this); /* stop any current scrolling before resetting */
				if((o.axis!=="x" && !d.overflowed[0]) || (o.axis==="y" && d.overflowed[0])){mCSB_dragger[0].add(mCSB_container).css("top",0);} /* reset y */
				if((o.axis!=="y" && !d.overflowed[1]) || (o.axis==="x" && d.overflowed[1])){ /* reset x */
					var cx=dx=0;
					if(d.langDir==="rtl"){ /* adjust left position for rtl direction */
						cx=mCustomScrollBox.width()-mCSB_container.outerWidth(false);
						dx=Math.abs(cx/d.scrollRatio.x);
					}
					mCSB_container.css("left",cx);
					mCSB_dragger[1].css("left",dx);
				}
			},
			/* -------------------- */


			/* binds scrollbar events */
			_bindEvents:function(){
				var $this=$(this),d=$this.data(pluginPfx),o=d.opt;
				if(!d.bindEvents){ /* check if events are already bound */
					functions._draggable.call(this);
					if(o.contentTouchScroll){functions._contentDraggable.call(this);}
					if(o.mouseWheel.enable){ /* bind mousewheel fn when plugin is available */
						function _mwt(){
							mousewheelTimeout=setTimeout(function(){
								if(!$.event.special.mousewheel){
									_mwt();
								}else{
									clearTimeout(mousewheelTimeout);
									functions._mousewheel.call($this[0]);
								}
							},1000);
						}
						var mousewheelTimeout;
						_mwt();
					}
					functions._draggerRail.call(this);
					functions._wrapperScroll.call(this);
					if(o.advanced.autoScrollOnFocus){functions._focus.call(this);}
					if(o.scrollButtons.enable){functions._buttons.call(this);}
					if(o.keyboard.enable){functions._keyboard.call(this);}
					d.bindEvents=true;
				}
			},
			/* -------------------- */


			/* unbinds scrollbar events */
			_unbindEvents:function(){
				var $this=$(this),d=$this.data(pluginPfx),
					namespace=pluginPfx+"_"+d.idx,
					sb=".mCSB_"+d.idx+"_scrollbar",
					sel=$("#mCSB_"+d.idx+",#mCSB_"+d.idx+"_container,#mCSB_"+d.idx+"_container_wrapper,"+sb+" .mCSB_draggerContainer,#mCSB_"+d.idx+"_dragger_vertical,#mCSB_"+d.idx+"_dragger_horizontal,"+sb+">a"),
					mCSB_container=$("#mCSB_"+d.idx+"_container");
				if(d.bindEvents){ /* check if events are bound */
					/* unbind namespaced events from document/selectors */
					$(document).unbind("."+namespace);
					sel.each(function(){
						$(this).unbind("."+namespace);
					});
					/* clear and delete timeouts/objects */
					clearTimeout($this[0]._focusTimeout); functions._delete.call(null,$this[0]._focusTimeout);
					clearTimeout(d.sequential.step); functions._delete.call(null,d.sequential.step);
					clearTimeout(mCSB_container[0].onCompleteTimeout); functions._delete.call(null,mCSB_container[0].onCompleteTimeout);
					d.bindEvents=false;
				}
			},
			/* -------------------- */


			/* toggles scrollbar visibility */
			_scrollbarVisibility:function(disabled){
				var $this=$(this),d=$this.data(pluginPfx),o=d.opt,
					contentWrapper=$("#mCSB_"+d.idx+"_container_wrapper"),
					content=contentWrapper.length ? contentWrapper : $("#mCSB_"+d.idx+"_container"),
					scrollbar=[$("#mCSB_"+d.idx+"_scrollbar_vertical"),$("#mCSB_"+d.idx+"_scrollbar_horizontal")],
					mCSB_dragger=[scrollbar[0].find(".mCSB_dragger"),scrollbar[1].find(".mCSB_dragger")];
				if(o.axis!=="x"){
					if(d.overflowed[0] && !disabled){
						scrollbar[0].add(mCSB_dragger[0]).add(scrollbar[0].children("a")).css("display","block");
						content.removeClass("mCS_no_scrollbar_y mCS_y_hidden");
					}else{
						if(o.alwaysShowScrollbar){
							if(o.alwaysShowScrollbar!==2){mCSB_dragger[0].add(scrollbar[0].children("a")).css("display","none");}
							content.removeClass("mCS_y_hidden");
						}else{
							scrollbar[0].css("display","none");
							content.addClass("mCS_y_hidden");
						}
						content.addClass("mCS_no_scrollbar_y");
					}
				}
				if(o.axis!=="y"){
					if(d.overflowed[1] && !disabled){
						scrollbar[1].add(mCSB_dragger[1]).add(scrollbar[1].children("a")).css("display","block");
						content.removeClass("mCS_no_scrollbar_x mCS_x_hidden");
					}else{
						if(o.alwaysShowScrollbar){
							if(o.alwaysShowScrollbar!==2){mCSB_dragger[1].add(scrollbar[1].children("a")).css("display","none");}
							content.removeClass("mCS_x_hidden");
						}else{
							scrollbar[1].css("display","none");
							content.addClass("mCS_x_hidden");
						}
						content.addClass("mCS_no_scrollbar_x");
					}
				}
				if(!d.overflowed[0] && !d.overflowed[1]){
					$this.addClass("mCS_no_scrollbar");
				}else{
					$this.removeClass("mCS_no_scrollbar");
				}
			},
			/* -------------------- */


			/* returns input coordinates of pointer, touch and mouse events (relative to document) */
			_coordinates:function(e){
				var t=e.type;
				switch(t){
					case "pointerdown": case "MSPointerDown": case "pointermove": case "MSPointerMove": case "pointerup": case "MSPointerUp":
						return [e.originalEvent.pageY,e.originalEvent.pageX];
						break;
					case "touchstart": case "touchmove": case "touchend":
						var touch=e.originalEvent.touches[0] || e.originalEvent.changedTouches[0];
						return [touch.pageY,touch.pageX];
						break;
					default:
						return [e.pageY,e.pageX];
				}
			},
			/* -------------------- */


			/*
			SCROLLBAR DRAG EVENTS
			scrolls content via scrollbar dragging
			*/
			_draggable:function(){
				var $this=$(this),d=$this.data(pluginPfx),o=d.opt,
					namespace=pluginPfx+"_"+d.idx,
					draggerId=["mCSB_"+d.idx+"_dragger_vertical","mCSB_"+d.idx+"_dragger_horizontal"],
					mCSB_container=$("#mCSB_"+d.idx+"_container"),
					mCSB_dragger=$("#"+draggerId[0]+",#"+draggerId[1]),
					draggable,dragY,dragX;
				mCSB_dragger.bind("mousedown."+namespace+" touchstart."+namespace+" pointerdown."+namespace+" MSPointerDown."+namespace,function(e){
					e.stopImmediatePropagation();
					e.preventDefault();
					if(!functions._mouseBtnLeft(e)){return;} /* left mouse button only */
					touchActive=true;
					if(oldIE){document.onselectstart=function(){return false;}} /* disable text selection for IE < 9 */
					_iframe(false); /* enable scrollbar dragging over iframes by disabling their events */
					functions._stop($this);
					draggable=$(this);
					var offset=draggable.offset(),y=functions._coordinates(e)[0]-offset.top,x=functions._coordinates(e)[1]-offset.left,
						h=draggable.height()+offset.top,w=draggable.width()+offset.left;
					if(y<h && y>0 && x<w && x>0){
						dragY=y;
						dragX=x;
					}
					functions._onDragClasses(draggable,"active",o.autoExpandScrollbar);
				}).bind("touchmove."+namespace,function(e){
					e.stopImmediatePropagation();
					e.preventDefault();
					var offset=draggable.offset(),y=functions._coordinates(e)[0]-offset.top,x=functions._coordinates(e)[1]-offset.left;
					_drag(dragY,dragX,y,x);
				});
				$(document).bind("mousemove."+namespace+" pointermove."+namespace+" MSPointerMove."+namespace,function(e){
					if(draggable){
						var offset=draggable.offset(),y=functions._coordinates(e)[0]-offset.top,x=functions._coordinates(e)[1]-offset.left;
						if(dragY===y){return;} /* has it really moved? */
						_drag(dragY,dragX,y,x);
					}
				}).add(mCSB_dragger).bind("mouseup."+namespace+" touchend."+namespace+" pointerup."+namespace+" MSPointerUp."+namespace,function(e){
					if(draggable){
						functions._onDragClasses(draggable,"active",o.autoExpandScrollbar);
						draggable=null;
					}
					touchActive=false;
					if(oldIE){document.onselectstart=null;} /* enable text selection for IE < 9 */
					_iframe(true); /* enable iframes events */
				});
				function _iframe(evt){
					var el=mCSB_container.find("iframe");
					if(!el.length){return;} /* check if content contains iframes */
					var val=!evt ? "none" : "auto";
					el.css("pointer-events",val); /* for IE11, iframe's display property should not be "block" */
				}
				function _drag(dragY,dragX,y,x){
					mCSB_container[0].idleTimer=o.scrollInertia<233 ? 250 : 0;
					if(draggable.attr("id")===draggerId[1]){
						var dir="x",to=((draggable[0].offsetLeft-dragX)+x)*d.scrollRatio.x;
					}else{
						var dir="y",to=((draggable[0].offsetTop-dragY)+y)*d.scrollRatio.y;
					}
					functions._scrollTo($this,to.toString(),{dir:dir,drag:true});
				}
			},
			/* -------------------- */


			/*
			TOUCH SWIPE EVENTS
			scrolls content via touch swipe
			Emulates the native touch-swipe scrolling with momentum found in iOS, Android and WP devices
			*/
			_contentDraggable:function(){
				var $this=$(this),d=$this.data(pluginPfx),o=d.opt,
					namespace=pluginPfx+"_"+d.idx,
					mCustomScrollBox=$("#mCSB_"+d.idx),
					mCSB_container=$("#mCSB_"+d.idx+"_container"),
					mCSB_dragger=[$("#mCSB_"+d.idx+"_dragger_vertical"),$("#mCSB_"+d.idx+"_dragger_horizontal")],
					dragY,dragX,touchStartY,touchStartX,touchMoveY=[],touchMoveX=[],startTime,runningTime,endTime,distance,speed,amount,
					durA=0,durB,overwrite=o.axis==="yx" ? "none" : "all";
				mCSB_container.bind("touchstart."+namespace+" pointerdown."+namespace+" MSPointerDown."+namespace,function(e){
					if(!functions._pointerTouch(e) || touchActive){return;}
					var offset=mCSB_container.offset();
					dragY=functions._coordinates(e)[0]-offset.top;
					dragX=functions._coordinates(e)[1]-offset.left;
				}).bind("touchmove."+namespace+" pointermove."+namespace+" MSPointerMove."+namespace,function(e){
					if(!functions._pointerTouch(e) || touchActive){return;}
					e.stopImmediatePropagation();
					runningTime=functions._getTime();
					var offset=mCustomScrollBox.offset(),y=functions._coordinates(e)[0]-offset.top,x=functions._coordinates(e)[1]-offset.left,
						easing="mcsLinearOut";
					touchMoveY.push(y);
					touchMoveX.push(x);
					if(d.overflowed[0]){
						var limit=mCSB_dragger[0].parent().height()-mCSB_dragger[0].height(),
							prevent=((dragY-y)>0 && (y-dragY)>-(limit*d.scrollRatio.y));
					}
					if(d.overflowed[1]){
						var limitX=mCSB_dragger[1].parent().width()-mCSB_dragger[1].width(),
							preventX=((dragX-x)>0 && (x-dragX)>-(limitX*d.scrollRatio.x));
					}
					if(prevent || preventX){e.preventDefault();} /* prevent native document scrolling */
					amount=o.axis==="yx" ? [(dragY-y),(dragX-x)] : o.axis==="x" ? [null,(dragX-x)] : [(dragY-y),null];
					mCSB_container[0].idleTimer=250;
					if(d.overflowed[0]){_drag(amount[0],durA,easing,"y","all",true);}
					if(d.overflowed[1]){_drag(amount[1],durA,easing,"x",overwrite,true);}
				});
				mCustomScrollBox.bind("touchstart."+namespace+" pointerdown."+namespace+" MSPointerDown."+namespace,function(e){
					if(!functions._pointerTouch(e) || touchActive){return;}
					e.stopImmediatePropagation();
					functions._stop($this);
					startTime=functions._getTime();
					var offset=mCustomScrollBox.offset();
					touchStartY=functions._coordinates(e)[0]-offset.top;
					touchStartX=functions._coordinates(e)[1]-offset.left;
					touchMoveY=[]; touchMoveX=[];
				}).bind("touchend."+namespace+" pointerup."+namespace+" MSPointerUp."+namespace,function(e){
					if(!functions._pointerTouch(e) || touchActive){return;}
					e.stopImmediatePropagation();
					endTime=functions._getTime();
					var offset=mCustomScrollBox.offset(),y=functions._coordinates(e)[0]-offset.top,x=functions._coordinates(e)[1]-offset.left;
					if((endTime-runningTime)>30){return;}
					speed=1000/(endTime-startTime);
					var easing="mcsEaseOut",slow=speed<2.5,
						diff=slow ? [touchMoveY[touchMoveY.length-2],touchMoveX[touchMoveX.length-2]] : [0,0];
					distance=slow ? [(y-diff[0]),(x-diff[1])] : [y-touchStartY,x-touchStartX];
					var absDistance=[Math.abs(distance[0]),Math.abs(distance[1])];
					speed=slow ? [Math.abs(distance[0]/4),Math.abs(distance[1]/4)] : [speed,speed];
					var a=[
						Math.abs(mCSB_container[0].offsetTop)-(distance[0]*_m((absDistance[0]/speed[0]),speed[0])),
						Math.abs(mCSB_container[0].offsetLeft)-(distance[1]*_m((absDistance[1]/speed[1]),speed[1]))
					];
					amount=o.axis==="yx" ? [a[0],a[1]] : o.axis==="x" ? [null,a[1]] : [a[0],null];
					durB=[(absDistance[0]*4)+o.scrollInertia,(absDistance[1]*4)+o.scrollInertia];
					var md=parseInt(o.contentTouchScroll) || 0; /* absolute minimum distance required */
					amount[0]=absDistance[0]>md ? amount[0] : 0;
					amount[1]=absDistance[1]>md ? amount[1] : 0;
					if(d.overflowed[0]){_drag(amount[0],durB[0],easing,"y",overwrite,false);}
					if(d.overflowed[1]){_drag(amount[1],durB[1],easing,"x",overwrite,false);}
				});
				function _m(ds,s){
					var r=[s*1.5,s*2,s/1.5,s/2];
					if(ds>90){
						return s>4 ? r[0] : r[3];
					}else if(ds>60){
						return s>3 ? r[3] : r[2];
					}else if(ds>30){
						return s>8 ? r[1] : s>6 ? r[0] : s>4 ? s : r[2];
					}else{
						return s>8 ? s : r[3];
					}
				}
				function _drag(amount,dur,easing,dir,overwrite,drag){
					if(!amount){return;}
					functions._scrollTo($this,amount.toString(),{dur:dur,scrollEasing:easing,dir:dir,overwrite:overwrite,drag:drag});
				}
			},
			/* -------------------- */


			/*
			MOUSE WHEEL EVENT
			scrolls content via mouse-wheel
			via mouse-wheel plugin (https://github.com/brandonaaron/jquery-mousewheel)
			*/
			_mousewheel:function(){
				var $this=$(this),d=$this.data(pluginPfx),o=d.opt,
					namespace=pluginPfx+"_"+d.idx,
					mCustomScrollBox=$("#mCSB_"+d.idx),
					mCSB_dragger=[$("#mCSB_"+d.idx+"_dragger_vertical"),$("#mCSB_"+d.idx+"_dragger_horizontal")];
				mCustomScrollBox.bind("mousewheel."+namespace,function(e,delta){
					functions._stop($this);
					if(functions._disableMousewheel($this,e.target)){return;} /* disables mouse-wheel when hovering specific elements */
					var deltaFactor=o.mouseWheel.deltaFactor!=="auto" ? parseInt(o.mouseWheel.deltaFactor) : (oldIE && e.deltaFactor<100) ? 100 : e.deltaFactor<40 ? 40 : e.deltaFactor || 100;
					if(o.axis==="x" || o.mouseWheel.axis==="x"){
						var dir="x",
							px=[Math.round(deltaFactor*d.scrollRatio.x),parseInt(o.mouseWheel.scrollAmount)],
							amount=o.mouseWheel.scrollAmount!=="auto" ? px[1] : px[0]>=mCustomScrollBox.width() ? mCustomScrollBox.width()*0.9 : px[0],
							contentPos=Math.abs($("#mCSB_"+d.idx+"_container")[0].offsetLeft),
							draggerPos=mCSB_dragger[1][0].offsetLeft,
							limit=mCSB_dragger[1].parent().width()-mCSB_dragger[1].width(),
							dlt=e.deltaX || e.deltaY || delta;
					}else{
						var dir="y",
							px=[Math.round(deltaFactor*d.scrollRatio.y),parseInt(o.mouseWheel.scrollAmount)],
							amount=o.mouseWheel.scrollAmount!=="auto" ? px[1] : px[0]>=mCustomScrollBox.height() ? mCustomScrollBox.height()*0.9 : px[0],
							contentPos=Math.abs($("#mCSB_"+d.idx+"_container")[0].offsetTop),
							draggerPos=mCSB_dragger[0][0].offsetTop,
							limit=mCSB_dragger[0].parent().height()-mCSB_dragger[0].height(),
							dlt=e.deltaY || delta;
					}
					if((dir==="y" && !d.overflowed[0]) || (dir==="x" && !d.overflowed[1])){return;}
					if(o.mouseWheel.invert){dlt=-dlt;}
					if(o.mouseWheel.normalizeDelta){dlt=dlt<0 ? -1 : 1;}
					if((dlt>0 && draggerPos!==0) || (dlt<0 && draggerPos!==limit) || o.mouseWheel.preventDefault){
						e.stopImmediatePropagation();
						e.preventDefault();
					}
					functions._scrollTo($this,(contentPos-(dlt*amount)).toString(),{dir:dir});
				});
			},
			/* -------------------- */


			/* disables mouse-wheel when hovering specific elements like select, datalist etc. */
			_disableMousewheel:function(el,target){
				var tag=target.nodeName.toLowerCase(),
					tags=el.data(pluginPfx).opt.mouseWheel.disableOver,
					/* elements that require focus */
					focusTags=["select","textarea"];
				return $.inArray(tag,tags) > -1 && !($.inArray(tag,focusTags) > -1 && !$(target).is(":focus"));
			},
			/* -------------------- */


			/*
			DRAGGER RAIL CLICK EVENT
			scrolls content via dragger rail
			*/
			_draggerRail:function(){
				var $this=$(this),d=$this.data(pluginPfx),
					namespace=pluginPfx+"_"+d.idx,
					mCSB_container=$("#mCSB_"+d.idx+"_container"),
					wrapper=mCSB_container.parent(),
					mCSB_draggerContainer=$(".mCSB_"+d.idx+"_scrollbar .mCSB_draggerContainer");
				mCSB_draggerContainer.bind("touchstart."+namespace+" pointerdown."+namespace+" MSPointerDown."+namespace,function(e){
					touchActive=true;
				}).bind("touchend."+namespace+" pointerup."+namespace+" MSPointerUp."+namespace,function(e){
					touchActive=false;
				}).bind("click."+namespace,function(e){
					if($(e.target).hasClass("mCSB_draggerContainer") || $(e.target).hasClass("mCSB_draggerRail")){
						functions._stop($this);
						var el=$(this),mCSB_dragger=el.find(".mCSB_dragger");
						if(el.parent(".mCSB_scrollTools_horizontal").length>0){
							if(!d.overflowed[1]){return;}
							var dir="x",
								clickDir=e.pageX>mCSB_dragger.offset().left ? -1 : 1,
								to=Math.abs(mCSB_container[0].offsetLeft)-(clickDir*(wrapper.width()*0.9));
						}else{
							if(!d.overflowed[0]){return;}
							var dir="y",
								clickDir=e.pageY>mCSB_dragger.offset().top ? -1 : 1,
								to=Math.abs(mCSB_container[0].offsetTop)-(clickDir*(wrapper.height()*0.9));
						}
						functions._scrollTo($this,to.toString(),{dir:dir,scrollEasing:"mcsEaseInOut"});
					}
				});
			},
			/* -------------------- */


			/*
			FOCUS EVENT
			scrolls content via element focus (e.g. clicking an input, pressing TAB key etc.)
			*/
			_focus:function(){
				var $this=$(this),d=$this.data(pluginPfx),o=d.opt,
					namespace=pluginPfx+"_"+d.idx,
					mCSB_container=$("#mCSB_"+d.idx+"_container"),
					wrapper=mCSB_container.parent();
				mCSB_container.bind("focusin."+namespace,function(e){
					var el=$(document.activeElement),
						nested=mCSB_container.find(".mCustomScrollBox").length,
						dur=0;
					if(!el.is(o.advanced.autoScrollOnFocus)){return;}
					functions._stop($this);
					clearTimeout($this[0]._focusTimeout);
					$this[0]._focusTimer=nested ? (dur+17)*nested : 0;
					$this[0]._focusTimeout=setTimeout(function(){
						var	to=[el.offset().top-mCSB_container.offset().top,el.offset().left-mCSB_container.offset().left],
							contentPos=[mCSB_container[0].offsetTop,mCSB_container[0].offsetLeft],
							isVisible=[
								(contentPos[0]+to[0]>=0 && contentPos[0]+to[0]<wrapper.height()-el.outerHeight(false)),
								(contentPos[1]+to[1]>=0 && contentPos[0]+to[1]<wrapper.width()-el.outerWidth(false))
							],
							overwrite=(o.axis==="yx" && !isVisible[0] && !isVisible[1]) ? "none" : "all";
						if(o.axis!=="x" && !isVisible[0]){
							functions._scrollTo($this,to[0].toString(),{dir:"y",scrollEasing:"mcsEaseInOut",overwrite:overwrite,dur:dur});
						}
						if(o.axis!=="y" && !isVisible[1]){
							functions._scrollTo($this,to[1].toString(),{dir:"x",scrollEasing:"mcsEaseInOut",overwrite:overwrite,dur:dur});
						}
					},$this[0]._focusTimer);
				});
			},
			/* -------------------- */


			/* sets content wrapper scrollTop/scrollLeft always to 0 */
			_wrapperScroll:function(){
				var $this=$(this),d=$this.data(pluginPfx),
					namespace=pluginPfx+"_"+d.idx,
					wrapper=$("#mCSB_"+d.idx+"_container").parent();
				wrapper.bind("scroll."+namespace,function(e){
					wrapper.scrollTop(0).scrollLeft(0);
				});
			},
			/* -------------------- */


			/*
			BUTTONS EVENTS
			scrolls content via up, down, left and right buttons
			*/
			_buttons:function(){
				var $this=$(this),d=$this.data(pluginPfx),o=d.opt,seq=d.sequential,
					namespace=pluginPfx+"_"+d.idx,
					mCSB_container=$("#mCSB_"+d.idx+"_container"),
					sel=".mCSB_"+d.idx+"_scrollbar",
					btn=$(sel+">a");
				btn.bind("mousedown."+namespace+" touchstart."+namespace+" pointerdown."+namespace+" MSPointerDown."+namespace+" mouseup."+namespace+" touchend."+namespace+" pointerup."+namespace+" MSPointerUp."+namespace+" mouseout."+namespace+" pointerout."+namespace+" MSPointerOut."+namespace+" click."+namespace,function(e){
					e.preventDefault();
					if(!functions._mouseBtnLeft(e)){return;} /* left mouse button only */
					var btnClass=$(this).attr("class");
					seq.type=o.scrollButtons.scrollType;
					switch(e.type){
						case "mousedown": case "touchstart": case "pointerdown": case "MSPointerDown":
							if(seq.type==="stepped"){return;}
							touchActive=true;
							d.tweenRunning=false;
							_seq("on",btnClass);
							break;
						case "mouseup": case "touchend": case "pointerup": case "MSPointerUp":
						case "mouseout": case "pointerout": case "MSPointerOut":
							if(seq.type==="stepped"){return;}
							touchActive=false;
							if(seq.dir){_seq("off",btnClass);}
							break;
						case "click":
							if(seq.type!=="stepped" || d.tweenRunning){return;}
							_seq("on",btnClass);
							break;
					}
					function _seq(a,c){
						seq.scrollAmount=o.snapAmount || o.scrollButtons.scrollAmount;
						functions._sequentialScroll.call(this,$this,a,c);
					}
				});
			},
			/* -------------------- */


			/*
			KEYBOARD EVENTS
			scrolls content via keyboard
			Keys: up arrow, down arrow, left arrow, right arrow, PgUp, PgDn, Home, End
			*/
			_keyboard:function(){
				var $this=$(this),d=$this.data(pluginPfx),o=d.opt,seq=d.sequential,
					namespace=pluginPfx+"_"+d.idx,
					mCustomScrollBox=$("#mCSB_"+d.idx),
					mCSB_container=$("#mCSB_"+d.idx+"_container"),
					wrapper=mCSB_container.parent(),
					editables="input,textarea,select,datalist,keygen,[contenteditable='true']";
				mCustomScrollBox.attr("tabindex","0").bind("blur."+namespace+" keydown."+namespace+" keyup."+namespace,function(e){
					switch(e.type){
						case "blur":
							if(d.tweenRunning && seq.dir){_seq("off",null);}
							break;
						case "keydown": case "keyup":
							var code=e.keyCode ? e.keyCode : e.which,action="on";
							if((o.axis!=="x" && (code===38 || code===40)) || (o.axis!=="y" && (code===37 || code===39))){
								/* up (38), down (40), left (37), right (39) arrows */
								if(((code===38 || code===40) && !d.overflowed[0]) || ((code===37 || code===39) && !d.overflowed[1])){return;}
								if(e.type==="keyup"){action="off";}
								if(!$(document.activeElement).is(editables)){
									e.preventDefault();
									e.stopImmediatePropagation();
									_seq(action,code);
								}
							}else if(code===33 || code===34){
								/* PgUp (33), PgDn (34) */
								if(d.overflowed[0] || d.overflowed[1]){
									e.preventDefault();
									e.stopImmediatePropagation();
								}
								if(e.type==="keyup"){
									functions._stop($this);
									var keyboardDir=code===34 ? -1 : 1;
									if(o.axis==="x" || (o.axis==="yx" && d.overflowed[1] && !d.overflowed[0])){
										var dir="x",to=Math.abs(mCSB_container[0].offsetLeft)-(keyboardDir*(wrapper.width()*0.9));
									}else{
										var dir="y",to=Math.abs(mCSB_container[0].offsetTop)-(keyboardDir*(wrapper.height()*0.9));
									}
									functions._scrollTo($this,to.toString(),{dir:dir,scrollEasing:"mcsEaseInOut"});
								}
							}else if(code===35 || code===36){
								/* End (35), Home (36) */
								if(!$(document.activeElement).is(editables)){
									if(d.overflowed[0] || d.overflowed[1]){
										e.preventDefault();
										e.stopImmediatePropagation();
									}
									if(e.type==="keyup"){
										if(o.axis==="x" || (o.axis==="yx" && d.overflowed[1] && !d.overflowed[0])){
											var dir="x",to=code===35 ? Math.abs(wrapper.width()-mCSB_container.outerWidth(false)) : 0;
										}else{
											var dir="y",to=code===35 ? Math.abs(wrapper.height()-mCSB_container.outerHeight(false)) : 0;
										}
										functions._scrollTo($this,to.toString(),{dir:dir,scrollEasing:"mcsEaseInOut"});
									}
								}
							}
							break;
					}
					function _seq(a,c){
						seq.type=o.keyboard.scrollType;
						seq.scrollAmount=o.snapAmount || o.keyboard.scrollAmount;
						if(seq.type==="stepped" && d.tweenRunning){return;}
						functions._sequentialScroll.call(this,$this,a,c);
					}
				});
			},
			/* -------------------- */


			/* scrolls content sequentially (used when scrolling via buttons, keyboard arrows etc.) */
			_sequentialScroll:function(el,action,trigger){
				var d=el.data(pluginPfx),o=d.opt,seq=d.sequential,
					mCSB_container=$("#mCSB_"+d.idx+"_container"),
					once=seq.type==="stepped" ? true : false;
				switch(action){
					case "on":
						seq.dir=[
							(trigger==="mCSB_buttonRight" || trigger==="mCSB_buttonLeft" || trigger===39 || trigger===37 ? "x" : "y"),
							(trigger==="mCSB_buttonUp" || trigger==="mCSB_buttonLeft" || trigger===38 || trigger===37 ? -1 : 1)
						];
						functions._stop(el);
						if(functions._isNumeric(trigger) && seq.type==="stepped"){return;}
						_start(once);
						break;
					case "off":
						_stop();
						if(once || (d.tweenRunning && seq.dir)){
							_start(true);
						}
						break;
				}
				/* starts sequence */
				function _start(once){
					var c=seq.type!=="stepped", /* continuous scrolling */
						t=!once ? 1000/60 : c ? o.scrollInertia/1.5 : o.scrollInertia, /* timer */
						m=!once ? 2.5 : c ? 7.5 : 40, /* multiplier */
						contentPos=[Math.abs(mCSB_container[0].offsetTop),Math.abs(mCSB_container[0].offsetLeft)],
						ratio=[d.scrollRatio.y>10 ? 10 : d.scrollRatio.y,d.scrollRatio.x>10 ? 10 : d.scrollRatio.x],
						amount=seq.dir[0]==="x" ? contentPos[1]+(seq.dir[1]*(ratio[1]*m)) : contentPos[0]+(seq.dir[1]*(ratio[0]*m)),
						px=seq.dir[0]==="x" ? contentPos[1]+(seq.dir[1]*parseInt(seq.scrollAmount)) : contentPos[0]+(seq.dir[1]*parseInt(seq.scrollAmount)),
						to=seq.scrollAmount!=="auto" ? px : amount,
						easing=!once ? "mcsLinear" : c ? "mcsLinearOut" : "mcsEaseInOut",
						onComplete=!once ? false : true;
					if(once && t<17){
						to=seq.dir[0]==="x" ? contentPos[1] : contentPos[0];
					}
					functions._scrollTo(el,to.toString(),{dir:seq.dir[0],scrollEasing:easing,dur:t,onComplete:onComplete});
					if(once){
						seq.dir=false;
						return;
					}
					clearTimeout(seq.step);
					seq.step=setTimeout(function(){
						_start();
					},t);
				}
				/* stops sequence */
				function _stop(){
					clearTimeout(seq.step);
					functions._stop(el);
				}
			},
			/* -------------------- */


			/* returns a yx array from value */
			_arr:function(val){
				var o=$(this).data(pluginPfx).opt,vals=[];
				if(typeof val==="function"){val=val();} /* check if the value is a single anonymous function */
				/* check if value is object or array, its length and create an array with yx values */
				if(!(val instanceof Array)){ /* object value (e.g. {y:"100",x:"100"}, 100 etc.) */
					vals[0]=val.y ? val.y : val.x || o.axis==="x" ? null : val;
					vals[1]=val.x ? val.x : val.y || o.axis==="y" ? null : val;
				}else{ /* array value (e.g. [100,100]) */
					vals=val.length>1 ? [val[0],val[1]] : o.axis==="x" ? [null,val[0]] : [val[0],null];
				}
				/* check if array values are anonymous functions */
				if(typeof vals[0]==="function"){vals[0]=vals[0]();}
				if(typeof vals[1]==="function"){vals[1]=vals[1]();}
				return vals;
			},
			/* -------------------- */


			/* translates values (e.g. "top", 100, "100px", "#id") to actual scroll-to positions */
			_to:function(val,dir){
				if(val==null || typeof val=="undefined"){return;}
				var $this=$(this),d=$this.data(pluginPfx),o=d.opt,
					mCSB_container=$("#mCSB_"+d.idx+"_container"),
					wrapper=mCSB_container.parent(),
					t=typeof val;
				if(!dir){dir=o.axis==="x" ? "x" : "y";}
				var contentLength=dir==="x" ? mCSB_container.outerWidth(false) : mCSB_container.outerHeight(false),
					contentOffset=dir==="x" ? mCSB_container.offset().left : mCSB_container.offset().top,
					contentPos=dir==="x" ? mCSB_container[0].offsetLeft : mCSB_container[0].offsetTop,
					cssProp=dir==="x" ? "left" : "top";
				switch(t){
					case "function": /* this currently is not used. Consider removing it */
						return val();
						break;
					case "object":
						if(val.nodeType){ /* DOM */
							var objOffset=dir==="x" ? $(val).offset().left : $(val).offset().top;
						}else if(val.jquery){ /* jquery object */
							if(!val.length){return;}
							var objOffset=dir==="x" ? val.offset().left : val.offset().top;
						}
						return objOffset-contentOffset;
						break;
					case "string": case "number":
						if(functions._isNumeric.call(null,val)){ /* numeric value */
							return Math.abs(val);
						}else if(val.indexOf("%")!==-1){ /* percentage value */
							return Math.abs(contentLength*parseInt(val)/100);
						}else if(val.indexOf("-=")!==-1){ /* decrease value */
							return Math.abs(contentPos-parseInt(val.split("-=")[1]));
						}else if(val.indexOf("+=")!==-1){ /* inrease value */
							var p=(contentPos+parseInt(val.split("+=")[1]));
							return p>=0 ? 0 : Math.abs(p);
						}else if(val.indexOf("px")!==-1 && functions._isNumeric.call(null,val.split("px")[0])){ /* pixels string value (e.g. "100px") */
							return Math.abs(val.split("px")[0]);
						}else{
							if(val==="top" || val==="left"){ /* special strings */
								return 0;
							}else if(val==="bottom"){
								return Math.abs(wrapper.height()-mCSB_container.outerHeight(false));
							}else if(val==="right"){
								return Math.abs(wrapper.width()-mCSB_container.outerWidth(false));
							}else if(val==="first" || val==="last"){
								var obj=mCSB_container.find(":"+val),
									objOffset=dir==="x" ? $(obj).offset().left : $(obj).offset().top;
								return objOffset-contentOffset;
							}else{
								if($(val).length){ /* jquery selector */
									var objOffset=dir==="x" ? $(val).offset().left : $(val).offset().top;
									return objOffset-contentOffset;
								}else{ /* other values (e.g. "100em") */
									mCSB_container.css(cssProp,val);
									methods.update.call(null,$this[0]);
									return;
								}
							}
						}
						break;
				}
			},
			/* -------------------- */


			/* calls the update method automatically */
			_autoUpdate:function(rem){
				var $this=$(this),d=$this.data(pluginPfx),o=d.opt,
					mCSB_container=$("#mCSB_"+d.idx+"_container");
				if(rem){
					/*
					removes autoUpdate timer
					usage: functions._autoUpdate.call(this,"remove");
					*/
					clearTimeout(mCSB_container[0].autoUpdate);
					functions._delete.call(null,mCSB_container[0].autoUpdate);
					return;
				}
				var	wrapper=mCSB_container.parent(),
					scrollbar=[$("#mCSB_"+d.idx+"_scrollbar_vertical"),$("#mCSB_"+d.idx+"_scrollbar_horizontal")],
					scrollbarSize=function(){return [
						scrollbar[0].is(":visible") ? scrollbar[0].outerHeight(true) : 0, /* returns y-scrollbar height */
						scrollbar[1].is(":visible") ? scrollbar[1].outerWidth(true) : 0 /* returns x-scrollbar width */
					]},
					oldSelSize=sizesSum(),newSelSize,
					os=[mCSB_container.outerHeight(false),mCSB_container.outerWidth(false),wrapper.height(),wrapper.width(),scrollbarSize()[0],scrollbarSize()[1]],ns,
					oldImgsLen=imgSum(),newImgsLen;
				upd();
				function upd(){
					clearTimeout(mCSB_container[0].autoUpdate);
					mCSB_container[0].autoUpdate=setTimeout(function(){
						/* update on specific selector(s) length and size change */
						if(o.advanced.updateOnSelectorChange){
							newSelSize=sizesSum();
							if(newSelSize!==oldSelSize){
								doUpd();
								oldSelSize=newSelSize;
								return;
							}
						}
						/* update on main element and scrollbar size changes */
						if(o.advanced.updateOnContentResize){
							ns=[mCSB_container.outerHeight(false),mCSB_container.outerWidth(false),wrapper.height(),wrapper.width(),scrollbarSize()[0],scrollbarSize()[1]];
							if(ns[0]!==os[0] || ns[1]!==os[1] || ns[2]!==os[2] || ns[3]!==os[3] || ns[4]!==os[4] || ns[5]!==os[5]){
								doUpd();
								os=ns;
							}
						}
						/* update on image load */
						if(o.advanced.updateOnImageLoad){
							newImgsLen=imgSum();
							if(newImgsLen!==oldImgsLen){
								mCSB_container.find("img").each(function(){
									imgLoader(this.src);
								});
								oldImgsLen=newImgsLen;
							}
						}
						if(o.advanced.updateOnSelectorChange || o.advanced.updateOnContentResize || o.advanced.updateOnImageLoad){upd();}
					},60);
				}
				/* returns images amount */
				function imgSum(){
					var total=0
					if(o.advanced.updateOnImageLoad){total=mCSB_container.find("img").length;}
					return total;
				}
				/* a tiny image loader */
				function imgLoader(src){
					var img=new Image();
					function createDelegate(contextObject,delegateMethod){
						return function(){return delegateMethod.apply(contextObject,arguments);}
					}
					function imgOnLoad(){
						this.onload=null;
						doUpd();
					}
					img.onload=createDelegate(img,imgOnLoad);
					img.src=src;
				}
				/* returns the total height and width sum of all elements matching the selector */
				function sizesSum(){
					if(o.advanced.updateOnSelectorChange===true){o.advanced.updateOnSelectorChange="*";}
					var total=0,sel=mCSB_container.find(o.advanced.updateOnSelectorChange);
					if(o.advanced.updateOnSelectorChange && sel.length>0){sel.each(function(){total+=$(this).height()+$(this).width();});}
					return total;
				}
				/* calls the update method */
				function doUpd(){
					clearTimeout(mCSB_container[0].autoUpdate);
					methods.update.call(null,$this[0]);
				}
			},
			/* -------------------- */


			/* snaps scrolling to a multiple of a pixels number */
			_snapAmount:function(to,amount,offset){
				return (Math.round(to/amount)*amount-offset);
			},
			/* -------------------- */


			/* stops content and scrollbar animations */
			_stop:function(el){
				var d=el.data(pluginPfx),
					sel=$("#mCSB_"+d.idx+"_container,#mCSB_"+d.idx+"_container_wrapper,#mCSB_"+d.idx+"_dragger_vertical,#mCSB_"+d.idx+"_dragger_horizontal");
				sel.each(function(){
					functions._stopTween.call(this);
				});
			},
			/* -------------------- */


			/*
			ANIMATES CONTENT
			This is where the actual scrolling happens
			*/
			_scrollTo:function(el,to,options){
				var d=el.data(pluginPfx),o=d.opt,
					defaults={
						trigger:"internal",
						dir:"y",
						scrollEasing:"mcsEaseOut",
						drag:false,
						dur:o.scrollInertia,
						overwrite:"all",
						callbacks:true,
						onStart:true,
						onUpdate:true,
						onComplete:true
					},
					options=$.extend(defaults,options),
					dur=[options.dur,(options.drag ? 0 : options.dur)],
					mCustomScrollBox=$("#mCSB_"+d.idx),
					mCSB_container=$("#mCSB_"+d.idx+"_container"),
					totalScrollOffsets=o.callbacks.onTotalScrollOffset ? functions._arr.call(el,o.callbacks.onTotalScrollOffset) : [0,0],
					totalScrollBackOffsets=o.callbacks.onTotalScrollBackOffset ? functions._arr.call(el,o.callbacks.onTotalScrollBackOffset) : [0,0];
				d.trigger=options.trigger;
				if(o.snapAmount){to=functions._snapAmount(to,o.snapAmount,o.snapOffset);} /* scrolling snapping */
				switch(options.dir){
					case "x":
						var mCSB_dragger=$("#mCSB_"+d.idx+"_dragger_horizontal"),
							property="left",
							contentPos=mCSB_container[0].offsetLeft,
							limit=[
								mCustomScrollBox.width()-mCSB_container.outerWidth(false),
								mCSB_dragger.parent().width()-mCSB_dragger.width()
							],
							scrollTo=[to,(to/d.scrollRatio.x)],
							tso=totalScrollOffsets[1],
							tsbo=totalScrollBackOffsets[1],
							totalScrollOffset=tso>0 ? tso/d.scrollRatio.x : 0,
							totalScrollBackOffset=tsbo>0 ? tsbo/d.scrollRatio.x : 0;
						break;
					case "y":
						var mCSB_dragger=$("#mCSB_"+d.idx+"_dragger_vertical"),
							property="top",
							contentPos=mCSB_container[0].offsetTop,
							limit=[
								mCustomScrollBox.height()-mCSB_container.outerHeight(false),
								mCSB_dragger.parent().height()-mCSB_dragger.height()
							],
							scrollTo=[to,(to/d.scrollRatio.y)],
							tso=totalScrollOffsets[0],
							tsbo=totalScrollBackOffsets[0],
							totalScrollOffset=tso>0 ? tso/d.scrollRatio.y : 0,
							totalScrollBackOffset=tsbo>0 ? tsbo/d.scrollRatio.y : 0;
						break;
				}
				if(scrollTo[1]<0){
					scrollTo=[0,0];
				}else if(scrollTo[1]>=limit[1]){
					scrollTo=[limit[0],limit[1]];
				}else{
					scrollTo[0]=-scrollTo[0];
				}
				clearTimeout(mCSB_container[0].onCompleteTimeout);
				if(!d.tweenRunning && ((contentPos===0 && scrollTo[0]>=0) || (contentPos===limit[0] && scrollTo[0]<=limit[0]))){return;}
				functions._tweenTo.call(null,mCSB_dragger[0],property,Math.round(scrollTo[1]),dur[1],options.scrollEasing);
				functions._tweenTo.call(null,mCSB_container[0],property,Math.round(scrollTo[0]),dur[0],options.scrollEasing,options.overwrite,{
					onStart:function(){
						if(options.callbacks && options.onStart && !d.tweenRunning){
							/* callbacks: onScrollStart */
							if(_cb("onScrollStart")){_mcs(); o.callbacks.onScrollStart.call(el[0]);}
							d.tweenRunning=true;
							functions._onDragClasses(mCSB_dragger);
							d.cbOffsets=_cbOffsets();
						}
					},onUpdate:function(){
						if(options.callbacks && options.onUpdate){
							/* callbacks: whileScrolling */
							if(_cb("whileScrolling")){_mcs(); o.callbacks.whileScrolling.call(el[0]);}
						}
					},onComplete:function(){
						if(options.callbacks && options.onComplete){
							if(o.axis==="yx"){clearTimeout(mCSB_container[0].onCompleteTimeout);}
							var t=mCSB_container[0].idleTimer || 0;
							mCSB_container[0].onCompleteTimeout=setTimeout(function(){
								/* callbacks: onScroll, onTotalScroll, onTotalScrollBack */
								if(_cb("onScroll")){_mcs(); o.callbacks.onScroll.call(el[0]);}
								if(_cb("onTotalScroll") && scrollTo[1]>=limit[1]-totalScrollOffset && d.cbOffsets[0]){_mcs(); o.callbacks.onTotalScroll.call(el[0]);}
								if(_cb("onTotalScrollBack") && scrollTo[1]<=totalScrollBackOffset && d.cbOffsets[1]){_mcs(); o.callbacks.onTotalScrollBack.call(el[0]);}
								d.tweenRunning=false;
								mCSB_container[0].idleTimer=0;
								functions._onDragClasses(mCSB_dragger,"hide");
							},t);
						}
					}
				});
				/* checks if callback function exists */
				function _cb(cb){
					return d && o.callbacks[cb] && typeof o.callbacks[cb]==="function";
				}
				/* checks whether callback offsets always trigger */
				function _cbOffsets(){
					return [o.callbacks.alwaysTriggerOffsets || contentPos>=limit[0]+tso,o.callbacks.alwaysTriggerOffsets || contentPos<=-tsbo];
				}
				/*
				populates object with useful values for the user
				values:
					content: this.mcs.content
					content top position: this.mcs.top
					content left position: this.mcs.left
					dragger top position: this.mcs.draggerTop
					dragger left position: this.mcs.draggerLeft
					scrolling y percentage: this.mcs.topPct
					scrolling x percentage: this.mcs.leftPct
					scrolling direction: this.mcs.direction
				*/
				function _mcs(){
					var cp=[mCSB_container[0].offsetTop,mCSB_container[0].offsetLeft], /* content position */
						dp=[mCSB_dragger[0].offsetTop,mCSB_dragger[0].offsetLeft], /* dragger position */
						cl=[mCSB_container.outerHeight(false),mCSB_container.outerWidth(false)], /* content length */
						pl=[mCustomScrollBox.height(),mCustomScrollBox.width()]; /* content parent length */
					el[0].mcs={
						content:mCSB_container, /* original content wrapper as jquery object */
						top:cp[0],left:cp[1],draggerTop:dp[0],draggerLeft:dp[1],
						topPct:Math.round((100*Math.abs(cp[0]))/(Math.abs(cl[0])-pl[0])),leftPct:Math.round((100*Math.abs(cp[1]))/(Math.abs(cl[1])-pl[1])),
						direction:options.dir
					};
					/*
					this refers to the original element containing the scrollbar(s)
					usage: this.mcs.top, this.mcs.leftPct etc.
					*/
				}
			},
			/* -------------------- */


			/*
			CUSTOM JAVASCRIPT ANIMATION TWEEN
			Lighter and faster than jquery animate() and css transitions
			Animates top/left properties and includes easings
			*/
			_tweenTo:function(el,prop,to,duration,easing,overwrite,callbacks){
				var callbacks=callbacks || {},
					onStart=callbacks.onStart || function(){},onUpdate=callbacks.onUpdate || function(){},onComplete=callbacks.onComplete || function(){},
					startTime=functions._getTime(),_delay,progress=0,from=el.offsetTop,elStyle=el.style;
				if(prop==="left"){from=el.offsetLeft;}
				var diff=to-from;
				el._mcsstop=0;
				if(overwrite!=="none"){_cancelTween();}
				_startTween();
				function _step(){
					if(el._mcsstop){return;}
					if(!progress){onStart.call();}
					progress=functions._getTime()-startTime;
					_tween();
					if(progress>=el._mcstime){
						el._mcstime=(progress>el._mcstime) ? progress+_delay-(progress- el._mcstime) : progress+_delay-1;
						if(el._mcstime<progress+1){el._mcstime=progress+1;}
					}
					if(el._mcstime<duration){el._mcsid=_request(_step);}else{onComplete.call();}
				}
				function _tween(){
					if(duration>0){
						el._mcscurrVal=_ease(el._mcstime,from,diff,duration,easing);
						elStyle[prop]=Math.round(el._mcscurrVal)+"px";
					}else{
						elStyle[prop]=to+"px";
					}
					onUpdate.call();
				}
				function _startTween(){
					_delay=1000/60;
					el._mcstime=progress+_delay;
					_request=(!window.requestAnimationFrame) ? function(f){_tween(); return setTimeout(f,0.01);} : window.requestAnimationFrame;
					el._mcsid=_request(_step);
				}
				function _cancelTween(){
					if(el._mcsid==null){return;}
					if(!window.requestAnimationFrame){clearTimeout(el._mcsid);
					}else{window.cancelAnimationFrame(el._mcsid);}
					el._mcsid=null;
				}
				function _ease(t,b,c,d,type){
					switch(type){
						case "linear": case "mcsLinear":
							return c*t/d + b;
							break;
						case "mcsLinearOut":
							t/=d; t--; return c * Math.sqrt(1 - t*t) + b;
							break;
						case "easeInOutSmooth":
							t/=d/2;
							if(t<1) return c/2*t*t + b;
							t--;
							return -c/2 * (t*(t-2) - 1) + b;
							break;
						case "easeInOutStrong":
							t/=d/2;
							if(t<1) return c/2 * Math.pow( 2, 10 * (t - 1) ) + b;
							t--;
							return c/2 * ( -Math.pow( 2, -10 * t) + 2 ) + b;
							break;
						case "easeInOut": case "mcsEaseInOut":
							t/=d/2;
							if(t<1) return c/2*t*t*t + b;
							t-=2;
							return c/2*(t*t*t + 2) + b;
							break;
						case "easeOutSmooth":
							t/=d; t--;
							return -c * (t*t*t*t - 1) + b;
							break;
						case "easeOutStrong":
							return c * ( -Math.pow( 2, -10 * t/d ) + 1 ) + b;
							break;
						case "easeOut": case "mcsEaseOut": default:
							var ts=(t/=d)*t,tc=ts*t;
							return b+c*(0.499999999999997*tc*ts + -2.5*ts*ts + 5.5*tc + -6.5*ts + 4*t);
					}
				}
			},
			/* -------------------- */


			/* returns current time */
			_getTime:function(){
				if(window.performance && window.performance.now){
					return window.performance.now();
				}else{
					if(window.performance && window.performance.webkitNow){
						return window.performance.webkitNow();
					}else{
						if(Date.now){return Date.now();}else{return new Date().getTime();}
					}
				}
			},
			/* -------------------- */


			/* stops a tween */
			_stopTween:function(){
				var el=this;
				if(el._mcsid==null){return;}
				if(!window.requestAnimationFrame){clearTimeout(el._mcsid);
				}else{window.cancelAnimationFrame(el._mcsid);}
				el._mcsid=null;
				el._mcsstop=1;
			},
			/* -------------------- */


			/* deletes a property (avoiding the exception thrown by IE) */
			_delete:function(p){
				try{delete p;}catch(e){p=null;}
			},
			/* -------------------- */


			/* detects left mouse button */
			_mouseBtnLeft:function(e){
				return !(e.which && e.which!==1);
			},
			/* -------------------- */


			/* detects if pointer type event is touch */
			_pointerTouch:function(e){
				var t=e.originalEvent.pointerType;
				return !(t && t!=="touch" && t!==2);
			},
			/* -------------------- */


			/* checks if value is numeric */
			_isNumeric:function(val){
				return !isNaN(parseFloat(val)) && isFinite(val);
			}
			/* -------------------- */

		};





	/*
	----------------------------------------
	PLUGIN SETUP
	----------------------------------------
	*/

	/* plugin dependencies */
	var _dlp=("https:"==document.location.protocol) ? "https:" : "http:"; /* dependency location protocol */
	/* load jquery-mousewheel plugin (via CDN) if it's not present (works when mCustomScrollbar fn is called on window load) */
	$.event.special.mousewheel || $("head").append(decodeURI("%3Cscript src="+_dlp+"//cdnjs.cloudflare.com/ajax/libs/jquery-mousewheel/3.1.11/jquery.mousewheel.min.js%3E%3C/script%3E"));

	/* plugin constructor functions */
	$.fn[pluginNS]=function(method){ /* usage: $(selector).mCustomScrollbar(); */
		if(methods[method]){
			return methods[method].apply(this,Array.prototype.slice.call(arguments,1));
		}else if(typeof method==="object" || !method){
			return methods.init.apply(this,arguments);
		}else{
			$.error("Method "+method+" does not exist");
		}
	};
	$[pluginNS]=function(method){ /* usage: $.mCustomScrollbar(); */
		if(methods[method]){
			return methods[method].apply(this,Array.prototype.slice.call(arguments,1));
		}else if(typeof method==="object" || !method){
			return methods.init.apply(this,arguments);
		}else{
			$.error("Method "+method+" does not exist");
		}
	};

	/*
	allow setting plugin default options.
	usage: $.mCustomScrollbar.defaults.scrollInertia=500;
	to apply any changed default options on default selectors (below), use inside document ready fn
	e.g.: $(document).ready(function(){ $.mCustomScrollbar.defaults.scrollInertia=500; });
	*/
	$[pluginNS].defaults=defaults;

	/*
	add window object (window.mCustomScrollbar)
	usage: if(window.mCustomScrollbar){console.log("custom scrollbar plugin loaded");}
	*/
	window[pluginNS]=true;

	$(window).load(function(){
		$(defaultSelector)[pluginNS](); /* add scrollbars automatically on default selector */
	});

}(jq111, window, document);
/*!
 * hoverIntent r7 // 2013.03.11 // jQuery 1.9.1+
 * http://cherne.net/brian/resources/jquery.hoverIntent.html
 *
 * You may use hoverIntent under the terms of the MIT license. Basically that
 * means you are free to use hoverIntent as long as this header is left intact.
 * Copyright 2007, 2013 Brian Cherne
 */

/* hoverIntent is similar to jQuery's built-in "hover" method except that
 * instead of firing the handlerIn function immediately, hoverIntent checks
 * to see if the user's mouse has slowed down (beneath the sensitivity
 * threshold) before firing the event. The handlerOut function is only
 * called after a matching handlerIn.
 *
 * // basic usage ... just like .hover()
 * .hoverIntent( handlerIn, handlerOut )
 * .hoverIntent( handlerInOut )
 *
 * // basic usage ... with event delegation!
 * .hoverIntent( handlerIn, handlerOut, selector )
 * .hoverIntent( handlerInOut, selector )
 *
 * // using a basic configuration object
 * .hoverIntent( config )
 *
 * @param  handlerIn   function OR configuration object
 * @param  handlerOut  function OR selector for delegation OR undefined
 * @param  selector    selector OR undefined
 * @author Brian Cherne <brian(at)cherne(dot)net>
 */
+function($) {
    $.fn.hoverIntent = function(handlerIn,handlerOut,selector) {

        // default configuration values
        var cfg = {
            interval: 100,
            sensitivity: 7,
            timeout: 0
        };

        if ( typeof handlerIn === "object" ) {
            cfg = $.extend(cfg, handlerIn );
        } else if ($.isFunction(handlerOut)) {
            cfg = $.extend(cfg, { over: handlerIn, out: handlerOut, selector: selector } );
        } else {
            cfg = $.extend(cfg, { over: handlerIn, out: handlerIn, selector: handlerOut } );
        }

        // instantiate variables
        // cX, cY = current X and Y position of mouse, updated by mousemove event
        // pX, pY = previous X and Y position of mouse, set by mouseover and polling interval
        var cX, cY, pX, pY;

        // A private function for getting mouse position
        var track = function(ev) {
            cX = ev.pageX;
            cY = ev.pageY;
        };

        // A private function for comparing current and previous mouse position
        var compare = function(ev,ob) {
            ob.hoverIntent_t = clearTimeout(ob.hoverIntent_t);
            // compare mouse positions to see if they've crossed the threshold
            if ( ( Math.abs(pX-cX) + Math.abs(pY-cY) ) < cfg.sensitivity ) {
                $(ob).off("mousemove.hoverIntent",track);
                // set hoverIntent state to true (so mouseOut can be called)
                ob.hoverIntent_s = 1;
                return cfg.over.apply(ob,[ev]);
            } else {
                // set previous coordinates for next time
                pX = cX; pY = cY;
                // use self-calling timeout, guarantees intervals are spaced out properly (avoids JavaScript timer bugs)
                ob.hoverIntent_t = setTimeout( function(){compare(ev, ob);} , cfg.interval );
            }
        };

        // A private function for delaying the mouseOut function
        var delay = function(ev,ob) {
            ob.hoverIntent_t = clearTimeout(ob.hoverIntent_t);
            ob.hoverIntent_s = 0;
            return cfg.out.apply(ob,[ev]);
        };

        // A private function for handling mouse 'hovering'
        var handleHover = function(e) {
            // copy objects to be passed into t (required for event object to be passed in IE)
            var ev = jq111.extend({},e);
            var ob = this;

            // cancel hoverIntent timer if it exists
            if (ob.hoverIntent_t) { ob.hoverIntent_t = clearTimeout(ob.hoverIntent_t); }

            // if e.type == "mouseenter"
            if (e.type == "mouseenter") {
                // set "previous" X and Y position based on initial entry point
                pX = ev.pageX; pY = ev.pageY;
                // update "current" X and Y position based on mousemove
                $(ob).on("mousemove.hoverIntent",track);
                // start polling interval (self-calling timeout) to compare mouse coordinates over time
                if (ob.hoverIntent_s != 1) { ob.hoverIntent_t = setTimeout( function(){compare(ev,ob);} , cfg.interval );}

                // else e.type == "mouseleave"
            } else {
                // unbind expensive mousemove event
                $(ob).off("mousemove.hoverIntent",track);
                // if hoverIntent state is true, then call the mouseOut function after the specified delay
                if (ob.hoverIntent_s == 1) { ob.hoverIntent_t = setTimeout( function(){delay(ev,ob);} , cfg.timeout );}
            }
        };

        // listen for mouseenter and mouseleave
        return this.on({'mouseenter.hoverIntent':handleHover,'mouseleave.hoverIntent':handleHover}, cfg.selector);
    };
}(jq111);
/*! Magnific Popup - v0.9.9 - 2013-12-27
 * http://dimsemenov.com/plugins/magnific-popup/
 * Copyright (c) 2013 Dmitry Semenov; */
+function (e) {
    var t, n, i, o, r, a, s, l = "Close",
        c = "BeforeClose",
        d = "AfterClose",
        u = "BeforeAppend",
        p = "MarkupParse",
        f = "Open",
        m = "Change",
        g = "mfp",
        h = "." + g,
        v = "mfp-ready",
        C = "mfp-removing",
        y = "mfp-prevent-close",
        w = function () {},
        b = !!window.jQuery,
        I = e(window),
        x = function (e, n) {
            t.ev.on(g + e + h, n)
        },
        k = function (t, n, i, o) {
            var r = document.createElement("div");
            return r.className = "mfp-" + t, i && (r.innerHTML = i), o ? n && n.appendChild(r) : (r = e(r), n && r.appendTo(n)), r
        },
        T = function (n, i) {
            t.ev.triggerHandler(g + n, i), t.st.callbacks && (n = n.charAt(0).toLowerCase() + n.slice(1), t.st.callbacks[n] && t.st.callbacks[n].apply(t, e.isArray(i) ? i : [i]))
        },
        E = function (n) {
            return n === s && t.currTemplate.closeBtn || (t.currTemplate.closeBtn = e(t.st.closeMarkup.replace("%title%", t.st.tClose)), s = n), t.currTemplate.closeBtn
        },
        _ = function () {
            e.magnificPopup.instance || (t = new w, t.init(), e.magnificPopup.instance = t)
        },
        S = function () {
            var e = document.createElement("p").style,
                t = ["ms", "O", "Moz", "Webkit"];
            if (void 0 !== e.transition) return !0;
            for (; t.length;)
                if (t.pop() + "Transition" in e) return !0;
            return !1
        };
    w.prototype = {
        constructor: w,
        init: function () {
            var n = navigator.appVersion;
            t.isIE7 = -1 !== n.indexOf("MSIE 7."), t.isIE8 = -1 !== n.indexOf("MSIE 8."), t.isLowIE = t.isIE7 || t.isIE8, t.isAndroid = /android/gi.test(n), t.isIOS = /iphone|ipad|ipod/gi.test(n), t.supportsTransition = S(), t.probablyMobile = t.isAndroid || t.isIOS || /(Opera Mini)|Kindle|webOS|BlackBerry|(Opera Mobi)|(Windows Phone)|IEMobile/i.test(navigator.userAgent), o = e(document), t.popupsCache = {}
        },
        open: function (n) {
            i || (i = e(document.body));
            var r;
            if (n.isObj === !1) {
                t.items = n.items.toArray(), t.index = 0;
                var s, l = n.items;
                for (r = 0; l.length > r; r++)
                    if (s = l[r], s.parsed && (s = s.el[0]), s === n.el[0]) {
                        t.index = r;
                        break
                    }
            } else t.items = e.isArray(n.items) ? n.items : [n.items], t.index = n.index || 0; if (t.isOpen) return t.updateItemHTML(), void 0;
            t.types = [], a = "", t.ev = n.mainEl && n.mainEl.length ? n.mainEl.eq(0) : o, n.key ? (t.popupsCache[n.key] || (t.popupsCache[n.key] = {}), t.currTemplate = t.popupsCache[n.key]) : t.currTemplate = {}, t.st = e.extend(!0, {}, e.magnificPopup.defaults, n), t.fixedContentPos = "auto" === t.st.fixedContentPos ? !t.probablyMobile : t.st.fixedContentPos, t.st.modal && (t.st.closeOnContentClick = !1, t.st.closeOnBgClick = !1, t.st.showCloseBtn = !1, t.st.enableEscapeKey = !1), t.bgOverlay || (t.bgOverlay = k("bg").on("click" + h, function () {
                t.close()
            }), t.wrap = k("wrap").attr("tabindex", -1).on("click" + h, function (e) {
                t._checkIfClose(e.target) && t.close()
            }), t.container = k("container", t.wrap)), t.contentContainer = k("content"), t.st.preloader && (t.preloader = k("preloader", t.container, t.st.tLoading));
            var c = e.magnificPopup.modules;
            for (r = 0; c.length > r; r++) {
                var d = c[r];
                d = d.charAt(0).toUpperCase() + d.slice(1), t["init" + d].call(t)
            }
            T("BeforeOpen"), t.st.showCloseBtn && (t.st.closeBtnInside ? (x(p, function (e, t, n, i) {
                n.close_replaceWith = E(i.type)
            }), a += " mfp-close-btn-in") : t.wrap.append(E())), t.st.alignTop && (a += " mfp-align-top"), t.fixedContentPos ? t.wrap.css({
                overflow: t.st.overflowY,
                overflowX: "hidden",
                overflowY: t.st.overflowY
            }) : t.wrap.css({
                top: I.scrollTop(),
                position: "absolute"
            }), (t.st.fixedBgPos === !1 || "auto" === t.st.fixedBgPos && !t.fixedContentPos) && t.bgOverlay.css({
                height: o.height(),
                position: "absolute"
            }), t.st.enableEscapeKey && o.on("keyup" + h, function (e) {
                27 === e.keyCode && t.close()
            }), I.on("resize" + h, function () {
                t.updateSize()
            }), t.st.closeOnContentClick || (a += " mfp-auto-cursor"), a && t.wrap.addClass(a);
            var u = t.wH = I.height(),
                m = {};
            if (t.fixedContentPos && t._hasScrollBar(u)) {
                var g = t._getScrollbarSize();
                g && (m.marginRight = g)
            }
            t.fixedContentPos && (t.isIE7 ? e("body, html").css("overflow", "hidden") : m.overflow = "hidden");
            var C = t.st.mainClass;
            return t.isIE7 && (C += " mfp-ie7"), C && t._addClassToMFP(C), t.updateItemHTML(), T("BuildControls"), e("html").css(m), t.bgOverlay.add(t.wrap).prependTo(t.st.prependTo || i), t._lastFocusedEl = document.activeElement, setTimeout(function () {
                t.content ? (t._addClassToMFP(v), t._setFocus()) : t.bgOverlay.addClass(v), o.on("focusin" + h, t._onFocusIn)
            }, 16), t.isOpen = !0, t.updateSize(u), T(f), n
        },
        close: function () {
            t.isOpen && (T(c), t.isOpen = !1, t.st.removalDelay && !t.isLowIE && t.supportsTransition ? (t._addClassToMFP(C), setTimeout(function () {
                t._close()
            }, t.st.removalDelay)) : t._close())
        },
        _close: function () {
            T(l);
            var n = C + " " + v + " ";
            if (t.bgOverlay.detach(), t.wrap.detach(), t.container.empty(), t.st.mainClass && (n += t.st.mainClass + " "), t._removeClassFromMFP(n), t.fixedContentPos) {
                var i = {
                    marginRight: ""
                };
                t.isIE7 ? e("body, html").css("overflow", "") : i.overflow = "", e("html").css(i)
            }
            o.off("keyup" + h + " focusin" + h), t.ev.off(h), t.wrap.attr("class", "mfp-wrap").removeAttr("style"), t.bgOverlay.attr("class", "mfp-bg"), t.container.attr("class", "mfp-container"), !t.st.showCloseBtn || t.st.closeBtnInside && t.currTemplate[t.currItem.type] !== !0 || t.currTemplate.closeBtn && t.currTemplate.closeBtn.detach(), t._lastFocusedEl && e(t._lastFocusedEl).focus(), t.currItem = null, t.content = null, t.currTemplate = null, t.prevHeight = 0, T(d)
        },
        updateSize: function (e) {
            if (t.isIOS) {
                var n = document.documentElement.clientWidth / window.innerWidth,
                    i = window.innerHeight * n;
                t.wrap.css("height", i), t.wH = i
            } else t.wH = e || I.height();
            t.fixedContentPos || t.wrap.css("height", t.wH), T("Resize")
        },
        updateItemHTML: function () {
            var n = t.items[t.index];
            t.contentContainer.detach(), t.content && t.content.detach(), n.parsed || (n = t.parseEl(t.index));
            var i = n.type;
            if (T("BeforeChange", [t.currItem ? t.currItem.type : "", i]), t.currItem = n, !t.currTemplate[i]) {
                var o = t.st[i] ? t.st[i].markup : !1;
                T("FirstMarkupParse", o), t.currTemplate[i] = o ? e(o) : !0
            }
            r && r !== n.type && t.container.removeClass("mfp-" + r + "-holder");
            var a = t["get" + i.charAt(0).toUpperCase() + i.slice(1)](n, t.currTemplate[i]);
            t.appendContent(a, i), n.preloaded = !0, T(m, n), r = n.type, t.container.prepend(t.contentContainer), T("AfterChange")
        },
        appendContent: function (e, n) {
            t.content = e, e ? t.st.showCloseBtn && t.st.closeBtnInside && t.currTemplate[n] === !0 ? t.content.find(".mfp-close").length || t.content.append(E()) : t.content = e : t.content = "", T(u), t.container.addClass("mfp-" + n + "-holder"), t.contentContainer.append(t.content)
        },
        parseEl: function (n) {
            var i, o = t.items[n];
            if (o.tagName ? o = {
                el: e(o)
            } : (i = o.type, o = {
                data: o,
                src: o.src
            }), o.el) {
                for (var r = t.types, a = 0; r.length > a; a++)
                    if (o.el.hasClass("mfp-" + r[a])) {
                        i = r[a];
                        break
                    }
                o.src = o.el.attr("data-mfp-src"), o.src || (o.src = o.el.attr("href"))
            }
            return o.type = i || t.st.type || "inline", o.index = n, o.parsed = !0, t.items[n] = o, T("ElementParse", o), t.items[n]
        },
        addGroup: function (e, n) {
            var i = function (i) {
                i.mfpEl = this, t._openClick(i, e, n)
            };
            n || (n = {});
            var o = "click.magnificPopup";
            n.mainEl = e, n.items ? (n.isObj = !0, e.off(o).on(o, i)) : (n.isObj = !1, n.delegate ? e.off(o).on(o, n.delegate, i) : (n.items = e, e.off(o).on(o, i)))
        },
        _openClick: function (n, i, o) {
            var r = void 0 !== o.midClick ? o.midClick : e.magnificPopup.defaults.midClick;
            if (r || 2 !== n.which && !n.ctrlKey && !n.metaKey) {
                var a = void 0 !== o.disableOn ? o.disableOn : e.magnificPopup.defaults.disableOn;
                if (a)
                    if (e.isFunction(a)) {
                        if (!a.call(t)) return !0
                    } else if (a > I.width()) return !0;
                n.type && (n.preventDefault(), t.isOpen && n.stopPropagation()), o.el = e(n.mfpEl), o.delegate && (o.items = i.find(o.delegate)), t.open(o)
            }
        },
        updateStatus: function (e, i) {
            if (t.preloader) {
                n !== e && t.container.removeClass("mfp-s-" + n), i || "loading" !== e || (i = t.st.tLoading);
                var o = {
                    status: e,
                    text: i
                };
                T("UpdateStatus", o), e = o.status, i = o.text, t.preloader.html(i), t.preloader.find("a").on("click", function (e) {
                    e.stopImmediatePropagation()
                }), t.container.addClass("mfp-s-" + e), n = e
            }
        },
        _checkIfClose: function (n) {
            if (!e(n).hasClass(y)) {
                var i = t.st.closeOnContentClick,
                    o = t.st.closeOnBgClick;
                if (i && o) return !0;
                if (!t.content || e(n).hasClass("mfp-close") || t.preloader && n === t.preloader[0]) return !0;
                if (n === t.content[0] || e.contains(t.content[0], n)) {
                    if (i) return !0
                } else if (o && e.contains(document, n)) return !0;
                return !1
            }
        },
        _addClassToMFP: function (e) {
            t.bgOverlay.addClass(e), t.wrap.addClass(e)
        },
        _removeClassFromMFP: function (e) {
            this.bgOverlay.removeClass(e), t.wrap.removeClass(e)
        },
        _hasScrollBar: function (e) {
            return (t.isIE7 ? o.height() : document.body.scrollHeight) > (e || I.height())
        },
        _setFocus: function () {
            (t.st.focus ? t.content.find(t.st.focus).eq(0) : t.wrap).focus()
        },
        _onFocusIn: function (n) {
            return n.target === t.wrap[0] || e.contains(t.wrap[0], n.target) ? void 0 : (t._setFocus(), !1)
        },
        _parseMarkup: function (t, n, i) {
            var o;
            i.data && (n = e.extend(i.data, n)), T(p, [t, n, i]), e.each(n, function (e, n) {
                if (void 0 === n || n === !1) return !0;
                if (o = e.split("_"), o.length > 1) {
                    var i = t.find(h + "-" + o[0]);
                    if (i.length > 0) {
                        var r = o[1];
                        "replaceWith" === r ? i[0] !== n[0] && i.replaceWith(n) : "img" === r ? i.is("img") ? i.attr("src", n) : i.replaceWith('<img src="' + n + '" class="' + i.attr("class") + '" />') : i.attr(o[1], n)
                    }
                } else t.find(h + "-" + e).html(n)
            })
        },
        _getScrollbarSize: function () {
            if (void 0 === t.scrollbarSize) {
                var e = document.createElement("div");
                e.id = "mfp-sbm", e.style.cssText = "width: 99px; height: 99px; overflow: scroll; position: absolute; top: -9999px;", document.body.appendChild(e), t.scrollbarSize = e.offsetWidth - e.clientWidth, document.body.removeChild(e)
            }
            return t.scrollbarSize
        }
    }, e.magnificPopup = {
        instance: null,
        proto: w.prototype,
        modules: [],
        open: function (t, n) {
            return _(), t = t ? e.extend(!0, {}, t) : {}, t.isObj = !0, t.index = n || 0, this.instance.open(t)
        },
        close: function () {
            return e.magnificPopup.instance && e.magnificPopup.instance.close()
        },
        registerModule: function (t, n) {
            n.options && (e.magnificPopup.defaults[t] = n.options), e.extend(this.proto, n.proto), this.modules.push(t)
        },
        defaults: {
            disableOn: 0,
            key: null,
            midClick: !1,
            mainClass: "",
            preloader: !0,
            focus: "",
            closeOnContentClick: !1,
            closeOnBgClick: !0,
            closeBtnInside: !0,
            showCloseBtn: !0,
            enableEscapeKey: !0,
            modal: !1,
            alignTop: !1,
            removalDelay: 0,
            prependTo: null,
            fixedContentPos: "auto",
            fixedBgPos: "auto",
            overflowY: "auto",
            closeMarkup: '<button title="%title%" type="button" class="mfp-close">&times;</button>',
            tClose: "Close (Esc)",
            tLoading: "Loading..."
        }
    }, e.fn.magnificPopup = function (n) {
        _();
        var i = e(this);
        if ("string" == typeof n)
            if ("open" === n) {
                var o, r = b ? i.data("magnificPopup") : i[0].magnificPopup,
                    a = parseInt(arguments[1], 10) || 0;
                r.items ? o = r.items[a] : (o = i, r.delegate && (o = o.find(r.delegate)), o = o.eq(a)), t._openClick({
                    mfpEl: o
                }, i, r)
            } else t.isOpen && t[n].apply(t, Array.prototype.slice.call(arguments, 1));
        else n = e.extend(!0, {}, n), b ? i.data("magnificPopup", n) : i[0].magnificPopup = n, t.addGroup(i, n);
        return i
    };
    var P, O, z, M = "inline",
        B = function () {
            z && (O.after(z.addClass(P)).detach(), z = null)
        };
    e.magnificPopup.registerModule(M, {
        options: {
            hiddenClass: "hide",
            markup: "",
            tNotFound: "Content not found"
        },
        proto: {
            initInline: function () {
                t.types.push(M), x(l + "." + M, function () {
                    B()
                })
            },
            getInline: function (n, i) {
                if (B(), n.src) {
                    var o = t.st.inline,
                        r = e(n.src);
                    if (r.length) {
                        var a = r[0].parentNode;
                        a && a.tagName && (O || (P = o.hiddenClass, O = k(P), P = "mfp-" + P), z = r.after(O).detach().removeClass(P)), t.updateStatus("ready")
                    } else t.updateStatus("error", o.tNotFound), r = e("<div>");
                    return n.inlineElement = r, r
                }
                return t.updateStatus("ready"), t._parseMarkup(i, {}, n), i
            }
        }
    });
    var F, H = "ajax",
        L = function () {
            F && i.removeClass(F)
        },
        A = function () {
            L(), t.req && t.req.abort()
        };
    e.magnificPopup.registerModule(H, {
        options: {
            settings: null,
            cursor: "mfp-ajax-cur",
            tError: '<a href="%url%">The content</a> could not be loaded.'
        },
        proto: {
            initAjax: function () {
                t.types.push(H), F = t.st.ajax.cursor, x(l + "." + H, A), x("BeforeChange." + H, A)
            },
            getAjax: function (n) {
                F && i.addClass(F), t.updateStatus("loading");
                var o = e.extend({
                    url: n.src,
                    success: function (i, o, r) {
                        var a = {
                            data: i,
                            xhr: r
                        };
                        T("ParseAjax", a), t.appendContent(e(a.data), H), n.finished = !0, L(), t._setFocus(), setTimeout(function () {
                            t.wrap.addClass(v)
                        }, 16), t.updateStatus("ready"), T("AjaxContentAdded")
                    },
                    error: function () {
                        L(), n.finished = n.loadError = !0, t.updateStatus("error", t.st.ajax.tError.replace("%url%", n.src))
                    }
                }, t.st.ajax.settings);
                return t.req = e.ajax(o), ""
            }
        }
    });
    var j, N = function (n) {
        if (n.data && void 0 !== n.data.title) return n.data.title;
        var i = t.st.image.titleSrc;
        if (i) {
            if (e.isFunction(i)) return i.call(t, n);
            if (n.el) return n.el.attr(i) || ""
        }
        return ""
    };
    e.magnificPopup.registerModule("image", {
        options: {
            markup: '<div class="mfp-figure"><div class="mfp-close"></div><figure><div class="mfp-img"></div><figcaption><div class="mfp-bottom-bar"><div class="mfp-title"></div><div class="mfp-counter"></div></div></figcaption></figure></div>',
            cursor: "mfp-zoom-out-cur",
            titleSrc: "title",
            verticalFit: !0,
            tError: '<a href="%url%">The image</a> could not be loaded.'
        },
        proto: {
            initImage: function () {
                var e = t.st.image,
                    n = ".image";
                t.types.push("image"), x(f + n, function () {
                    "image" === t.currItem.type && e.cursor && i.addClass(e.cursor)
                }), x(l + n, function () {
                    e.cursor && i.removeClass(e.cursor), I.off("resize" + h)
                }), x("Resize" + n, t.resizeImage), t.isLowIE && x("AfterChange", t.resizeImage)
            },
            resizeImage: function () {
                var e = t.currItem;
                if (e && e.img && t.st.image.verticalFit) {
                    var n = 0;
                    t.isLowIE && (n = parseInt(e.img.css("padding-top"), 10) + parseInt(e.img.css("padding-bottom"), 10)), e.img.css("max-height", t.wH - n)
                }
            },
            _onImageHasSize: function (e) {
                e.img && (e.hasSize = !0, j && clearInterval(j), e.isCheckingImgSize = !1, T("ImageHasSize", e), e.imgHidden && (t.content && t.content.removeClass("mfp-loading"), e.imgHidden = !1))
            },
            findImageSize: function (e) {
                var n = 0,
                    i = e.img[0],
                    o = function (r) {
                        j && clearInterval(j), j = setInterval(function () {
                            return i.naturalWidth > 0 ? (t._onImageHasSize(e), void 0) : (n > 200 && clearInterval(j), n++, 3 === n ? o(10) : 40 === n ? o(50) : 100 === n && o(500), void 0)
                        }, r)
                    };
                o(1)
            },
            getImage: function (n, i) {
                var o = 0,
                    r = function () {
                        n && (n.img[0].complete ? (n.img.off(".mfploader"), n === t.currItem && (t._onImageHasSize(n), t.updateStatus("ready")), n.hasSize = !0, n.loaded = !0, T("ImageLoadComplete")) : (o++, 200 > o ? setTimeout(r, 100) : a()))
                    },
                    a = function () {
                        n && (n.img.off(".mfploader"), n === t.currItem && (t._onImageHasSize(n), t.updateStatus("error", s.tError.replace("%url%", n.src))), n.hasSize = !0, n.loaded = !0, n.loadError = !0)
                    },
                    s = t.st.image,
                    l = i.find(".mfp-img");
                if (l.length) {
                    var c = document.createElement("img");
                    c.className = "mfp-img", n.img = e(c).on("load.mfploader", r).on("error.mfploader", a), c.src = n.src, l.is("img") && (n.img = n.img.clone()), c = n.img[0], c.naturalWidth > 0 ? n.hasSize = !0 : c.width || (n.hasSize = !1)
                }
                return t._parseMarkup(i, {
                    title: N(n),
                    img_replaceWith: n.img
                }, n), t.resizeImage(), n.hasSize ? (j && clearInterval(j), n.loadError ? (i.addClass("mfp-loading"), t.updateStatus("error", s.tError.replace("%url%", n.src))) : (i.removeClass("mfp-loading"), t.updateStatus("ready")), i) : (t.updateStatus("loading"), n.loading = !0, n.hasSize || (n.imgHidden = !0, i.addClass("mfp-loading"), t.findImageSize(n)), i)
            }
        }
    });
    var W, R = function () {
        return void 0 === W && (W = void 0 !== document.createElement("p").style.MozTransform), W
    };
    e.magnificPopup.registerModule("zoom", {
        options: {
            enabled: !1,
            easing: "ease-in-out",
            duration: 300,
            opener: function (e) {
                return e.is("img") ? e : e.find("img")
            }
        },
        proto: {
            initZoom: function () {
                var e, n = t.st.zoom,
                    i = ".zoom";
                if (n.enabled && t.supportsTransition) {
                    var o, r, a = n.duration,
                        s = function (e) {
                            var t = e.clone().removeAttr("style").removeAttr("class").addClass("mfp-animated-image"),
                                i = "all " + n.duration / 1e3 + "s " + n.easing,
                                o = {
                                    position: "fixed",
                                    zIndex: 9999,
                                    left: 0,
                                    top: 0,
                                    "-webkit-backface-visibility": "hidden"
                                },
                                r = "transition";
                            return o["-webkit-" + r] = o["-moz-" + r] = o["-o-" + r] = o[r] = i, t.css(o), t
                        },
                        d = function () {
                            t.content.css("visibility", "visible")
                        };
                    x("BuildControls" + i, function () {
                        if (t._allowZoom()) {
                            if (clearTimeout(o), t.content.css("visibility", "hidden"), e = t._getItemToZoom(), !e) return d(), void 0;
                            r = s(e), r.css(t._getOffset()), t.wrap.append(r), o = setTimeout(function () {
                                r.css(t._getOffset(!0)), o = setTimeout(function () {
                                    d(), setTimeout(function () {
                                        r.remove(), e = r = null, T("ZoomAnimationEnded")
                                    }, 16)
                                }, a)
                            }, 16)
                        }
                    }), x(c + i, function () {
                        if (t._allowZoom()) {
                            if (clearTimeout(o), t.st.removalDelay = a, !e) {
                                if (e = t._getItemToZoom(), !e) return;
                                r = s(e)
                            }
                            r.css(t._getOffset(!0)), t.wrap.append(r), t.content.css("visibility", "hidden"), setTimeout(function () {
                                r.css(t._getOffset())
                            }, 16)
                        }
                    }), x(l + i, function () {
                        t._allowZoom() && (d(), r && r.remove(), e = null)
                    })
                }
            },
            _allowZoom: function () {
                return "image" === t.currItem.type
            },
            _getItemToZoom: function () {
                return t.currItem.hasSize ? t.currItem.img : !1
            },
            _getOffset: function (n) {
                var i;
                i = n ? t.currItem.img : t.st.zoom.opener(t.currItem.el || t.currItem);
                var o = i.offset(),
                    r = parseInt(i.css("padding-top"), 10),
                    a = parseInt(i.css("padding-bottom"), 10);
                o.top -= e(window).scrollTop() - r;
                var s = {
                    width: i.width(),
                    height: (b ? i.innerHeight() : i[0].offsetHeight) - a - r
                };
                return R() ? s["-moz-transform"] = s.transform = "translate(" + o.left + "px," + o.top + "px)" : (s.left = o.left, s.top = o.top), s
            }
        }
    });
    var Z = "iframe",
        q = "//about:blank",
        D = function (e) {
            if (t.currTemplate[Z]) {
                var n = t.currTemplate[Z].find("iframe");
                n.length && (e || (n[0].src = q), t.isIE8 && n.css("display", e ? "block" : "none"))
            }
        };
    e.magnificPopup.registerModule(Z, {
        options: {
            markup: '<div class="mfp-iframe-scaler"><div class="mfp-close"></div><iframe class="mfp-iframe" src="//about:blank" frameborder="0" allowfullscreen></iframe></div>',
            srcAction: "iframe_src",
            patterns: {
                youtube: {
                    index: "youtube.com",
                    id: "v=",
                    src: "//www.youtube.com/embed/%id%?autoplay=1"
                },
                vimeo: {
                    index: "vimeo.com/",
                    id: "/",
                    src: "//player.vimeo.com/video/%id%?autoplay=1"
                },
                gmaps: {
                    index: "//maps.google.",
                    src: "%id%&output=embed"
                }
            }
        },
        proto: {
            initIframe: function () {
                t.types.push(Z), x("BeforeChange", function (e, t, n) {
                    t !== n && (t === Z ? D() : n === Z && D(!0))
                }), x(l + "." + Z, function () {
                    D()
                })
            },
            getIframe: function (n, i) {
                var o = n.src,
                    r = t.st.iframe;
                e.each(r.patterns, function () {
                    return o.indexOf(this.index) > -1 ? (this.id && (o = "string" == typeof this.id ? o.substr(o.lastIndexOf(this.id) + this.id.length, o.length) : this.id.call(this, o)), o = this.src.replace("%id%", o), !1) : void 0
                });
                var a = {};
                return r.srcAction && (a[r.srcAction] = o), t._parseMarkup(i, a, n), t.updateStatus("ready"), i
            }
        }
    });
    var K = function (e) {
            var n = t.items.length;
            return e > n - 1 ? e - n : 0 > e ? n + e : e
        },
        Y = function (e, t, n) {
            return e.replace(/%curr%/gi, t + 1).replace(/%total%/gi, n)
        };
    e.magnificPopup.registerModule("gallery", {
        options: {
            enabled: !1,
            arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>',
            preload: [0, 2],
            navigateByImgClick: !0,
            arrows: !0,
            tPrev: "Previous (Left arrow key)",
            tNext: "Next (Right arrow key)",
            tCounter: "%curr% of %total%"
        },
        proto: {
            initGallery: function () {
                var n = t.st.gallery,
                    i = ".mfp-gallery",
                    r = Boolean(e.fn.mfpFastClick);
                return t.direction = !0, n && n.enabled ? (a += " mfp-gallery", x(f + i, function () {
                    n.navigateByImgClick && t.wrap.on("click" + i, ".mfp-img", function () {
                        return t.items.length > 1 ? (t.next(), !1) : void 0
                    }), o.on("keydown" + i, function (e) {
                        37 === e.keyCode ? t.prev() : 39 === e.keyCode && t.next()
                    })
                }), x("UpdateStatus" + i, function (e, n) {
                    n.text && (n.text = Y(n.text, t.currItem.index, t.items.length))
                }), x(p + i, function (e, i, o, r) {
                    var a = t.items.length;
                    o.counter = a > 1 ? Y(n.tCounter, r.index, a) : ""
                }), x("BuildControls" + i, function () {
                    if (t.items.length > 1 && n.arrows && !t.arrowLeft) {
                        var i = n.arrowMarkup,
                            o = t.arrowLeft = e(i.replace(/%title%/gi, n.tPrev).replace(/%dir%/gi, "left")).addClass(y),
                            a = t.arrowRight = e(i.replace(/%title%/gi, n.tNext).replace(/%dir%/gi, "right")).addClass(y),
                            s = r ? "mfpFastClick" : "click";
                        o[s](function () {
                            t.prev()
                        }), a[s](function () {
                            t.next()
                        }), t.isIE7 && (k("b", o[0], !1, !0), k("a", o[0], !1, !0), k("b", a[0], !1, !0), k("a", a[0], !1, !0)), t.container.append(o.add(a))
                    }
                }), x(m + i, function () {
                    t._preloadTimeout && clearTimeout(t._preloadTimeout), t._preloadTimeout = setTimeout(function () {
                        t.preloadNearbyImages(), t._preloadTimeout = null
                    }, 16)
                }), x(l + i, function () {
                    o.off(i), t.wrap.off("click" + i), t.arrowLeft && r && t.arrowLeft.add(t.arrowRight).destroyMfpFastClick(), t.arrowRight = t.arrowLeft = null
                }), void 0) : !1
            },
            next: function () {
                t.direction = !0, t.index = K(t.index + 1), t.updateItemHTML()
            },
            prev: function () {
                t.direction = !1, t.index = K(t.index - 1), t.updateItemHTML()
            },
            goTo: function (e) {
                t.direction = e >= t.index, t.index = e, t.updateItemHTML()
            },
            preloadNearbyImages: function () {
                var e, n = t.st.gallery.preload,
                    i = Math.min(n[0], t.items.length),
                    o = Math.min(n[1], t.items.length);
                for (e = 1;
                    (t.direction ? o : i) >= e; e++) t._preloadItem(t.index + e);
                for (e = 1;
                    (t.direction ? i : o) >= e; e++) t._preloadItem(t.index - e)
            },
            _preloadItem: function (n) {
                if (n = K(n), !t.items[n].preloaded) {
                    var i = t.items[n];
                    i.parsed || (i = t.parseEl(n)), T("LazyLoad", i), "image" === i.type && (i.img = e('<img class="mfp-img" />').on("load.mfploader", function () {
                        i.hasSize = !0
                    }).on("error.mfploader", function () {
                        i.hasSize = !0, i.loadError = !0, T("LazyLoadError", i)
                    }).attr("src", i.src)), i.preloaded = !0
                }
            }
        }
    });
    var U = "retina";
    e.magnificPopup.registerModule(U, {
        options: {
            replaceSrc: function (e) {
                return e.src.replace(/\.\w+$/, function (e) {
                    return "@2x" + e
                })
            },
            ratio: 1
        },
        proto: {
            initRetina: function () {
                if (window.devicePixelRatio > 1) {
                    var e = t.st.retina,
                        n = e.ratio;
                    n = isNaN(n) ? n() : n, n > 1 && (x("ImageHasSize." + U, function (e, t) {
                        t.img.css({
                            "max-width": t.img[0].naturalWidth / n,
                            width: "100%"
                        })
                    }), x("ElementParse." + U, function (t, i) {
                        i.src = e.replaceSrc(i, n)
                    }))
                }
            }
        }
    }),
    function () {
        var t = 1e3,
            n = "ontouchstart" in window,
            i = function () {
                I.off("touchmove" + r + " touchend" + r)
            },
            o = "mfpFastClick",
            r = "." + o;
        e.fn.mfpFastClick = function (o) {
            return e(this).each(function () {
                var a, s = e(this);
                if (n) {
                    var l, c, d, u, p, f;
                    s.on("touchstart" + r, function (e) {
                        u = !1, f = 1, p = e.originalEvent ? e.originalEvent.touches[0] : e.touches[0], c = p.clientX, d = p.clientY, I.on("touchmove" + r, function (e) {
                            p = e.originalEvent ? e.originalEvent.touches : e.touches, f = p.length, p = p[0], (Math.abs(p.clientX - c) > 10 || Math.abs(p.clientY - d) > 10) && (u = !0, i())
                        }).on("touchend" + r, function (e) {
                            i(), u || f > 1 || (a = !0, e.preventDefault(), clearTimeout(l), l = setTimeout(function () {
                                a = !1
                            }, t), o())
                        })
                    })
                }
                s.on("click" + r, function () {
                    a || o()
                })
            })
        }, e.fn.destroyMfpFastClick = function () {
            e(this).off("touchstart" + r + " click" + r), n && I.off("touchmove" + r + " touchend" + r)
        }
    }(), _()
}(jq111);
/* jQuery Plugins for Kentico */

+function ($) {

    $.namespace('Deepend', {
        UpdateWebPart: function (settings) {
            if (this.length == 1) {
                this.each(function () {

                    var $self = $(this);

                    var payload = $.extend(true, {
                        documentId: $self.data('documentid'),
                        webPartId: $self.data('webpartid'),
                        shuffleIndex: $self.data('shuffleindex'),
                    }, settings);

                    if (typeof payload.success === "function")
                        delete payload.success;

                    $.ajax({
                        url: '/api/Module/Get',
                        dataType: 'json',
                        data: payload,
                        success: function (data) {
                            $self.html(data.Content);

                            if (typeof settings.success === "function")
                                settings.success(data);
                        }
                    });
                });
            } else {
                var payload = { WebPart: [] };

                this.each(function () {

                    var $self = $(this);

                    payload.DocumentId = $self.data('documentid');

                    var properties = $.extend(true, { shuffleIndex: $self.data('shuffleindex'), }, settings);

                    if (typeof properties.success === "function")
                        delete properties.success;

                    var propertyList = [];
                    for (key in properties)
                        propertyList.push({ key: key, value: properties[key] });

                    var webpart = {
                        WebPartId: $self.data('webpartid'),
                        PropertyList: propertyList,
                        // Properties: properties
                    };

                    payload.WebPart.push(webpart);

                });

                var $all = this;

                $.ajax({
                    url: '/api/Module/GetMany',
                    dataType: 'json',
                    data: payload,
                    method: 'POST',
                    success: function (data) {

                        // Initialize New Buffer
                        var buffer = {};

                        // Convert to Dictionary
                        for (i = 0, j = data.length; i < j; i++)
                            buffer[data[i].WebPartID] = data[i];

                        // Apply HTML to Page
                        $all.each(function () {

                            var $self = $(this);

                            $self.html(buffer[$self.data('webpartid')].Content);

                        });

                        // Run Success Function
                        if (typeof settings.success === "function")
                            settings.success(data);
                    }
                });
            }
        }
    });

}(jq111)
/*
This function defines the state of the screen view, based on
predefined breakpoints. This fires on load, and on resize events
(see timeOut event below). Additionally, on resize this function
broadcasts an event, based on screen size, which can be bound to
DOM elements; useful if plugins (such as sliders etc) need to
be re-instantiated
*/

/*To bind DOM elements to listed to broadcasted trigger, follow
the below pattern:

FOR A SINGLE TRIGGER:
This will change the background colour of the supplied elem
when screensize is small (sm), or less than 480px wide

$('.element-selctor').bind('sm', function() {
    $(this).css('background-color','red');
});

FOR A MULTIPLE TRIGGERS:

$('element-selctor').bind({
    'sm': function() {
        $(this).css('background-color','red');
    },
    'md': function() {
        $(this).css('background-color','green');
    },
    'lg': function() {
        $(this).css('background-color','blue');
    },
    'xlg': function() {
        $(this).css('background-color','yellow');
    }
});

*/

+function($){
    screenView = 'default';
    viewPortDetect = function(){
        var w = window.innerWidth;
        var h = window.innerHeight;

        //Custom conditions for messaging module
        if ( w > 480 && w <= 568 ) {

            var messagingElement = $('#orientation-message');
            messagingElement.css('display','block');
            messagingTimer = setTimeout(function(){

                messagingElement.animate({
                    opacity: 0
                }, 1000, function () {
                    // Animation complete.
                    messagingElement.css('display','none');
                    clearTimeout(messagingTimer);
                });

            }, 3000);
        }


        if(w <= 480){

            screenView = 'sm';
            $.trigger('sm');

        } else if ( w >= 480 && w <= 768 ) {

            screenView = 'md';
            $.trigger('md');

        } else if ( w > 768 && w <= 1024 ) {

            screenView = 'lg';
            $.trigger('lg');

        } else if ( w > 1024 ) {

            screenView = 'xlg';
            $.trigger('xlg');

        }

        //Bind resize event to above function
        var resizeTimer;
        //$(window).resize(function() {  //BAD
        window.onresize=(function() {    //GOOD
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function(){
                viewPortDetect();
            }, 50);
        });

        console.log('VIEWPORT DETECT :: ScreenView = ' + screenView);
    }
}(jq111);
/*
* FlowType.JS v1.1
* Copyright 2013-2014, Simple Focus http://simplefocus.com/
*
* FlowType.JS by Simple Focus (http://simplefocus.com/)
* is licensed under the MIT License. Read a copy of the
* license in the LICENSE.txt file or at
* http://choosealicense.com/licenses/mit
*
* Thanks to Giovanni Difeterici (http://www.gdifeterici.com/)
*/

+function($) {
   $.fn.flowtype = function(options) {

// Establish default settings/variables
// ====================================
      var settings = $.extend({
         maximum   : 9999,
         minimum   : 1,
         maxFont   : 9999,
         minFont   : 1,
         fontRatio : 35
      }, options),

// Do the magic math
// =================
      changes = function(el) {
         var $el = $(el),
            elw = $el.width(),
            width = elw > settings.maximum ? settings.maximum : elw < settings.minimum ? settings.minimum : elw,
            fontBase = width / settings.fontRatio,
            fontSize = fontBase > settings.maxFont ? settings.maxFont : fontBase < settings.minFont ? settings.minFont : fontBase;
         $el.css('font-size', fontSize + 'px');
      };

// Make the magic visible
// ======================
      return this.each(function() {
      // Context for resize callback
         var that = this;
      // Make changes upon resize
         $(window).resize(function(){changes(that);});
      // Set changes on load
         changes(this);
      });
   };
}(jq111);
//! moment.js
//! version : 2.7.0
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

(function (undefined) {

    /************************************
        Constants
    ************************************/

    var moment,
        VERSION = "2.7.0",
        // the global-scope this is NOT the global object in Node.js
        globalScope = typeof global !== 'undefined' ? global : this,
        oldGlobalMoment,
        round = Math.round,
        i,

        YEAR = 0,
        MONTH = 1,
        DATE = 2,
        HOUR = 3,
        MINUTE = 4,
        SECOND = 5,
        MILLISECOND = 6,

        // internal storage for language config files
        languages = {},

        // moment internal properties
        momentProperties = {
            _isAMomentObject: null,
            _i : null,
            _f : null,
            _l : null,
            _strict : null,
            _tzm : null,
            _isUTC : null,
            _offset : null,  // optional. Combine with _isUTC
            _pf : null,
            _lang : null  // optional
        },

        // check for nodeJS
        hasModule = (typeof module !== 'undefined' && module.exports),

        // ASP.NET json date format regex
        aspNetJsonRegex = /^\/?Date\((\-?\d+)/i,
        aspNetTimeSpanJsonRegex = /(\-)?(?:(\d*)\.)?(\d+)\:(\d+)(?:\:(\d+)\.?(\d{3})?)?/,

        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
        isoDurationRegex = /^(-)?P(?:(?:([0-9,.]*)Y)?(?:([0-9,.]*)M)?(?:([0-9,.]*)D)?(?:T(?:([0-9,.]*)H)?(?:([0-9,.]*)M)?(?:([0-9,.]*)S)?)?|([0-9,.]*)W)$/,

        // format tokens
        formattingTokens = /(\[[^\[]*\])|(\\)?(Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Q|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|mm?|ss?|S{1,4}|X|zz?|ZZ?|.)/g,
        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LT|LL?L?L?|l{1,4})/g,

        // parsing token regexes
        parseTokenOneOrTwoDigits = /\d\d?/, // 0 - 99
        parseTokenOneToThreeDigits = /\d{1,3}/, // 0 - 999
        parseTokenOneToFourDigits = /\d{1,4}/, // 0 - 9999
        parseTokenOneToSixDigits = /[+\-]?\d{1,6}/, // -999,999 - 999,999
        parseTokenDigits = /\d+/, // nonzero number of digits
        parseTokenWord = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i, // any word (or two) characters or numbers including two/three word month in arabic.
        parseTokenTimezone = /Z|[\+\-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
        parseTokenT = /T/i, // T (ISO separator)
        parseTokenTimestampMs = /[\+\-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
        parseTokenOrdinal = /\d{1,2}/,

        //strict parsing regexes
        parseTokenOneDigit = /\d/, // 0 - 9
        parseTokenTwoDigits = /\d\d/, // 00 - 99
        parseTokenThreeDigits = /\d{3}/, // 000 - 999
        parseTokenFourDigits = /\d{4}/, // 0000 - 9999
        parseTokenSixDigits = /[+-]?\d{6}/, // -999,999 - 999,999
        parseTokenSignedNumber = /[+-]?\d+/, // -inf - inf

        // iso 8601 regex
        // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
        isoRegex = /^\s*(?:[+-]\d{6}|\d{4})-(?:(\d\d-\d\d)|(W\d\d$)|(W\d\d-\d)|(\d\d\d))((T| )(\d\d(:\d\d(:\d\d(\.\d+)?)?)?)?([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/,

        isoFormat = 'YYYY-MM-DDTHH:mm:ssZ',

        isoDates = [
            ['YYYYYY-MM-DD', /[+-]\d{6}-\d{2}-\d{2}/],
            ['YYYY-MM-DD', /\d{4}-\d{2}-\d{2}/],
            ['GGGG-[W]WW-E', /\d{4}-W\d{2}-\d/],
            ['GGGG-[W]WW', /\d{4}-W\d{2}/],
            ['YYYY-DDD', /\d{4}-\d{3}/]
        ],

        // iso time formats and regexes
        isoTimes = [
            ['HH:mm:ss.SSSS', /(T| )\d\d:\d\d:\d\d\.\d+/],
            ['HH:mm:ss', /(T| )\d\d:\d\d:\d\d/],
            ['HH:mm', /(T| )\d\d:\d\d/],
            ['HH', /(T| )\d\d/]
        ],

        // timezone chunker "+10:00" > ["10", "00"] or "-1530" > ["-15", "30"]
        parseTimezoneChunker = /([\+\-]|\d\d)/gi,

        // getter and setter names
        proxyGettersAndSetters = 'Date|Hours|Minutes|Seconds|Milliseconds'.split('|'),
        unitMillisecondFactors = {
            'Milliseconds' : 1,
            'Seconds' : 1e3,
            'Minutes' : 6e4,
            'Hours' : 36e5,
            'Days' : 864e5,
            'Months' : 2592e6,
            'Years' : 31536e6
        },

        unitAliases = {
            ms : 'millisecond',
            s : 'second',
            m : 'minute',
            h : 'hour',
            d : 'day',
            D : 'date',
            w : 'week',
            W : 'isoWeek',
            M : 'month',
            Q : 'quarter',
            y : 'year',
            DDD : 'dayOfYear',
            e : 'weekday',
            E : 'isoWeekday',
            gg: 'weekYear',
            GG: 'isoWeekYear'
        },

        camelFunctions = {
            dayofyear : 'dayOfYear',
            isoweekday : 'isoWeekday',
            isoweek : 'isoWeek',
            weekyear : 'weekYear',
            isoweekyear : 'isoWeekYear'
        },

        // format function strings
        formatFunctions = {},

        // default relative time thresholds
        relativeTimeThresholds = {
          s: 45,   //seconds to minutes
          m: 45,   //minutes to hours
          h: 22,   //hours to days
          dd: 25,  //days to month (month == 1)
          dm: 45,  //days to months (months > 1)
          dy: 345  //days to year
        },

        // tokens to ordinalize and pad
        ordinalizeTokens = 'DDD w W M D d'.split(' '),
        paddedTokens = 'M D H h m s w W'.split(' '),

        formatTokenFunctions = {
            M    : function () {
                return this.month() + 1;
            },
            MMM  : function (format) {
                return this.lang().monthsShort(this, format);
            },
            MMMM : function (format) {
                return this.lang().months(this, format);
            },
            D    : function () {
                return this.date();
            },
            DDD  : function () {
                return this.dayOfYear();
            },
            d    : function () {
                return this.day();
            },
            dd   : function (format) {
                return this.lang().weekdaysMin(this, format);
            },
            ddd  : function (format) {
                return this.lang().weekdaysShort(this, format);
            },
            dddd : function (format) {
                return this.lang().weekdays(this, format);
            },
            w    : function () {
                return this.week();
            },
            W    : function () {
                return this.isoWeek();
            },
            YY   : function () {
                return leftZeroFill(this.year() % 100, 2);
            },
            YYYY : function () {
                return leftZeroFill(this.year(), 4);
            },
            YYYYY : function () {
                return leftZeroFill(this.year(), 5);
            },
            YYYYYY : function () {
                var y = this.year(), sign = y >= 0 ? '+' : '-';
                return sign + leftZeroFill(Math.abs(y), 6);
            },
            gg   : function () {
                return leftZeroFill(this.weekYear() % 100, 2);
            },
            gggg : function () {
                return leftZeroFill(this.weekYear(), 4);
            },
            ggggg : function () {
                return leftZeroFill(this.weekYear(), 5);
            },
            GG   : function () {
                return leftZeroFill(this.isoWeekYear() % 100, 2);
            },
            GGGG : function () {
                return leftZeroFill(this.isoWeekYear(), 4);
            },
            GGGGG : function () {
                return leftZeroFill(this.isoWeekYear(), 5);
            },
            e : function () {
                return this.weekday();
            },
            E : function () {
                return this.isoWeekday();
            },
            a    : function () {
                return this.lang().meridiem(this.hours(), this.minutes(), true);
            },
            A    : function () {
                return this.lang().meridiem(this.hours(), this.minutes(), false);
            },
            H    : function () {
                return this.hours();
            },
            h    : function () {
                return this.hours() % 12 || 12;
            },
            m    : function () {
                return this.minutes();
            },
            s    : function () {
                return this.seconds();
            },
            S    : function () {
                return toInt(this.milliseconds() / 100);
            },
            SS   : function () {
                return leftZeroFill(toInt(this.milliseconds() / 10), 2);
            },
            SSS  : function () {
                return leftZeroFill(this.milliseconds(), 3);
            },
            SSSS : function () {
                return leftZeroFill(this.milliseconds(), 3);
            },
            Z    : function () {
                var a = -this.zone(),
                    b = "+";
                if (a < 0) {
                    a = -a;
                    b = "-";
                }
                return b + leftZeroFill(toInt(a / 60), 2) + ":" + leftZeroFill(toInt(a) % 60, 2);
            },
            ZZ   : function () {
                var a = -this.zone(),
                    b = "+";
                if (a < 0) {
                    a = -a;
                    b = "-";
                }
                return b + leftZeroFill(toInt(a / 60), 2) + leftZeroFill(toInt(a) % 60, 2);
            },
            z : function () {
                return this.zoneAbbr();
            },
            zz : function () {
                return this.zoneName();
            },
            X    : function () {
                return this.unix();
            },
            Q : function () {
                return this.quarter();
            }
        },

        lists = ['months', 'monthsShort', 'weekdays', 'weekdaysShort', 'weekdaysMin'];

    // Pick the first defined of two or three arguments. dfl comes from
    // default.
    function dfl(a, b, c) {
        switch (arguments.length) {
            case 2: return a != null ? a : b;
            case 3: return a != null ? a : b != null ? b : c;
            default: throw new Error("Implement me");
        }
    }

    function defaultParsingFlags() {
        // We need to deep clone this object, and es5 standard is not very
        // helpful.
        return {
            empty : false,
            unusedTokens : [],
            unusedInput : [],
            overflow : -2,
            charsLeftOver : 0,
            nullInput : false,
            invalidMonth : null,
            invalidFormat : false,
            userInvalidated : false,
            iso: false
        };
    }

    function deprecate(msg, fn) {
        var firstTime = true;
        function printMsg() {
            if (moment.suppressDeprecationWarnings === false &&
                    typeof console !== 'undefined' && console.warn) {
                console.warn("Deprecation warning: " + msg);
            }
        }
        return extend(function () {
            if (firstTime) {
                printMsg();
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    function padToken(func, count) {
        return function (a) {
            return leftZeroFill(func.call(this, a), count);
        };
    }
    function ordinalizeToken(func, period) {
        return function (a) {
            return this.lang().ordinal(func.call(this, a), period);
        };
    }

    while (ordinalizeTokens.length) {
        i = ordinalizeTokens.pop();
        formatTokenFunctions[i + 'o'] = ordinalizeToken(formatTokenFunctions[i], i);
    }
    while (paddedTokens.length) {
        i = paddedTokens.pop();
        formatTokenFunctions[i + i] = padToken(formatTokenFunctions[i], 2);
    }
    formatTokenFunctions.DDDD = padToken(formatTokenFunctions.DDD, 3);


    /************************************
        Constructors
    ************************************/

    function Language() {

    }

    // Moment prototype object
    function Moment(config) {
        checkOverflow(config);
        extend(this, config);
    }

    // Duration Constructor
    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        // representation for dateAddRemove
        this._milliseconds = +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 36e5; // 1000 * 60 * 60
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days +
            weeks * 7;
        // It is impossible translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months +
            quarters * 3 +
            years * 12;

        this._data = {};

        this._bubble();
    }

    /************************************
        Helpers
    ************************************/


    function extend(a, b) {
        for (var i in b) {
            if (b.hasOwnProperty(i)) {
                a[i] = b[i];
            }
        }

        if (b.hasOwnProperty("toString")) {
            a.toString = b.toString;
        }

        if (b.hasOwnProperty("valueOf")) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function cloneMoment(m) {
        var result = {}, i;
        for (i in m) {
            if (m.hasOwnProperty(i) && momentProperties.hasOwnProperty(i)) {
                result[i] = m[i];
            }
        }

        return result;
    }

    function absRound(number) {
        if (number < 0) {
            return Math.ceil(number);
        } else {
            return Math.floor(number);
        }
    }

    // left zero fill a number
    // see http://jsperf.com/left-zero-filling for performance comparison
    function leftZeroFill(number, targetLength, forceSign) {
        var output = '' + Math.abs(number),
            sign = number >= 0;

        while (output.length < targetLength) {
            output = '0' + output;
        }
        return (sign ? (forceSign ? '+' : '') : '-') + output;
    }

    // helper function for _.addTime and _.subtractTime
    function addOrSubtractDurationFromMoment(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = duration._days,
            months = duration._months;
        updateOffset = updateOffset == null ? true : updateOffset;

        if (milliseconds) {
            mom._d.setTime(+mom._d + milliseconds * isAdding);
        }
        if (days) {
            rawSetter(mom, 'Date', rawGetter(mom, 'Date') + days * isAdding);
        }
        if (months) {
            rawMonthSetter(mom, rawGetter(mom, 'Month') + months * isAdding);
        }
        if (updateOffset) {
            moment.updateOffset(mom, days || months);
        }
    }

    // check if is an array
    function isArray(input) {
        return Object.prototype.toString.call(input) === '[object Array]';
    }

    function isDate(input) {
        return  Object.prototype.toString.call(input) === '[object Date]' ||
                input instanceof Date;
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if ((dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    function normalizeUnits(units) {
        if (units) {
            var lowered = units.toLowerCase().replace(/(.)s$/, '$1');
            units = unitAliases[units] || camelFunctions[lowered] || lowered;
        }
        return units;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (inputObject.hasOwnProperty(prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    function makeList(field) {
        var count, setter;

        if (field.indexOf('week') === 0) {
            count = 7;
            setter = 'day';
        }
        else if (field.indexOf('month') === 0) {
            count = 12;
            setter = 'month';
        }
        else {
            return;
        }

        moment[field] = function (format, index) {
            var i, getter,
                method = moment.fn._lang[field],
                results = [];

            if (typeof format === 'number') {
                index = format;
                format = undefined;
            }

            getter = function (i) {
                var m = moment().utc().set(setter, i);
                return method.call(moment.fn._lang, m, format || '');
            };

            if (index != null) {
                return getter(index);
            }
            else {
                for (i = 0; i < count; i++) {
                    results.push(getter(i));
                }
                return results;
            }
        };
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            if (coercedNumber >= 0) {
                value = Math.floor(coercedNumber);
            } else {
                value = Math.ceil(coercedNumber);
            }
        }

        return value;
    }

    function daysInMonth(year, month) {
        return new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
    }

    function weeksInYear(year, dow, doy) {
        return weekOfYear(moment([year, 11, 31 + dow - doy]), dow, doy).week;
    }

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    function checkOverflow(m) {
        var overflow;
        if (m._a && m._pf.overflow === -2) {
            overflow =
                m._a[MONTH] < 0 || m._a[MONTH] > 11 ? MONTH :
                m._a[DATE] < 1 || m._a[DATE] > daysInMonth(m._a[YEAR], m._a[MONTH]) ? DATE :
                m._a[HOUR] < 0 || m._a[HOUR] > 23 ? HOUR :
                m._a[MINUTE] < 0 || m._a[MINUTE] > 59 ? MINUTE :
                m._a[SECOND] < 0 || m._a[SECOND] > 59 ? SECOND :
                m._a[MILLISECOND] < 0 || m._a[MILLISECOND] > 999 ? MILLISECOND :
                -1;

            if (m._pf._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
                overflow = DATE;
            }

            m._pf.overflow = overflow;
        }
    }

    function isValid(m) {
        if (m._isValid == null) {
            m._isValid = !isNaN(m._d.getTime()) &&
                m._pf.overflow < 0 &&
                !m._pf.empty &&
                !m._pf.invalidMonth &&
                !m._pf.nullInput &&
                !m._pf.invalidFormat &&
                !m._pf.userInvalidated;

            if (m._strict) {
                m._isValid = m._isValid &&
                    m._pf.charsLeftOver === 0 &&
                    m._pf.unusedTokens.length === 0;
            }
        }
        return m._isValid;
    }

    function normalizeLanguage(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function makeAs(input, model) {
        return model._isUTC ? moment(input).zone(model._offset || 0) :
            moment(input).local();
    }

    /************************************
        Languages
    ************************************/


    extend(Language.prototype, {

        set : function (config) {
            var prop, i;
            for (i in config) {
                prop = config[i];
                if (typeof prop === 'function') {
                    this[i] = prop;
                } else {
                    this['_' + i] = prop;
                }
            }
        },

        _months : "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        months : function (m) {
            return this._months[m.month()];
        },

        _monthsShort : "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),
        monthsShort : function (m) {
            return this._monthsShort[m.month()];
        },

        monthsParse : function (monthName) {
            var i, mom, regex;

            if (!this._monthsParse) {
                this._monthsParse = [];
            }

            for (i = 0; i < 12; i++) {
                // make the regex if we don't have it already
                if (!this._monthsParse[i]) {
                    mom = moment.utc([2000, i]);
                    regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                    this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
                }
                // test the regex
                if (this._monthsParse[i].test(monthName)) {
                    return i;
                }
            }
        },

        _weekdays : "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        weekdays : function (m) {
            return this._weekdays[m.day()];
        },

        _weekdaysShort : "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),
        weekdaysShort : function (m) {
            return this._weekdaysShort[m.day()];
        },

        _weekdaysMin : "Su_Mo_Tu_We_Th_Fr_Sa".split("_"),
        weekdaysMin : function (m) {
            return this._weekdaysMin[m.day()];
        },

        weekdaysParse : function (weekdayName) {
            var i, mom, regex;

            if (!this._weekdaysParse) {
                this._weekdaysParse = [];
            }

            for (i = 0; i < 7; i++) {
                // make the regex if we don't have it already
                if (!this._weekdaysParse[i]) {
                    mom = moment([2000, 1]).day(i);
                    regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                    this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
                }
                // test the regex
                if (this._weekdaysParse[i].test(weekdayName)) {
                    return i;
                }
            }
        },

        _longDateFormat : {
            LT : "h:mm A",
            L : "MM/DD/YYYY",
            LL : "MMMM D YYYY",
            LLL : "MMMM D YYYY LT",
            LLLL : "dddd, MMMM D YYYY LT"
        },
        longDateFormat : function (key) {
            var output = this._longDateFormat[key];
            if (!output && this._longDateFormat[key.toUpperCase()]) {
                output = this._longDateFormat[key.toUpperCase()].replace(/MMMM|MM|DD|dddd/g, function (val) {
                    return val.slice(1);
                });
                this._longDateFormat[key] = output;
            }
            return output;
        },

        isPM : function (input) {
            // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
            // Using charAt should be more compatible.
            return ((input + '').toLowerCase().charAt(0) === 'p');
        },

        _meridiemParse : /[ap]\.?m?\.?/i,
        meridiem : function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'pm' : 'PM';
            } else {
                return isLower ? 'am' : 'AM';
            }
        },

        _calendar : {
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            nextWeek : 'dddd [at] LT',
            lastDay : '[Yesterday at] LT',
            lastWeek : '[Last] dddd [at] LT',
            sameElse : 'L'
        },
        calendar : function (key, mom) {
            var output = this._calendar[key];
            return typeof output === 'function' ? output.apply(mom) : output;
        },

        _relativeTime : {
            future : "in %s",
            past : "%s ago",
            s : "a few seconds",
            m : "a minute",
            mm : "%d minutes",
            h : "an hour",
            hh : "%d hours",
            d : "a day",
            dd : "%d days",
            M : "a month",
            MM : "%d months",
            y : "a year",
            yy : "%d years"
        },
        relativeTime : function (number, withoutSuffix, string, isFuture) {
            var output = this._relativeTime[string];
            return (typeof output === 'function') ?
                output(number, withoutSuffix, string, isFuture) :
                output.replace(/%d/i, number);
        },
        pastFuture : function (diff, output) {
            var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
            return typeof format === 'function' ? format(output) : format.replace(/%s/i, output);
        },

        ordinal : function (number) {
            return this._ordinal.replace("%d", number);
        },
        _ordinal : "%d",

        preparse : function (string) {
            return string;
        },

        postformat : function (string) {
            return string;
        },

        week : function (mom) {
            return weekOfYear(mom, this._week.dow, this._week.doy).week;
        },

        _week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 1st is the first week of the year.
        },

        _invalidDate: 'Invalid date',
        invalidDate: function () {
            return this._invalidDate;
        }
    });

    // Loads a language definition into the `languages` cache.  The function
    // takes a key and optionally values.  If not in the browser and no values
    // are provided, it will load the language file module.  As a convenience,
    // this function also returns the language values.
    function loadLang(key, values) {
        values.abbr = key;
        if (!languages[key]) {
            languages[key] = new Language();
        }
        languages[key].set(values);
        return languages[key];
    }

    // Remove a language from the `languages` cache. Mostly useful in tests.
    function unloadLang(key) {
        delete languages[key];
    }

    // Determines which language definition to use and returns it.
    //
    // With no parameters, it will return the global language.  If you
    // pass in a language key, such as 'en', it will return the
    // definition for 'en', so long as 'en' has already been loaded using
    // moment.lang.
    function getLangDefinition(key) {
        var i = 0, j, lang, next, split,
            get = function (k) {
                if (!languages[k] && hasModule) {
                    try {
                        require('./lang/' + k);
                    } catch (e) { }
                }
                return languages[k];
            };

        if (!key) {
            return moment.fn._lang;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            lang = get(key);
            if (lang) {
                return lang;
            }
            key = [key];
        }

        //pick the language from the array
        //try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
        //substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
        while (i < key.length) {
            split = normalizeLanguage(key[i]).split('-');
            j = split.length;
            next = normalizeLanguage(key[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                lang = get(split.slice(0, j).join('-'));
                if (lang) {
                    return lang;
                }
                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return moment.fn._lang;
    }

    /************************************
        Formatting
    ************************************/


    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, "");
        }
        return input.replace(/\\/g, "");
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = "";
            for (i = 0; i < length; i++) {
                output += array[i] instanceof Function ? array[i].call(mom, format) : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {

        if (!m.isValid()) {
            return m.lang().invalidDate();
        }

        format = expandFormat(format, m.lang());

        if (!formatFunctions[format]) {
            formatFunctions[format] = makeFormatFunction(format);
        }

        return formatFunctions[format](m);
    }

    function expandFormat(format, lang) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return lang.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }


    /************************************
        Parsing
    ************************************/


    // get the regex to find the next token
    function getParseRegexForToken(token, config) {
        var a, strict = config._strict;
        switch (token) {
        case 'Q':
            return parseTokenOneDigit;
        case 'DDDD':
            return parseTokenThreeDigits;
        case 'YYYY':
        case 'GGGG':
        case 'gggg':
            return strict ? parseTokenFourDigits : parseTokenOneToFourDigits;
        case 'Y':
        case 'G':
        case 'g':
            return parseTokenSignedNumber;
        case 'YYYYYY':
        case 'YYYYY':
        case 'GGGGG':
        case 'ggggg':
            return strict ? parseTokenSixDigits : parseTokenOneToSixDigits;
        case 'S':
            if (strict) { return parseTokenOneDigit; }
            /* falls through */
        case 'SS':
            if (strict) { return parseTokenTwoDigits; }
            /* falls through */
        case 'SSS':
            if (strict) { return parseTokenThreeDigits; }
            /* falls through */
        case 'DDD':
            return parseTokenOneToThreeDigits;
        case 'MMM':
        case 'MMMM':
        case 'dd':
        case 'ddd':
        case 'dddd':
            return parseTokenWord;
        case 'a':
        case 'A':
            return getLangDefinition(config._l)._meridiemParse;
        case 'X':
            return parseTokenTimestampMs;
        case 'Z':
        case 'ZZ':
            return parseTokenTimezone;
        case 'T':
            return parseTokenT;
        case 'SSSS':
            return parseTokenDigits;
        case 'MM':
        case 'DD':
        case 'YY':
        case 'GG':
        case 'gg':
        case 'HH':
        case 'hh':
        case 'mm':
        case 'ss':
        case 'ww':
        case 'WW':
            return strict ? parseTokenTwoDigits : parseTokenOneOrTwoDigits;
        case 'M':
        case 'D':
        case 'd':
        case 'H':
        case 'h':
        case 'm':
        case 's':
        case 'w':
        case 'W':
        case 'e':
        case 'E':
            return parseTokenOneOrTwoDigits;
        case 'Do':
            return parseTokenOrdinal;
        default :
            a = new RegExp(regexpEscape(unescapeFormat(token.replace('\\', '')), "i"));
            return a;
        }
    }

    function timezoneMinutesFromString(string) {
        string = string || "";
        var possibleTzMatches = (string.match(parseTokenTimezone) || []),
            tzChunk = possibleTzMatches[possibleTzMatches.length - 1] || [],
            parts = (tzChunk + '').match(parseTimezoneChunker) || ['-', 0, 0],
            minutes = +(parts[1] * 60) + toInt(parts[2]);

        return parts[0] === '+' ? -minutes : minutes;
    }

    // function to convert string input to date
    function addTimeToArrayFromToken(token, input, config) {
        var a, datePartArray = config._a;

        switch (token) {
        // QUARTER
        case 'Q':
            if (input != null) {
                datePartArray[MONTH] = (toInt(input) - 1) * 3;
            }
            break;
        // MONTH
        case 'M' : // fall through to MM
        case 'MM' :
            if (input != null) {
                datePartArray[MONTH] = toInt(input) - 1;
            }
            break;
        case 'MMM' : // fall through to MMMM
        case 'MMMM' :
            a = getLangDefinition(config._l).monthsParse(input);
            // if we didn't find a month name, mark the date as invalid.
            if (a != null) {
                datePartArray[MONTH] = a;
            } else {
                config._pf.invalidMonth = input;
            }
            break;
        // DAY OF MONTH
        case 'D' : // fall through to DD
        case 'DD' :
            if (input != null) {
                datePartArray[DATE] = toInt(input);
            }
            break;
        case 'Do' :
            if (input != null) {
                datePartArray[DATE] = toInt(parseInt(input, 10));
            }
            break;
        // DAY OF YEAR
        case 'DDD' : // fall through to DDDD
        case 'DDDD' :
            if (input != null) {
                config._dayOfYear = toInt(input);
            }

            break;
        // YEAR
        case 'YY' :
            datePartArray[YEAR] = moment.parseTwoDigitYear(input);
            break;
        case 'YYYY' :
        case 'YYYYY' :
        case 'YYYYYY' :
            datePartArray[YEAR] = toInt(input);
            break;
        // AM / PM
        case 'a' : // fall through to A
        case 'A' :
            config._isPm = getLangDefinition(config._l).isPM(input);
            break;
        // 24 HOUR
        case 'H' : // fall through to hh
        case 'HH' : // fall through to hh
        case 'h' : // fall through to hh
        case 'hh' :
            datePartArray[HOUR] = toInt(input);
            break;
        // MINUTE
        case 'm' : // fall through to mm
        case 'mm' :
            datePartArray[MINUTE] = toInt(input);
            break;
        // SECOND
        case 's' : // fall through to ss
        case 'ss' :
            datePartArray[SECOND] = toInt(input);
            break;
        // MILLISECOND
        case 'S' :
        case 'SS' :
        case 'SSS' :
        case 'SSSS' :
            datePartArray[MILLISECOND] = toInt(('0.' + input) * 1000);
            break;
        // UNIX TIMESTAMP WITH MS
        case 'X':
            config._d = new Date(parseFloat(input) * 1000);
            break;
        // TIMEZONE
        case 'Z' : // fall through to ZZ
        case 'ZZ' :
            config._useUTC = true;
            config._tzm = timezoneMinutesFromString(input);
            break;
        // WEEKDAY - human
        case 'dd':
        case 'ddd':
        case 'dddd':
            a = getLangDefinition(config._l).weekdaysParse(input);
            // if we didn't get a weekday name, mark the date as invalid
            if (a != null) {
                config._w = config._w || {};
                config._w['d'] = a;
            } else {
                config._pf.invalidWeekday = input;
            }
            break;
        // WEEK, WEEK DAY - numeric
        case 'w':
        case 'ww':
        case 'W':
        case 'WW':
        case 'd':
        case 'e':
        case 'E':
            token = token.substr(0, 1);
            /* falls through */
        case 'gggg':
        case 'GGGG':
        case 'GGGGG':
            token = token.substr(0, 2);
            if (input) {
                config._w = config._w || {};
                config._w[token] = toInt(input);
            }
            break;
        case 'gg':
        case 'GG':
            config._w = config._w || {};
            config._w[token] = moment.parseTwoDigitYear(input);
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, lang;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = dfl(w.GG, config._a[YEAR], weekOfYear(moment(), 1, 4).year);
            week = dfl(w.W, 1);
            weekday = dfl(w.E, 1);
        } else {
            lang = getLangDefinition(config._l);
            dow = lang._week.dow;
            doy = lang._week.doy;

            weekYear = dfl(w.gg, config._a[YEAR], weekOfYear(moment(), dow, doy).year);
            week = dfl(w.w, 1);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < dow) {
                    ++week;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from begining of week
                weekday = w.e + dow;
            } else {
                // default to begining of week
                weekday = dow;
            }
        }
        temp = dayOfYearFromWeeks(weekYear, week, weekday, doy, dow);

        config._a[YEAR] = temp.year;
        config._dayOfYear = temp.dayOfYear;
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function dateFromConfig(config) {
        var i, date, input = [], currentDate, yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear) {
            yearToUse = dfl(config._a[YEAR], currentDate[YEAR]);

            if (config._dayOfYear > daysInYear(yearToUse)) {
                config._pf._overflowDayOfYear = true;
            }

            date = makeUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
        }

        config._d = (config._useUTC ? makeUTCDate : makeDate).apply(null, input);
        // Apply timezone offset from input. The actual zone can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() + config._tzm);
        }
    }

    function dateFromObject(config) {
        var normalizedInput;

        if (config._d) {
            return;
        }

        normalizedInput = normalizeObjectUnits(config._i);
        config._a = [
            normalizedInput.year,
            normalizedInput.month,
            normalizedInput.day,
            normalizedInput.hour,
            normalizedInput.minute,
            normalizedInput.second,
            normalizedInput.millisecond
        ];

        dateFromConfig(config);
    }

    function currentDateArray(config) {
        var now = new Date();
        if (config._useUTC) {
            return [
                now.getUTCFullYear(),
                now.getUTCMonth(),
                now.getUTCDate()
            ];
        } else {
            return [now.getFullYear(), now.getMonth(), now.getDate()];
        }
    }

    // date from string and format string
    function makeDateFromStringAndFormat(config) {

        if (config._f === moment.ISO_8601) {
            parseISO(config);
            return;
        }

        config._a = [];
        config._pf.empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var lang = getLangDefinition(config._l),
            string = '' + config._i,
            i, parsedInput, tokens, token, skipped,
            stringLength = string.length,
            totalParsedInputLength = 0;

        tokens = expandFormat(config._f, lang).match(formattingTokens) || [];

        for (i = 0; i < tokens.length; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    config._pf.unusedInput.push(skipped);
                }
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    config._pf.empty = false;
                }
                else {
                    config._pf.unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            }
            else if (config._strict && !parsedInput) {
                config._pf.unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        config._pf.charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) {
            config._pf.unusedInput.push(string);
        }

        // handle am pm
        if (config._isPm && config._a[HOUR] < 12) {
            config._a[HOUR] += 12;
        }
        // if is 12 am, change hours to 0
        if (config._isPm === false && config._a[HOUR] === 12) {
            config._a[HOUR] = 0;
        }

        dateFromConfig(config);
        checkOverflow(config);
    }

    function unescapeFormat(s) {
        return s.replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        });
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function regexpEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    // date from string and array of format strings
    function makeDateFromStringAndArray(config) {
        var tempConfig,
            bestMoment,

            scoreToBeat,
            i,
            currentScore;

        if (config._f.length === 0) {
            config._pf.invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < config._f.length; i++) {
            currentScore = 0;
            tempConfig = extend({}, config);
            tempConfig._pf = defaultParsingFlags();
            tempConfig._f = config._f[i];
            makeDateFromStringAndFormat(tempConfig);

            if (!isValid(tempConfig)) {
                continue;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += tempConfig._pf.charsLeftOver;

            //or tokens
            currentScore += tempConfig._pf.unusedTokens.length * 10;

            tempConfig._pf.score = currentScore;

            if (scoreToBeat == null || currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    // date from iso format
    function parseISO(config) {
        var i, l,
            string = config._i,
            match = isoRegex.exec(string);

        if (match) {
            config._pf.iso = true;
            for (i = 0, l = isoDates.length; i < l; i++) {
                if (isoDates[i][1].exec(string)) {
                    // match[5] should be "T" or undefined
                    config._f = isoDates[i][0] + (match[6] || " ");
                    break;
                }
            }
            for (i = 0, l = isoTimes.length; i < l; i++) {
                if (isoTimes[i][1].exec(string)) {
                    config._f += isoTimes[i][0];
                    break;
                }
            }
            if (string.match(parseTokenTimezone)) {
                config._f += "Z";
            }
            makeDateFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    // date from iso format or fallback
    function makeDateFromString(config) {
        parseISO(config);
        if (config._isValid === false) {
            delete config._isValid;
            moment.createFromInputFallback(config);
        }
    }

    function makeDateFromInput(config) {
        var input = config._i,
            matched = aspNetJsonRegex.exec(input);

        if (input === undefined) {
            config._d = new Date();
        } else if (matched) {
            config._d = new Date(+matched[1]);
        } else if (typeof input === 'string') {
            makeDateFromString(config);
        } else if (isArray(input)) {
            config._a = input.slice(0);
            dateFromConfig(config);
        } else if (isDate(input)) {
            config._d = new Date(+input);
        } else if (typeof(input) === 'object') {
            dateFromObject(config);
        } else if (typeof(input) === 'number') {
            // from milliseconds
            config._d = new Date(input);
        } else {
            moment.createFromInputFallback(config);
        }
    }

    function makeDate(y, m, d, h, M, s, ms) {
        //can't just apply() to create a date:
        //http://stackoverflow.com/questions/181348/instantiating-a-javascript-object-by-calling-prototype-constructor-apply
        var date = new Date(y, m, d, h, M, s, ms);

        //the date constructor doesn't accept years < 1970
        if (y < 1970) {
            date.setFullYear(y);
        }
        return date;
    }

    function makeUTCDate(y) {
        var date = new Date(Date.UTC.apply(null, arguments));
        if (y < 1970) {
            date.setUTCFullYear(y);
        }
        return date;
    }

    function parseWeekday(input, language) {
        if (typeof input === 'string') {
            if (!isNaN(input)) {
                input = parseInt(input, 10);
            }
            else {
                input = language.weekdaysParse(input);
                if (typeof input !== 'number') {
                    return null;
                }
            }
        }
        return input;
    }

    /************************************
        Relative Time
    ************************************/


    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, lang) {
        return lang.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime(milliseconds, withoutSuffix, lang) {
        var seconds = round(Math.abs(milliseconds) / 1000),
            minutes = round(seconds / 60),
            hours = round(minutes / 60),
            days = round(hours / 24),
            years = round(days / 365),
            args = seconds < relativeTimeThresholds.s  && ['s', seconds] ||
                minutes === 1 && ['m'] ||
                minutes < relativeTimeThresholds.m && ['mm', minutes] ||
                hours === 1 && ['h'] ||
                hours < relativeTimeThresholds.h && ['hh', hours] ||
                days === 1 && ['d'] ||
                days <= relativeTimeThresholds.dd && ['dd', days] ||
                days <= relativeTimeThresholds.dm && ['M'] ||
                days < relativeTimeThresholds.dy && ['MM', round(days / 30)] ||
                years === 1 && ['y'] || ['yy', years];
        args[2] = withoutSuffix;
        args[3] = milliseconds > 0;
        args[4] = lang;
        return substituteTimeAgo.apply({}, args);
    }


    /************************************
        Week of Year
    ************************************/


    // firstDayOfWeek       0 = sun, 6 = sat
    //                      the day of the week that starts the week
    //                      (usually sunday or monday)
    // firstDayOfWeekOfYear 0 = sun, 6 = sat
    //                      the first week is the week that contains the first
    //                      of this day of the week
    //                      (eg. ISO weeks use thursday (4))
    function weekOfYear(mom, firstDayOfWeek, firstDayOfWeekOfYear) {
        var end = firstDayOfWeekOfYear - firstDayOfWeek,
            daysToDayOfWeek = firstDayOfWeekOfYear - mom.day(),
            adjustedMoment;


        if (daysToDayOfWeek > end) {
            daysToDayOfWeek -= 7;
        }

        if (daysToDayOfWeek < end - 7) {
            daysToDayOfWeek += 7;
        }

        adjustedMoment = moment(mom).add('d', daysToDayOfWeek);
        return {
            week: Math.ceil(adjustedMoment.dayOfYear() / 7),
            year: adjustedMoment.year()
        };
    }

    //http://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, firstDayOfWeekOfYear, firstDayOfWeek) {
        var d = makeUTCDate(year, 0, 1).getUTCDay(), daysToAdd, dayOfYear;

        d = d === 0 ? 7 : d;
        weekday = weekday != null ? weekday : firstDayOfWeek;
        daysToAdd = firstDayOfWeek - d + (d > firstDayOfWeekOfYear ? 7 : 0) - (d < firstDayOfWeek ? 7 : 0);
        dayOfYear = 7 * (week - 1) + (weekday - firstDayOfWeek) + daysToAdd + 1;

        return {
            year: dayOfYear > 0 ? year : year - 1,
            dayOfYear: dayOfYear > 0 ?  dayOfYear : daysInYear(year - 1) + dayOfYear
        };
    }

    /************************************
        Top Level Functions
    ************************************/

    function makeMoment(config) {
        var input = config._i,
            format = config._f;

        if (input === null || (format === undefined && input === '')) {
            return moment.invalid({nullInput: true});
        }

        if (typeof input === 'string') {
            config._i = input = getLangDefinition().preparse(input);
        }

        if (moment.isMoment(input)) {
            config = cloneMoment(input);

            config._d = new Date(+input._d);
        } else if (format) {
            if (isArray(format)) {
                makeDateFromStringAndArray(config);
            } else {
                makeDateFromStringAndFormat(config);
            }
        } else {
            makeDateFromInput(config);
        }

        return new Moment(config);
    }

    moment = function (input, format, lang, strict) {
        var c;

        if (typeof(lang) === "boolean") {
            strict = lang;
            lang = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c = {};
        c._isAMomentObject = true;
        c._i = input;
        c._f = format;
        c._l = lang;
        c._strict = strict;
        c._isUTC = false;
        c._pf = defaultParsingFlags();

        return makeMoment(c);
    };

    moment.suppressDeprecationWarnings = false;

    moment.createFromInputFallback = deprecate(
            "moment construction falls back to js Date. This is " +
            "discouraged and will be removed in upcoming major " +
            "release. Please refer to " +
            "https://github.com/moment/moment/issues/1407 for more info.",
            function (config) {
        config._d = new Date(config._i);
    });

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return moment();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    moment.min = function () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    };

    moment.max = function () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    };

    // creating with utc
    moment.utc = function (input, format, lang, strict) {
        var c;

        if (typeof(lang) === "boolean") {
            strict = lang;
            lang = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c = {};
        c._isAMomentObject = true;
        c._useUTC = true;
        c._isUTC = true;
        c._l = lang;
        c._i = input;
        c._f = format;
        c._strict = strict;
        c._pf = defaultParsingFlags();

        return makeMoment(c).utc();
    };

    // creating with unix timestamp (in seconds)
    moment.unix = function (input) {
        return moment(input * 1000);
    };

    // duration
    moment.duration = function (input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            parseIso;

        if (moment.isDuration(input)) {
            duration = {
                ms: input._milliseconds,
                d: input._days,
                M: input._months
            };
        } else if (typeof input === 'number') {
            duration = {};
            if (key) {
                duration[key] = input;
            } else {
                duration.milliseconds = input;
            }
        } else if (!!(match = aspNetTimeSpanJsonRegex.exec(input))) {
            sign = (match[1] === "-") ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(match[MILLISECOND]) * sign
            };
        } else if (!!(match = isoDurationRegex.exec(input))) {
            sign = (match[1] === "-") ? -1 : 1;
            parseIso = function (inp) {
                // We'd normally use ~~inp for this, but unfortunately it also
                // converts floats to ints.
                // inp may be undefined, so careful calling replace on it.
                var res = inp && parseFloat(inp.replace(',', '.'));
                // apply sign while we're at it
                return (isNaN(res) ? 0 : res) * sign;
            };
            duration = {
                y: parseIso(match[2]),
                M: parseIso(match[3]),
                d: parseIso(match[4]),
                h: parseIso(match[5]),
                m: parseIso(match[6]),
                s: parseIso(match[7]),
                w: parseIso(match[8])
            };
        }

        ret = new Duration(duration);

        if (moment.isDuration(input) && input.hasOwnProperty('_lang')) {
            ret._lang = input._lang;
        }

        return ret;
    };

    // version number
    moment.version = VERSION;

    // default format
    moment.defaultFormat = isoFormat;

    // constant that refers to the ISO standard
    moment.ISO_8601 = function () {};

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    moment.momentProperties = momentProperties;

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    moment.updateOffset = function () {};

    // This function allows you to set a threshold for relative time strings
    moment.relativeTimeThreshold = function(threshold, limit) {
      if (relativeTimeThresholds[threshold] === undefined) {
        return false;
      }
      relativeTimeThresholds[threshold] = limit;
      return true;
    };

    // This function will load languages and then set the global language.  If
    // no arguments are passed in, it will simply return the current global
    // language key.
    moment.lang = function (key, values) {
        var r;
        if (!key) {
            return moment.fn._lang._abbr;
        }
        if (values) {
            loadLang(normalizeLanguage(key), values);
        } else if (values === null) {
            unloadLang(key);
            key = 'en';
        } else if (!languages[key]) {
            getLangDefinition(key);
        }
        r = moment.duration.fn._lang = moment.fn._lang = getLangDefinition(key);
        return r._abbr;
    };

    // returns language data
    moment.langData = function (key) {
        if (key && key._lang && key._lang._abbr) {
            key = key._lang._abbr;
        }
        return getLangDefinition(key);
    };

    // compare moment object
    moment.isMoment = function (obj) {
        return obj instanceof Moment ||
            (obj != null &&  obj.hasOwnProperty('_isAMomentObject'));
    };

    // for typechecking Duration objects
    moment.isDuration = function (obj) {
        return obj instanceof Duration;
    };

    for (i = lists.length - 1; i >= 0; --i) {
        makeList(lists[i]);
    }

    moment.normalizeUnits = function (units) {
        return normalizeUnits(units);
    };

    moment.invalid = function (flags) {
        var m = moment.utc(NaN);
        if (flags != null) {
            extend(m._pf, flags);
        }
        else {
            m._pf.userInvalidated = true;
        }

        return m;
    };

    moment.parseZone = function () {
        return moment.apply(null, arguments).parseZone();
    };

    moment.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    /************************************
        Moment Prototype
    ************************************/


    extend(moment.fn = Moment.prototype, {

        clone : function () {
            return moment(this);
        },

        valueOf : function () {
            return +this._d + ((this._offset || 0) * 60000);
        },

        unix : function () {
            return Math.floor(+this / 1000);
        },

        toString : function () {
            return this.clone().lang('en').format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
        },

        toDate : function () {
            return this._offset ? new Date(+this) : this._d;
        },

        toISOString : function () {
            var m = moment(this).utc();
            if (0 < m.year() && m.year() <= 9999) {
                return formatMoment(m, 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
            } else {
                return formatMoment(m, 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
            }
        },

        toArray : function () {
            var m = this;
            return [
                m.year(),
                m.month(),
                m.date(),
                m.hours(),
                m.minutes(),
                m.seconds(),
                m.milliseconds()
            ];
        },

        isValid : function () {
            return isValid(this);
        },

        isDSTShifted : function () {

            if (this._a) {
                return this.isValid() && compareArrays(this._a, (this._isUTC ? moment.utc(this._a) : moment(this._a)).toArray()) > 0;
            }

            return false;
        },

        parsingFlags : function () {
            return extend({}, this._pf);
        },

        invalidAt: function () {
            return this._pf.overflow;
        },

        utc : function () {
            return this.zone(0);
        },

        local : function () {
            this.zone(0);
            this._isUTC = false;
            return this;
        },

        format : function (inputString) {
            var output = formatMoment(this, inputString || moment.defaultFormat);
            return this.lang().postformat(output);
        },

        add : function (input, val) {
            var dur;
            // switch args to support add('s', 1) and add(1, 's')
            if (typeof input === 'string' && typeof val === 'string') {
                dur = moment.duration(isNaN(+val) ? +input : +val, isNaN(+val) ? val : input);
            } else if (typeof input === 'string') {
                dur = moment.duration(+val, input);
            } else {
                dur = moment.duration(input, val);
            }
            addOrSubtractDurationFromMoment(this, dur, 1);
            return this;
        },

        subtract : function (input, val) {
            var dur;
            // switch args to support subtract('s', 1) and subtract(1, 's')
            if (typeof input === 'string' && typeof val === 'string') {
                dur = moment.duration(isNaN(+val) ? +input : +val, isNaN(+val) ? val : input);
            } else if (typeof input === 'string') {
                dur = moment.duration(+val, input);
            } else {
                dur = moment.duration(input, val);
            }
            addOrSubtractDurationFromMoment(this, dur, -1);
            return this;
        },

        diff : function (input, units, asFloat) {
            var that = makeAs(input, this),
                zoneDiff = (this.zone() - that.zone()) * 6e4,
                diff, output;

            units = normalizeUnits(units);

            if (units === 'year' || units === 'month') {
                // average number of days in the months in the given dates
                diff = (this.daysInMonth() + that.daysInMonth()) * 432e5; // 24 * 60 * 60 * 1000 / 2
                // difference in months
                output = ((this.year() - that.year()) * 12) + (this.month() - that.month());
                // adjust by taking difference in days, average number of days
                // and dst in the given months.
                output += ((this - moment(this).startOf('month')) -
                        (that - moment(that).startOf('month'))) / diff;
                // same as above but with zones, to negate all dst
                output -= ((this.zone() - moment(this).startOf('month').zone()) -
                        (that.zone() - moment(that).startOf('month').zone())) * 6e4 / diff;
                if (units === 'year') {
                    output = output / 12;
                }
            } else {
                diff = (this - that);
                output = units === 'second' ? diff / 1e3 : // 1000
                    units === 'minute' ? diff / 6e4 : // 1000 * 60
                    units === 'hour' ? diff / 36e5 : // 1000 * 60 * 60
                    units === 'day' ? (diff - zoneDiff) / 864e5 : // 1000 * 60 * 60 * 24, negate dst
                    units === 'week' ? (diff - zoneDiff) / 6048e5 : // 1000 * 60 * 60 * 24 * 7, negate dst
                    diff;
            }
            return asFloat ? output : absRound(output);
        },

        from : function (time, withoutSuffix) {
            return moment.duration(this.diff(time)).lang(this.lang()._abbr).humanize(!withoutSuffix);
        },

        fromNow : function (withoutSuffix) {
            return this.from(moment(), withoutSuffix);
        },

        calendar : function (time) {
            // We want to compare the start of today, vs this.
            // Getting start-of-today depends on whether we're zone'd or not.
            var now = time || moment(),
                sod = makeAs(now, this).startOf('day'),
                diff = this.diff(sod, 'days', true),
                format = diff < -6 ? 'sameElse' :
                    diff < -1 ? 'lastWeek' :
                    diff < 0 ? 'lastDay' :
                    diff < 1 ? 'sameDay' :
                    diff < 2 ? 'nextDay' :
                    diff < 7 ? 'nextWeek' : 'sameElse';
            return this.format(this.lang().calendar(format, this));
        },

        isLeapYear : function () {
            return isLeapYear(this.year());
        },

        isDST : function () {
            return (this.zone() < this.clone().month(0).zone() ||
                this.zone() < this.clone().month(5).zone());
        },

        day : function (input) {
            var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
            if (input != null) {
                input = parseWeekday(input, this.lang());
                return this.add({ d : input - day });
            } else {
                return day;
            }
        },

        month : makeAccessor('Month', true),

        startOf: function (units) {
            units = normalizeUnits(units);
            // the following switch intentionally omits break keywords
            // to utilize falling through the cases.
            switch (units) {
            case 'year':
                this.month(0);
                /* falls through */
            case 'quarter':
            case 'month':
                this.date(1);
                /* falls through */
            case 'week':
            case 'isoWeek':
            case 'day':
                this.hours(0);
                /* falls through */
            case 'hour':
                this.minutes(0);
                /* falls through */
            case 'minute':
                this.seconds(0);
                /* falls through */
            case 'second':
                this.milliseconds(0);
                /* falls through */
            }

            // weeks are a special case
            if (units === 'week') {
                this.weekday(0);
            } else if (units === 'isoWeek') {
                this.isoWeekday(1);
            }

            // quarters are also special
            if (units === 'quarter') {
                this.month(Math.floor(this.month() / 3) * 3);
            }

            return this;
        },

        endOf: function (units) {
            units = normalizeUnits(units);
            return this.startOf(units).add((units === 'isoWeek' ? 'week' : units), 1).subtract('ms', 1);
        },

        isAfter: function (input, units) {
            units = typeof units !== 'undefined' ? units : 'millisecond';
            return +this.clone().startOf(units) > +moment(input).startOf(units);
        },

        isBefore: function (input, units) {
            units = typeof units !== 'undefined' ? units : 'millisecond';
            return +this.clone().startOf(units) < +moment(input).startOf(units);
        },

        isSame: function (input, units) {
            units = units || 'ms';
            return +this.clone().startOf(units) === +makeAs(input, this).startOf(units);
        },

        min: deprecate(
                 "moment().min is deprecated, use moment.min instead. https://github.com/moment/moment/issues/1548",
                 function (other) {
                     other = moment.apply(null, arguments);
                     return other < this ? this : other;
                 }
         ),

        max: deprecate(
                "moment().max is deprecated, use moment.max instead. https://github.com/moment/moment/issues/1548",
                function (other) {
                    other = moment.apply(null, arguments);
                    return other > this ? this : other;
                }
        ),

        // keepTime = true means only change the timezone, without affecting
        // the local hour. So 5:31:26 +0300 --[zone(2, true)]--> 5:31:26 +0200
        // It is possible that 5:31:26 doesn't exist int zone +0200, so we
        // adjust the time as needed, to be valid.
        //
        // Keeping the time actually adds/subtracts (one hour)
        // from the actual represented time. That is why we call updateOffset
        // a second time. In case it wants us to change the offset again
        // _changeInProgress == true case, then we have to adjust, because
        // there is no such time in the given timezone.
        zone : function (input, keepTime) {
            var offset = this._offset || 0;
            if (input != null) {
                if (typeof input === "string") {
                    input = timezoneMinutesFromString(input);
                }
                if (Math.abs(input) < 16) {
                    input = input * 60;
                }
                this._offset = input;
                this._isUTC = true;
                if (offset !== input) {
                    if (!keepTime || this._changeInProgress) {
                        addOrSubtractDurationFromMoment(this,
                                moment.duration(offset - input, 'm'), 1, false);
                    } else if (!this._changeInProgress) {
                        this._changeInProgress = true;
                        moment.updateOffset(this, true);
                        this._changeInProgress = null;
                    }
                }
            } else {
                return this._isUTC ? offset : this._d.getTimezoneOffset();
            }
            return this;
        },

        zoneAbbr : function () {
            return this._isUTC ? "UTC" : "";
        },

        zoneName : function () {
            return this._isUTC ? "Coordinated Universal Time" : "";
        },

        parseZone : function () {
            if (this._tzm) {
                this.zone(this._tzm);
            } else if (typeof this._i === 'string') {
                this.zone(this._i);
            }
            return this;
        },

        hasAlignedHourOffset : function (input) {
            if (!input) {
                input = 0;
            }
            else {
                input = moment(input).zone();
            }

            return (this.zone() - input) % 60 === 0;
        },

        daysInMonth : function () {
            return daysInMonth(this.year(), this.month());
        },

        dayOfYear : function (input) {
            var dayOfYear = round((moment(this).startOf('day') - moment(this).startOf('year')) / 864e5) + 1;
            return input == null ? dayOfYear : this.add("d", (input - dayOfYear));
        },

        quarter : function (input) {
            return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
        },

        weekYear : function (input) {
            var year = weekOfYear(this, this.lang()._week.dow, this.lang()._week.doy).year;
            return input == null ? year : this.add("y", (input - year));
        },

        isoWeekYear : function (input) {
            var year = weekOfYear(this, 1, 4).year;
            return input == null ? year : this.add("y", (input - year));
        },

        week : function (input) {
            var week = this.lang().week(this);
            return input == null ? week : this.add("d", (input - week) * 7);
        },

        isoWeek : function (input) {
            var week = weekOfYear(this, 1, 4).week;
            return input == null ? week : this.add("d", (input - week) * 7);
        },

        weekday : function (input) {
            var weekday = (this.day() + 7 - this.lang()._week.dow) % 7;
            return input == null ? weekday : this.add("d", input - weekday);
        },

        isoWeekday : function (input) {
            // behaves the same as moment#day except
            // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
            // as a setter, sunday should belong to the previous week.
            return input == null ? this.day() || 7 : this.day(this.day() % 7 ? input : input - 7);
        },

        isoWeeksInYear : function () {
            return weeksInYear(this.year(), 1, 4);
        },

        weeksInYear : function () {
            var weekInfo = this._lang._week;
            return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
        },

        get : function (units) {
            units = normalizeUnits(units);
            return this[units]();
        },

        set : function (units, value) {
            units = normalizeUnits(units);
            if (typeof this[units] === 'function') {
                this[units](value);
            }
            return this;
        },

        // If passed a language key, it will set the language for this
        // instance.  Otherwise, it will return the language configuration
        // variables for this instance.
        lang : function (key) {
            if (key === undefined) {
                return this._lang;
            } else {
                this._lang = getLangDefinition(key);
                return this;
            }
        }
    });

    function rawMonthSetter(mom, value) {
        var dayOfMonth;

        // TODO: Move this out of here!
        if (typeof value === 'string') {
            value = mom.lang().monthsParse(value);
            // TODO: Another silent failure?
            if (typeof value !== 'number') {
                return mom;
            }
        }

        dayOfMonth = Math.min(mom.date(),
                daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function rawGetter(mom, unit) {
        return mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]();
    }

    function rawSetter(mom, unit, value) {
        if (unit === 'Month') {
            return rawMonthSetter(mom, value);
        } else {
            return mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
        }
    }

    function makeAccessor(unit, keepTime) {
        return function (value) {
            if (value != null) {
                rawSetter(this, unit, value);
                moment.updateOffset(this, keepTime);
                return this;
            } else {
                return rawGetter(this, unit);
            }
        };
    }

    moment.fn.millisecond = moment.fn.milliseconds = makeAccessor('Milliseconds', false);
    moment.fn.second = moment.fn.seconds = makeAccessor('Seconds', false);
    moment.fn.minute = moment.fn.minutes = makeAccessor('Minutes', false);
    // Setting the hour should keep the time, because the user explicitly
    // specified which hour he wants. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    moment.fn.hour = moment.fn.hours = makeAccessor('Hours', true);
    // moment.fn.month is defined separately
    moment.fn.date = makeAccessor('Date', true);
    moment.fn.dates = deprecate("dates accessor is deprecated. Use date instead.", makeAccessor('Date', true));
    moment.fn.year = makeAccessor('FullYear', true);
    moment.fn.years = deprecate("years accessor is deprecated. Use year instead.", makeAccessor('FullYear', true));

    // add plural methods
    moment.fn.days = moment.fn.day;
    moment.fn.months = moment.fn.month;
    moment.fn.weeks = moment.fn.week;
    moment.fn.isoWeeks = moment.fn.isoWeek;
    moment.fn.quarters = moment.fn.quarter;

    // add aliased format methods
    moment.fn.toJSON = moment.fn.toISOString;

    /************************************
        Duration Prototype
    ************************************/


    extend(moment.duration.fn = Duration.prototype, {

        _bubble : function () {
            var milliseconds = this._milliseconds,
                days = this._days,
                months = this._months,
                data = this._data,
                seconds, minutes, hours, years;

            // The following code bubbles up values, see the tests for
            // examples of what that means.
            data.milliseconds = milliseconds % 1000;

            seconds = absRound(milliseconds / 1000);
            data.seconds = seconds % 60;

            minutes = absRound(seconds / 60);
            data.minutes = minutes % 60;

            hours = absRound(minutes / 60);
            data.hours = hours % 24;

            days += absRound(hours / 24);
            data.days = days % 30;

            months += absRound(days / 30);
            data.months = months % 12;

            years = absRound(months / 12);
            data.years = years;
        },

        weeks : function () {
            return absRound(this.days() / 7);
        },

        valueOf : function () {
            return this._milliseconds +
              this._days * 864e5 +
              (this._months % 12) * 2592e6 +
              toInt(this._months / 12) * 31536e6;
        },

        humanize : function (withSuffix) {
            var difference = +this,
                output = relativeTime(difference, !withSuffix, this.lang());

            if (withSuffix) {
                output = this.lang().pastFuture(difference, output);
            }

            return this.lang().postformat(output);
        },

        add : function (input, val) {
            // supports only 2.0-style add(1, 's') or add(moment)
            var dur = moment.duration(input, val);

            this._milliseconds += dur._milliseconds;
            this._days += dur._days;
            this._months += dur._months;

            this._bubble();

            return this;
        },

        subtract : function (input, val) {
            var dur = moment.duration(input, val);

            this._milliseconds -= dur._milliseconds;
            this._days -= dur._days;
            this._months -= dur._months;

            this._bubble();

            return this;
        },

        get : function (units) {
            units = normalizeUnits(units);
            return this[units.toLowerCase() + 's']();
        },

        as : function (units) {
            units = normalizeUnits(units);
            return this['as' + units.charAt(0).toUpperCase() + units.slice(1) + 's']();
        },

        lang : moment.fn.lang,

        toIsoString : function () {
            // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
            var years = Math.abs(this.years()),
                months = Math.abs(this.months()),
                days = Math.abs(this.days()),
                hours = Math.abs(this.hours()),
                minutes = Math.abs(this.minutes()),
                seconds = Math.abs(this.seconds() + this.milliseconds() / 1000);

            if (!this.asSeconds()) {
                // this is the same as C#'s (Noda) and python (isodate)...
                // but not other JS (goog.date)
                return 'P0D';
            }

            return (this.asSeconds() < 0 ? '-' : '') +
                'P' +
                (years ? years + 'Y' : '') +
                (months ? months + 'M' : '') +
                (days ? days + 'D' : '') +
                ((hours || minutes || seconds) ? 'T' : '') +
                (hours ? hours + 'H' : '') +
                (minutes ? minutes + 'M' : '') +
                (seconds ? seconds + 'S' : '');
        }
    });

    function makeDurationGetter(name) {
        moment.duration.fn[name] = function () {
            return this._data[name];
        };
    }

    function makeDurationAsGetter(name, factor) {
        moment.duration.fn['as' + name] = function () {
            return +this / factor;
        };
    }

    for (i in unitMillisecondFactors) {
        if (unitMillisecondFactors.hasOwnProperty(i)) {
            makeDurationAsGetter(i, unitMillisecondFactors[i]);
            makeDurationGetter(i.toLowerCase());
        }
    }

    makeDurationAsGetter('Weeks', 6048e5);
    moment.duration.fn.asMonths = function () {
        return (+this - this.years() * 31536e6) / 2592e6 + this.years() * 12;
    };


    /************************************
        Default Lang
    ************************************/


    // Set default language, other languages will inherit from English.
    moment.lang('en', {
        ordinal : function (number) {
            var b = number % 10,
                output = (toInt(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        }
    });

    /* EMBED_LANGUAGES */

    /************************************
        Exposing Moment
    ************************************/

    function makeGlobal(shouldDeprecate) {
        /*global ender:false */
        if (typeof ender !== 'undefined') {
            return;
        }
        oldGlobalMoment = globalScope.moment;
        if (shouldDeprecate) {
            globalScope.moment = deprecate(
                    "Accessing Moment through the global scope is " +
                    "deprecated, and will be removed in an upcoming " +
                    "release.",
                    moment);
        } else {
            globalScope.moment = moment;
        }
    }

    // CommonJS module is defined
    if (hasModule) {
        module.exports = moment;
    } else if (typeof define === "function" && define.amd) {
        define("moment", function (require, exports, module) {
            if (module.config && module.config() && module.config().noGlobal === true) {
                // release the global variable
                globalScope.moment = oldGlobalMoment;
            }

            return moment;
        });
        makeGlobal(true);
    } else {
        makeGlobal();
    }
}).call(this);
/*! Picturefill - Responsive Images that work today. (and mimic the proposed Picture element with span elements). Author: Scott Jehl, Filament Group, 2012 | License: MIT/GPLv2 */

(function( w ){

	// Enable strict mode
	"use strict";

	w.picturefill = function() {
		var ps = w.document.getElementsByTagName( "span" );

		// Loop the pictures
		for( var i = 0, il = ps.length; i < il; i++ ){
			if( ps[ i ].getAttribute( "data-picture" ) !== null ){

				var sources = ps[ i ].getElementsByTagName( "span" ),
					matches = [];

				// See if which sources match
				for( var j = 0, jl = sources.length; j < jl; j++ ){
					var media = sources[ j ].getAttribute( "data-media" );
					// if there's no media specified, OR w.matchMedia is supported 
					if( !media || ( w.matchMedia && w.matchMedia( media ).matches ) ){
						matches.push( sources[ j ] );
					}
				}

			// Find any existing img element in the picture element
			var picImg = ps[ i ].getElementsByTagName( "img" )[ 0 ];

			if( matches.length ){
				var matchedEl = matches.pop();
				if( !picImg || picImg.parentNode.nodeName === "NOSCRIPT" ){
					picImg = w.document.createElement( "img" );
					picImg.alt = ps[ i ].getAttribute( "data-alt" );
				}
				else if( matchedEl === picImg.parentNode ){
					// Skip further actions if the correct image is already in place
					continue;
				}

				picImg.src =  matchedEl.getAttribute( "data-src" );
				matchedEl.appendChild( picImg );
				picImg.removeAttribute("width");
				picImg.removeAttribute("height");
			}
			else if( picImg ){
				picImg.parentNode.removeChild( picImg );
			}
		}
		}
	};

	// Run on resize and domready (w.load as a fallback)
	if( w.addEventListener ){
		w.addEventListener( "resize", w.picturefill, false );
		w.addEventListener( "DOMContentLoaded", function(){
			w.picturefill();
			// Run once only
			w.removeEventListener( "load", w.picturefill, false );
		}, false );
		w.addEventListener( "load", w.picturefill, false );
	}
	else if( w.attachEvent ){
		w.attachEvent( "onload", w.picturefill );
	}

}( this ));
/*!

 handlebars v1.3.0

Copyright (C) 2011 by Yehuda Katz

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE.

@license
*/
/* exported Handlebars */
var Handlebars = (function() {
// handlebars/safe-string.js
var __module4__ = (function() {
  "use strict";
  var __exports__;
  // Build out our basic SafeString type
  function SafeString(string) {
    this.string = string;
  }

  SafeString.prototype.toString = function() {
    return "" + this.string;
  };

  __exports__ = SafeString;
  return __exports__;
})();

// handlebars/utils.js
var __module3__ = (function(__dependency1__) {
  "use strict";
  var __exports__ = {};
  /*jshint -W004 */
  var SafeString = __dependency1__;

  var escape = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#x27;",
    "`": "&#x60;"
  };

  var badChars = /[&<>"'`]/g;
  var possible = /[&<>"'`]/;

  function escapeChar(chr) {
    return escape[chr] || "&amp;";
  }

  function extend(obj, value) {
    for(var key in value) {
      if(Object.prototype.hasOwnProperty.call(value, key)) {
        obj[key] = value[key];
      }
    }
  }

  __exports__.extend = extend;var toString = Object.prototype.toString;
  __exports__.toString = toString;
  // Sourced from lodash
  // https://github.com/bestiejs/lodash/blob/master/LICENSE.txt
  var isFunction = function(value) {
    return typeof value === 'function';
  };
  // fallback for older versions of Chrome and Safari
  if (isFunction(/x/)) {
    isFunction = function(value) {
      return typeof value === 'function' && toString.call(value) === '[object Function]';
    };
  }
  var isFunction;
  __exports__.isFunction = isFunction;
  var isArray = Array.isArray || function(value) {
    return (value && typeof value === 'object') ? toString.call(value) === '[object Array]' : false;
  };
  __exports__.isArray = isArray;

  function escapeExpression(string) {
    // don't escape SafeStrings, since they're already safe
    if (string instanceof SafeString) {
      return string.toString();
    } else if (!string && string !== 0) {
      return "";
    }

    // Force a string conversion as this will be done by the append regardless and
    // the regex test will do this transparently behind the scenes, causing issues if
    // an object's to string has escaped characters in it.
    string = "" + string;

    if(!possible.test(string)) { return string; }
    return string.replace(badChars, escapeChar);
  }

  __exports__.escapeExpression = escapeExpression;function isEmpty(value) {
    if (!value && value !== 0) {
      return true;
    } else if (isArray(value) && value.length === 0) {
      return true;
    } else {
      return false;
    }
  }

  __exports__.isEmpty = isEmpty;
  return __exports__;
})(__module4__);

// handlebars/exception.js
var __module5__ = (function() {
  "use strict";
  var __exports__;

  var errorProps = ['description', 'fileName', 'lineNumber', 'message', 'name', 'number', 'stack'];

  function Exception(message, node) {
    var line;
    if (node && node.firstLine) {
      line = node.firstLine;

      message += ' - ' + line + ':' + node.firstColumn;
    }

    var tmp = Error.prototype.constructor.call(this, message);

    // Unfortunately errors are not enumerable in Chrome (at least), so `for prop in tmp` doesn't work.
    for (var idx = 0; idx < errorProps.length; idx++) {
      this[errorProps[idx]] = tmp[errorProps[idx]];
    }

    if (line) {
      this.lineNumber = line;
      this.column = node.firstColumn;
    }
  }

  Exception.prototype = new Error();

  __exports__ = Exception;
  return __exports__;
})();

// handlebars/base.js
var __module2__ = (function(__dependency1__, __dependency2__) {
  "use strict";
  var __exports__ = {};
  var Utils = __dependency1__;
  var Exception = __dependency2__;

  var VERSION = "1.3.0";
  __exports__.VERSION = VERSION;var COMPILER_REVISION = 4;
  __exports__.COMPILER_REVISION = COMPILER_REVISION;
  var REVISION_CHANGES = {
    1: '<= 1.0.rc.2', // 1.0.rc.2 is actually rev2 but doesn't report it
    2: '== 1.0.0-rc.3',
    3: '== 1.0.0-rc.4',
    4: '>= 1.0.0'
  };
  __exports__.REVISION_CHANGES = REVISION_CHANGES;
  var isArray = Utils.isArray,
      isFunction = Utils.isFunction,
      toString = Utils.toString,
      objectType = '[object Object]';

  function HandlebarsEnvironment(helpers, partials) {
    this.helpers = helpers || {};
    this.partials = partials || {};

    registerDefaultHelpers(this);
  }

  __exports__.HandlebarsEnvironment = HandlebarsEnvironment;HandlebarsEnvironment.prototype = {
    constructor: HandlebarsEnvironment,

    logger: logger,
    log: log,

    registerHelper: function(name, fn, inverse) {
      if (toString.call(name) === objectType) {
        if (inverse || fn) { throw new Exception('Arg not supported with multiple helpers'); }
        Utils.extend(this.helpers, name);
      } else {
        if (inverse) { fn.not = inverse; }
        this.helpers[name] = fn;
      }
    },

    registerPartial: function(name, str) {
      if (toString.call(name) === objectType) {
        Utils.extend(this.partials,  name);
      } else {
        this.partials[name] = str;
      }
    }
  };

  function registerDefaultHelpers(instance) {
    instance.registerHelper('helperMissing', function(arg) {
      if(arguments.length === 2) {
        return undefined;
      } else {
        throw new Exception("Missing helper: '" + arg + "'");
      }
    });

    instance.registerHelper('blockHelperMissing', function(context, options) {
      var inverse = options.inverse || function() {}, fn = options.fn;

      if (isFunction(context)) { context = context.call(this); }

      if(context === true) {
        return fn(this);
      } else if(context === false || context == null) {
        return inverse(this);
      } else if (isArray(context)) {
        if(context.length > 0) {
          return instance.helpers.each(context, options);
        } else {
          return inverse(this);
        }
      } else {
        return fn(context);
      }
    });

    instance.registerHelper('each', function(context, options) {
      var fn = options.fn, inverse = options.inverse;
      var i = 0, ret = "", data;

      if (isFunction(context)) { context = context.call(this); }

      if (options.data) {
        data = createFrame(options.data);
      }

      if(context && typeof context === 'object') {
        if (isArray(context)) {
          for(var j = context.length; i<j; i++) {
            if (data) {
              data.index = i;
              data.first = (i === 0);
              data.last  = (i === (context.length-1));
            }
            ret = ret + fn(context[i], { data: data });
          }
        } else {
          for(var key in context) {
            if(context.hasOwnProperty(key)) {
              if(data) { 
                data.key = key; 
                data.index = i;
                data.first = (i === 0);
              }
              ret = ret + fn(context[key], {data: data});
              i++;
            }
          }
        }
      }

      if(i === 0){
        ret = inverse(this);
      }

      return ret;
    });

    instance.registerHelper('if', function(conditional, options) {
      if (isFunction(conditional)) { conditional = conditional.call(this); }

      // Default behavior is to render the positive path if the value is truthy and not empty.
      // The `includeZero` option may be set to treat the condtional as purely not empty based on the
      // behavior of isEmpty. Effectively this determines if 0 is handled by the positive path or negative.
      if ((!options.hash.includeZero && !conditional) || Utils.isEmpty(conditional)) {
        return options.inverse(this);
      } else {
        return options.fn(this);
      }
    });

    instance.registerHelper('unless', function(conditional, options) {
      return instance.helpers['if'].call(this, conditional, {fn: options.inverse, inverse: options.fn, hash: options.hash});
    });

    instance.registerHelper('with', function(context, options) {
      if (isFunction(context)) { context = context.call(this); }

      if (!Utils.isEmpty(context)) return options.fn(context);
    });

    instance.registerHelper('log', function(context, options) {
      var level = options.data && options.data.level != null ? parseInt(options.data.level, 10) : 1;
      instance.log(level, context);
    });
  }

  var logger = {
    methodMap: { 0: 'debug', 1: 'info', 2: 'warn', 3: 'error' },

    // State enum
    DEBUG: 0,
    INFO: 1,
    WARN: 2,
    ERROR: 3,
    level: 3,

    // can be overridden in the host environment
    log: function(level, obj) {
      if (logger.level <= level) {
        var method = logger.methodMap[level];
        if (typeof console !== 'undefined' && console[method]) {
          console[method].call(console, obj);
        }
      }
    }
  };
  __exports__.logger = logger;
  function log(level, obj) { logger.log(level, obj); }

  __exports__.log = log;var createFrame = function(object) {
    var obj = {};
    Utils.extend(obj, object);
    return obj;
  };
  __exports__.createFrame = createFrame;
  return __exports__;
})(__module3__, __module5__);

// handlebars/runtime.js
var __module6__ = (function(__dependency1__, __dependency2__, __dependency3__) {
  "use strict";
  var __exports__ = {};
  var Utils = __dependency1__;
  var Exception = __dependency2__;
  var COMPILER_REVISION = __dependency3__.COMPILER_REVISION;
  var REVISION_CHANGES = __dependency3__.REVISION_CHANGES;

  function checkRevision(compilerInfo) {
    var compilerRevision = compilerInfo && compilerInfo[0] || 1,
        currentRevision = COMPILER_REVISION;

    if (compilerRevision !== currentRevision) {
      if (compilerRevision < currentRevision) {
        var runtimeVersions = REVISION_CHANGES[currentRevision],
            compilerVersions = REVISION_CHANGES[compilerRevision];
        throw new Exception("Template was precompiled with an older version of Handlebars than the current runtime. "+
              "Please update your precompiler to a newer version ("+runtimeVersions+") or downgrade your runtime to an older version ("+compilerVersions+").");
      } else {
        // Use the embedded version info since the runtime doesn't know about this revision yet
        throw new Exception("Template was precompiled with a newer version of Handlebars than the current runtime. "+
              "Please update your runtime to a newer version ("+compilerInfo[1]+").");
      }
    }
  }

  __exports__.checkRevision = checkRevision;// TODO: Remove this line and break up compilePartial

  function template(templateSpec, env) {
    if (!env) {
      throw new Exception("No environment passed to template");
    }

    // Note: Using env.VM references rather than local var references throughout this section to allow
    // for external users to override these as psuedo-supported APIs.
    var invokePartialWrapper = function(partial, name, context, helpers, partials, data) {
      var result = env.VM.invokePartial.apply(this, arguments);
      if (result != null) { return result; }

      if (env.compile) {
        var options = { helpers: helpers, partials: partials, data: data };
        partials[name] = env.compile(partial, { data: data !== undefined }, env);
        return partials[name](context, options);
      } else {
        throw new Exception("The partial " + name + " could not be compiled when running in runtime-only mode");
      }
    };

    // Just add water
    var container = {
      escapeExpression: Utils.escapeExpression,
      invokePartial: invokePartialWrapper,
      programs: [],
      program: function(i, fn, data) {
        var programWrapper = this.programs[i];
        if(data) {
          programWrapper = program(i, fn, data);
        } else if (!programWrapper) {
          programWrapper = this.programs[i] = program(i, fn);
        }
        return programWrapper;
      },
      merge: function(param, common) {
        var ret = param || common;

        if (param && common && (param !== common)) {
          ret = {};
          Utils.extend(ret, common);
          Utils.extend(ret, param);
        }
        return ret;
      },
      programWithDepth: env.VM.programWithDepth,
      noop: env.VM.noop,
      compilerInfo: null
    };

    return function(context, options) {
      options = options || {};
      var namespace = options.partial ? options : env,
          helpers,
          partials;

      if (!options.partial) {
        helpers = options.helpers;
        partials = options.partials;
      }
      var result = templateSpec.call(
            container,
            namespace, context,
            helpers,
            partials,
            options.data);

      if (!options.partial) {
        env.VM.checkRevision(container.compilerInfo);
      }

      return result;
    };
  }

  __exports__.template = template;function programWithDepth(i, fn, data /*, $depth */) {
    var args = Array.prototype.slice.call(arguments, 3);

    var prog = function(context, options) {
      options = options || {};

      return fn.apply(this, [context, options.data || data].concat(args));
    };
    prog.program = i;
    prog.depth = args.length;
    return prog;
  }

  __exports__.programWithDepth = programWithDepth;function program(i, fn, data) {
    var prog = function(context, options) {
      options = options || {};

      return fn(context, options.data || data);
    };
    prog.program = i;
    prog.depth = 0;
    return prog;
  }

  __exports__.program = program;function invokePartial(partial, name, context, helpers, partials, data) {
    var options = { partial: true, helpers: helpers, partials: partials, data: data };

    if(partial === undefined) {
      throw new Exception("The partial " + name + " could not be found");
    } else if(partial instanceof Function) {
      return partial(context, options);
    }
  }

  __exports__.invokePartial = invokePartial;function noop() { return ""; }

  __exports__.noop = noop;
  return __exports__;
})(__module3__, __module5__, __module2__);

// handlebars.runtime.js
var __module1__ = (function(__dependency1__, __dependency2__, __dependency3__, __dependency4__, __dependency5__) {
  "use strict";
  var __exports__;
  /*globals Handlebars: true */
  var base = __dependency1__;

  // Each of these augment the Handlebars object. No need to setup here.
  // (This is done to easily share code between commonjs and browse envs)
  var SafeString = __dependency2__;
  var Exception = __dependency3__;
  var Utils = __dependency4__;
  var runtime = __dependency5__;

  // For compatibility and usage outside of module systems, make the Handlebars object a namespace
  var create = function() {
    var hb = new base.HandlebarsEnvironment();

    Utils.extend(hb, base);
    hb.SafeString = SafeString;
    hb.Exception = Exception;
    hb.Utils = Utils;

    hb.VM = runtime;
    hb.template = function(spec) {
      return runtime.template(spec, hb);
    };

    return hb;
  };

  var Handlebars = create();
  Handlebars.create = create;

  __exports__ = Handlebars;
  return __exports__;
})(__module2__, __module4__, __module5__, __module3__, __module6__);

// handlebars/compiler/ast.js
var __module7__ = (function(__dependency1__) {
  "use strict";
  var __exports__;
  var Exception = __dependency1__;

  function LocationInfo(locInfo){
    locInfo = locInfo || {};
    this.firstLine   = locInfo.first_line;
    this.firstColumn = locInfo.first_column;
    this.lastColumn  = locInfo.last_column;
    this.lastLine    = locInfo.last_line;
  }

  var AST = {
    ProgramNode: function(statements, inverseStrip, inverse, locInfo) {
      var inverseLocationInfo, firstInverseNode;
      if (arguments.length === 3) {
        locInfo = inverse;
        inverse = null;
      } else if (arguments.length === 2) {
        locInfo = inverseStrip;
        inverseStrip = null;
      }

      LocationInfo.call(this, locInfo);
      this.type = "program";
      this.statements = statements;
      this.strip = {};

      if(inverse) {
        firstInverseNode = inverse[0];
        if (firstInverseNode) {
          inverseLocationInfo = {
            first_line: firstInverseNode.firstLine,
            last_line: firstInverseNode.lastLine,
            last_column: firstInverseNode.lastColumn,
            first_column: firstInverseNode.firstColumn
          };
          this.inverse = new AST.ProgramNode(inverse, inverseStrip, inverseLocationInfo);
        } else {
          this.inverse = new AST.ProgramNode(inverse, inverseStrip);
        }
        this.strip.right = inverseStrip.left;
      } else if (inverseStrip) {
        this.strip.left = inverseStrip.right;
      }
    },

    MustacheNode: function(rawParams, hash, open, strip, locInfo) {
      LocationInfo.call(this, locInfo);
      this.type = "mustache";
      this.strip = strip;

      // Open may be a string parsed from the parser or a passed boolean flag
      if (open != null && open.charAt) {
        // Must use charAt to support IE pre-10
        var escapeFlag = open.charAt(3) || open.charAt(2);
        this.escaped = escapeFlag !== '{' && escapeFlag !== '&';
      } else {
        this.escaped = !!open;
      }

      if (rawParams instanceof AST.SexprNode) {
        this.sexpr = rawParams;
      } else {
        // Support old AST API
        this.sexpr = new AST.SexprNode(rawParams, hash);
      }

      this.sexpr.isRoot = true;

      // Support old AST API that stored this info in MustacheNode
      this.id = this.sexpr.id;
      this.params = this.sexpr.params;
      this.hash = this.sexpr.hash;
      this.eligibleHelper = this.sexpr.eligibleHelper;
      this.isHelper = this.sexpr.isHelper;
    },

    SexprNode: function(rawParams, hash, locInfo) {
      LocationInfo.call(this, locInfo);

      this.type = "sexpr";
      this.hash = hash;

      var id = this.id = rawParams[0];
      var params = this.params = rawParams.slice(1);

      // a mustache is an eligible helper if:
      // * its id is simple (a single part, not `this` or `..`)
      var eligibleHelper = this.eligibleHelper = id.isSimple;

      // a mustache is definitely a helper if:
      // * it is an eligible helper, and
      // * it has at least one parameter or hash segment
      this.isHelper = eligibleHelper && (params.length || hash);

      // if a mustache is an eligible helper but not a definite
      // helper, it is ambiguous, and will be resolved in a later
      // pass or at runtime.
    },

    PartialNode: function(partialName, context, strip, locInfo) {
      LocationInfo.call(this, locInfo);
      this.type         = "partial";
      this.partialName  = partialName;
      this.context      = context;
      this.strip = strip;
    },

    BlockNode: function(mustache, program, inverse, close, locInfo) {
      LocationInfo.call(this, locInfo);

      if(mustache.sexpr.id.original !== close.path.original) {
        throw new Exception(mustache.sexpr.id.original + " doesn't match " + close.path.original, this);
      }

      this.type = 'block';
      this.mustache = mustache;
      this.program  = program;
      this.inverse  = inverse;

      this.strip = {
        left: mustache.strip.left,
        right: close.strip.right
      };

      (program || inverse).strip.left = mustache.strip.right;
      (inverse || program).strip.right = close.strip.left;

      if (inverse && !program) {
        this.isInverse = true;
      }
    },

    ContentNode: function(string, locInfo) {
      LocationInfo.call(this, locInfo);
      this.type = "content";
      this.string = string;
    },

    HashNode: function(pairs, locInfo) {
      LocationInfo.call(this, locInfo);
      this.type = "hash";
      this.pairs = pairs;
    },

    IdNode: function(parts, locInfo) {
      LocationInfo.call(this, locInfo);
      this.type = "ID";

      var original = "",
          dig = [],
          depth = 0;

      for(var i=0,l=parts.length; i<l; i++) {
        var part = parts[i].part;
        original += (parts[i].separator || '') + part;

        if (part === ".." || part === "." || part === "this") {
          if (dig.length > 0) {
            throw new Exception("Invalid path: " + original, this);
          } else if (part === "..") {
            depth++;
          } else {
            this.isScoped = true;
          }
        } else {
          dig.push(part);
        }
      }

      this.original = original;
      this.parts    = dig;
      this.string   = dig.join('.');
      this.depth    = depth;

      // an ID is simple if it only has one part, and that part is not
      // `..` or `this`.
      this.isSimple = parts.length === 1 && !this.isScoped && depth === 0;

      this.stringModeValue = this.string;
    },

    PartialNameNode: function(name, locInfo) {
      LocationInfo.call(this, locInfo);
      this.type = "PARTIAL_NAME";
      this.name = name.original;
    },

    DataNode: function(id, locInfo) {
      LocationInfo.call(this, locInfo);
      this.type = "DATA";
      this.id = id;
    },

    StringNode: function(string, locInfo) {
      LocationInfo.call(this, locInfo);
      this.type = "STRING";
      this.original =
        this.string =
        this.stringModeValue = string;
    },

    IntegerNode: function(integer, locInfo) {
      LocationInfo.call(this, locInfo);
      this.type = "INTEGER";
      this.original =
        this.integer = integer;
      this.stringModeValue = Number(integer);
    },

    BooleanNode: function(bool, locInfo) {
      LocationInfo.call(this, locInfo);
      this.type = "BOOLEAN";
      this.bool = bool;
      this.stringModeValue = bool === "true";
    },

    CommentNode: function(comment, locInfo) {
      LocationInfo.call(this, locInfo);
      this.type = "comment";
      this.comment = comment;
    }
  };

  // Must be exported as an object rather than the root of the module as the jison lexer
  // most modify the object to operate properly.
  __exports__ = AST;
  return __exports__;
})(__module5__);

// handlebars/compiler/parser.js
var __module9__ = (function() {
  "use strict";
  var __exports__;
  /* jshint ignore:start */
  /* Jison generated parser */
  var handlebars = (function(){
  var parser = {trace: function trace() { },
  yy: {},
  symbols_: {"error":2,"root":3,"statements":4,"EOF":5,"program":6,"simpleInverse":7,"statement":8,"openInverse":9,"closeBlock":10,"openBlock":11,"mustache":12,"partial":13,"CONTENT":14,"COMMENT":15,"OPEN_BLOCK":16,"sexpr":17,"CLOSE":18,"OPEN_INVERSE":19,"OPEN_ENDBLOCK":20,"path":21,"OPEN":22,"OPEN_UNESCAPED":23,"CLOSE_UNESCAPED":24,"OPEN_PARTIAL":25,"partialName":26,"partial_option0":27,"sexpr_repetition0":28,"sexpr_option0":29,"dataName":30,"param":31,"STRING":32,"INTEGER":33,"BOOLEAN":34,"OPEN_SEXPR":35,"CLOSE_SEXPR":36,"hash":37,"hash_repetition_plus0":38,"hashSegment":39,"ID":40,"EQUALS":41,"DATA":42,"pathSegments":43,"SEP":44,"$accept":0,"$end":1},
  terminals_: {2:"error",5:"EOF",14:"CONTENT",15:"COMMENT",16:"OPEN_BLOCK",18:"CLOSE",19:"OPEN_INVERSE",20:"OPEN_ENDBLOCK",22:"OPEN",23:"OPEN_UNESCAPED",24:"CLOSE_UNESCAPED",25:"OPEN_PARTIAL",32:"STRING",33:"INTEGER",34:"BOOLEAN",35:"OPEN_SEXPR",36:"CLOSE_SEXPR",40:"ID",41:"EQUALS",42:"DATA",44:"SEP"},
  productions_: [0,[3,2],[3,1],[6,2],[6,3],[6,2],[6,1],[6,1],[6,0],[4,1],[4,2],[8,3],[8,3],[8,1],[8,1],[8,1],[8,1],[11,3],[9,3],[10,3],[12,3],[12,3],[13,4],[7,2],[17,3],[17,1],[31,1],[31,1],[31,1],[31,1],[31,1],[31,3],[37,1],[39,3],[26,1],[26,1],[26,1],[30,2],[21,1],[43,3],[43,1],[27,0],[27,1],[28,0],[28,2],[29,0],[29,1],[38,1],[38,2]],
  performAction: function anonymous(yytext,yyleng,yylineno,yy,yystate,$$,_$) {

  var $0 = $$.length - 1;
  switch (yystate) {
  case 1: return new yy.ProgramNode($$[$0-1], this._$); 
  break;
  case 2: return new yy.ProgramNode([], this._$); 
  break;
  case 3:this.$ = new yy.ProgramNode([], $$[$0-1], $$[$0], this._$);
  break;
  case 4:this.$ = new yy.ProgramNode($$[$0-2], $$[$0-1], $$[$0], this._$);
  break;
  case 5:this.$ = new yy.ProgramNode($$[$0-1], $$[$0], [], this._$);
  break;
  case 6:this.$ = new yy.ProgramNode($$[$0], this._$);
  break;
  case 7:this.$ = new yy.ProgramNode([], this._$);
  break;
  case 8:this.$ = new yy.ProgramNode([], this._$);
  break;
  case 9:this.$ = [$$[$0]];
  break;
  case 10: $$[$0-1].push($$[$0]); this.$ = $$[$0-1]; 
  break;
  case 11:this.$ = new yy.BlockNode($$[$0-2], $$[$0-1].inverse, $$[$0-1], $$[$0], this._$);
  break;
  case 12:this.$ = new yy.BlockNode($$[$0-2], $$[$0-1], $$[$0-1].inverse, $$[$0], this._$);
  break;
  case 13:this.$ = $$[$0];
  break;
  case 14:this.$ = $$[$0];
  break;
  case 15:this.$ = new yy.ContentNode($$[$0], this._$);
  break;
  case 16:this.$ = new yy.CommentNode($$[$0], this._$);
  break;
  case 17:this.$ = new yy.MustacheNode($$[$0-1], null, $$[$0-2], stripFlags($$[$0-2], $$[$0]), this._$);
  break;
  case 18:this.$ = new yy.MustacheNode($$[$0-1], null, $$[$0-2], stripFlags($$[$0-2], $$[$0]), this._$);
  break;
  case 19:this.$ = {path: $$[$0-1], strip: stripFlags($$[$0-2], $$[$0])};
  break;
  case 20:this.$ = new yy.MustacheNode($$[$0-1], null, $$[$0-2], stripFlags($$[$0-2], $$[$0]), this._$);
  break;
  case 21:this.$ = new yy.MustacheNode($$[$0-1], null, $$[$0-2], stripFlags($$[$0-2], $$[$0]), this._$);
  break;
  case 22:this.$ = new yy.PartialNode($$[$0-2], $$[$0-1], stripFlags($$[$0-3], $$[$0]), this._$);
  break;
  case 23:this.$ = stripFlags($$[$0-1], $$[$0]);
  break;
  case 24:this.$ = new yy.SexprNode([$$[$0-2]].concat($$[$0-1]), $$[$0], this._$);
  break;
  case 25:this.$ = new yy.SexprNode([$$[$0]], null, this._$);
  break;
  case 26:this.$ = $$[$0];
  break;
  case 27:this.$ = new yy.StringNode($$[$0], this._$);
  break;
  case 28:this.$ = new yy.IntegerNode($$[$0], this._$);
  break;
  case 29:this.$ = new yy.BooleanNode($$[$0], this._$);
  break;
  case 30:this.$ = $$[$0];
  break;
  case 31:$$[$0-1].isHelper = true; this.$ = $$[$0-1];
  break;
  case 32:this.$ = new yy.HashNode($$[$0], this._$);
  break;
  case 33:this.$ = [$$[$0-2], $$[$0]];
  break;
  case 34:this.$ = new yy.PartialNameNode($$[$0], this._$);
  break;
  case 35:this.$ = new yy.PartialNameNode(new yy.StringNode($$[$0], this._$), this._$);
  break;
  case 36:this.$ = new yy.PartialNameNode(new yy.IntegerNode($$[$0], this._$));
  break;
  case 37:this.$ = new yy.DataNode($$[$0], this._$);
  break;
  case 38:this.$ = new yy.IdNode($$[$0], this._$);
  break;
  case 39: $$[$0-2].push({part: $$[$0], separator: $$[$0-1]}); this.$ = $$[$0-2]; 
  break;
  case 40:this.$ = [{part: $$[$0]}];
  break;
  case 43:this.$ = [];
  break;
  case 44:$$[$0-1].push($$[$0]);
  break;
  case 47:this.$ = [$$[$0]];
  break;
  case 48:$$[$0-1].push($$[$0]);
  break;
  }
  },
  table: [{3:1,4:2,5:[1,3],8:4,9:5,11:6,12:7,13:8,14:[1,9],15:[1,10],16:[1,12],19:[1,11],22:[1,13],23:[1,14],25:[1,15]},{1:[3]},{5:[1,16],8:17,9:5,11:6,12:7,13:8,14:[1,9],15:[1,10],16:[1,12],19:[1,11],22:[1,13],23:[1,14],25:[1,15]},{1:[2,2]},{5:[2,9],14:[2,9],15:[2,9],16:[2,9],19:[2,9],20:[2,9],22:[2,9],23:[2,9],25:[2,9]},{4:20,6:18,7:19,8:4,9:5,11:6,12:7,13:8,14:[1,9],15:[1,10],16:[1,12],19:[1,21],20:[2,8],22:[1,13],23:[1,14],25:[1,15]},{4:20,6:22,7:19,8:4,9:5,11:6,12:7,13:8,14:[1,9],15:[1,10],16:[1,12],19:[1,21],20:[2,8],22:[1,13],23:[1,14],25:[1,15]},{5:[2,13],14:[2,13],15:[2,13],16:[2,13],19:[2,13],20:[2,13],22:[2,13],23:[2,13],25:[2,13]},{5:[2,14],14:[2,14],15:[2,14],16:[2,14],19:[2,14],20:[2,14],22:[2,14],23:[2,14],25:[2,14]},{5:[2,15],14:[2,15],15:[2,15],16:[2,15],19:[2,15],20:[2,15],22:[2,15],23:[2,15],25:[2,15]},{5:[2,16],14:[2,16],15:[2,16],16:[2,16],19:[2,16],20:[2,16],22:[2,16],23:[2,16],25:[2,16]},{17:23,21:24,30:25,40:[1,28],42:[1,27],43:26},{17:29,21:24,30:25,40:[1,28],42:[1,27],43:26},{17:30,21:24,30:25,40:[1,28],42:[1,27],43:26},{17:31,21:24,30:25,40:[1,28],42:[1,27],43:26},{21:33,26:32,32:[1,34],33:[1,35],40:[1,28],43:26},{1:[2,1]},{5:[2,10],14:[2,10],15:[2,10],16:[2,10],19:[2,10],20:[2,10],22:[2,10],23:[2,10],25:[2,10]},{10:36,20:[1,37]},{4:38,8:4,9:5,11:6,12:7,13:8,14:[1,9],15:[1,10],16:[1,12],19:[1,11],20:[2,7],22:[1,13],23:[1,14],25:[1,15]},{7:39,8:17,9:5,11:6,12:7,13:8,14:[1,9],15:[1,10],16:[1,12],19:[1,21],20:[2,6],22:[1,13],23:[1,14],25:[1,15]},{17:23,18:[1,40],21:24,30:25,40:[1,28],42:[1,27],43:26},{10:41,20:[1,37]},{18:[1,42]},{18:[2,43],24:[2,43],28:43,32:[2,43],33:[2,43],34:[2,43],35:[2,43],36:[2,43],40:[2,43],42:[2,43]},{18:[2,25],24:[2,25],36:[2,25]},{18:[2,38],24:[2,38],32:[2,38],33:[2,38],34:[2,38],35:[2,38],36:[2,38],40:[2,38],42:[2,38],44:[1,44]},{21:45,40:[1,28],43:26},{18:[2,40],24:[2,40],32:[2,40],33:[2,40],34:[2,40],35:[2,40],36:[2,40],40:[2,40],42:[2,40],44:[2,40]},{18:[1,46]},{18:[1,47]},{24:[1,48]},{18:[2,41],21:50,27:49,40:[1,28],43:26},{18:[2,34],40:[2,34]},{18:[2,35],40:[2,35]},{18:[2,36],40:[2,36]},{5:[2,11],14:[2,11],15:[2,11],16:[2,11],19:[2,11],20:[2,11],22:[2,11],23:[2,11],25:[2,11]},{21:51,40:[1,28],43:26},{8:17,9:5,11:6,12:7,13:8,14:[1,9],15:[1,10],16:[1,12],19:[1,11],20:[2,3],22:[1,13],23:[1,14],25:[1,15]},{4:52,8:4,9:5,11:6,12:7,13:8,14:[1,9],15:[1,10],16:[1,12],19:[1,11],20:[2,5],22:[1,13],23:[1,14],25:[1,15]},{14:[2,23],15:[2,23],16:[2,23],19:[2,23],20:[2,23],22:[2,23],23:[2,23],25:[2,23]},{5:[2,12],14:[2,12],15:[2,12],16:[2,12],19:[2,12],20:[2,12],22:[2,12],23:[2,12],25:[2,12]},{14:[2,18],15:[2,18],16:[2,18],19:[2,18],20:[2,18],22:[2,18],23:[2,18],25:[2,18]},{18:[2,45],21:56,24:[2,45],29:53,30:60,31:54,32:[1,57],33:[1,58],34:[1,59],35:[1,61],36:[2,45],37:55,38:62,39:63,40:[1,64],42:[1,27],43:26},{40:[1,65]},{18:[2,37],24:[2,37],32:[2,37],33:[2,37],34:[2,37],35:[2,37],36:[2,37],40:[2,37],42:[2,37]},{14:[2,17],15:[2,17],16:[2,17],19:[2,17],20:[2,17],22:[2,17],23:[2,17],25:[2,17]},{5:[2,20],14:[2,20],15:[2,20],16:[2,20],19:[2,20],20:[2,20],22:[2,20],23:[2,20],25:[2,20]},{5:[2,21],14:[2,21],15:[2,21],16:[2,21],19:[2,21],20:[2,21],22:[2,21],23:[2,21],25:[2,21]},{18:[1,66]},{18:[2,42]},{18:[1,67]},{8:17,9:5,11:6,12:7,13:8,14:[1,9],15:[1,10],16:[1,12],19:[1,11],20:[2,4],22:[1,13],23:[1,14],25:[1,15]},{18:[2,24],24:[2,24],36:[2,24]},{18:[2,44],24:[2,44],32:[2,44],33:[2,44],34:[2,44],35:[2,44],36:[2,44],40:[2,44],42:[2,44]},{18:[2,46],24:[2,46],36:[2,46]},{18:[2,26],24:[2,26],32:[2,26],33:[2,26],34:[2,26],35:[2,26],36:[2,26],40:[2,26],42:[2,26]},{18:[2,27],24:[2,27],32:[2,27],33:[2,27],34:[2,27],35:[2,27],36:[2,27],40:[2,27],42:[2,27]},{18:[2,28],24:[2,28],32:[2,28],33:[2,28],34:[2,28],35:[2,28],36:[2,28],40:[2,28],42:[2,28]},{18:[2,29],24:[2,29],32:[2,29],33:[2,29],34:[2,29],35:[2,29],36:[2,29],40:[2,29],42:[2,29]},{18:[2,30],24:[2,30],32:[2,30],33:[2,30],34:[2,30],35:[2,30],36:[2,30],40:[2,30],42:[2,30]},{17:68,21:24,30:25,40:[1,28],42:[1,27],43:26},{18:[2,32],24:[2,32],36:[2,32],39:69,40:[1,70]},{18:[2,47],24:[2,47],36:[2,47],40:[2,47]},{18:[2,40],24:[2,40],32:[2,40],33:[2,40],34:[2,40],35:[2,40],36:[2,40],40:[2,40],41:[1,71],42:[2,40],44:[2,40]},{18:[2,39],24:[2,39],32:[2,39],33:[2,39],34:[2,39],35:[2,39],36:[2,39],40:[2,39],42:[2,39],44:[2,39]},{5:[2,22],14:[2,22],15:[2,22],16:[2,22],19:[2,22],20:[2,22],22:[2,22],23:[2,22],25:[2,22]},{5:[2,19],14:[2,19],15:[2,19],16:[2,19],19:[2,19],20:[2,19],22:[2,19],23:[2,19],25:[2,19]},{36:[1,72]},{18:[2,48],24:[2,48],36:[2,48],40:[2,48]},{41:[1,71]},{21:56,30:60,31:73,32:[1,57],33:[1,58],34:[1,59],35:[1,61],40:[1,28],42:[1,27],43:26},{18:[2,31],24:[2,31],32:[2,31],33:[2,31],34:[2,31],35:[2,31],36:[2,31],40:[2,31],42:[2,31]},{18:[2,33],24:[2,33],36:[2,33],40:[2,33]}],
  defaultActions: {3:[2,2],16:[2,1],50:[2,42]},
  parseError: function parseError(str, hash) {
      throw new Error(str);
  },
  parse: function parse(input) {
      var self = this, stack = [0], vstack = [null], lstack = [], table = this.table, yytext = "", yylineno = 0, yyleng = 0, recovering = 0, TERROR = 2, EOF = 1;
      this.lexer.setInput(input);
      this.lexer.yy = this.yy;
      this.yy.lexer = this.lexer;
      this.yy.parser = this;
      if (typeof this.lexer.yylloc == "undefined")
          this.lexer.yylloc = {};
      var yyloc = this.lexer.yylloc;
      lstack.push(yyloc);
      var ranges = this.lexer.options && this.lexer.options.ranges;
      if (typeof this.yy.parseError === "function")
          this.parseError = this.yy.parseError;
      function popStack(n) {
          stack.length = stack.length - 2 * n;
          vstack.length = vstack.length - n;
          lstack.length = lstack.length - n;
      }
      function lex() {
          var token;
          token = self.lexer.lex() || 1;
          if (typeof token !== "number") {
              token = self.symbols_[token] || token;
          }
          return token;
      }
      var symbol, preErrorSymbol, state, action, a, r, yyval = {}, p, len, newState, expected;
      while (true) {
          state = stack[stack.length - 1];
          if (this.defaultActions[state]) {
              action = this.defaultActions[state];
          } else {
              if (symbol === null || typeof symbol == "undefined") {
                  symbol = lex();
              }
              action = table[state] && table[state][symbol];
          }
          if (typeof action === "undefined" || !action.length || !action[0]) {
              var errStr = "";
              if (!recovering) {
                  expected = [];
                  for (p in table[state])
                      if (this.terminals_[p] && p > 2) {
                          expected.push("'" + this.terminals_[p] + "'");
                      }
                  if (this.lexer.showPosition) {
                      errStr = "Parse error on line " + (yylineno + 1) + ":\n" + this.lexer.showPosition() + "\nExpecting " + expected.join(", ") + ", got '" + (this.terminals_[symbol] || symbol) + "'";
                  } else {
                      errStr = "Parse error on line " + (yylineno + 1) + ": Unexpected " + (symbol == 1?"end of input":"'" + (this.terminals_[symbol] || symbol) + "'");
                  }
                  this.parseError(errStr, {text: this.lexer.match, token: this.terminals_[symbol] || symbol, line: this.lexer.yylineno, loc: yyloc, expected: expected});
              }
          }
          if (action[0] instanceof Array && action.length > 1) {
              throw new Error("Parse Error: multiple actions possible at state: " + state + ", token: " + symbol);
          }
          switch (action[0]) {
          case 1:
              stack.push(symbol);
              vstack.push(this.lexer.yytext);
              lstack.push(this.lexer.yylloc);
              stack.push(action[1]);
              symbol = null;
              if (!preErrorSymbol) {
                  yyleng = this.lexer.yyleng;
                  yytext = this.lexer.yytext;
                  yylineno = this.lexer.yylineno;
                  yyloc = this.lexer.yylloc;
                  if (recovering > 0)
                      recovering--;
              } else {
                  symbol = preErrorSymbol;
                  preErrorSymbol = null;
              }
              break;
          case 2:
              len = this.productions_[action[1]][1];
              yyval.$ = vstack[vstack.length - len];
              yyval._$ = {first_line: lstack[lstack.length - (len || 1)].first_line, last_line: lstack[lstack.length - 1].last_line, first_column: lstack[lstack.length - (len || 1)].first_column, last_column: lstack[lstack.length - 1].last_column};
              if (ranges) {
                  yyval._$.range = [lstack[lstack.length - (len || 1)].range[0], lstack[lstack.length - 1].range[1]];
              }
              r = this.performAction.call(yyval, yytext, yyleng, yylineno, this.yy, action[1], vstack, lstack);
              if (typeof r !== "undefined") {
                  return r;
              }
              if (len) {
                  stack = stack.slice(0, -1 * len * 2);
                  vstack = vstack.slice(0, -1 * len);
                  lstack = lstack.slice(0, -1 * len);
              }
              stack.push(this.productions_[action[1]][0]);
              vstack.push(yyval.$);
              lstack.push(yyval._$);
              newState = table[stack[stack.length - 2]][stack[stack.length - 1]];
              stack.push(newState);
              break;
          case 3:
              return true;
          }
      }
      return true;
  }
  };


  function stripFlags(open, close) {
    return {
      left: open.charAt(2) === '~',
      right: close.charAt(0) === '~' || close.charAt(1) === '~'
    };
  }

  /* Jison generated lexer */
  var lexer = (function(){
  var lexer = ({EOF:1,
  parseError:function parseError(str, hash) {
          if (this.yy.parser) {
              this.yy.parser.parseError(str, hash);
          } else {
              throw new Error(str);
          }
      },
  setInput:function (input) {
          this._input = input;
          this._more = this._less = this.done = false;
          this.yylineno = this.yyleng = 0;
          this.yytext = this.matched = this.match = '';
          this.conditionStack = ['INITIAL'];
          this.yylloc = {first_line:1,first_column:0,last_line:1,last_column:0};
          if (this.options.ranges) this.yylloc.range = [0,0];
          this.offset = 0;
          return this;
      },
  input:function () {
          var ch = this._input[0];
          this.yytext += ch;
          this.yyleng++;
          this.offset++;
          this.match += ch;
          this.matched += ch;
          var lines = ch.match(/(?:\r\n?|\n).*/g);
          if (lines) {
              this.yylineno++;
              this.yylloc.last_line++;
          } else {
              this.yylloc.last_column++;
          }
          if (this.options.ranges) this.yylloc.range[1]++;

          this._input = this._input.slice(1);
          return ch;
      },
  unput:function (ch) {
          var len = ch.length;
          var lines = ch.split(/(?:\r\n?|\n)/g);

          this._input = ch + this._input;
          this.yytext = this.yytext.substr(0, this.yytext.length-len-1);
          //this.yyleng -= len;
          this.offset -= len;
          var oldLines = this.match.split(/(?:\r\n?|\n)/g);
          this.match = this.match.substr(0, this.match.length-1);
          this.matched = this.matched.substr(0, this.matched.length-1);

          if (lines.length-1) this.yylineno -= lines.length-1;
          var r = this.yylloc.range;

          this.yylloc = {first_line: this.yylloc.first_line,
            last_line: this.yylineno+1,
            first_column: this.yylloc.first_column,
            last_column: lines ?
                (lines.length === oldLines.length ? this.yylloc.first_column : 0) + oldLines[oldLines.length - lines.length].length - lines[0].length:
                this.yylloc.first_column - len
            };

          if (this.options.ranges) {
              this.yylloc.range = [r[0], r[0] + this.yyleng - len];
          }
          return this;
      },
  more:function () {
          this._more = true;
          return this;
      },
  less:function (n) {
          this.unput(this.match.slice(n));
      },
  pastInput:function () {
          var past = this.matched.substr(0, this.matched.length - this.match.length);
          return (past.length > 20 ? '...':'') + past.substr(-20).replace(/\n/g, "");
      },
  upcomingInput:function () {
          var next = this.match;
          if (next.length < 20) {
              next += this._input.substr(0, 20-next.length);
          }
          return (next.substr(0,20)+(next.length > 20 ? '...':'')).replace(/\n/g, "");
      },
  showPosition:function () {
          var pre = this.pastInput();
          var c = new Array(pre.length + 1).join("-");
          return pre + this.upcomingInput() + "\n" + c+"^";
      },
  next:function () {
          if (this.done) {
              return this.EOF;
          }
          if (!this._input) this.done = true;

          var token,
              match,
              tempMatch,
              index,
              col,
              lines;
          if (!this._more) {
              this.yytext = '';
              this.match = '';
          }
          var rules = this._currentRules();
          for (var i=0;i < rules.length; i++) {
              tempMatch = this._input.match(this.rules[rules[i]]);
              if (tempMatch && (!match || tempMatch[0].length > match[0].length)) {
                  match = tempMatch;
                  index = i;
                  if (!this.options.flex) break;
              }
          }
          if (match) {
              lines = match[0].match(/(?:\r\n?|\n).*/g);
              if (lines) this.yylineno += lines.length;
              this.yylloc = {first_line: this.yylloc.last_line,
                             last_line: this.yylineno+1,
                             first_column: this.yylloc.last_column,
                             last_column: lines ? lines[lines.length-1].length-lines[lines.length-1].match(/\r?\n?/)[0].length : this.yylloc.last_column + match[0].length};
              this.yytext += match[0];
              this.match += match[0];
              this.matches = match;
              this.yyleng = this.yytext.length;
              if (this.options.ranges) {
                  this.yylloc.range = [this.offset, this.offset += this.yyleng];
              }
              this._more = false;
              this._input = this._input.slice(match[0].length);
              this.matched += match[0];
              token = this.performAction.call(this, this.yy, this, rules[index],this.conditionStack[this.conditionStack.length-1]);
              if (this.done && this._input) this.done = false;
              if (token) return token;
              else return;
          }
          if (this._input === "") {
              return this.EOF;
          } else {
              return this.parseError('Lexical error on line '+(this.yylineno+1)+'. Unrecognized text.\n'+this.showPosition(),
                      {text: "", token: null, line: this.yylineno});
          }
      },
  lex:function lex() {
          var r = this.next();
          if (typeof r !== 'undefined') {
              return r;
          } else {
              return this.lex();
          }
      },
  begin:function begin(condition) {
          this.conditionStack.push(condition);
      },
  popState:function popState() {
          return this.conditionStack.pop();
      },
  _currentRules:function _currentRules() {
          return this.conditions[this.conditionStack[this.conditionStack.length-1]].rules;
      },
  topState:function () {
          return this.conditionStack[this.conditionStack.length-2];
      },
  pushState:function begin(condition) {
          this.begin(condition);
      }});
  lexer.options = {};
  lexer.performAction = function anonymous(yy,yy_,$avoiding_name_collisions,YY_START) {


  function strip(start, end) {
    return yy_.yytext = yy_.yytext.substr(start, yy_.yyleng-end);
  }


  var YYSTATE=YY_START
  switch($avoiding_name_collisions) {
  case 0:
                                     if(yy_.yytext.slice(-2) === "\\\\") {
                                       strip(0,1);
                                       this.begin("mu");
                                     } else if(yy_.yytext.slice(-1) === "\\") {
                                       strip(0,1);
                                       this.begin("emu");
                                     } else {
                                       this.begin("mu");
                                     }
                                     if(yy_.yytext) return 14;
                                   
  break;
  case 1:return 14;
  break;
  case 2:
                                     this.popState();
                                     return 14;
                                   
  break;
  case 3:strip(0,4); this.popState(); return 15;
  break;
  case 4:return 35;
  break;
  case 5:return 36;
  break;
  case 6:return 25;
  break;
  case 7:return 16;
  break;
  case 8:return 20;
  break;
  case 9:return 19;
  break;
  case 10:return 19;
  break;
  case 11:return 23;
  break;
  case 12:return 22;
  break;
  case 13:this.popState(); this.begin('com');
  break;
  case 14:strip(3,5); this.popState(); return 15;
  break;
  case 15:return 22;
  break;
  case 16:return 41;
  break;
  case 17:return 40;
  break;
  case 18:return 40;
  break;
  case 19:return 44;
  break;
  case 20:// ignore whitespace
  break;
  case 21:this.popState(); return 24;
  break;
  case 22:this.popState(); return 18;
  break;
  case 23:yy_.yytext = strip(1,2).replace(/\\"/g,'"'); return 32;
  break;
  case 24:yy_.yytext = strip(1,2).replace(/\\'/g,"'"); return 32;
  break;
  case 25:return 42;
  break;
  case 26:return 34;
  break;
  case 27:return 34;
  break;
  case 28:return 33;
  break;
  case 29:return 40;
  break;
  case 30:yy_.yytext = strip(1,2); return 40;
  break;
  case 31:return 'INVALID';
  break;
  case 32:return 5;
  break;
  }
  };
  lexer.rules = [/^(?:[^\x00]*?(?=(\{\{)))/,/^(?:[^\x00]+)/,/^(?:[^\x00]{2,}?(?=(\{\{|\\\{\{|\\\\\{\{|$)))/,/^(?:[\s\S]*?--\}\})/,/^(?:\()/,/^(?:\))/,/^(?:\{\{(~)?>)/,/^(?:\{\{(~)?#)/,/^(?:\{\{(~)?\/)/,/^(?:\{\{(~)?\^)/,/^(?:\{\{(~)?\s*else\b)/,/^(?:\{\{(~)?\{)/,/^(?:\{\{(~)?&)/,/^(?:\{\{!--)/,/^(?:\{\{![\s\S]*?\}\})/,/^(?:\{\{(~)?)/,/^(?:=)/,/^(?:\.\.)/,/^(?:\.(?=([=~}\s\/.)])))/,/^(?:[\/.])/,/^(?:\s+)/,/^(?:\}(~)?\}\})/,/^(?:(~)?\}\})/,/^(?:"(\\["]|[^"])*")/,/^(?:'(\\[']|[^'])*')/,/^(?:@)/,/^(?:true(?=([~}\s)])))/,/^(?:false(?=([~}\s)])))/,/^(?:-?[0-9]+(?=([~}\s)])))/,/^(?:([^\s!"#%-,\.\/;->@\[-\^`\{-~]+(?=([=~}\s\/.)]))))/,/^(?:\[[^\]]*\])/,/^(?:.)/,/^(?:$)/];
  lexer.conditions = {"mu":{"rules":[4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32],"inclusive":false},"emu":{"rules":[2],"inclusive":false},"com":{"rules":[3],"inclusive":false},"INITIAL":{"rules":[0,1,32],"inclusive":true}};
  return lexer;})()
  parser.lexer = lexer;
  function Parser () { this.yy = {}; }Parser.prototype = parser;parser.Parser = Parser;
  return new Parser;
  })();__exports__ = handlebars;
  /* jshint ignore:end */
  return __exports__;
})();

// handlebars/compiler/base.js
var __module8__ = (function(__dependency1__, __dependency2__) {
  "use strict";
  var __exports__ = {};
  var parser = __dependency1__;
  var AST = __dependency2__;

  __exports__.parser = parser;

  function parse(input) {
    // Just return if an already-compile AST was passed in.
    if(input.constructor === AST.ProgramNode) { return input; }

    parser.yy = AST;
    return parser.parse(input);
  }

  __exports__.parse = parse;
  return __exports__;
})(__module9__, __module7__);

// handlebars/compiler/compiler.js
var __module10__ = (function(__dependency1__) {
  "use strict";
  var __exports__ = {};
  var Exception = __dependency1__;

  function Compiler() {}

  __exports__.Compiler = Compiler;// the foundHelper register will disambiguate helper lookup from finding a
  // function in a context. This is necessary for mustache compatibility, which
  // requires that context functions in blocks are evaluated by blockHelperMissing,
  // and then proceed as if the resulting value was provided to blockHelperMissing.

  Compiler.prototype = {
    compiler: Compiler,

    disassemble: function() {
      var opcodes = this.opcodes, opcode, out = [], params, param;

      for (var i=0, l=opcodes.length; i<l; i++) {
        opcode = opcodes[i];

        if (opcode.opcode === 'DECLARE') {
          out.push("DECLARE " + opcode.name + "=" + opcode.value);
        } else {
          params = [];
          for (var j=0; j<opcode.args.length; j++) {
            param = opcode.args[j];
            if (typeof param === "string") {
              param = "\"" + param.replace("\n", "\\n") + "\"";
            }
            params.push(param);
          }
          out.push(opcode.opcode + " " + params.join(" "));
        }
      }

      return out.join("\n");
    },

    equals: function(other) {
      var len = this.opcodes.length;
      if (other.opcodes.length !== len) {
        return false;
      }

      for (var i = 0; i < len; i++) {
        var opcode = this.opcodes[i],
            otherOpcode = other.opcodes[i];
        if (opcode.opcode !== otherOpcode.opcode || opcode.args.length !== otherOpcode.args.length) {
          return false;
        }
        for (var j = 0; j < opcode.args.length; j++) {
          if (opcode.args[j] !== otherOpcode.args[j]) {
            return false;
          }
        }
      }

      len = this.children.length;
      if (other.children.length !== len) {
        return false;
      }
      for (i = 0; i < len; i++) {
        if (!this.children[i].equals(other.children[i])) {
          return false;
        }
      }

      return true;
    },

    guid: 0,

    compile: function(program, options) {
      this.opcodes = [];
      this.children = [];
      this.depths = {list: []};
      this.options = options;

      // These changes will propagate to the other compiler components
      var knownHelpers = this.options.knownHelpers;
      this.options.knownHelpers = {
        'helperMissing': true,
        'blockHelperMissing': true,
        'each': true,
        'if': true,
        'unless': true,
        'with': true,
        'log': true
      };
      if (knownHelpers) {
        for (var name in knownHelpers) {
          this.options.knownHelpers[name] = knownHelpers[name];
        }
      }

      return this.accept(program);
    },

    accept: function(node) {
      var strip = node.strip || {},
          ret;
      if (strip.left) {
        this.opcode('strip');
      }

      ret = this[node.type](node);

      if (strip.right) {
        this.opcode('strip');
      }

      return ret;
    },

    program: function(program) {
      var statements = program.statements;

      for(var i=0, l=statements.length; i<l; i++) {
        this.accept(statements[i]);
      }
      this.isSimple = l === 1;

      this.depths.list = this.depths.list.sort(function(a, b) {
        return a - b;
      });

      return this;
    },

    compileProgram: function(program) {
      var result = new this.compiler().compile(program, this.options);
      var guid = this.guid++, depth;

      this.usePartial = this.usePartial || result.usePartial;

      this.children[guid] = result;

      for(var i=0, l=result.depths.list.length; i<l; i++) {
        depth = result.depths.list[i];

        if(depth < 2) { continue; }
        else { this.addDepth(depth - 1); }
      }

      return guid;
    },

    block: function(block) {
      var mustache = block.mustache,
          program = block.program,
          inverse = block.inverse;

      if (program) {
        program = this.compileProgram(program);
      }

      if (inverse) {
        inverse = this.compileProgram(inverse);
      }

      var sexpr = mustache.sexpr;
      var type = this.classifySexpr(sexpr);

      if (type === "helper") {
        this.helperSexpr(sexpr, program, inverse);
      } else if (type === "simple") {
        this.simpleSexpr(sexpr);

        // now that the simple mustache is resolved, we need to
        // evaluate it by executing `blockHelperMissing`
        this.opcode('pushProgram', program);
        this.opcode('pushProgram', inverse);
        this.opcode('emptyHash');
        this.opcode('blockValue');
      } else {
        this.ambiguousSexpr(sexpr, program, inverse);

        // now that the simple mustache is resolved, we need to
        // evaluate it by executing `blockHelperMissing`
        this.opcode('pushProgram', program);
        this.opcode('pushProgram', inverse);
        this.opcode('emptyHash');
        this.opcode('ambiguousBlockValue');
      }

      this.opcode('append');
    },

    hash: function(hash) {
      var pairs = hash.pairs, pair, val;

      this.opcode('pushHash');

      for(var i=0, l=pairs.length; i<l; i++) {
        pair = pairs[i];
        val  = pair[1];

        if (this.options.stringParams) {
          if(val.depth) {
            this.addDepth(val.depth);
          }
          this.opcode('getContext', val.depth || 0);
          this.opcode('pushStringParam', val.stringModeValue, val.type);

          if (val.type === 'sexpr') {
            // Subexpressions get evaluated and passed in
            // in string params mode.
            this.sexpr(val);
          }
        } else {
          this.accept(val);
        }

        this.opcode('assignToHash', pair[0]);
      }
      this.opcode('popHash');
    },

    partial: function(partial) {
      var partialName = partial.partialName;
      this.usePartial = true;

      if(partial.context) {
        this.ID(partial.context);
      } else {
        this.opcode('push', 'depth0');
      }

      this.opcode('invokePartial', partialName.name);
      this.opcode('append');
    },

    content: function(content) {
      this.opcode('appendContent', content.string);
    },

    mustache: function(mustache) {
      this.sexpr(mustache.sexpr);

      if(mustache.escaped && !this.options.noEscape) {
        this.opcode('appendEscaped');
      } else {
        this.opcode('append');
      }
    },

    ambiguousSexpr: function(sexpr, program, inverse) {
      var id = sexpr.id,
          name = id.parts[0],
          isBlock = program != null || inverse != null;

      this.opcode('getContext', id.depth);

      this.opcode('pushProgram', program);
      this.opcode('pushProgram', inverse);

      this.opcode('invokeAmbiguous', name, isBlock);
    },

    simpleSexpr: function(sexpr) {
      var id = sexpr.id;

      if (id.type === 'DATA') {
        this.DATA(id);
      } else if (id.parts.length) {
        this.ID(id);
      } else {
        // Simplified ID for `this`
        this.addDepth(id.depth);
        this.opcode('getContext', id.depth);
        this.opcode('pushContext');
      }

      this.opcode('resolvePossibleLambda');
    },

    helperSexpr: function(sexpr, program, inverse) {
      var params = this.setupFullMustacheParams(sexpr, program, inverse),
          name = sexpr.id.parts[0];

      if (this.options.knownHelpers[name]) {
        this.opcode('invokeKnownHelper', params.length, name);
      } else if (this.options.knownHelpersOnly) {
        throw new Exception("You specified knownHelpersOnly, but used the unknown helper " + name, sexpr);
      } else {
        this.opcode('invokeHelper', params.length, name, sexpr.isRoot);
      }
    },

    sexpr: function(sexpr) {
      var type = this.classifySexpr(sexpr);

      if (type === "simple") {
        this.simpleSexpr(sexpr);
      } else if (type === "helper") {
        this.helperSexpr(sexpr);
      } else {
        this.ambiguousSexpr(sexpr);
      }
    },

    ID: function(id) {
      this.addDepth(id.depth);
      this.opcode('getContext', id.depth);

      var name = id.parts[0];
      if (!name) {
        this.opcode('pushContext');
      } else {
        this.opcode('lookupOnContext', id.parts[0]);
      }

      for(var i=1, l=id.parts.length; i<l; i++) {
        this.opcode('lookup', id.parts[i]);
      }
    },

    DATA: function(data) {
      this.options.data = true;
      if (data.id.isScoped || data.id.depth) {
        throw new Exception('Scoped data references are not supported: ' + data.original, data);
      }

      this.opcode('lookupData');
      var parts = data.id.parts;
      for(var i=0, l=parts.length; i<l; i++) {
        this.opcode('lookup', parts[i]);
      }
    },

    STRING: function(string) {
      this.opcode('pushString', string.string);
    },

    INTEGER: function(integer) {
      this.opcode('pushLiteral', integer.integer);
    },

    BOOLEAN: function(bool) {
      this.opcode('pushLiteral', bool.bool);
    },

    comment: function() {},

    // HELPERS
    opcode: function(name) {
      this.opcodes.push({ opcode: name, args: [].slice.call(arguments, 1) });
    },

    declare: function(name, value) {
      this.opcodes.push({ opcode: 'DECLARE', name: name, value: value });
    },

    addDepth: function(depth) {
      if(depth === 0) { return; }

      if(!this.depths[depth]) {
        this.depths[depth] = true;
        this.depths.list.push(depth);
      }
    },

    classifySexpr: function(sexpr) {
      var isHelper   = sexpr.isHelper;
      var isEligible = sexpr.eligibleHelper;
      var options    = this.options;

      // if ambiguous, we can possibly resolve the ambiguity now
      if (isEligible && !isHelper) {
        var name = sexpr.id.parts[0];

        if (options.knownHelpers[name]) {
          isHelper = true;
        } else if (options.knownHelpersOnly) {
          isEligible = false;
        }
      }

      if (isHelper) { return "helper"; }
      else if (isEligible) { return "ambiguous"; }
      else { return "simple"; }
    },

    pushParams: function(params) {
      var i = params.length, param;

      while(i--) {
        param = params[i];

        if(this.options.stringParams) {
          if(param.depth) {
            this.addDepth(param.depth);
          }

          this.opcode('getContext', param.depth || 0);
          this.opcode('pushStringParam', param.stringModeValue, param.type);

          if (param.type === 'sexpr') {
            // Subexpressions get evaluated and passed in
            // in string params mode.
            this.sexpr(param);
          }
        } else {
          this[param.type](param);
        }
      }
    },

    setupFullMustacheParams: function(sexpr, program, inverse) {
      var params = sexpr.params;
      this.pushParams(params);

      this.opcode('pushProgram', program);
      this.opcode('pushProgram', inverse);

      if (sexpr.hash) {
        this.hash(sexpr.hash);
      } else {
        this.opcode('emptyHash');
      }

      return params;
    }
  };

  function precompile(input, options, env) {
    if (input == null || (typeof input !== 'string' && input.constructor !== env.AST.ProgramNode)) {
      throw new Exception("You must pass a string or Handlebars AST to Handlebars.precompile. You passed " + input);
    }

    options = options || {};
    if (!('data' in options)) {
      options.data = true;
    }

    var ast = env.parse(input);
    var environment = new env.Compiler().compile(ast, options);
    return new env.JavaScriptCompiler().compile(environment, options);
  }

  __exports__.precompile = precompile;function compile(input, options, env) {
    if (input == null || (typeof input !== 'string' && input.constructor !== env.AST.ProgramNode)) {
      throw new Exception("You must pass a string or Handlebars AST to Handlebars.compile. You passed " + input);
    }

    options = options || {};

    if (!('data' in options)) {
      options.data = true;
    }

    var compiled;

    function compileInput() {
      var ast = env.parse(input);
      var environment = new env.Compiler().compile(ast, options);
      var templateSpec = new env.JavaScriptCompiler().compile(environment, options, undefined, true);
      return env.template(templateSpec);
    }

    // Template is only compiled on first use and cached after that point.
    return function(context, options) {
      if (!compiled) {
        compiled = compileInput();
      }
      return compiled.call(this, context, options);
    };
  }

  __exports__.compile = compile;
  return __exports__;
})(__module5__);

// handlebars/compiler/javascript-compiler.js
var __module11__ = (function(__dependency1__, __dependency2__) {
  "use strict";
  var __exports__;
  var COMPILER_REVISION = __dependency1__.COMPILER_REVISION;
  var REVISION_CHANGES = __dependency1__.REVISION_CHANGES;
  var log = __dependency1__.log;
  var Exception = __dependency2__;

  function Literal(value) {
    this.value = value;
  }

  function JavaScriptCompiler() {}

  JavaScriptCompiler.prototype = {
    // PUBLIC API: You can override these methods in a subclass to provide
    // alternative compiled forms for name lookup and buffering semantics
    nameLookup: function(parent, name /* , type*/) {
      var wrap,
          ret;
      if (parent.indexOf('depth') === 0) {
        wrap = true;
      }

      if (/^[0-9]+$/.test(name)) {
        ret = parent + "[" + name + "]";
      } else if (JavaScriptCompiler.isValidJavaScriptVariableName(name)) {
        ret = parent + "." + name;
      }
      else {
        ret = parent + "['" + name + "']";
      }

      if (wrap) {
        return '(' + parent + ' && ' + ret + ')';
      } else {
        return ret;
      }
    },

    compilerInfo: function() {
      var revision = COMPILER_REVISION,
          versions = REVISION_CHANGES[revision];
      return "this.compilerInfo = ["+revision+",'"+versions+"'];\n";
    },

    appendToBuffer: function(string) {
      if (this.environment.isSimple) {
        return "return " + string + ";";
      } else {
        return {
          appendToBuffer: true,
          content: string,
          toString: function() { return "buffer += " + string + ";"; }
        };
      }
    },

    initializeBuffer: function() {
      return this.quotedString("");
    },

    namespace: "Handlebars",
    // END PUBLIC API

    compile: function(environment, options, context, asObject) {
      this.environment = environment;
      this.options = options || {};

      log('debug', this.environment.disassemble() + "\n\n");

      this.name = this.environment.name;
      this.isChild = !!context;
      this.context = context || {
        programs: [],
        environments: [],
        aliases: { }
      };

      this.preamble();

      this.stackSlot = 0;
      this.stackVars = [];
      this.registers = { list: [] };
      this.hashes = [];
      this.compileStack = [];
      this.inlineStack = [];

      this.compileChildren(environment, options);

      var opcodes = environment.opcodes, opcode;

      this.i = 0;

      for(var l=opcodes.length; this.i<l; this.i++) {
        opcode = opcodes[this.i];

        if(opcode.opcode === 'DECLARE') {
          this[opcode.name] = opcode.value;
        } else {
          this[opcode.opcode].apply(this, opcode.args);
        }

        // Reset the stripNext flag if it was not set by this operation.
        if (opcode.opcode !== this.stripNext) {
          this.stripNext = false;
        }
      }

      // Flush any trailing content that might be pending.
      this.pushSource('');

      if (this.stackSlot || this.inlineStack.length || this.compileStack.length) {
        throw new Exception('Compile completed with content left on stack');
      }

      return this.createFunctionContext(asObject);
    },

    preamble: function() {
      var out = [];

      if (!this.isChild) {
        var namespace = this.namespace;

        var copies = "helpers = this.merge(helpers, " + namespace + ".helpers);";
        if (this.environment.usePartial) { copies = copies + " partials = this.merge(partials, " + namespace + ".partials);"; }
        if (this.options.data) { copies = copies + " data = data || {};"; }
        out.push(copies);
      } else {
        out.push('');
      }

      if (!this.environment.isSimple) {
        out.push(", buffer = " + this.initializeBuffer());
      } else {
        out.push("");
      }

      // track the last context pushed into place to allow skipping the
      // getContext opcode when it would be a noop
      this.lastContext = 0;
      this.source = out;
    },

    createFunctionContext: function(asObject) {
      var locals = this.stackVars.concat(this.registers.list);

      if(locals.length > 0) {
        this.source[1] = this.source[1] + ", " + locals.join(", ");
      }

      // Generate minimizer alias mappings
      if (!this.isChild) {
        for (var alias in this.context.aliases) {
          if (this.context.aliases.hasOwnProperty(alias)) {
            this.source[1] = this.source[1] + ', ' + alias + '=' + this.context.aliases[alias];
          }
        }
      }

      if (this.source[1]) {
        this.source[1] = "var " + this.source[1].substring(2) + ";";
      }

      // Merge children
      if (!this.isChild) {
        this.source[1] += '\n' + this.context.programs.join('\n') + '\n';
      }

      if (!this.environment.isSimple) {
        this.pushSource("return buffer;");
      }

      var params = this.isChild ? ["depth0", "data"] : ["Handlebars", "depth0", "helpers", "partials", "data"];

      for(var i=0, l=this.environment.depths.list.length; i<l; i++) {
        params.push("depth" + this.environment.depths.list[i]);
      }

      // Perform a second pass over the output to merge content when possible
      var source = this.mergeSource();

      if (!this.isChild) {
        source = this.compilerInfo()+source;
      }

      if (asObject) {
        params.push(source);

        return Function.apply(this, params);
      } else {
        var functionSource = 'function ' + (this.name || '') + '(' + params.join(',') + ') {\n  ' + source + '}';
        log('debug', functionSource + "\n\n");
        return functionSource;
      }
    },
    mergeSource: function() {
      // WARN: We are not handling the case where buffer is still populated as the source should
      // not have buffer append operations as their final action.
      var source = '',
          buffer;
      for (var i = 0, len = this.source.length; i < len; i++) {
        var line = this.source[i];
        if (line.appendToBuffer) {
          if (buffer) {
            buffer = buffer + '\n    + ' + line.content;
          } else {
            buffer = line.content;
          }
        } else {
          if (buffer) {
            source += 'buffer += ' + buffer + ';\n  ';
            buffer = undefined;
          }
          source += line + '\n  ';
        }
      }
      return source;
    },

    // [blockValue]
    //
    // On stack, before: hash, inverse, program, value
    // On stack, after: return value of blockHelperMissing
    //
    // The purpose of this opcode is to take a block of the form
    // `{{#foo}}...{{/foo}}`, resolve the value of `foo`, and
    // replace it on the stack with the result of properly
    // invoking blockHelperMissing.
    blockValue: function() {
      this.context.aliases.blockHelperMissing = 'helpers.blockHelperMissing';

      var params = ["depth0"];
      this.setupParams(0, params);

      this.replaceStack(function(current) {
        params.splice(1, 0, current);
        return "blockHelperMissing.call(" + params.join(", ") + ")";
      });
    },

    // [ambiguousBlockValue]
    //
    // On stack, before: hash, inverse, program, value
    // Compiler value, before: lastHelper=value of last found helper, if any
    // On stack, after, if no lastHelper: same as [blockValue]
    // On stack, after, if lastHelper: value
    ambiguousBlockValue: function() {
      this.context.aliases.blockHelperMissing = 'helpers.blockHelperMissing';

      var params = ["depth0"];
      this.setupParams(0, params);

      var current = this.topStack();
      params.splice(1, 0, current);

      this.pushSource("if (!" + this.lastHelper + ") { " + current + " = blockHelperMissing.call(" + params.join(", ") + "); }");
    },

    // [appendContent]
    //
    // On stack, before: ...
    // On stack, after: ...
    //
    // Appends the string value of `content` to the current buffer
    appendContent: function(content) {
      if (this.pendingContent) {
        content = this.pendingContent + content;
      }
      if (this.stripNext) {
        content = content.replace(/^\s+/, '');
      }

      this.pendingContent = content;
    },

    // [strip]
    //
    // On stack, before: ...
    // On stack, after: ...
    //
    // Removes any trailing whitespace from the prior content node and flags
    // the next operation for stripping if it is a content node.
    strip: function() {
      if (this.pendingContent) {
        this.pendingContent = this.pendingContent.replace(/\s+$/, '');
      }
      this.stripNext = 'strip';
    },

    // [append]
    //
    // On stack, before: value, ...
    // On stack, after: ...
    //
    // Coerces `value` to a String and appends it to the current buffer.
    //
    // If `value` is truthy, or 0, it is coerced into a string and appended
    // Otherwise, the empty string is appended
    append: function() {
      // Force anything that is inlined onto the stack so we don't have duplication
      // when we examine local
      this.flushInline();
      var local = this.popStack();
      this.pushSource("if(" + local + " || " + local + " === 0) { " + this.appendToBuffer(local) + " }");
      if (this.environment.isSimple) {
        this.pushSource("else { " + this.appendToBuffer("''") + " }");
      }
    },

    // [appendEscaped]
    //
    // On stack, before: value, ...
    // On stack, after: ...
    //
    // Escape `value` and append it to the buffer
    appendEscaped: function() {
      this.context.aliases.escapeExpression = 'this.escapeExpression';

      this.pushSource(this.appendToBuffer("escapeExpression(" + this.popStack() + ")"));
    },

    // [getContext]
    //
    // On stack, before: ...
    // On stack, after: ...
    // Compiler value, after: lastContext=depth
    //
    // Set the value of the `lastContext` compiler value to the depth
    getContext: function(depth) {
      if(this.lastContext !== depth) {
        this.lastContext = depth;
      }
    },

    // [lookupOnContext]
    //
    // On stack, before: ...
    // On stack, after: currentContext[name], ...
    //
    // Looks up the value of `name` on the current context and pushes
    // it onto the stack.
    lookupOnContext: function(name) {
      this.push(this.nameLookup('depth' + this.lastContext, name, 'context'));
    },

    // [pushContext]
    //
    // On stack, before: ...
    // On stack, after: currentContext, ...
    //
    // Pushes the value of the current context onto the stack.
    pushContext: function() {
      this.pushStackLiteral('depth' + this.lastContext);
    },

    // [resolvePossibleLambda]
    //
    // On stack, before: value, ...
    // On stack, after: resolved value, ...
    //
    // If the `value` is a lambda, replace it on the stack by
    // the return value of the lambda
    resolvePossibleLambda: function() {
      this.context.aliases.functionType = '"function"';

      this.replaceStack(function(current) {
        return "typeof " + current + " === functionType ? " + current + ".apply(depth0) : " + current;
      });
    },

    // [lookup]
    //
    // On stack, before: value, ...
    // On stack, after: value[name], ...
    //
    // Replace the value on the stack with the result of looking
    // up `name` on `value`
    lookup: function(name) {
      this.replaceStack(function(current) {
        return current + " == null || " + current + " === false ? " + current + " : " + this.nameLookup(current, name, 'context');
      });
    },

    // [lookupData]
    //
    // On stack, before: ...
    // On stack, after: data, ...
    //
    // Push the data lookup operator
    lookupData: function() {
      this.pushStackLiteral('data');
    },

    // [pushStringParam]
    //
    // On stack, before: ...
    // On stack, after: string, currentContext, ...
    //
    // This opcode is designed for use in string mode, which
    // provides the string value of a parameter along with its
    // depth rather than resolving it immediately.
    pushStringParam: function(string, type) {
      this.pushStackLiteral('depth' + this.lastContext);

      this.pushString(type);

      // If it's a subexpression, the string result
      // will be pushed after this opcode.
      if (type !== 'sexpr') {
        if (typeof string === 'string') {
          this.pushString(string);
        } else {
          this.pushStackLiteral(string);
        }
      }
    },

    emptyHash: function() {
      this.pushStackLiteral('{}');

      if (this.options.stringParams) {
        this.push('{}'); // hashContexts
        this.push('{}'); // hashTypes
      }
    },
    pushHash: function() {
      if (this.hash) {
        this.hashes.push(this.hash);
      }
      this.hash = {values: [], types: [], contexts: []};
    },
    popHash: function() {
      var hash = this.hash;
      this.hash = this.hashes.pop();

      if (this.options.stringParams) {
        this.push('{' + hash.contexts.join(',') + '}');
        this.push('{' + hash.types.join(',') + '}');
      }

      this.push('{\n    ' + hash.values.join(',\n    ') + '\n  }');
    },

    // [pushString]
    //
    // On stack, before: ...
    // On stack, after: quotedString(string), ...
    //
    // Push a quoted version of `string` onto the stack
    pushString: function(string) {
      this.pushStackLiteral(this.quotedString(string));
    },

    // [push]
    //
    // On stack, before: ...
    // On stack, after: expr, ...
    //
    // Push an expression onto the stack
    push: function(expr) {
      this.inlineStack.push(expr);
      return expr;
    },

    // [pushLiteral]
    //
    // On stack, before: ...
    // On stack, after: value, ...
    //
    // Pushes a value onto the stack. This operation prevents
    // the compiler from creating a temporary variable to hold
    // it.
    pushLiteral: function(value) {
      this.pushStackLiteral(value);
    },

    // [pushProgram]
    //
    // On stack, before: ...
    // On stack, after: program(guid), ...
    //
    // Push a program expression onto the stack. This takes
    // a compile-time guid and converts it into a runtime-accessible
    // expression.
    pushProgram: function(guid) {
      if (guid != null) {
        this.pushStackLiteral(this.programExpression(guid));
      } else {
        this.pushStackLiteral(null);
      }
    },

    // [invokeHelper]
    //
    // On stack, before: hash, inverse, program, params..., ...
    // On stack, after: result of helper invocation
    //
    // Pops off the helper's parameters, invokes the helper,
    // and pushes the helper's return value onto the stack.
    //
    // If the helper is not found, `helperMissing` is called.
    invokeHelper: function(paramSize, name, isRoot) {
      this.context.aliases.helperMissing = 'helpers.helperMissing';
      this.useRegister('helper');

      var helper = this.lastHelper = this.setupHelper(paramSize, name, true);
      var nonHelper = this.nameLookup('depth' + this.lastContext, name, 'context');

      var lookup = 'helper = ' + helper.name + ' || ' + nonHelper;
      if (helper.paramsInit) {
        lookup += ',' + helper.paramsInit;
      }

      this.push(
        '('
          + lookup
          + ',helper '
            + '? helper.call(' + helper.callParams + ') '
            + ': helperMissing.call(' + helper.helperMissingParams + '))');

      // Always flush subexpressions. This is both to prevent the compounding size issue that
      // occurs when the code has to be duplicated for inlining and also to prevent errors
      // due to the incorrect options object being passed due to the shared register.
      if (!isRoot) {
        this.flushInline();
      }
    },

    // [invokeKnownHelper]
    //
    // On stack, before: hash, inverse, program, params..., ...
    // On stack, after: result of helper invocation
    //
    // This operation is used when the helper is known to exist,
    // so a `helperMissing` fallback is not required.
    invokeKnownHelper: function(paramSize, name) {
      var helper = this.setupHelper(paramSize, name);
      this.push(helper.name + ".call(" + helper.callParams + ")");
    },

    // [invokeAmbiguous]
    //
    // On stack, before: hash, inverse, program, params..., ...
    // On stack, after: result of disambiguation
    //
    // This operation is used when an expression like `{{foo}}`
    // is provided, but we don't know at compile-time whether it
    // is a helper or a path.
    //
    // This operation emits more code than the other options,
    // and can be avoided by passing the `knownHelpers` and
    // `knownHelpersOnly` flags at compile-time.
    invokeAmbiguous: function(name, helperCall) {
      this.context.aliases.functionType = '"function"';
      this.useRegister('helper');

      this.emptyHash();
      var helper = this.setupHelper(0, name, helperCall);

      var helperName = this.lastHelper = this.nameLookup('helpers', name, 'helper');

      var nonHelper = this.nameLookup('depth' + this.lastContext, name, 'context');
      var nextStack = this.nextStack();

      if (helper.paramsInit) {
        this.pushSource(helper.paramsInit);
      }
      this.pushSource('if (helper = ' + helperName + ') { ' + nextStack + ' = helper.call(' + helper.callParams + '); }');
      this.pushSource('else { helper = ' + nonHelper + '; ' + nextStack + ' = typeof helper === functionType ? helper.call(' + helper.callParams + ') : helper; }');
    },

    // [invokePartial]
    //
    // On stack, before: context, ...
    // On stack after: result of partial invocation
    //
    // This operation pops off a context, invokes a partial with that context,
    // and pushes the result of the invocation back.
    invokePartial: function(name) {
      var params = [this.nameLookup('partials', name, 'partial'), "'" + name + "'", this.popStack(), "helpers", "partials"];

      if (this.options.data) {
        params.push("data");
      }

      this.context.aliases.self = "this";
      this.push("self.invokePartial(" + params.join(", ") + ")");
    },

    // [assignToHash]
    //
    // On stack, before: value, hash, ...
    // On stack, after: hash, ...
    //
    // Pops a value and hash off the stack, assigns `hash[key] = value`
    // and pushes the hash back onto the stack.
    assignToHash: function(key) {
      var value = this.popStack(),
          context,
          type;

      if (this.options.stringParams) {
        type = this.popStack();
        context = this.popStack();
      }

      var hash = this.hash;
      if (context) {
        hash.contexts.push("'" + key + "': " + context);
      }
      if (type) {
        hash.types.push("'" + key + "': " + type);
      }
      hash.values.push("'" + key + "': (" + value + ")");
    },

    // HELPERS

    compiler: JavaScriptCompiler,

    compileChildren: function(environment, options) {
      var children = environment.children, child, compiler;

      for(var i=0, l=children.length; i<l; i++) {
        child = children[i];
        compiler = new this.compiler();

        var index = this.matchExistingProgram(child);

        if (index == null) {
          this.context.programs.push('');     // Placeholder to prevent name conflicts for nested children
          index = this.context.programs.length;
          child.index = index;
          child.name = 'program' + index;
          this.context.programs[index] = compiler.compile(child, options, this.context);
          this.context.environments[index] = child;
        } else {
          child.index = index;
          child.name = 'program' + index;
        }
      }
    },
    matchExistingProgram: function(child) {
      for (var i = 0, len = this.context.environments.length; i < len; i++) {
        var environment = this.context.environments[i];
        if (environment && environment.equals(child)) {
          return i;
        }
      }
    },

    programExpression: function(guid) {
      this.context.aliases.self = "this";

      if(guid == null) {
        return "self.noop";
      }

      var child = this.environment.children[guid],
          depths = child.depths.list, depth;

      var programParams = [child.index, child.name, "data"];

      for(var i=0, l = depths.length; i<l; i++) {
        depth = depths[i];

        if(depth === 1) { programParams.push("depth0"); }
        else { programParams.push("depth" + (depth - 1)); }
      }

      return (depths.length === 0 ? "self.program(" : "self.programWithDepth(") + programParams.join(", ") + ")";
    },

    register: function(name, val) {
      this.useRegister(name);
      this.pushSource(name + " = " + val + ";");
    },

    useRegister: function(name) {
      if(!this.registers[name]) {
        this.registers[name] = true;
        this.registers.list.push(name);
      }
    },

    pushStackLiteral: function(item) {
      return this.push(new Literal(item));
    },

    pushSource: function(source) {
      if (this.pendingContent) {
        this.source.push(this.appendToBuffer(this.quotedString(this.pendingContent)));
        this.pendingContent = undefined;
      }

      if (source) {
        this.source.push(source);
      }
    },

    pushStack: function(item) {
      this.flushInline();

      var stack = this.incrStack();
      if (item) {
        this.pushSource(stack + " = " + item + ";");
      }
      this.compileStack.push(stack);
      return stack;
    },

    replaceStack: function(callback) {
      var prefix = '',
          inline = this.isInline(),
          stack,
          createdStack,
          usedLiteral;

      // If we are currently inline then we want to merge the inline statement into the
      // replacement statement via ','
      if (inline) {
        var top = this.popStack(true);

        if (top instanceof Literal) {
          // Literals do not need to be inlined
          stack = top.value;
          usedLiteral = true;
        } else {
          // Get or create the current stack name for use by the inline
          createdStack = !this.stackSlot;
          var name = !createdStack ? this.topStackName() : this.incrStack();

          prefix = '(' + this.push(name) + ' = ' + top + '),';
          stack = this.topStack();
        }
      } else {
        stack = this.topStack();
      }

      var item = callback.call(this, stack);

      if (inline) {
        if (!usedLiteral) {
          this.popStack();
        }
        if (createdStack) {
          this.stackSlot--;
        }
        this.push('(' + prefix + item + ')');
      } else {
        // Prevent modification of the context depth variable. Through replaceStack
        if (!/^stack/.test(stack)) {
          stack = this.nextStack();
        }

        this.pushSource(stack + " = (" + prefix + item + ");");
      }
      return stack;
    },

    nextStack: function() {
      return this.pushStack();
    },

    incrStack: function() {
      this.stackSlot++;
      if(this.stackSlot > this.stackVars.length) { this.stackVars.push("stack" + this.stackSlot); }
      return this.topStackName();
    },
    topStackName: function() {
      return "stack" + this.stackSlot;
    },
    flushInline: function() {
      var inlineStack = this.inlineStack;
      if (inlineStack.length) {
        this.inlineStack = [];
        for (var i = 0, len = inlineStack.length; i < len; i++) {
          var entry = inlineStack[i];
          if (entry instanceof Literal) {
            this.compileStack.push(entry);
          } else {
            this.pushStack(entry);
          }
        }
      }
    },
    isInline: function() {
      return this.inlineStack.length;
    },

    popStack: function(wrapped) {
      var inline = this.isInline(),
          item = (inline ? this.inlineStack : this.compileStack).pop();

      if (!wrapped && (item instanceof Literal)) {
        return item.value;
      } else {
        if (!inline) {
          if (!this.stackSlot) {
            throw new Exception('Invalid stack pop');
          }
          this.stackSlot--;
        }
        return item;
      }
    },

    topStack: function(wrapped) {
      var stack = (this.isInline() ? this.inlineStack : this.compileStack),
          item = stack[stack.length - 1];

      if (!wrapped && (item instanceof Literal)) {
        return item.value;
      } else {
        return item;
      }
    },

    quotedString: function(str) {
      return '"' + str
        .replace(/\\/g, '\\\\')
        .replace(/"/g, '\\"')
        .replace(/\n/g, '\\n')
        .replace(/\r/g, '\\r')
        .replace(/\u2028/g, '\\u2028')   // Per Ecma-262 7.3 + 7.8.4
        .replace(/\u2029/g, '\\u2029') + '"';
    },

    setupHelper: function(paramSize, name, missingParams) {
      var params = [],
          paramsInit = this.setupParams(paramSize, params, missingParams);
      var foundHelper = this.nameLookup('helpers', name, 'helper');

      return {
        params: params,
        paramsInit: paramsInit,
        name: foundHelper,
        callParams: ["depth0"].concat(params).join(", "),
        helperMissingParams: missingParams && ["depth0", this.quotedString(name)].concat(params).join(", ")
      };
    },

    setupOptions: function(paramSize, params) {
      var options = [], contexts = [], types = [], param, inverse, program;

      options.push("hash:" + this.popStack());

      if (this.options.stringParams) {
        options.push("hashTypes:" + this.popStack());
        options.push("hashContexts:" + this.popStack());
      }

      inverse = this.popStack();
      program = this.popStack();

      // Avoid setting fn and inverse if neither are set. This allows
      // helpers to do a check for `if (options.fn)`
      if (program || inverse) {
        if (!program) {
          this.context.aliases.self = "this";
          program = "self.noop";
        }

        if (!inverse) {
          this.context.aliases.self = "this";
          inverse = "self.noop";
        }

        options.push("inverse:" + inverse);
        options.push("fn:" + program);
      }

      for(var i=0; i<paramSize; i++) {
        param = this.popStack();
        params.push(param);

        if(this.options.stringParams) {
          types.push(this.popStack());
          contexts.push(this.popStack());
        }
      }

      if (this.options.stringParams) {
        options.push("contexts:[" + contexts.join(",") + "]");
        options.push("types:[" + types.join(",") + "]");
      }

      if(this.options.data) {
        options.push("data:data");
      }

      return options;
    },

    // the params and contexts arguments are passed in arrays
    // to fill in
    setupParams: function(paramSize, params, useRegister) {
      var options = '{' + this.setupOptions(paramSize, params).join(',') + '}';

      if (useRegister) {
        this.useRegister('options');
        params.push('options');
        return 'options=' + options;
      } else {
        params.push(options);
        return '';
      }
    }
  };

  var reservedWords = (
    "break else new var" +
    " case finally return void" +
    " catch for switch while" +
    " continue function this with" +
    " default if throw" +
    " delete in try" +
    " do instanceof typeof" +
    " abstract enum int short" +
    " boolean export interface static" +
    " byte extends long super" +
    " char final native synchronized" +
    " class float package throws" +
    " const goto private transient" +
    " debugger implements protected volatile" +
    " double import public let yield"
  ).split(" ");

  var compilerWords = JavaScriptCompiler.RESERVED_WORDS = {};

  for(var i=0, l=reservedWords.length; i<l; i++) {
    compilerWords[reservedWords[i]] = true;
  }

  JavaScriptCompiler.isValidJavaScriptVariableName = function(name) {
    if(!JavaScriptCompiler.RESERVED_WORDS[name] && /^[a-zA-Z_$][0-9a-zA-Z_$]*$/.test(name)) {
      return true;
    }
    return false;
  };

  __exports__ = JavaScriptCompiler;
  return __exports__;
})(__module2__, __module5__);

// handlebars.js
var __module0__ = (function(__dependency1__, __dependency2__, __dependency3__, __dependency4__, __dependency5__) {
  "use strict";
  var __exports__;
  /*globals Handlebars: true */
  var Handlebars = __dependency1__;

  // Compiler imports
  var AST = __dependency2__;
  var Parser = __dependency3__.parser;
  var parse = __dependency3__.parse;
  var Compiler = __dependency4__.Compiler;
  var compile = __dependency4__.compile;
  var precompile = __dependency4__.precompile;
  var JavaScriptCompiler = __dependency5__;

  var _create = Handlebars.create;
  var create = function() {
    var hb = _create();

    hb.compile = function(input, options) {
      return compile(input, options, hb);
    };
    hb.precompile = function (input, options) {
      return precompile(input, options, hb);
    };

    hb.AST = AST;
    hb.Compiler = Compiler;
    hb.JavaScriptCompiler = JavaScriptCompiler;
    hb.Parser = Parser;
    hb.parse = parse;

    return hb;
  };

  Handlebars = create();
  Handlebars.create = create;

  __exports__ = Handlebars;
  return __exports__;
})(__module1__, __module7__, __module8__, __module10__, __module11__);

  return __module0__;
})();

/*! matchMedia() polyfill - Test a CSS media type/query in JS. Authors & copyright (c) 2012: Scott Jehl, Paul Irish, Nicholas Zakas. Dual MIT/BSD license */
window.matchMedia=window.matchMedia||(function(e,f){var c,a=e.documentElement,b=a.firstElementChild||a.firstChild,d=e.createElement("body"),g=e.createElement("div");g.id="mq-test-1";g.style.cssText="position:absolute;top:-100em";d.appendChild(g);return function(h){g.innerHTML='&shy;<style media="'+h+'"> #mq-test-1 { width: 42px; }</style>';a.insertBefore(d,b);c=g.offsetWidth==42;a.removeChild(d);return{matches:c,media:h}}})(document);
/*! jQuery UI - v1.11.2 - 2014-11-16
* http://jqueryui.com
* Includes: core.js, datepicker.js
* Copyright 2014 jQuery Foundation and other contributors; Licensed MIT */
+function (jQuery) {
/*! jQuery UI - v1.11.2 - 2014-11-16
* http://jqueryui.com
* Includes: core.js, datepicker.js
* Copyright 2014 jQuery Foundation and other contributors; Licensed MIT */
(function( factory ) {
	if ( typeof define === "function" && define.amd ) {

		// AMD. Register as an anonymous module.
		define([ "jquery" ], factory );
	} else {

		// Browser globals
		factory( jQuery );
	}
}(function( $ ) {
/*!
 * jQuery UI Core 1.11.2
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/category/ui-core/
 */


// $.ui might exist from components with no dependencies, e.g., $.ui.position
$.ui = $.ui || {};

$.extend( $.ui, {
	version: "1.11.2",

	keyCode: {
		BACKSPACE: 8,
		COMMA: 188,
		DELETE: 46,
		DOWN: 40,
		END: 35,
		ENTER: 13,
		ESCAPE: 27,
		HOME: 36,
		LEFT: 37,
		PAGE_DOWN: 34,
		PAGE_UP: 33,
		PERIOD: 190,
		RIGHT: 39,
		SPACE: 32,
		TAB: 9,
		UP: 38
	}
});

// plugins
$.fn.extend({
	scrollParent: function( includeHidden ) {
		var position = this.css( "position" ),
			excludeStaticParent = position === "absolute",
			overflowRegex = includeHidden ? /(auto|scroll|hidden)/ : /(auto|scroll)/,
			scrollParent = this.parents().filter( function() {
				var parent = $( this );
				if ( excludeStaticParent && parent.css( "position" ) === "static" ) {
					return false;
				}
				return overflowRegex.test( parent.css( "overflow" ) + parent.css( "overflow-y" ) + parent.css( "overflow-x" ) );
			}).eq( 0 );

		return position === "fixed" || !scrollParent.length ? $( this[ 0 ].ownerDocument || document ) : scrollParent;
	},

	uniqueId: (function() {
		var uuid = 0;

		return function() {
			return this.each(function() {
				if ( !this.id ) {
					this.id = "ui-id-" + ( ++uuid );
				}
			});
		};
	})(),

	removeUniqueId: function() {
		return this.each(function() {
			if ( /^ui-id-\d+$/.test( this.id ) ) {
				$( this ).removeAttr( "id" );
			}
		});
	}
});

// selectors
function focusable( element, isTabIndexNotNaN ) {
	var map, mapName, img,
		nodeName = element.nodeName.toLowerCase();
	if ( "area" === nodeName ) {
		map = element.parentNode;
		mapName = map.name;
		if ( !element.href || !mapName || map.nodeName.toLowerCase() !== "map" ) {
			return false;
		}
		img = $( "img[usemap='#" + mapName + "']" )[ 0 ];
		return !!img && visible( img );
	}
	return ( /input|select|textarea|button|object/.test( nodeName ) ?
		!element.disabled :
		"a" === nodeName ?
			element.href || isTabIndexNotNaN :
			isTabIndexNotNaN) &&
		// the element and all of its ancestors must be visible
		visible( element );
}

function visible( element ) {
	return $.expr.filters.visible( element ) &&
		!$( element ).parents().addBack().filter(function() {
			return $.css( this, "visibility" ) === "hidden";
		}).length;
}

$.extend( $.expr[ ":" ], {
	data: $.expr.createPseudo ?
		$.expr.createPseudo(function( dataName ) {
			return function( elem ) {
				return !!$.data( elem, dataName );
			};
		}) :
		// support: jQuery <1.8
		function( elem, i, match ) {
			return !!$.data( elem, match[ 3 ] );
		},

	focusable: function( element ) {
		return focusable( element, !isNaN( $.attr( element, "tabindex" ) ) );
	},

	tabbable: function( element ) {
		var tabIndex = $.attr( element, "tabindex" ),
			isTabIndexNaN = isNaN( tabIndex );
		return ( isTabIndexNaN || tabIndex >= 0 ) && focusable( element, !isTabIndexNaN );
	}
});

// support: jQuery <1.8
if ( !$( "<a>" ).outerWidth( 1 ).jquery ) {
	$.each( [ "Width", "Height" ], function( i, name ) {
		var side = name === "Width" ? [ "Left", "Right" ] : [ "Top", "Bottom" ],
			type = name.toLowerCase(),
			orig = {
				innerWidth: $.fn.innerWidth,
				innerHeight: $.fn.innerHeight,
				outerWidth: $.fn.outerWidth,
				outerHeight: $.fn.outerHeight
			};

		function reduce( elem, size, border, margin ) {
			$.each( side, function() {
				size -= parseFloat( $.css( elem, "padding" + this ) ) || 0;
				if ( border ) {
					size -= parseFloat( $.css( elem, "border" + this + "Width" ) ) || 0;
				}
				if ( margin ) {
					size -= parseFloat( $.css( elem, "margin" + this ) ) || 0;
				}
			});
			return size;
		}

		$.fn[ "inner" + name ] = function( size ) {
			if ( size === undefined ) {
				return orig[ "inner" + name ].call( this );
			}

			return this.each(function() {
				$( this ).css( type, reduce( this, size ) + "px" );
			});
		};

		$.fn[ "outer" + name] = function( size, margin ) {
			if ( typeof size !== "number" ) {
				return orig[ "outer" + name ].call( this, size );
			}

			return this.each(function() {
				$( this).css( type, reduce( this, size, true, margin ) + "px" );
			});
		};
	});
}

// support: jQuery <1.8
if ( !$.fn.addBack ) {
	$.fn.addBack = function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter( selector )
		);
	};
}

// support: jQuery 1.6.1, 1.6.2 (http://bugs.jquery.com/ticket/9413)
if ( $( "<a>" ).data( "a-b", "a" ).removeData( "a-b" ).data( "a-b" ) ) {
	$.fn.removeData = (function( removeData ) {
		return function( key ) {
			if ( arguments.length ) {
				return removeData.call( this, $.camelCase( key ) );
			} else {
				return removeData.call( this );
			}
		};
	})( $.fn.removeData );
}

// deprecated
$.ui.ie = !!/msie [\w.]+/.exec( navigator.userAgent.toLowerCase() );

$.fn.extend({
	focus: (function( orig ) {
		return function( delay, fn ) {
			return typeof delay === "number" ?
				this.each(function() {
					var elem = this;
					setTimeout(function() {
						$( elem ).focus();
						if ( fn ) {
							fn.call( elem );
						}
					}, delay );
				}) :
				orig.apply( this, arguments );
		};
	})( $.fn.focus ),

	disableSelection: (function() {
		var eventType = "onselectstart" in document.createElement( "div" ) ?
			"selectstart" :
			"mousedown";

		return function() {
			return this.bind( eventType + ".ui-disableSelection", function( event ) {
				event.preventDefault();
			});
		};
	})(),

	enableSelection: function() {
		return this.unbind( ".ui-disableSelection" );
	},

	zIndex: function( zIndex ) {
		if ( zIndex !== undefined ) {
			return this.css( "zIndex", zIndex );
		}

		if ( this.length ) {
			var elem = $( this[ 0 ] ), position, value;
			while ( elem.length && elem[ 0 ] !== document ) {
				// Ignore z-index if position is set to a value where z-index is ignored by the browser
				// This makes behavior of this function consistent across browsers
				// WebKit always returns auto if the element is positioned
				position = elem.css( "position" );
				if ( position === "absolute" || position === "relative" || position === "fixed" ) {
					// IE returns 0 when zIndex is not specified
					// other browsers return a string
					// we ignore the case of nested elements with an explicit value of 0
					// <div style="z-index: -10;"><div style="z-index: 0;"></div></div>
					value = parseInt( elem.css( "zIndex" ), 10 );
					if ( !isNaN( value ) && value !== 0 ) {
						return value;
					}
				}
				elem = elem.parent();
			}
		}

		return 0;
	}
});

// $.ui.plugin is deprecated. Use $.widget() extensions instead.
$.ui.plugin = {
	add: function( module, option, set ) {
		var i,
			proto = $.ui[ module ].prototype;
		for ( i in set ) {
			proto.plugins[ i ] = proto.plugins[ i ] || [];
			proto.plugins[ i ].push( [ option, set[ i ] ] );
		}
	},
	call: function( instance, name, args, allowDisconnected ) {
		var i,
			set = instance.plugins[ name ];

		if ( !set ) {
			return;
		}

		if ( !allowDisconnected && ( !instance.element[ 0 ].parentNode || instance.element[ 0 ].parentNode.nodeType === 11 ) ) {
			return;
		}

		for ( i = 0; i < set.length; i++ ) {
			if ( instance.options[ set[ i ][ 0 ] ] ) {
				set[ i ][ 1 ].apply( instance.element, args );
			}
		}
	}
};


/*!
 * jQuery UI Datepicker 1.11.2
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/datepicker/
 */


$.extend($.ui, { datepicker: { version: "1.11.2" } });

var datepicker_instActive;

function datepicker_getZindex( elem ) {
	var position, value;
	while ( elem.length && elem[ 0 ] !== document ) {
		// Ignore z-index if position is set to a value where z-index is ignored by the browser
		// This makes behavior of this function consistent across browsers
		// WebKit always returns auto if the element is positioned
		position = elem.css( "position" );
		if ( position === "absolute" || position === "relative" || position === "fixed" ) {
			// IE returns 0 when zIndex is not specified
			// other browsers return a string
			// we ignore the case of nested elements with an explicit value of 0
			// <div style="z-index: -10;"><div style="z-index: 0;"></div></div>
			value = parseInt( elem.css( "zIndex" ), 10 );
			if ( !isNaN( value ) && value !== 0 ) {
				return value;
			}
		}
		elem = elem.parent();
	}

	return 0;
}
/* Date picker manager.
   Use the singleton instance of this class, $.datepicker, to interact with the date picker.
   Settings for (groups of) date pickers are maintained in an instance object,
   allowing multiple different settings on the same page. */

function Datepicker() {
	this._curInst = null; // The current instance in use
	this._keyEvent = false; // If the last event was a key event
	this._disabledInputs = []; // List of date picker inputs that have been disabled
	this._datepickerShowing = false; // True if the popup picker is showing , false if not
	this._inDialog = false; // True if showing within a "dialog", false if not
	this._mainDivId = "ui-datepicker-div"; // The ID of the main datepicker division
	this._inlineClass = "ui-datepicker-inline"; // The name of the inline marker class
	this._appendClass = "ui-datepicker-append"; // The name of the append marker class
	this._triggerClass = "ui-datepicker-trigger"; // The name of the trigger marker class
	this._dialogClass = "ui-datepicker-dialog"; // The name of the dialog marker class
	this._disableClass = "ui-datepicker-disabled"; // The name of the disabled covering marker class
	this._unselectableClass = "ui-datepicker-unselectable"; // The name of the unselectable cell marker class
	this._currentClass = "ui-datepicker-current-day"; // The name of the current day marker class
	this._dayOverClass = "ui-datepicker-days-cell-over"; // The name of the day hover marker class
	this.regional = []; // Available regional settings, indexed by language code
	this.regional[""] = { // Default regional settings
		closeText: "Done", // Display text for close link
		prevText: "Prev", // Display text for previous month link
		nextText: "Next", // Display text for next month link
		currentText: "Today", // Display text for current month link
		monthNames: ["January","February","March","April","May","June",
			"July","August","September","October","November","December"], // Names of months for drop-down and formatting
		monthNamesShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"], // For formatting
		dayNames: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"], // For formatting
		dayNamesShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"], // For formatting
		dayNamesMin: ["Su","Mo","Tu","We","Th","Fr","Sa"], // Column headings for days starting at Sunday
		weekHeader: "Wk", // Column header for week of the year
		dateFormat: "mm/dd/yy", // See format options on parseDate
		firstDay: 0, // The first day of the week, Sun = 0, Mon = 1, ...
		isRTL: false, // True if right-to-left language, false if left-to-right
		showMonthAfterYear: false, // True if the year select precedes month, false for month then year
		yearSuffix: "" // Additional text to append to the year in the month headers
	};
	this._defaults = { // Global defaults for all the date picker instances
		showOn: "focus", // "focus" for popup on focus,
			// "button" for trigger button, or "both" for either
		showAnim: "fadeIn", // Name of jQuery animation for popup
		showOptions: {}, // Options for enhanced animations
		defaultDate: null, // Used when field is blank: actual date,
			// +/-number for offset from today, null for today
		appendText: "", // Display text following the input box, e.g. showing the format
		buttonText: "...", // Text for trigger button
		buttonImage: "", // URL for trigger button image
		buttonImageOnly: false, // True if the image appears alone, false if it appears on a button
		hideIfNoPrevNext: false, // True to hide next/previous month links
			// if not applicable, false to just disable them
		navigationAsDateFormat: false, // True if date formatting applied to prev/today/next links
		gotoCurrent: false, // True if today link goes back to current selection instead
		changeMonth: false, // True if month can be selected directly, false if only prev/next
		changeYear: false, // True if year can be selected directly, false if only prev/next
		yearRange: "c-10:c+10", // Range of years to display in drop-down,
			// either relative to today's year (-nn:+nn), relative to currently displayed year
			// (c-nn:c+nn), absolute (nnnn:nnnn), or a combination of the above (nnnn:-n)
		showOtherMonths: false, // True to show dates in other months, false to leave blank
		selectOtherMonths: false, // True to allow selection of dates in other months, false for unselectable
		showWeek: false, // True to show week of the year, false to not show it
		calculateWeek: this.iso8601Week, // How to calculate the week of the year,
			// takes a Date and returns the number of the week for it
		shortYearCutoff: "+10", // Short year values < this are in the current century,
			// > this are in the previous century,
			// string value starting with "+" for current year + value
		minDate: null, // The earliest selectable date, or null for no limit
		maxDate: null, // The latest selectable date, or null for no limit
		duration: "fast", // Duration of display/closure
		beforeShowDay: null, // Function that takes a date and returns an array with
			// [0] = true if selectable, false if not, [1] = custom CSS class name(s) or "",
			// [2] = cell title (optional), e.g. $.datepicker.noWeekends
		beforeShow: null, // Function that takes an input field and
			// returns a set of custom settings for the date picker
		onSelect: null, // Define a callback function when a date is selected
		onChangeMonthYear: null, // Define a callback function when the month or year is changed
		onClose: null, // Define a callback function when the datepicker is closed
		numberOfMonths: 1, // Number of months to show at a time
		showCurrentAtPos: 0, // The position in multipe months at which to show the current month (starting at 0)
		stepMonths: 1, // Number of months to step back/forward
		stepBigMonths: 12, // Number of months to step back/forward for the big links
		altField: "", // Selector for an alternate field to store selected dates into
		altFormat: "", // The date format to use for the alternate field
		constrainInput: true, // The input is constrained by the current date format
		showButtonPanel: false, // True to show button panel, false to not show it
		autoSize: false, // True to size the input for the date format, false to leave as is
		disabled: false // The initial disabled state
	};
	$.extend(this._defaults, this.regional[""]);
	this.regional.en = $.extend( true, {}, this.regional[ "" ]);
	this.regional[ "en-US" ] = $.extend( true, {}, this.regional.en );
	this.dpDiv = datepicker_bindHover($("<div id='" + this._mainDivId + "' class='ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all'></div>"));
}

$.extend(Datepicker.prototype, {
	/* Class name added to elements to indicate already configured with a date picker. */
	markerClassName: "hasDatepicker",

	//Keep track of the maximum number of rows displayed (see #7043)
	maxRows: 4,

	// TODO rename to "widget" when switching to widget factory
	_widgetDatepicker: function() {
		return this.dpDiv;
	},

	/* Override the default settings for all instances of the date picker.
	 * @param  settings  object - the new settings to use as defaults (anonymous object)
	 * @return the manager object
	 */
	setDefaults: function(settings) {
		datepicker_extendRemove(this._defaults, settings || {});
		return this;
	},

	/* Attach the date picker to a jQuery selection.
	 * @param  target	element - the target input field or division or span
	 * @param  settings  object - the new settings to use for this date picker instance (anonymous)
	 */
	_attachDatepicker: function(target, settings) {
		var nodeName, inline, inst;
		nodeName = target.nodeName.toLowerCase();
		inline = (nodeName === "div" || nodeName === "span");
		if (!target.id) {
			this.uuid += 1;
			target.id = "dp" + this.uuid;
		}
		inst = this._newInst($(target), inline);
		inst.settings = $.extend({}, settings || {});
		if (nodeName === "input") {
			this._connectDatepicker(target, inst);
		} else if (inline) {
			this._inlineDatepicker(target, inst);
		}
	},

	/* Create a new instance object. */
	_newInst: function(target, inline) {
		var id = target[0].id.replace(/([^A-Za-z0-9_\-])/g, "\\\\$1"); // escape jQuery meta chars
		return {id: id, input: target, // associated target
			selectedDay: 0, selectedMonth: 0, selectedYear: 0, // current selection
			drawMonth: 0, drawYear: 0, // month being drawn
			inline: inline, // is datepicker inline or not
			dpDiv: (!inline ? this.dpDiv : // presentation div
			datepicker_bindHover($("<div class='" + this._inlineClass + " ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all'></div>")))};
	},

	/* Attach the date picker to an input field. */
	_connectDatepicker: function(target, inst) {
		var input = $(target);
		inst.append = $([]);
		inst.trigger = $([]);
		if (input.hasClass(this.markerClassName)) {
			return;
		}
		this._attachments(input, inst);
		input.addClass(this.markerClassName).keydown(this._doKeyDown).
			keypress(this._doKeyPress).keyup(this._doKeyUp);
		this._autoSize(inst);
		$.data(target, "datepicker", inst);
		//If disabled option is true, disable the datepicker once it has been attached to the input (see ticket #5665)
		if( inst.settings.disabled ) {
			this._disableDatepicker( target );
		}
	},

	/* Make attachments based on settings. */
	_attachments: function(input, inst) {
		var showOn, buttonText, buttonImage,
			appendText = this._get(inst, "appendText"),
			isRTL = this._get(inst, "isRTL");

		if (inst.append) {
			inst.append.remove();
		}
		if (appendText) {
			inst.append = $("<span class='" + this._appendClass + "'>" + appendText + "</span>");
			input[isRTL ? "before" : "after"](inst.append);
		}

		input.unbind("focus", this._showDatepicker);

		if (inst.trigger) {
			inst.trigger.remove();
		}

		showOn = this._get(inst, "showOn");
		if (showOn === "focus" || showOn === "both") { // pop-up date picker when in the marked field
			input.focus(this._showDatepicker);
		}
		if (showOn === "button" || showOn === "both") { // pop-up date picker when button clicked
			buttonText = this._get(inst, "buttonText");
			buttonImage = this._get(inst, "buttonImage");
			inst.trigger = $(this._get(inst, "buttonImageOnly") ?
				$("<img/>").addClass(this._triggerClass).
					attr({ src: buttonImage, alt: buttonText, title: buttonText }) :
				$("<button type='button'></button>").addClass(this._triggerClass).
					html(!buttonImage ? buttonText : $("<img/>").attr(
					{ src:buttonImage, alt:buttonText, title:buttonText })));
			input[isRTL ? "before" : "after"](inst.trigger);
			inst.trigger.click(function() {
				if ($.datepicker._datepickerShowing && $.datepicker._lastInput === input[0]) {
					$.datepicker._hideDatepicker();
				} else if ($.datepicker._datepickerShowing && $.datepicker._lastInput !== input[0]) {
					$.datepicker._hideDatepicker();
					$.datepicker._showDatepicker(input[0]);
				} else {
					$.datepicker._showDatepicker(input[0]);
				}
				return false;
			});
		}
	},

	/* Apply the maximum length for the date format. */
	_autoSize: function(inst) {
		if (this._get(inst, "autoSize") && !inst.inline) {
			var findMax, max, maxI, i,
				date = new Date(2009, 12 - 1, 20), // Ensure double digits
				dateFormat = this._get(inst, "dateFormat");

			if (dateFormat.match(/[DM]/)) {
				findMax = function(names) {
					max = 0;
					maxI = 0;
					for (i = 0; i < names.length; i++) {
						if (names[i].length > max) {
							max = names[i].length;
							maxI = i;
						}
					}
					return maxI;
				};
				date.setMonth(findMax(this._get(inst, (dateFormat.match(/MM/) ?
					"monthNames" : "monthNamesShort"))));
				date.setDate(findMax(this._get(inst, (dateFormat.match(/DD/) ?
					"dayNames" : "dayNamesShort"))) + 20 - date.getDay());
			}
			inst.input.attr("size", this._formatDate(inst, date).length);
		}
	},

	/* Attach an inline date picker to a div. */
	_inlineDatepicker: function(target, inst) {
		var divSpan = $(target);
		if (divSpan.hasClass(this.markerClassName)) {
			return;
		}
		divSpan.addClass(this.markerClassName).append(inst.dpDiv);
		$.data(target, "datepicker", inst);
		this._setDate(inst, this._getDefaultDate(inst), true);
		this._updateDatepicker(inst);
		this._updateAlternate(inst);
		//If disabled option is true, disable the datepicker before showing it (see ticket #5665)
		if( inst.settings.disabled ) {
			this._disableDatepicker( target );
		}
		// Set display:block in place of inst.dpDiv.show() which won't work on disconnected elements
		// http://bugs.jqueryui.com/ticket/7552 - A Datepicker created on a detached div has zero height
		inst.dpDiv.css( "display", "block" );
	},

	/* Pop-up the date picker in a "dialog" box.
	 * @param  input element - ignored
	 * @param  date	string or Date - the initial date to display
	 * @param  onSelect  function - the function to call when a date is selected
	 * @param  settings  object - update the dialog date picker instance's settings (anonymous object)
	 * @param  pos int[2] - coordinates for the dialog's position within the screen or
	 *					event - with x/y coordinates or
	 *					leave empty for default (screen centre)
	 * @return the manager object
	 */
	_dialogDatepicker: function(input, date, onSelect, settings, pos) {
		var id, browserWidth, browserHeight, scrollX, scrollY,
			inst = this._dialogInst; // internal instance

		if (!inst) {
			this.uuid += 1;
			id = "dp" + this.uuid;
			this._dialogInput = $("<input type='text' id='" + id +
				"' style='position: absolute; top: -100px; width: 0px;'/>");
			this._dialogInput.keydown(this._doKeyDown);
			$("body").append(this._dialogInput);
			inst = this._dialogInst = this._newInst(this._dialogInput, false);
			inst.settings = {};
			$.data(this._dialogInput[0], "datepicker", inst);
		}
		datepicker_extendRemove(inst.settings, settings || {});
		date = (date && date.constructor === Date ? this._formatDate(inst, date) : date);
		this._dialogInput.val(date);

		this._pos = (pos ? (pos.length ? pos : [pos.pageX, pos.pageY]) : null);
		if (!this._pos) {
			browserWidth = document.documentElement.clientWidth;
			browserHeight = document.documentElement.clientHeight;
			scrollX = document.documentElement.scrollLeft || document.body.scrollLeft;
			scrollY = document.documentElement.scrollTop || document.body.scrollTop;
			this._pos = // should use actual width/height below
				[(browserWidth / 2) - 100 + scrollX, (browserHeight / 2) - 150 + scrollY];
		}

		// move input on screen for focus, but hidden behind dialog
		this._dialogInput.css("left", (this._pos[0] + 20) + "px").css("top", this._pos[1] + "px");
		inst.settings.onSelect = onSelect;
		this._inDialog = true;
		this.dpDiv.addClass(this._dialogClass);
		this._showDatepicker(this._dialogInput[0]);
		if ($.blockUI) {
			$.blockUI(this.dpDiv);
		}
		$.data(this._dialogInput[0], "datepicker", inst);
		return this;
	},

	/* Detach a datepicker from its control.
	 * @param  target	element - the target input field or division or span
	 */
	_destroyDatepicker: function(target) {
		var nodeName,
			$target = $(target),
			inst = $.data(target, "datepicker");

		if (!$target.hasClass(this.markerClassName)) {
			return;
		}

		nodeName = target.nodeName.toLowerCase();
		$.removeData(target, "datepicker");
		if (nodeName === "input") {
			inst.append.remove();
			inst.trigger.remove();
			$target.removeClass(this.markerClassName).
				unbind("focus", this._showDatepicker).
				unbind("keydown", this._doKeyDown).
				unbind("keypress", this._doKeyPress).
				unbind("keyup", this._doKeyUp);
		} else if (nodeName === "div" || nodeName === "span") {
			$target.removeClass(this.markerClassName).empty();
		}
	},

	/* Enable the date picker to a jQuery selection.
	 * @param  target	element - the target input field or division or span
	 */
	_enableDatepicker: function(target) {
		var nodeName, inline,
			$target = $(target),
			inst = $.data(target, "datepicker");

		if (!$target.hasClass(this.markerClassName)) {
			return;
		}

		nodeName = target.nodeName.toLowerCase();
		if (nodeName === "input") {
			target.disabled = false;
			inst.trigger.filter("button").
				each(function() { this.disabled = false; }).end().
				filter("img").css({opacity: "1.0", cursor: ""});
		} else if (nodeName === "div" || nodeName === "span") {
			inline = $target.children("." + this._inlineClass);
			inline.children().removeClass("ui-state-disabled");
			inline.find("select.ui-datepicker-month, select.ui-datepicker-year").
				prop("disabled", false);
		}
		this._disabledInputs = $.map(this._disabledInputs,
			function(value) { return (value === target ? null : value); }); // delete entry
	},

	/* Disable the date picker to a jQuery selection.
	 * @param  target	element - the target input field or division or span
	 */
	_disableDatepicker: function(target) {
		var nodeName, inline,
			$target = $(target),
			inst = $.data(target, "datepicker");

		if (!$target.hasClass(this.markerClassName)) {
			return;
		}

		nodeName = target.nodeName.toLowerCase();
		if (nodeName === "input") {
			target.disabled = true;
			inst.trigger.filter("button").
				each(function() { this.disabled = true; }).end().
				filter("img").css({opacity: "0.5", cursor: "default"});
		} else if (nodeName === "div" || nodeName === "span") {
			inline = $target.children("." + this._inlineClass);
			inline.children().addClass("ui-state-disabled");
			inline.find("select.ui-datepicker-month, select.ui-datepicker-year").
				prop("disabled", true);
		}
		this._disabledInputs = $.map(this._disabledInputs,
			function(value) { return (value === target ? null : value); }); // delete entry
		this._disabledInputs[this._disabledInputs.length] = target;
	},

	/* Is the first field in a jQuery collection disabled as a datepicker?
	 * @param  target	element - the target input field or division or span
	 * @return boolean - true if disabled, false if enabled
	 */
	_isDisabledDatepicker: function(target) {
		if (!target) {
			return false;
		}
		for (var i = 0; i < this._disabledInputs.length; i++) {
			if (this._disabledInputs[i] === target) {
				return true;
			}
		}
		return false;
	},

	/* Retrieve the instance data for the target control.
	 * @param  target  element - the target input field or division or span
	 * @return  object - the associated instance data
	 * @throws  error if a jQuery problem getting data
	 */
	_getInst: function(target) {
		try {
			return $.data(target, "datepicker");
		}
		catch (err) {
			throw "Missing instance data for this datepicker";
		}
	},

	/* Update or retrieve the settings for a date picker attached to an input field or division.
	 * @param  target  element - the target input field or division or span
	 * @param  name	object - the new settings to update or
	 *				string - the name of the setting to change or retrieve,
	 *				when retrieving also "all" for all instance settings or
	 *				"defaults" for all global defaults
	 * @param  value   any - the new value for the setting
	 *				(omit if above is an object or to retrieve a value)
	 */
	_optionDatepicker: function(target, name, value) {
		var settings, date, minDate, maxDate,
			inst = this._getInst(target);

		if (arguments.length === 2 && typeof name === "string") {
			return (name === "defaults" ? $.extend({}, $.datepicker._defaults) :
				(inst ? (name === "all" ? $.extend({}, inst.settings) :
				this._get(inst, name)) : null));
		}

		settings = name || {};
		if (typeof name === "string") {
			settings = {};
			settings[name] = value;
		}

		if (inst) {
			if (this._curInst === inst) {
				this._hideDatepicker();
			}

			date = this._getDateDatepicker(target, true);
			minDate = this._getMinMaxDate(inst, "min");
			maxDate = this._getMinMaxDate(inst, "max");
			datepicker_extendRemove(inst.settings, settings);
			// reformat the old minDate/maxDate values if dateFormat changes and a new minDate/maxDate isn't provided
			if (minDate !== null && settings.dateFormat !== undefined && settings.minDate === undefined) {
				inst.settings.minDate = this._formatDate(inst, minDate);
			}
			if (maxDate !== null && settings.dateFormat !== undefined && settings.maxDate === undefined) {
				inst.settings.maxDate = this._formatDate(inst, maxDate);
			}
			if ( "disabled" in settings ) {
				if ( settings.disabled ) {
					this._disableDatepicker(target);
				} else {
					this._enableDatepicker(target);
				}
			}
			this._attachments($(target), inst);
			this._autoSize(inst);
			this._setDate(inst, date);
			this._updateAlternate(inst);
			this._updateDatepicker(inst);
		}
	},

	// change method deprecated
	_changeDatepicker: function(target, name, value) {
		this._optionDatepicker(target, name, value);
	},

	/* Redraw the date picker attached to an input field or division.
	 * @param  target  element - the target input field or division or span
	 */
	_refreshDatepicker: function(target) {
		var inst = this._getInst(target);
		if (inst) {
			this._updateDatepicker(inst);
		}
	},

	/* Set the dates for a jQuery selection.
	 * @param  target element - the target input field or division or span
	 * @param  date	Date - the new date
	 */
	_setDateDatepicker: function(target, date) {
		var inst = this._getInst(target);
		if (inst) {
			this._setDate(inst, date);
			this._updateDatepicker(inst);
			this._updateAlternate(inst);
		}
	},

	/* Get the date(s) for the first entry in a jQuery selection.
	 * @param  target element - the target input field or division or span
	 * @param  noDefault boolean - true if no default date is to be used
	 * @return Date - the current date
	 */
	_getDateDatepicker: function(target, noDefault) {
		var inst = this._getInst(target);
		if (inst && !inst.inline) {
			this._setDateFromField(inst, noDefault);
		}
		return (inst ? this._getDate(inst) : null);
	},

	/* Handle keystrokes. */
	_doKeyDown: function(event) {
		var onSelect, dateStr, sel,
			inst = $.datepicker._getInst(event.target),
			handled = true,
			isRTL = inst.dpDiv.is(".ui-datepicker-rtl");

		inst._keyEvent = true;
		if ($.datepicker._datepickerShowing) {
			switch (event.keyCode) {
				case 9: $.datepicker._hideDatepicker();
						handled = false;
						break; // hide on tab out
				case 13: sel = $("td." + $.datepicker._dayOverClass + ":not(." +
									$.datepicker._currentClass + ")", inst.dpDiv);
						if (sel[0]) {
							$.datepicker._selectDay(event.target, inst.selectedMonth, inst.selectedYear, sel[0]);
						}

						onSelect = $.datepicker._get(inst, "onSelect");
						if (onSelect) {
							dateStr = $.datepicker._formatDate(inst);

							// trigger custom callback
							onSelect.apply((inst.input ? inst.input[0] : null), [dateStr, inst]);
						} else {
							$.datepicker._hideDatepicker();
						}

						return false; // don't submit the form
				case 27: $.datepicker._hideDatepicker();
						break; // hide on escape
				case 33: $.datepicker._adjustDate(event.target, (event.ctrlKey ?
							-$.datepicker._get(inst, "stepBigMonths") :
							-$.datepicker._get(inst, "stepMonths")), "M");
						break; // previous month/year on page up/+ ctrl
				case 34: $.datepicker._adjustDate(event.target, (event.ctrlKey ?
							+$.datepicker._get(inst, "stepBigMonths") :
							+$.datepicker._get(inst, "stepMonths")), "M");
						break; // next month/year on page down/+ ctrl
				case 35: if (event.ctrlKey || event.metaKey) {
							$.datepicker._clearDate(event.target);
						}
						handled = event.ctrlKey || event.metaKey;
						break; // clear on ctrl or command +end
				case 36: if (event.ctrlKey || event.metaKey) {
							$.datepicker._gotoToday(event.target);
						}
						handled = event.ctrlKey || event.metaKey;
						break; // current on ctrl or command +home
				case 37: if (event.ctrlKey || event.metaKey) {
							$.datepicker._adjustDate(event.target, (isRTL ? +1 : -1), "D");
						}
						handled = event.ctrlKey || event.metaKey;
						// -1 day on ctrl or command +left
						if (event.originalEvent.altKey) {
							$.datepicker._adjustDate(event.target, (event.ctrlKey ?
								-$.datepicker._get(inst, "stepBigMonths") :
								-$.datepicker._get(inst, "stepMonths")), "M");
						}
						// next month/year on alt +left on Mac
						break;
				case 38: if (event.ctrlKey || event.metaKey) {
							$.datepicker._adjustDate(event.target, -7, "D");
						}
						handled = event.ctrlKey || event.metaKey;
						break; // -1 week on ctrl or command +up
				case 39: if (event.ctrlKey || event.metaKey) {
							$.datepicker._adjustDate(event.target, (isRTL ? -1 : +1), "D");
						}
						handled = event.ctrlKey || event.metaKey;
						// +1 day on ctrl or command +right
						if (event.originalEvent.altKey) {
							$.datepicker._adjustDate(event.target, (event.ctrlKey ?
								+$.datepicker._get(inst, "stepBigMonths") :
								+$.datepicker._get(inst, "stepMonths")), "M");
						}
						// next month/year on alt +right
						break;
				case 40: if (event.ctrlKey || event.metaKey) {
							$.datepicker._adjustDate(event.target, +7, "D");
						}
						handled = event.ctrlKey || event.metaKey;
						break; // +1 week on ctrl or command +down
				default: handled = false;
			}
		} else if (event.keyCode === 36 && event.ctrlKey) { // display the date picker on ctrl+home
			$.datepicker._showDatepicker(this);
		} else {
			handled = false;
		}

		if (handled) {
			event.preventDefault();
			event.stopPropagation();
		}
	},

	/* Filter entered characters - based on date format. */
	_doKeyPress: function(event) {
		var chars, chr,
			inst = $.datepicker._getInst(event.target);

		if ($.datepicker._get(inst, "constrainInput")) {
			chars = $.datepicker._possibleChars($.datepicker._get(inst, "dateFormat"));
			chr = String.fromCharCode(event.charCode == null ? event.keyCode : event.charCode);
			return event.ctrlKey || event.metaKey || (chr < " " || !chars || chars.indexOf(chr) > -1);
		}
	},

	/* Synchronise manual entry and field/alternate field. */
	_doKeyUp: function(event) {
		var date,
			inst = $.datepicker._getInst(event.target);

		if (inst.input.val() !== inst.lastVal) {
			try {
				date = $.datepicker.parseDate($.datepicker._get(inst, "dateFormat"),
					(inst.input ? inst.input.val() : null),
					$.datepicker._getFormatConfig(inst));

				if (date) { // only if valid
					$.datepicker._setDateFromField(inst);
					$.datepicker._updateAlternate(inst);
					$.datepicker._updateDatepicker(inst);
				}
			}
			catch (err) {
			}
		}
		return true;
	},

	/* Pop-up the date picker for a given input field.
	 * If false returned from beforeShow event handler do not show.
	 * @param  input  element - the input field attached to the date picker or
	 *					event - if triggered by focus
	 */
	_showDatepicker: function(input) {
		input = input.target || input;
		if (input.nodeName.toLowerCase() !== "input") { // find from button/image trigger
			input = $("input", input.parentNode)[0];
		}

		if ($.datepicker._isDisabledDatepicker(input) || $.datepicker._lastInput === input) { // already here
			return;
		}

		var inst, beforeShow, beforeShowSettings, isFixed,
			offset, showAnim, duration;

		inst = $.datepicker._getInst(input);
		if ($.datepicker._curInst && $.datepicker._curInst !== inst) {
			$.datepicker._curInst.dpDiv.stop(true, true);
			if ( inst && $.datepicker._datepickerShowing ) {
				$.datepicker._hideDatepicker( $.datepicker._curInst.input[0] );
			}
		}

		beforeShow = $.datepicker._get(inst, "beforeShow");
		beforeShowSettings = beforeShow ? beforeShow.apply(input, [input, inst]) : {};
		if(beforeShowSettings === false){
			return;
		}
		datepicker_extendRemove(inst.settings, beforeShowSettings);

		inst.lastVal = null;
		$.datepicker._lastInput = input;
		$.datepicker._setDateFromField(inst);

		if ($.datepicker._inDialog) { // hide cursor
			input.value = "";
		}
		if (!$.datepicker._pos) { // position below input
			$.datepicker._pos = $.datepicker._findPos(input);
			$.datepicker._pos[1] += input.offsetHeight; // add the height
		}

		isFixed = false;
		$(input).parents().each(function() {
			isFixed |= $(this).css("position") === "fixed";
			return !isFixed;
		});

		offset = {left: $.datepicker._pos[0], top: $.datepicker._pos[1]};
		$.datepicker._pos = null;
		//to avoid flashes on Firefox
		inst.dpDiv.empty();
		// determine sizing offscreen
		inst.dpDiv.css({position: "absolute", display: "block", top: "-1000px"});
		$.datepicker._updateDatepicker(inst);
		// fix width for dynamic number of date pickers
		// and adjust position before showing
		offset = $.datepicker._checkOffset(inst, offset, isFixed);
		inst.dpDiv.css({position: ($.datepicker._inDialog && $.blockUI ?
			"static" : (isFixed ? "fixed" : "absolute")), display: "none",
			left: offset.left + "px", top: offset.top + "px"});

		if (!inst.inline) {
			showAnim = $.datepicker._get(inst, "showAnim");
			duration = $.datepicker._get(inst, "duration");
			inst.dpDiv.css( "z-index", datepicker_getZindex( $( input ) ) + 1 );
			$.datepicker._datepickerShowing = true;

			if ( $.effects && $.effects.effect[ showAnim ] ) {
				inst.dpDiv.show(showAnim, $.datepicker._get(inst, "showOptions"), duration);
			} else {
				inst.dpDiv[showAnim || "show"](showAnim ? duration : null);
			}

			if ( $.datepicker._shouldFocusInput( inst ) ) {
				inst.input.focus();
			}

			$.datepicker._curInst = inst;
		}
	},

	/* Generate the date picker content. */
	_updateDatepicker: function(inst) {
		this.maxRows = 4; //Reset the max number of rows being displayed (see #7043)
		datepicker_instActive = inst; // for delegate hover events
		inst.dpDiv.empty().append(this._generateHTML(inst));
		this._attachHandlers(inst);

		var origyearshtml,
			numMonths = this._getNumberOfMonths(inst),
			cols = numMonths[1],
			width = 17,
			activeCell = inst.dpDiv.find( "." + this._dayOverClass + " a" );

		if ( activeCell.length > 0 ) {
			datepicker_handleMouseover.apply( activeCell.get( 0 ) );
		}

		inst.dpDiv.removeClass("ui-datepicker-multi-2 ui-datepicker-multi-3 ui-datepicker-multi-4").width("");
		if (cols > 1) {
			inst.dpDiv.addClass("ui-datepicker-multi-" + cols).css("width", (width * cols) + "em");
		}
		inst.dpDiv[(numMonths[0] !== 1 || numMonths[1] !== 1 ? "add" : "remove") +
			"Class"]("ui-datepicker-multi");
		inst.dpDiv[(this._get(inst, "isRTL") ? "add" : "remove") +
			"Class"]("ui-datepicker-rtl");

		if (inst === $.datepicker._curInst && $.datepicker._datepickerShowing && $.datepicker._shouldFocusInput( inst ) ) {
			inst.input.focus();
		}

		// deffered render of the years select (to avoid flashes on Firefox)
		if( inst.yearshtml ){
			origyearshtml = inst.yearshtml;
			setTimeout(function(){
				//assure that inst.yearshtml didn't change.
				if( origyearshtml === inst.yearshtml && inst.yearshtml ){
					inst.dpDiv.find("select.ui-datepicker-year:first").replaceWith(inst.yearshtml);
				}
				origyearshtml = inst.yearshtml = null;
			}, 0);
		}
	},

	// #6694 - don't focus the input if it's already focused
	// this breaks the change event in IE
	// Support: IE and jQuery <1.9
	_shouldFocusInput: function( inst ) {
		return inst.input && inst.input.is( ":visible" ) && !inst.input.is( ":disabled" ) && !inst.input.is( ":focus" );
	},

	/* Check positioning to remain on screen. */
	_checkOffset: function(inst, offset, isFixed) {
		var dpWidth = inst.dpDiv.outerWidth(),
			dpHeight = inst.dpDiv.outerHeight(),
			inputWidth = inst.input ? inst.input.outerWidth() : 0,
			inputHeight = inst.input ? inst.input.outerHeight() : 0,
			viewWidth = document.documentElement.clientWidth + (isFixed ? 0 : $(document).scrollLeft()),
			viewHeight = document.documentElement.clientHeight + (isFixed ? 0 : $(document).scrollTop());

		offset.left -= (this._get(inst, "isRTL") ? (dpWidth - inputWidth) : 0);
		offset.left -= (isFixed && offset.left === inst.input.offset().left) ? $(document).scrollLeft() : 0;
		offset.top -= (isFixed && offset.top === (inst.input.offset().top + inputHeight)) ? $(document).scrollTop() : 0;

		// now check if datepicker is showing outside window viewport - move to a better place if so.
		offset.left -= Math.min(offset.left, (offset.left + dpWidth > viewWidth && viewWidth > dpWidth) ?
			Math.abs(offset.left + dpWidth - viewWidth) : 0);
		offset.top -= Math.min(offset.top, (offset.top + dpHeight > viewHeight && viewHeight > dpHeight) ?
			Math.abs(dpHeight + inputHeight) : 0);

		return offset;
	},

	/* Find an object's position on the screen. */
	_findPos: function(obj) {
		var position,
			inst = this._getInst(obj),
			isRTL = this._get(inst, "isRTL");

		while (obj && (obj.type === "hidden" || obj.nodeType !== 1 || $.expr.filters.hidden(obj))) {
			obj = obj[isRTL ? "previousSibling" : "nextSibling"];
		}

		position = $(obj).offset();
		return [position.left, position.top];
	},

	/* Hide the date picker from view.
	 * @param  input  element - the input field attached to the date picker
	 */
	_hideDatepicker: function(input) {
		var showAnim, duration, postProcess, onClose,
			inst = this._curInst;

		if (!inst || (input && inst !== $.data(input, "datepicker"))) {
			return;
		}

		if (this._datepickerShowing) {
			showAnim = this._get(inst, "showAnim");
			duration = this._get(inst, "duration");
			postProcess = function() {
				$.datepicker._tidyDialog(inst);
			};

			// DEPRECATED: after BC for 1.8.x $.effects[ showAnim ] is not needed
			if ( $.effects && ( $.effects.effect[ showAnim ] || $.effects[ showAnim ] ) ) {
				inst.dpDiv.hide(showAnim, $.datepicker._get(inst, "showOptions"), duration, postProcess);
			} else {
				inst.dpDiv[(showAnim === "slideDown" ? "slideUp" :
					(showAnim === "fadeIn" ? "fadeOut" : "hide"))]((showAnim ? duration : null), postProcess);
			}

			if (!showAnim) {
				postProcess();
			}
			this._datepickerShowing = false;

			onClose = this._get(inst, "onClose");
			if (onClose) {
				onClose.apply((inst.input ? inst.input[0] : null), [(inst.input ? inst.input.val() : ""), inst]);
			}

			this._lastInput = null;
			if (this._inDialog) {
				this._dialogInput.css({ position: "absolute", left: "0", top: "-100px" });
				if ($.blockUI) {
					$.unblockUI();
					$("body").append(this.dpDiv);
				}
			}
			this._inDialog = false;
		}
	},

	/* Tidy up after a dialog display. */
	_tidyDialog: function(inst) {
		inst.dpDiv.removeClass(this._dialogClass).unbind(".ui-datepicker-calendar");
	},

	/* Close date picker if clicked elsewhere. */
	_checkExternalClick: function(event) {
		if (!$.datepicker._curInst) {
			return;
		}

		var $target = $(event.target),
			inst = $.datepicker._getInst($target[0]);

		if ( ( ( $target[0].id !== $.datepicker._mainDivId &&
				$target.parents("#" + $.datepicker._mainDivId).length === 0 &&
				!$target.hasClass($.datepicker.markerClassName) &&
				!$target.closest("." + $.datepicker._triggerClass).length &&
				$.datepicker._datepickerShowing && !($.datepicker._inDialog && $.blockUI) ) ) ||
			( $target.hasClass($.datepicker.markerClassName) && $.datepicker._curInst !== inst ) ) {
				$.datepicker._hideDatepicker();
		}
	},

	/* Adjust one of the date sub-fields. */
	_adjustDate: function(id, offset, period) {
		var target = $(id),
			inst = this._getInst(target[0]);

		if (this._isDisabledDatepicker(target[0])) {
			return;
		}
		this._adjustInstDate(inst, offset +
			(period === "M" ? this._get(inst, "showCurrentAtPos") : 0), // undo positioning
			period);
		this._updateDatepicker(inst);
	},

	/* Action for current link. */
	_gotoToday: function(id) {
		var date,
			target = $(id),
			inst = this._getInst(target[0]);

		if (this._get(inst, "gotoCurrent") && inst.currentDay) {
			inst.selectedDay = inst.currentDay;
			inst.drawMonth = inst.selectedMonth = inst.currentMonth;
			inst.drawYear = inst.selectedYear = inst.currentYear;
		} else {
			date = new Date();
			inst.selectedDay = date.getDate();
			inst.drawMonth = inst.selectedMonth = date.getMonth();
			inst.drawYear = inst.selectedYear = date.getFullYear();
		}
		this._notifyChange(inst);
		this._adjustDate(target);
	},

	/* Action for selecting a new month/year. */
	_selectMonthYear: function(id, select, period) {
		var target = $(id),
			inst = this._getInst(target[0]);

		inst["selected" + (period === "M" ? "Month" : "Year")] =
		inst["draw" + (period === "M" ? "Month" : "Year")] =
			parseInt(select.options[select.selectedIndex].value,10);

		this._notifyChange(inst);
		this._adjustDate(target);
	},

	/* Action for selecting a day. */
	_selectDay: function(id, month, year, td) {
		var inst,
			target = $(id);

		if ($(td).hasClass(this._unselectableClass) || this._isDisabledDatepicker(target[0])) {
			return;
		}

		inst = this._getInst(target[0]);
		inst.selectedDay = inst.currentDay = $("a", td).html();
		inst.selectedMonth = inst.currentMonth = month;
		inst.selectedYear = inst.currentYear = year;
		this._selectDate(id, this._formatDate(inst,
			inst.currentDay, inst.currentMonth, inst.currentYear));
	},

	/* Erase the input field and hide the date picker. */
	_clearDate: function(id) {
		var target = $(id);
		this._selectDate(target, "");
	},

	/* Update the input field with the selected date. */
	_selectDate: function(id, dateStr) {
		var onSelect,
			target = $(id),
			inst = this._getInst(target[0]);

		dateStr = (dateStr != null ? dateStr : this._formatDate(inst));
		if (inst.input) {
			inst.input.val(dateStr);
		}
		this._updateAlternate(inst);

		onSelect = this._get(inst, "onSelect");
		if (onSelect) {
			onSelect.apply((inst.input ? inst.input[0] : null), [dateStr, inst]);  // trigger custom callback
		} else if (inst.input) {
			inst.input.trigger("change"); // fire the change event
		}

		if (inst.inline){
			this._updateDatepicker(inst);
		} else {
			this._hideDatepicker();
			this._lastInput = inst.input[0];
			if (typeof(inst.input[0]) !== "object") {
				inst.input.focus(); // restore focus
			}
			this._lastInput = null;
		}
	},

	/* Update any alternate field to synchronise with the main field. */
	_updateAlternate: function(inst) {
		var altFormat, date, dateStr,
			altField = this._get(inst, "altField");

		if (altField) { // update alternate field too
			altFormat = this._get(inst, "altFormat") || this._get(inst, "dateFormat");
			date = this._getDate(inst);
			dateStr = this.formatDate(altFormat, date, this._getFormatConfig(inst));
			$(altField).each(function() { $(this).val(dateStr); });
		}
	},

	/* Set as beforeShowDay function to prevent selection of weekends.
	 * @param  date  Date - the date to customise
	 * @return [boolean, string] - is this date selectable?, what is its CSS class?
	 */
	noWeekends: function(date) {
		var day = date.getDay();
		return [(day > 0 && day < 6), ""];
	},

	/* Set as calculateWeek to determine the week of the year based on the ISO 8601 definition.
	 * @param  date  Date - the date to get the week for
	 * @return  number - the number of the week within the year that contains this date
	 */
	iso8601Week: function(date) {
		var time,
			checkDate = new Date(date.getTime());

		// Find Thursday of this week starting on Monday
		checkDate.setDate(checkDate.getDate() + 4 - (checkDate.getDay() || 7));

		time = checkDate.getTime();
		checkDate.setMonth(0); // Compare with Jan 1
		checkDate.setDate(1);
		return Math.floor(Math.round((time - checkDate) / 86400000) / 7) + 1;
	},

	/* Parse a string value into a date object.
	 * See formatDate below for the possible formats.
	 *
	 * @param  format string - the expected format of the date
	 * @param  value string - the date in the above format
	 * @param  settings Object - attributes include:
	 *					shortYearCutoff  number - the cutoff year for determining the century (optional)
	 *					dayNamesShort	string[7] - abbreviated names of the days from Sunday (optional)
	 *					dayNames		string[7] - names of the days from Sunday (optional)
	 *					monthNamesShort string[12] - abbreviated names of the months (optional)
	 *					monthNames		string[12] - names of the months (optional)
	 * @return  Date - the extracted date value or null if value is blank
	 */
	parseDate: function (format, value, settings) {
		if (format == null || value == null) {
			throw "Invalid arguments";
		}

		value = (typeof value === "object" ? value.toString() : value + "");
		if (value === "") {
			return null;
		}

		var iFormat, dim, extra,
			iValue = 0,
			shortYearCutoffTemp = (settings ? settings.shortYearCutoff : null) || this._defaults.shortYearCutoff,
			shortYearCutoff = (typeof shortYearCutoffTemp !== "string" ? shortYearCutoffTemp :
				new Date().getFullYear() % 100 + parseInt(shortYearCutoffTemp, 10)),
			dayNamesShort = (settings ? settings.dayNamesShort : null) || this._defaults.dayNamesShort,
			dayNames = (settings ? settings.dayNames : null) || this._defaults.dayNames,
			monthNamesShort = (settings ? settings.monthNamesShort : null) || this._defaults.monthNamesShort,
			monthNames = (settings ? settings.monthNames : null) || this._defaults.monthNames,
			year = -1,
			month = -1,
			day = -1,
			doy = -1,
			literal = false,
			date,
			// Check whether a format character is doubled
			lookAhead = function(match) {
				var matches = (iFormat + 1 < format.length && format.charAt(iFormat + 1) === match);
				if (matches) {
					iFormat++;
				}
				return matches;
			},
			// Extract a number from the string value
			getNumber = function(match) {
				var isDoubled = lookAhead(match),
					size = (match === "@" ? 14 : (match === "!" ? 20 :
					(match === "y" && isDoubled ? 4 : (match === "o" ? 3 : 2)))),
					minSize = (match === "y" ? size : 1),
					digits = new RegExp("^\\d{" + minSize + "," + size + "}"),
					num = value.substring(iValue).match(digits);
				if (!num) {
					throw "Missing number at position " + iValue;
				}
				iValue += num[0].length;
				return parseInt(num[0], 10);
			},
			// Extract a name from the string value and convert to an index
			getName = function(match, shortNames, longNames) {
				var index = -1,
					names = $.map(lookAhead(match) ? longNames : shortNames, function (v, k) {
						return [ [k, v] ];
					}).sort(function (a, b) {
						return -(a[1].length - b[1].length);
					});

				$.each(names, function (i, pair) {
					var name = pair[1];
					if (value.substr(iValue, name.length).toLowerCase() === name.toLowerCase()) {
						index = pair[0];
						iValue += name.length;
						return false;
					}
				});
				if (index !== -1) {
					return index + 1;
				} else {
					throw "Unknown name at position " + iValue;
				}
			},
			// Confirm that a literal character matches the string value
			checkLiteral = function() {
				if (value.charAt(iValue) !== format.charAt(iFormat)) {
					throw "Unexpected literal at position " + iValue;
				}
				iValue++;
			};

		for (iFormat = 0; iFormat < format.length; iFormat++) {
			if (literal) {
				if (format.charAt(iFormat) === "'" && !lookAhead("'")) {
					literal = false;
				} else {
					checkLiteral();
				}
			} else {
				switch (format.charAt(iFormat)) {
					case "d":
						day = getNumber("d");
						break;
					case "D":
						getName("D", dayNamesShort, dayNames);
						break;
					case "o":
						doy = getNumber("o");
						break;
					case "m":
						month = getNumber("m");
						break;
					case "M":
						month = getName("M", monthNamesShort, monthNames);
						break;
					case "y":
						year = getNumber("y");
						break;
					case "@":
						date = new Date(getNumber("@"));
						year = date.getFullYear();
						month = date.getMonth() + 1;
						day = date.getDate();
						break;
					case "!":
						date = new Date((getNumber("!") - this._ticksTo1970) / 10000);
						year = date.getFullYear();
						month = date.getMonth() + 1;
						day = date.getDate();
						break;
					case "'":
						if (lookAhead("'")){
							checkLiteral();
						} else {
							literal = true;
						}
						break;
					default:
						checkLiteral();
				}
			}
		}

		if (iValue < value.length){
			extra = value.substr(iValue);
			if (!/^\s+/.test(extra)) {
				throw "Extra/unparsed characters found in date: " + extra;
			}
		}

		if (year === -1) {
			year = new Date().getFullYear();
		} else if (year < 100) {
			year += new Date().getFullYear() - new Date().getFullYear() % 100 +
				(year <= shortYearCutoff ? 0 : -100);
		}

		if (doy > -1) {
			month = 1;
			day = doy;
			do {
				dim = this._getDaysInMonth(year, month - 1);
				if (day <= dim) {
					break;
				}
				month++;
				day -= dim;
			} while (true);
		}

		date = this._daylightSavingAdjust(new Date(year, month - 1, day));
		if (date.getFullYear() !== year || date.getMonth() + 1 !== month || date.getDate() !== day) {
			throw "Invalid date"; // E.g. 31/02/00
		}
		return date;
	},

	/* Standard date formats. */
	ATOM: "yy-mm-dd", // RFC 3339 (ISO 8601)
	COOKIE: "D, dd M yy",
	ISO_8601: "yy-mm-dd",
	RFC_822: "D, d M y",
	RFC_850: "DD, dd-M-y",
	RFC_1036: "D, d M y",
	RFC_1123: "D, d M yy",
	RFC_2822: "D, d M yy",
	RSS: "D, d M y", // RFC 822
	TICKS: "!",
	TIMESTAMP: "@",
	W3C: "yy-mm-dd", // ISO 8601

	_ticksTo1970: (((1970 - 1) * 365 + Math.floor(1970 / 4) - Math.floor(1970 / 100) +
		Math.floor(1970 / 400)) * 24 * 60 * 60 * 10000000),

	/* Format a date object into a string value.
	 * The format can be combinations of the following:
	 * d  - day of month (no leading zero)
	 * dd - day of month (two digit)
	 * o  - day of year (no leading zeros)
	 * oo - day of year (three digit)
	 * D  - day name short
	 * DD - day name long
	 * m  - month of year (no leading zero)
	 * mm - month of year (two digit)
	 * M  - month name short
	 * MM - month name long
	 * y  - year (two digit)
	 * yy - year (four digit)
	 * @ - Unix timestamp (ms since 01/01/1970)
	 * ! - Windows ticks (100ns since 01/01/0001)
	 * "..." - literal text
	 * '' - single quote
	 *
	 * @param  format string - the desired format of the date
	 * @param  date Date - the date value to format
	 * @param  settings Object - attributes include:
	 *					dayNamesShort	string[7] - abbreviated names of the days from Sunday (optional)
	 *					dayNames		string[7] - names of the days from Sunday (optional)
	 *					monthNamesShort string[12] - abbreviated names of the months (optional)
	 *					monthNames		string[12] - names of the months (optional)
	 * @return  string - the date in the above format
	 */
	formatDate: function (format, date, settings) {
		if (!date) {
			return "";
		}

		var iFormat,
			dayNamesShort = (settings ? settings.dayNamesShort : null) || this._defaults.dayNamesShort,
			dayNames = (settings ? settings.dayNames : null) || this._defaults.dayNames,
			monthNamesShort = (settings ? settings.monthNamesShort : null) || this._defaults.monthNamesShort,
			monthNames = (settings ? settings.monthNames : null) || this._defaults.monthNames,
			// Check whether a format character is doubled
			lookAhead = function(match) {
				var matches = (iFormat + 1 < format.length && format.charAt(iFormat + 1) === match);
				if (matches) {
					iFormat++;
				}
				return matches;
			},
			// Format a number, with leading zero if necessary
			formatNumber = function(match, value, len) {
				var num = "" + value;
				if (lookAhead(match)) {
					while (num.length < len) {
						num = "0" + num;
					}
				}
				return num;
			},
			// Format a name, short or long as requested
			formatName = function(match, value, shortNames, longNames) {
				return (lookAhead(match) ? longNames[value] : shortNames[value]);
			},
			output = "",
			literal = false;

		if (date) {
			for (iFormat = 0; iFormat < format.length; iFormat++) {
				if (literal) {
					if (format.charAt(iFormat) === "'" && !lookAhead("'")) {
						literal = false;
					} else {
						output += format.charAt(iFormat);
					}
				} else {
					switch (format.charAt(iFormat)) {
						case "d":
							output += formatNumber("d", date.getDate(), 2);
							break;
						case "D":
							output += formatName("D", date.getDay(), dayNamesShort, dayNames);
							break;
						case "o":
							output += formatNumber("o",
								Math.round((new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime() - new Date(date.getFullYear(), 0, 0).getTime()) / 86400000), 3);
							break;
						case "m":
							output += formatNumber("m", date.getMonth() + 1, 2);
							break;
						case "M":
							output += formatName("M", date.getMonth(), monthNamesShort, monthNames);
							break;
						case "y":
							output += (lookAhead("y") ? date.getFullYear() :
								(date.getYear() % 100 < 10 ? "0" : "") + date.getYear() % 100);
							break;
						case "@":
							output += date.getTime();
							break;
						case "!":
							output += date.getTime() * 10000 + this._ticksTo1970;
							break;
						case "'":
							if (lookAhead("'")) {
								output += "'";
							} else {
								literal = true;
							}
							break;
						default:
							output += format.charAt(iFormat);
					}
				}
			}
		}
		return output;
	},

	/* Extract all possible characters from the date format. */
	_possibleChars: function (format) {
		var iFormat,
			chars = "",
			literal = false,
			// Check whether a format character is doubled
			lookAhead = function(match) {
				var matches = (iFormat + 1 < format.length && format.charAt(iFormat + 1) === match);
				if (matches) {
					iFormat++;
				}
				return matches;
			};

		for (iFormat = 0; iFormat < format.length; iFormat++) {
			if (literal) {
				if (format.charAt(iFormat) === "'" && !lookAhead("'")) {
					literal = false;
				} else {
					chars += format.charAt(iFormat);
				}
			} else {
				switch (format.charAt(iFormat)) {
					case "d": case "m": case "y": case "@":
						chars += "0123456789";
						break;
					case "D": case "M":
						return null; // Accept anything
					case "'":
						if (lookAhead("'")) {
							chars += "'";
						} else {
							literal = true;
						}
						break;
					default:
						chars += format.charAt(iFormat);
				}
			}
		}
		return chars;
	},

	/* Get a setting value, defaulting if necessary. */
	_get: function(inst, name) {
		return inst.settings[name] !== undefined ?
			inst.settings[name] : this._defaults[name];
	},

	/* Parse existing date and initialise date picker. */
	_setDateFromField: function(inst, noDefault) {
		if (inst.input.val() === inst.lastVal) {
			return;
		}

		var dateFormat = this._get(inst, "dateFormat"),
			dates = inst.lastVal = inst.input ? inst.input.val() : null,
			defaultDate = this._getDefaultDate(inst),
			date = defaultDate,
			settings = this._getFormatConfig(inst);

		try {
			date = this.parseDate(dateFormat, dates, settings) || defaultDate;
		} catch (event) {
			dates = (noDefault ? "" : dates);
		}
		inst.selectedDay = date.getDate();
		inst.drawMonth = inst.selectedMonth = date.getMonth();
		inst.drawYear = inst.selectedYear = date.getFullYear();
		inst.currentDay = (dates ? date.getDate() : 0);
		inst.currentMonth = (dates ? date.getMonth() : 0);
		inst.currentYear = (dates ? date.getFullYear() : 0);
		this._adjustInstDate(inst);
	},

	/* Retrieve the default date shown on opening. */
	_getDefaultDate: function(inst) {
		return this._restrictMinMax(inst,
			this._determineDate(inst, this._get(inst, "defaultDate"), new Date()));
	},

	/* A date may be specified as an exact value or a relative one. */
	_determineDate: function(inst, date, defaultDate) {
		var offsetNumeric = function(offset) {
				var date = new Date();
				date.setDate(date.getDate() + offset);
				return date;
			},
			offsetString = function(offset) {
				try {
					return $.datepicker.parseDate($.datepicker._get(inst, "dateFormat"),
						offset, $.datepicker._getFormatConfig(inst));
				}
				catch (e) {
					// Ignore
				}

				var date = (offset.toLowerCase().match(/^c/) ?
					$.datepicker._getDate(inst) : null) || new Date(),
					year = date.getFullYear(),
					month = date.getMonth(),
					day = date.getDate(),
					pattern = /([+\-]?[0-9]+)\s*(d|D|w|W|m|M|y|Y)?/g,
					matches = pattern.exec(offset);

				while (matches) {
					switch (matches[2] || "d") {
						case "d" : case "D" :
							day += parseInt(matches[1],10); break;
						case "w" : case "W" :
							day += parseInt(matches[1],10) * 7; break;
						case "m" : case "M" :
							month += parseInt(matches[1],10);
							day = Math.min(day, $.datepicker._getDaysInMonth(year, month));
							break;
						case "y": case "Y" :
							year += parseInt(matches[1],10);
							day = Math.min(day, $.datepicker._getDaysInMonth(year, month));
							break;
					}
					matches = pattern.exec(offset);
				}
				return new Date(year, month, day);
			},
			newDate = (date == null || date === "" ? defaultDate : (typeof date === "string" ? offsetString(date) :
				(typeof date === "number" ? (isNaN(date) ? defaultDate : offsetNumeric(date)) : new Date(date.getTime()))));

		newDate = (newDate && newDate.toString() === "Invalid Date" ? defaultDate : newDate);
		if (newDate) {
			newDate.setHours(0);
			newDate.setMinutes(0);
			newDate.setSeconds(0);
			newDate.setMilliseconds(0);
		}
		return this._daylightSavingAdjust(newDate);
	},

	/* Handle switch to/from daylight saving.
	 * Hours may be non-zero on daylight saving cut-over:
	 * > 12 when midnight changeover, but then cannot generate
	 * midnight datetime, so jump to 1AM, otherwise reset.
	 * @param  date  (Date) the date to check
	 * @return  (Date) the corrected date
	 */
	_daylightSavingAdjust: function(date) {
		if (!date) {
			return null;
		}
		date.setHours(date.getHours() > 12 ? date.getHours() + 2 : 0);
		return date;
	},

	/* Set the date(s) directly. */
	_setDate: function(inst, date, noChange) {
		var clear = !date,
			origMonth = inst.selectedMonth,
			origYear = inst.selectedYear,
			newDate = this._restrictMinMax(inst, this._determineDate(inst, date, new Date()));

		inst.selectedDay = inst.currentDay = newDate.getDate();
		inst.drawMonth = inst.selectedMonth = inst.currentMonth = newDate.getMonth();
		inst.drawYear = inst.selectedYear = inst.currentYear = newDate.getFullYear();
		if ((origMonth !== inst.selectedMonth || origYear !== inst.selectedYear) && !noChange) {
			this._notifyChange(inst);
		}
		this._adjustInstDate(inst);
		if (inst.input) {
			inst.input.val(clear ? "" : this._formatDate(inst));
		}
	},

	/* Retrieve the date(s) directly. */
	_getDate: function(inst) {
		var startDate = (!inst.currentYear || (inst.input && inst.input.val() === "") ? null :
			this._daylightSavingAdjust(new Date(
			inst.currentYear, inst.currentMonth, inst.currentDay)));
			return startDate;
	},

	/* Attach the onxxx handlers.  These are declared statically so
	 * they work with static code transformers like Caja.
	 */
	_attachHandlers: function(inst) {
		var stepMonths = this._get(inst, "stepMonths"),
			id = "#" + inst.id.replace( /\\\\/g, "\\" );
		inst.dpDiv.find("[data-handler]").map(function () {
			var handler = {
				prev: function () {
					$.datepicker._adjustDate(id, -stepMonths, "M");
				},
				next: function () {
					$.datepicker._adjustDate(id, +stepMonths, "M");
				},
				hide: function () {
					$.datepicker._hideDatepicker();
				},
				today: function () {
					$.datepicker._gotoToday(id);
				},
				selectDay: function () {
					$.datepicker._selectDay(id, +this.getAttribute("data-month"), +this.getAttribute("data-year"), this);
					return false;
				},
				selectMonth: function () {
					$.datepicker._selectMonthYear(id, this, "M");
					return false;
				},
				selectYear: function () {
					$.datepicker._selectMonthYear(id, this, "Y");
					return false;
				}
			};
			$(this).bind(this.getAttribute("data-event"), handler[this.getAttribute("data-handler")]);
		});
	},

	/* Generate the HTML for the current state of the date picker. */
	_generateHTML: function(inst) {
		var maxDraw, prevText, prev, nextText, next, currentText, gotoDate,
			controls, buttonPanel, firstDay, showWeek, dayNames, dayNamesMin,
			monthNames, monthNamesShort, beforeShowDay, showOtherMonths,
			selectOtherMonths, defaultDate, html, dow, row, group, col, selectedDate,
			cornerClass, calender, thead, day, daysInMonth, leadDays, curRows, numRows,
			printDate, dRow, tbody, daySettings, otherMonth, unselectable,
			tempDate = new Date(),
			today = this._daylightSavingAdjust(
				new Date(tempDate.getFullYear(), tempDate.getMonth(), tempDate.getDate())), // clear time
			isRTL = this._get(inst, "isRTL"),
			showButtonPanel = this._get(inst, "showButtonPanel"),
			hideIfNoPrevNext = this._get(inst, "hideIfNoPrevNext"),
			navigationAsDateFormat = this._get(inst, "navigationAsDateFormat"),
			numMonths = this._getNumberOfMonths(inst),
			showCurrentAtPos = this._get(inst, "showCurrentAtPos"),
			stepMonths = this._get(inst, "stepMonths"),
			isMultiMonth = (numMonths[0] !== 1 || numMonths[1] !== 1),
			currentDate = this._daylightSavingAdjust((!inst.currentDay ? new Date(9999, 9, 9) :
				new Date(inst.currentYear, inst.currentMonth, inst.currentDay))),
			minDate = this._getMinMaxDate(inst, "min"),
			maxDate = this._getMinMaxDate(inst, "max"),
			drawMonth = inst.drawMonth - showCurrentAtPos,
			drawYear = inst.drawYear;

		if (drawMonth < 0) {
			drawMonth += 12;
			drawYear--;
		}
		if (maxDate) {
			maxDraw = this._daylightSavingAdjust(new Date(maxDate.getFullYear(),
				maxDate.getMonth() - (numMonths[0] * numMonths[1]) + 1, maxDate.getDate()));
			maxDraw = (minDate && maxDraw < minDate ? minDate : maxDraw);
			while (this._daylightSavingAdjust(new Date(drawYear, drawMonth, 1)) > maxDraw) {
				drawMonth--;
				if (drawMonth < 0) {
					drawMonth = 11;
					drawYear--;
				}
			}
		}
		inst.drawMonth = drawMonth;
		inst.drawYear = drawYear;

		prevText = this._get(inst, "prevText");
		prevText = (!navigationAsDateFormat ? prevText : this.formatDate(prevText,
			this._daylightSavingAdjust(new Date(drawYear, drawMonth - stepMonths, 1)),
			this._getFormatConfig(inst)));

		prev = (this._canAdjustMonth(inst, -1, drawYear, drawMonth) ?
			"<a class='ui-datepicker-prev ui-corner-all' data-handler='prev' data-event='click'" +
			" title='" + prevText + "'><span class='ui-icon ui-icon-circle-triangle-" + ( isRTL ? "e" : "w") + "'>" + prevText + "</span></a>" :
			(hideIfNoPrevNext ? "" : "<a class='ui-datepicker-prev ui-corner-all ui-state-disabled' title='"+ prevText +"'><span class='ui-icon ui-icon-circle-triangle-" + ( isRTL ? "e" : "w") + "'>" + prevText + "</span></a>"));

		nextText = this._get(inst, "nextText");
		nextText = (!navigationAsDateFormat ? nextText : this.formatDate(nextText,
			this._daylightSavingAdjust(new Date(drawYear, drawMonth + stepMonths, 1)),
			this._getFormatConfig(inst)));

		next = (this._canAdjustMonth(inst, +1, drawYear, drawMonth) ?
			"<a class='ui-datepicker-next ui-corner-all' data-handler='next' data-event='click'" +
			" title='" + nextText + "'><span class='ui-icon ui-icon-circle-triangle-" + ( isRTL ? "w" : "e") + "'>" + nextText + "</span></a>" :
			(hideIfNoPrevNext ? "" : "<a class='ui-datepicker-next ui-corner-all ui-state-disabled' title='"+ nextText + "'><span class='ui-icon ui-icon-circle-triangle-" + ( isRTL ? "w" : "e") + "'>" + nextText + "</span></a>"));

		currentText = this._get(inst, "currentText");
		gotoDate = (this._get(inst, "gotoCurrent") && inst.currentDay ? currentDate : today);
		currentText = (!navigationAsDateFormat ? currentText :
			this.formatDate(currentText, gotoDate, this._getFormatConfig(inst)));

		controls = (!inst.inline ? "<button type='button' class='ui-datepicker-close ui-state-default ui-priority-primary ui-corner-all' data-handler='hide' data-event='click'>" +
			this._get(inst, "closeText") + "</button>" : "");

		buttonPanel = (showButtonPanel) ? "<div class='ui-datepicker-buttonpane ui-widget-content'>" + (isRTL ? controls : "") +
			(this._isInRange(inst, gotoDate) ? "<button type='button' class='ui-datepicker-current ui-state-default ui-priority-secondary ui-corner-all' data-handler='today' data-event='click'" +
			">" + currentText + "</button>" : "") + (isRTL ? "" : controls) + "</div>" : "";

		firstDay = parseInt(this._get(inst, "firstDay"),10);
		firstDay = (isNaN(firstDay) ? 0 : firstDay);

		showWeek = this._get(inst, "showWeek");
		dayNames = this._get(inst, "dayNames");
		dayNamesMin = this._get(inst, "dayNamesMin");
		monthNames = this._get(inst, "monthNames");
		monthNamesShort = this._get(inst, "monthNamesShort");
		beforeShowDay = this._get(inst, "beforeShowDay");
		showOtherMonths = this._get(inst, "showOtherMonths");
		selectOtherMonths = this._get(inst, "selectOtherMonths");
		defaultDate = this._getDefaultDate(inst);
		html = "";
		dow;
		for (row = 0; row < numMonths[0]; row++) {
			group = "";
			this.maxRows = 4;
			for (col = 0; col < numMonths[1]; col++) {
				selectedDate = this._daylightSavingAdjust(new Date(drawYear, drawMonth, inst.selectedDay));
				cornerClass = " ui-corner-all";
				calender = "";
				if (isMultiMonth) {
					calender += "<div class='ui-datepicker-group";
					if (numMonths[1] > 1) {
						switch (col) {
							case 0: calender += " ui-datepicker-group-first";
								cornerClass = " ui-corner-" + (isRTL ? "right" : "left"); break;
							case numMonths[1]-1: calender += " ui-datepicker-group-last";
								cornerClass = " ui-corner-" + (isRTL ? "left" : "right"); break;
							default: calender += " ui-datepicker-group-middle"; cornerClass = ""; break;
						}
					}
					calender += "'>";
				}
				calender += "<div class='ui-datepicker-header ui-widget-header ui-helper-clearfix" + cornerClass + "'>" +
					(/all|left/.test(cornerClass) && row === 0 ? (isRTL ? next : prev) : "") +
					(/all|right/.test(cornerClass) && row === 0 ? (isRTL ? prev : next) : "") +
					this._generateMonthYearHeader(inst, drawMonth, drawYear, minDate, maxDate,
					row > 0 || col > 0, monthNames, monthNamesShort) + // draw month headers
					"</div><table class='ui-datepicker-calendar'><thead>" +
					"<tr>";
				thead = (showWeek ? "<th class='ui-datepicker-week-col'>" + this._get(inst, "weekHeader") + "</th>" : "");
				for (dow = 0; dow < 7; dow++) { // days of the week
					day = (dow + firstDay) % 7;
					thead += "<th scope='col'" + ((dow + firstDay + 6) % 7 >= 5 ? " class='ui-datepicker-week-end'" : "") + ">" +
						"<span title='" + dayNames[day] + "'>" + dayNamesMin[day] + "</span></th>";
				}
				calender += thead + "</tr></thead><tbody>";
				daysInMonth = this._getDaysInMonth(drawYear, drawMonth);
				if (drawYear === inst.selectedYear && drawMonth === inst.selectedMonth) {
					inst.selectedDay = Math.min(inst.selectedDay, daysInMonth);
				}
				leadDays = (this._getFirstDayOfMonth(drawYear, drawMonth) - firstDay + 7) % 7;
				curRows = Math.ceil((leadDays + daysInMonth) / 7); // calculate the number of rows to generate
				numRows = (isMultiMonth ? this.maxRows > curRows ? this.maxRows : curRows : curRows); //If multiple months, use the higher number of rows (see #7043)
				this.maxRows = numRows;
				printDate = this._daylightSavingAdjust(new Date(drawYear, drawMonth, 1 - leadDays));
				for (dRow = 0; dRow < numRows; dRow++) { // create date picker rows
					calender += "<tr>";
					tbody = (!showWeek ? "" : "<td class='ui-datepicker-week-col'>" +
						this._get(inst, "calculateWeek")(printDate) + "</td>");
					for (dow = 0; dow < 7; dow++) { // create date picker days
						daySettings = (beforeShowDay ?
							beforeShowDay.apply((inst.input ? inst.input[0] : null), [printDate]) : [true, ""]);
						otherMonth = (printDate.getMonth() !== drawMonth);
						unselectable = (otherMonth && !selectOtherMonths) || !daySettings[0] ||
							(minDate && printDate < minDate) || (maxDate && printDate > maxDate);
						tbody += "<td class='" +
							((dow + firstDay + 6) % 7 >= 5 ? " ui-datepicker-week-end" : "") + // highlight weekends
							(otherMonth ? " ui-datepicker-other-month" : "") + // highlight days from other months
							((printDate.getTime() === selectedDate.getTime() && drawMonth === inst.selectedMonth && inst._keyEvent) || // user pressed key
							(defaultDate.getTime() === printDate.getTime() && defaultDate.getTime() === selectedDate.getTime()) ?
							// or defaultDate is current printedDate and defaultDate is selectedDate
							" " + this._dayOverClass : "") + // highlight selected day
							(unselectable ? " " + this._unselectableClass + " ui-state-disabled": "") +  // highlight unselectable days
							(otherMonth && !showOtherMonths ? "" : " " + daySettings[1] + // highlight custom dates
							(printDate.getTime() === currentDate.getTime() ? " " + this._currentClass : "") + // highlight selected day
							(printDate.getTime() === today.getTime() ? " ui-datepicker-today" : "")) + "'" + // highlight today (if different)
							((!otherMonth || showOtherMonths) && daySettings[2] ? " title='" + daySettings[2].replace(/'/g, "&#39;") + "'" : "") + // cell title
							(unselectable ? "" : " data-handler='selectDay' data-event='click' data-month='" + printDate.getMonth() + "' data-year='" + printDate.getFullYear() + "'") + ">" + // actions
							(otherMonth && !showOtherMonths ? "&#xa0;" : // display for other months
							(unselectable ? "<span class='ui-state-default'>" + printDate.getDate() + "</span>" : "<a class='ui-state-default" +
							(printDate.getTime() === today.getTime() ? " ui-state-highlight" : "") +
							(printDate.getTime() === currentDate.getTime() ? " ui-state-active" : "") + // highlight selected day
							(otherMonth ? " ui-priority-secondary" : "") + // distinguish dates from other months
							"' href='#'>" + printDate.getDate() + "</a>")) + "</td>"; // display selectable date
						printDate.setDate(printDate.getDate() + 1);
						printDate = this._daylightSavingAdjust(printDate);
					}
					calender += tbody + "</tr>";
				}
				drawMonth++;
				if (drawMonth > 11) {
					drawMonth = 0;
					drawYear++;
				}
				calender += "</tbody></table>" + (isMultiMonth ? "</div>" +
							((numMonths[0] > 0 && col === numMonths[1]-1) ? "<div class='ui-datepicker-row-break'></div>" : "") : "");
				group += calender;
			}
			html += group;
		}
		html += buttonPanel;
		inst._keyEvent = false;
		return html;
	},

	/* Generate the month and year header. */
	_generateMonthYearHeader: function(inst, drawMonth, drawYear, minDate, maxDate,
			secondary, monthNames, monthNamesShort) {

		var inMinYear, inMaxYear, month, years, thisYear, determineYear, year, endYear,
			changeMonth = this._get(inst, "changeMonth"),
			changeYear = this._get(inst, "changeYear"),
			showMonthAfterYear = this._get(inst, "showMonthAfterYear"),
			html = "<div class='ui-datepicker-title'>",
			monthHtml = "";

		// month selection
		if (secondary || !changeMonth) {
			monthHtml += "<span class='ui-datepicker-month'>" + monthNames[drawMonth] + "</span>";
		} else {
			inMinYear = (minDate && minDate.getFullYear() === drawYear);
			inMaxYear = (maxDate && maxDate.getFullYear() === drawYear);
			monthHtml += "<select class='ui-datepicker-month' data-handler='selectMonth' data-event='change'>";
			for ( month = 0; month < 12; month++) {
				if ((!inMinYear || month >= minDate.getMonth()) && (!inMaxYear || month <= maxDate.getMonth())) {
					monthHtml += "<option value='" + month + "'" +
						(month === drawMonth ? " selected='selected'" : "") +
						">" + monthNamesShort[month] + "</option>";
				}
			}
			monthHtml += "</select>";
		}

		if (!showMonthAfterYear) {
			html += monthHtml + (secondary || !(changeMonth && changeYear) ? "&#xa0;" : "");
		}

		// year selection
		if ( !inst.yearshtml ) {
			inst.yearshtml = "";
			if (secondary || !changeYear) {
				html += "<span class='ui-datepicker-year'>" + drawYear + "</span>";
			} else {
				// determine range of years to display
				years = this._get(inst, "yearRange").split(":");
				thisYear = new Date().getFullYear();
				determineYear = function(value) {
					var year = (value.match(/c[+\-].*/) ? drawYear + parseInt(value.substring(1), 10) :
						(value.match(/[+\-].*/) ? thisYear + parseInt(value, 10) :
						parseInt(value, 10)));
					return (isNaN(year) ? thisYear : year);
				};
				year = determineYear(years[0]);
				endYear = Math.max(year, determineYear(years[1] || ""));
				year = (minDate ? Math.max(year, minDate.getFullYear()) : year);
				endYear = (maxDate ? Math.min(endYear, maxDate.getFullYear()) : endYear);
				inst.yearshtml += "<select class='ui-datepicker-year' data-handler='selectYear' data-event='change'>";
				for (; year <= endYear; year++) {
					inst.yearshtml += "<option value='" + year + "'" +
						(year === drawYear ? " selected='selected'" : "") +
						">" + year + "</option>";
				}
				inst.yearshtml += "</select>";

				html += inst.yearshtml;
				inst.yearshtml = null;
			}
		}

		html += this._get(inst, "yearSuffix");
		if (showMonthAfterYear) {
			html += (secondary || !(changeMonth && changeYear) ? "&#xa0;" : "") + monthHtml;
		}
		html += "</div>"; // Close datepicker_header
		return html;
	},

	/* Adjust one of the date sub-fields. */
	_adjustInstDate: function(inst, offset, period) {
		var year = inst.drawYear + (period === "Y" ? offset : 0),
			month = inst.drawMonth + (period === "M" ? offset : 0),
			day = Math.min(inst.selectedDay, this._getDaysInMonth(year, month)) + (period === "D" ? offset : 0),
			date = this._restrictMinMax(inst, this._daylightSavingAdjust(new Date(year, month, day)));

		inst.selectedDay = date.getDate();
		inst.drawMonth = inst.selectedMonth = date.getMonth();
		inst.drawYear = inst.selectedYear = date.getFullYear();
		if (period === "M" || period === "Y") {
			this._notifyChange(inst);
		}
	},

	/* Ensure a date is within any min/max bounds. */
	_restrictMinMax: function(inst, date) {
		var minDate = this._getMinMaxDate(inst, "min"),
			maxDate = this._getMinMaxDate(inst, "max"),
			newDate = (minDate && date < minDate ? minDate : date);
		return (maxDate && newDate > maxDate ? maxDate : newDate);
	},

	/* Notify change of month/year. */
	_notifyChange: function(inst) {
		var onChange = this._get(inst, "onChangeMonthYear");
		if (onChange) {
			onChange.apply((inst.input ? inst.input[0] : null),
				[inst.selectedYear, inst.selectedMonth + 1, inst]);
		}
	},

	/* Determine the number of months to show. */
	_getNumberOfMonths: function(inst) {
		var numMonths = this._get(inst, "numberOfMonths");
		return (numMonths == null ? [1, 1] : (typeof numMonths === "number" ? [1, numMonths] : numMonths));
	},

	/* Determine the current maximum date - ensure no time components are set. */
	_getMinMaxDate: function(inst, minMax) {
		return this._determineDate(inst, this._get(inst, minMax + "Date"), null);
	},

	/* Find the number of days in a given month. */
	_getDaysInMonth: function(year, month) {
		return 32 - this._daylightSavingAdjust(new Date(year, month, 32)).getDate();
	},

	/* Find the day of the week of the first of a month. */
	_getFirstDayOfMonth: function(year, month) {
		return new Date(year, month, 1).getDay();
	},

	/* Determines if we should allow a "next/prev" month display change. */
	_canAdjustMonth: function(inst, offset, curYear, curMonth) {
		var numMonths = this._getNumberOfMonths(inst),
			date = this._daylightSavingAdjust(new Date(curYear,
			curMonth + (offset < 0 ? offset : numMonths[0] * numMonths[1]), 1));

		if (offset < 0) {
			date.setDate(this._getDaysInMonth(date.getFullYear(), date.getMonth()));
		}
		return this._isInRange(inst, date);
	},

	/* Is the given date in the accepted range? */
	_isInRange: function(inst, date) {
		var yearSplit, currentYear,
			minDate = this._getMinMaxDate(inst, "min"),
			maxDate = this._getMinMaxDate(inst, "max"),
			minYear = null,
			maxYear = null,
			years = this._get(inst, "yearRange");
			if (years){
				yearSplit = years.split(":");
				currentYear = new Date().getFullYear();
				minYear = parseInt(yearSplit[0], 10);
				maxYear = parseInt(yearSplit[1], 10);
				if ( yearSplit[0].match(/[+\-].*/) ) {
					minYear += currentYear;
				}
				if ( yearSplit[1].match(/[+\-].*/) ) {
					maxYear += currentYear;
				}
			}

		return ((!minDate || date.getTime() >= minDate.getTime()) &&
			(!maxDate || date.getTime() <= maxDate.getTime()) &&
			(!minYear || date.getFullYear() >= minYear) &&
			(!maxYear || date.getFullYear() <= maxYear));
	},

	/* Provide the configuration settings for formatting/parsing. */
	_getFormatConfig: function(inst) {
		var shortYearCutoff = this._get(inst, "shortYearCutoff");
		shortYearCutoff = (typeof shortYearCutoff !== "string" ? shortYearCutoff :
			new Date().getFullYear() % 100 + parseInt(shortYearCutoff, 10));
		return {shortYearCutoff: shortYearCutoff,
			dayNamesShort: this._get(inst, "dayNamesShort"), dayNames: this._get(inst, "dayNames"),
			monthNamesShort: this._get(inst, "monthNamesShort"), monthNames: this._get(inst, "monthNames")};
	},

	/* Format the given date for display. */
	_formatDate: function(inst, day, month, year) {
		if (!day) {
			inst.currentDay = inst.selectedDay;
			inst.currentMonth = inst.selectedMonth;
			inst.currentYear = inst.selectedYear;
		}
		var date = (day ? (typeof day === "object" ? day :
			this._daylightSavingAdjust(new Date(year, month, day))) :
			this._daylightSavingAdjust(new Date(inst.currentYear, inst.currentMonth, inst.currentDay)));
		return this.formatDate(this._get(inst, "dateFormat"), date, this._getFormatConfig(inst));
	}
});

/*
 * Bind hover events for datepicker elements.
 * Done via delegate so the binding only occurs once in the lifetime of the parent div.
 * Global datepicker_instActive, set by _updateDatepicker allows the handlers to find their way back to the active picker.
 */
function datepicker_bindHover(dpDiv) {
	var selector = "button, .ui-datepicker-prev, .ui-datepicker-next, .ui-datepicker-calendar td a";
	return dpDiv.delegate(selector, "mouseout", function() {
			$(this).removeClass("ui-state-hover");
			if (this.className.indexOf("ui-datepicker-prev") !== -1) {
				$(this).removeClass("ui-datepicker-prev-hover");
			}
			if (this.className.indexOf("ui-datepicker-next") !== -1) {
				$(this).removeClass("ui-datepicker-next-hover");
			}
		})
		.delegate( selector, "mouseover", datepicker_handleMouseover );
}

function datepicker_handleMouseover() {
	if (!$.datepicker._isDisabledDatepicker( datepicker_instActive.inline? datepicker_instActive.dpDiv.parent()[0] : datepicker_instActive.input[0])) {
		$(this).parents(".ui-datepicker-calendar").find("a").removeClass("ui-state-hover");
		$(this).addClass("ui-state-hover");
		if (this.className.indexOf("ui-datepicker-prev") !== -1) {
			$(this).addClass("ui-datepicker-prev-hover");
		}
		if (this.className.indexOf("ui-datepicker-next") !== -1) {
			$(this).addClass("ui-datepicker-next-hover");
		}
	}
}

/* jQuery extend now ignores nulls! */
function datepicker_extendRemove(target, props) {
	$.extend(target, props);
	for (var name in props) {
		if (props[name] == null) {
			target[name] = props[name];
		}
	}
	return target;
}

/* Invoke the datepicker functionality.
   @param  options  string - a command, optionally followed by additional parameters or
					Object - settings for attaching new datepicker functionality
   @return  jQuery object */
$.fn.datepicker = function(options){

	/* Verify an empty collection wasn't passed - Fixes #6976 */
	if ( !this.length ) {
		return this;
	}

	/* Initialise the date picker. */
	if (!$.datepicker.initialized) {
		$(document).mousedown($.datepicker._checkExternalClick);
		$.datepicker.initialized = true;
	}

	/* Append datepicker main container to body if not exist. */
	if ($("#"+$.datepicker._mainDivId).length === 0) {
		$("body").append($.datepicker.dpDiv);
	}

	var otherArgs = Array.prototype.slice.call(arguments, 1);
	if (typeof options === "string" && (options === "isDisabled" || options === "getDate" || options === "widget")) {
		return $.datepicker["_" + options + "Datepicker"].
			apply($.datepicker, [this[0]].concat(otherArgs));
	}
	if (options === "option" && arguments.length === 2 && typeof arguments[1] === "string") {
		return $.datepicker["_" + options + "Datepicker"].
			apply($.datepicker, [this[0]].concat(otherArgs));
	}
	return this.each(function() {
		typeof options === "string" ?
			$.datepicker["_" + options + "Datepicker"].
				apply($.datepicker, [this].concat(otherArgs)) :
			$.datepicker._attachDatepicker(this, options);
	});
};

$.datepicker = new Datepicker(); // singleton instance
$.datepicker.initialized = false;
$.datepicker.uuid = new Date().getTime();
$.datepicker.version = "1.11.2";

var datepicker = $.datepicker;



}));
}(jq111);
/*
 * The MIT License
 *
 * Copyright (c) 2012 James Allardice
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"),
 * to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense,
 * and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */

// Defines the global Placeholders object along with various utility methods
(function (global) {

    "use strict";

    // Cross-browser DOM event binding
    function addEventListener(elem, event, fn) {
        if (elem.addEventListener) {
            return elem.addEventListener(event, fn, false);
        }
        if (elem.attachEvent) {
            return elem.attachEvent("on" + event, fn);
        }
    }

    // Check whether an item is in an array (we don't use Array.prototype.indexOf so we don't clobber any existing polyfills - this is a really simple alternative)
    function inArray(arr, item) {
        var i, len;
        for (i = 0, len = arr.length; i < len; i++) {
            if (arr[i] === item) {
                return true;
            }
        }
        return false;
    }

    // Move the caret to the index position specified. Assumes that the element has focus
    function moveCaret(elem, index) {
        var range;
        if (elem.createTextRange) {
            range = elem.createTextRange();
            range.move("character", index);
            range.select();
        } else if (elem.selectionStart) {
            elem.focus();
            elem.setSelectionRange(index, index);
        }
    }

    // Attempt to change the type property of an input element
    function changeType(elem, type) {
        try {
            elem.type = type;
            return true;
        } catch (e) {
            // You can't change input type in IE8 and below
            return false;
        }
    }

    // Expose public methods
    global.Placeholders = {
        Utils: {
            addEventListener: addEventListener,
            inArray: inArray,
            moveCaret: moveCaret,
            changeType: changeType
        }
    };

}(this));

(function (global) {

    "use strict";

    var validTypes = [
            "text",
            "search",
            "url",
            "tel",
            "email",
            "password",
            "number",
            "textarea"
        ],

        // The list of keycodes that are not allowed when the polyfill is configured to hide-on-input
        badKeys = [

            // The following keys all cause the caret to jump to the end of the input value
            27, // Escape
            33, // Page up
            34, // Page down
            35, // End
            36, // Home

            // Arrow keys allow you to move the caret manually, which should be prevented when the placeholder is visible
            37, // Left
            38, // Up
            39, // Right
            40, // Down

            // The following keys allow you to modify the placeholder text by removing characters, which should be prevented when the placeholder is visible
            8, // Backspace
            46 // Delete
        ],

        // Styling variables
        placeholderStyleColor = "#ccc",
        placeholderClassName = "placeholdersjs",
        classNameRegExp = new RegExp("(?:^|\\s)" + placeholderClassName + "(?!\\S)"),

        // These will hold references to all elements that can be affected. NodeList objects are live, so we only need to get those references once
        inputs, textareas,

        // The various data-* attributes used by the polyfill
        ATTR_CURRENT_VAL = "data-placeholder-value",
        ATTR_ACTIVE = "data-placeholder-active",
        ATTR_INPUT_TYPE = "data-placeholder-type",
        ATTR_FORM_HANDLED = "data-placeholder-submit",
        ATTR_EVENTS_BOUND = "data-placeholder-bound",
        ATTR_OPTION_FOCUS = "data-placeholder-focus",
        ATTR_OPTION_LIVE = "data-placeholder-live",
        ATTR_MAXLENGTH = "data-placeholder-maxlength",

        // Various other variables used throughout the rest of the script
        test = document.createElement("input"),
        head = document.getElementsByTagName("head")[0],
        root = document.documentElement,
        Placeholders = global.Placeholders,
        Utils = Placeholders.Utils,
        hideOnInput, liveUpdates, keydownVal, styleElem, styleRules, placeholder, timer, form, elem, len, i;

    // No-op (used in place of public methods when native support is detected)
    function noop() {}

    // Avoid IE9 activeElement of death when an iframe is used.
    // More info:
    // http://bugs.jquery.com/ticket/13393
    // https://github.com/jquery/jquery/commit/85fc5878b3c6af73f42d61eedf73013e7faae408
    function safeActiveElement() {
        try {
            return document.activeElement;
        } catch (err) {}
    }

    // Hide the placeholder value on a single element. Returns true if the placeholder was hidden and false if it was not (because it wasn't visible in the first place)
    function hidePlaceholder(elem, keydownValue) {
        var type,
            maxLength,
            valueChanged = (!!keydownValue && elem.value !== keydownValue),
            isPlaceholderValue = (elem.value === elem.getAttribute(ATTR_CURRENT_VAL));

        if ((valueChanged || isPlaceholderValue) && elem.getAttribute(ATTR_ACTIVE) === "true") {
            elem.removeAttribute(ATTR_ACTIVE);
            elem.value = elem.value.replace(elem.getAttribute(ATTR_CURRENT_VAL), "");
            elem.className = elem.className.replace(classNameRegExp, "");

            // Restore the maxlength value
            maxLength = elem.getAttribute(ATTR_MAXLENGTH);
            if (parseInt(maxLength, 10) >= 0) { // Old FF returns -1 if attribute not set (see GH-56)
                elem.setAttribute("maxLength", maxLength);
                elem.removeAttribute(ATTR_MAXLENGTH);
            }

            // If the polyfill has changed the type of the element we need to change it back
            type = elem.getAttribute(ATTR_INPUT_TYPE);
            if (type) {
                elem.type = type;
            }
            return true;
        }
        return false;
    }

    // Show the placeholder value on a single element. Returns true if the placeholder was shown and false if it was not (because it was already visible)
    function showPlaceholder(elem) {
        var type,
            maxLength,
            val = elem.getAttribute(ATTR_CURRENT_VAL);
        if (elem.value === "" && val) {
            elem.setAttribute(ATTR_ACTIVE, "true");
            elem.value = val;
            elem.className += " " + placeholderClassName;

            // Store and remove the maxlength value
            maxLength = elem.getAttribute(ATTR_MAXLENGTH);
            if (!maxLength) {
                elem.setAttribute(ATTR_MAXLENGTH, elem.maxLength);
                elem.removeAttribute("maxLength");
            }

            // If the type of element needs to change, change it (e.g. password inputs)
            type = elem.getAttribute(ATTR_INPUT_TYPE);
            if (type) {
                elem.type = "text";
            } else if (elem.type === "password") {
                if (Utils.changeType(elem, "text")) {
                    elem.setAttribute(ATTR_INPUT_TYPE, "password");
                }
            }
            return true;
        }
        return false;
    }

    function handleElem(node, callback) {

        var handleInputsLength, handleTextareasLength, handleInputs, handleTextareas, elem, len, i;

        // Check if the passed in node is an input/textarea (in which case it can't have any affected descendants)
        if (node && node.getAttribute(ATTR_CURRENT_VAL)) {
            callback(node);
        } else {

            // If an element was passed in, get all affected descendants. Otherwise, get all affected elements in document
            handleInputs = node ? node.getElementsByTagName("input") : inputs;
            handleTextareas = node ? node.getElementsByTagName("textarea") : textareas;

            handleInputsLength = handleInputs ? handleInputs.length : 0;
            handleTextareasLength = handleTextareas ? handleTextareas.length : 0;

            // Run the callback for each element
            for (i = 0, len = handleInputsLength + handleTextareasLength; i < len; i++) {
                elem = i < handleInputsLength ? handleInputs[i] : handleTextareas[i - handleInputsLength];
                callback(elem);
            }
        }
    }

    // Return all affected elements to their normal state (remove placeholder value if present)
    function disablePlaceholders(node) {
        handleElem(node, hidePlaceholder);
    }

    // Show the placeholder value on all appropriate elements
    function enablePlaceholders(node) {
        handleElem(node, showPlaceholder);
    }

    // Returns a function that is used as a focus event handler
    function makeFocusHandler(elem) {
        return function () {

            // Only hide the placeholder value if the (default) hide-on-focus behaviour is enabled
            if (hideOnInput && elem.value === elem.getAttribute(ATTR_CURRENT_VAL) && elem.getAttribute(ATTR_ACTIVE) === "true") {

                // Move the caret to the start of the input (this mimics the behaviour of all browsers that do not hide the placeholder on focus)
                Utils.moveCaret(elem, 0);

            } else {

                // Remove the placeholder
                hidePlaceholder(elem);
            }
        };
    }

    // Returns a function that is used as a blur event handler
    function makeBlurHandler(elem) {
        return function () {
            showPlaceholder(elem);
        };
    }

    // Functions that are used as a event handlers when the hide-on-input behaviour has been activated - very basic implementation of the "input" event
    function makeKeydownHandler(elem) {
        return function (e) {
            keydownVal = elem.value;

            //Prevent the use of the arrow keys (try to keep the cursor before the placeholder)
            if (elem.getAttribute(ATTR_ACTIVE) === "true") {
                if (keydownVal === elem.getAttribute(ATTR_CURRENT_VAL) && Utils.inArray(badKeys, e.keyCode)) {
                    if (e.preventDefault) {
                        e.preventDefault();
                    }
                    return false;
                }
            }
        };
    }
    function makeKeyupHandler(elem) {
        return function () {
            hidePlaceholder(elem, keydownVal);

            // If the element is now empty we need to show the placeholder
            if (elem.value === "") {
                elem.blur();
                Utils.moveCaret(elem, 0);
            }
        };
    }
    function makeClickHandler(elem) {
        return function () {
            if (elem === safeActiveElement() && elem.value === elem.getAttribute(ATTR_CURRENT_VAL) && elem.getAttribute(ATTR_ACTIVE) === "true") {
                Utils.moveCaret(elem, 0);
            }
        };
    }

    // Returns a function that is used as a submit event handler on form elements that have children affected by this polyfill
    function makeSubmitHandler(form) {
        return function () {

            // Turn off placeholders on all appropriate descendant elements
            disablePlaceholders(form);
        };
    }

    // Bind event handlers to an element that we need to affect with the polyfill
    function newElement(elem) {

        // If the element is part of a form, make sure the placeholder string is not submitted as a value
        if (elem.form) {
            form = elem.form;

            // If the type of the property is a string then we have a "form" attribute and need to get the real form
            if (typeof form === "string") {
                form = document.getElementById(form);
            }

            // Set a flag on the form so we know it's been handled (forms can contain multiple inputs)
            if (!form.getAttribute(ATTR_FORM_HANDLED)) {
                Utils.addEventListener(form, "submit", makeSubmitHandler(form));
                form.setAttribute(ATTR_FORM_HANDLED, "true");
            }
        }

        // Bind event handlers to the element so we can hide/show the placeholder as appropriate
        Utils.addEventListener(elem, "focus", makeFocusHandler(elem));
        Utils.addEventListener(elem, "blur", makeBlurHandler(elem));

        // If the placeholder should hide on input rather than on focus we need additional event handlers
        if (hideOnInput) {
            Utils.addEventListener(elem, "keydown", makeKeydownHandler(elem));
            Utils.addEventListener(elem, "keyup", makeKeyupHandler(elem));
            Utils.addEventListener(elem, "click", makeClickHandler(elem));
        }

        // Remember that we've bound event handlers to this element
        elem.setAttribute(ATTR_EVENTS_BOUND, "true");
        elem.setAttribute(ATTR_CURRENT_VAL, placeholder);

        // If the element doesn't have a value and is not focussed, set it to the placeholder string
        if (hideOnInput || elem !== safeActiveElement()) {
            showPlaceholder(elem);
        }
    }

    Placeholders.nativeSupport = test.placeholder !== void 0;

    if (!Placeholders.nativeSupport) {

        // Get references to all the input and textarea elements currently in the DOM (live NodeList objects to we only need to do this once)
        inputs = document.getElementsByTagName("input");
        textareas = document.getElementsByTagName("textarea");

        // Get any settings declared as data-* attributes on the root element (currently the only options are whether to hide the placeholder on focus or input and whether to auto-update)
        hideOnInput = root.getAttribute(ATTR_OPTION_FOCUS) === "false";
        liveUpdates = root.getAttribute(ATTR_OPTION_LIVE) !== "false";

        // Create style element for placeholder styles (instead of directly setting style properties on elements - allows for better flexibility alongside user-defined styles)
        styleElem = document.createElement("style");
        styleElem.type = "text/css";

        // Create style rules as text node
        styleRules = document.createTextNode("." + placeholderClassName + " { color:" + placeholderStyleColor + "; }");

        // Append style rules to newly created stylesheet
        if (styleElem.styleSheet) {
            styleElem.styleSheet.cssText = styleRules.nodeValue;
        } else {
            styleElem.appendChild(styleRules);
        }

        // Prepend new style element to the head (before any existing stylesheets, so user-defined rules take precedence)
        head.insertBefore(styleElem, head.firstChild);

        // Set up the placeholders
        for (i = 0, len = inputs.length + textareas.length; i < len; i++) {
            elem = i < inputs.length ? inputs[i] : textareas[i - inputs.length];

            // Get the value of the placeholder attribute, if any. IE10 emulating IE7 fails with getAttribute, hence the use of the attributes node
            placeholder = elem.attributes.placeholder;
            if (placeholder) {

                // IE returns an empty object instead of undefined if the attribute is not present
                placeholder = placeholder.nodeValue;

                // Only apply the polyfill if this element is of a type that supports placeholders, and has a placeholder attribute with a non-empty value
                if (placeholder && Utils.inArray(validTypes, elem.type)) {
                    newElement(elem);
                }
            }
        }

        // If enabled, the polyfill will repeatedly check for changed/added elements and apply to those as well
        timer = setInterval(function () {
            for (i = 0, len = inputs.length + textareas.length; i < len; i++) {
                elem = i < inputs.length ? inputs[i] : textareas[i - inputs.length];

                // Only apply the polyfill if this element is of a type that supports placeholders, and has a placeholder attribute with a non-empty value
                placeholder = elem.attributes.placeholder;
                if (placeholder) {
                    placeholder = placeholder.nodeValue;
                    if (placeholder && Utils.inArray(validTypes, elem.type)) {

                        // If the element hasn't had event handlers bound to it then add them
                        if (!elem.getAttribute(ATTR_EVENTS_BOUND)) {
                            newElement(elem);
                        }

                        // If the placeholder value has changed or not been initialised yet we need to update the display
                        if (placeholder !== elem.getAttribute(ATTR_CURRENT_VAL) || (elem.type === "password" && !elem.getAttribute(ATTR_INPUT_TYPE))) {

                            // Attempt to change the type of password inputs (fails in IE < 9)
                            if (elem.type === "password" && !elem.getAttribute(ATTR_INPUT_TYPE) && Utils.changeType(elem, "text")) {
                                elem.setAttribute(ATTR_INPUT_TYPE, "password");
                            }

                            // If the placeholder value has changed and the placeholder is currently on display we need to change it
                            if (elem.value === elem.getAttribute(ATTR_CURRENT_VAL)) {
                                elem.value = placeholder;
                            }

                            // Keep a reference to the current placeholder value in case it changes via another script
                            elem.setAttribute(ATTR_CURRENT_VAL, placeholder);
                        }
                    }
                } else if (elem.getAttribute(ATTR_ACTIVE)) {
                    hidePlaceholder(elem);
                    elem.removeAttribute(ATTR_CURRENT_VAL);
                }
            }

            // If live updates are not enabled cancel the timer
            if (!liveUpdates) {
                clearInterval(timer);
            }
        }, 100);
    }

    Utils.addEventListener(global, "beforeunload", function () {
        Placeholders.disable();
    });

    // Expose public methods
    Placeholders.disable = Placeholders.nativeSupport ? noop : disablePlaceholders;
    Placeholders.enable = Placeholders.nativeSupport ? noop : enablePlaceholders;

}(this));

(function ($) {

    "use strict";

    var originalValFn = $.fn.val,
        originalPropFn = $.fn.prop;

    if (!Placeholders.nativeSupport) {

        $.fn.val = function (val) {
            var originalValue = originalValFn.apply(this, arguments),
                placeholder = this.eq(0).data("placeholder-value");
            if (val === undefined && this.eq(0).data("placeholder-active") && originalValue === placeholder) {
                return "";
            }
            return originalValue;
        };

        $.fn.prop = function (name, val) {
            if (val === undefined && this.eq(0).data("placeholder-active") && name === "value") {
                return "";
            }
            return originalPropFn.apply(this, arguments);
        };
    }

}(jq111));

/*!
* Clamp.js 0.5.1
*
* Copyright 2011-2013, Joseph Schmitt http://joe.sh
* Released under the WTFPL license
* http://sam.zoy.org/wtfpl/
*/

(function(){
  /**
   * Clamps a text node.
   * @param {HTMLElement} element. Element containing the text node to clamp.
   * @param {Object} options. Options to pass to the clamper.
   */
  function clamp(element, options) {
    options = options || {};

    var self = this,
      win = window,
      opt = {
        clamp:              options.clamp || 2,
        useNativeClamp:     typeof(options.useNativeClamp) != 'undefined' ? options.useNativeClamp : true,
        splitOnChars:       options.splitOnChars || ['.', '-', '–', '—', ' '], //Split on sentences (periods), hypens, en-dashes, em-dashes, and words (spaces).
        animate:            options.animate || false,
        truncationChar:     options.truncationChar || '…',
        truncationHTML:     options.truncationHTML
      },

      sty = element.style,
      originalText = element.innerHTML,

      supportsNativeClamp = typeof(element.style.webkitLineClamp) != 'undefined',
      clampValue = opt.clamp,
      isCSSValue = clampValue.indexOf && (clampValue.indexOf('px') > -1 || clampValue.indexOf('em') > -1),
      truncationHTMLContainer;

    if (opt.truncationHTML) {
      truncationHTMLContainer = document.createElement('span');
      truncationHTMLContainer.innerHTML = opt.truncationHTML;
    }


// UTILITY FUNCTIONS __________________________________________________________

    /**
     * Return the current style for an element.
     * @param {HTMLElement} elem The element to compute.
     * @param {string} prop The style property.
     * @returns {number}
     */
    function computeStyle(elem, prop) {
      if (!win.getComputedStyle) {
        win.getComputedStyle = function(el, pseudo) {
          this.el = el;
          this.getPropertyValue = function(prop) {
            var re = /(\-([a-z]){1})/g;
            if (prop == 'float') prop = 'styleFloat';
            if (re.test(prop)) {
              prop = prop.replace(re, function () {
                return arguments[2].toUpperCase();
              });
            }
            return el.currentStyle && el.currentStyle[prop] ? el.currentStyle[prop] : null;
          }
          return this;
        }
      }

      return win.getComputedStyle(elem, null).getPropertyValue(prop);
    }

    /**
     * Returns the maximum number of lines of text that should be rendered based
     * on the current height of the element and the line-height of the text.
     */
    function getMaxLines(height) {
      var availHeight = height || element.clientHeight,
        lineHeight = getLineHeight(element);

      return Math.max(Math.floor(availHeight/lineHeight), 0);
    }

    /**
     * Returns the maximum height a given element should have based on the line-
     * height of the text and the given clamp value.
     */
    function getMaxHeight(clmp) {
      var lineHeight = getLineHeight(element);
      return lineHeight * clmp;
    }

    /**
     * Returns the line-height of an element as an integer.
     */
    function getLineHeight(elem) {
      var lh = computeStyle(elem, 'line-height');
      if (lh == 'normal') {
        // Normal line heights vary from browser to browser. The spec recommends
        // a value between 1.0 and 1.2 of the font size. Using 1.1 to split the diff.
        lh = parseInt(computeStyle(elem, 'font-size')) * 1.2;
      }
      return parseInt(lh);
    }


// MEAT AND POTATOES (MMMM, POTATOES...) ______________________________________
    var splitOnChars = opt.splitOnChars.slice(0),
      splitChar = splitOnChars[0],
      chunks,
      lastChunk;

    /**
     * Gets an element's last child. That may be another node or a node's contents.
     */
    function getLastChild(elem) {
      //Current element has children, need to go deeper and get last child as a text node
      if (elem.lastChild.children && elem.lastChild.children.length > 0) {
        return getLastChild(Array.prototype.slice.call(elem.children).pop());
      }
      //This is the absolute last child, a text node, but something's wrong with it. Remove it and keep trying
      else if (!elem.lastChild || !elem.lastChild.nodeValue || elem.lastChild.nodeValue == '' || elem.lastChild.nodeValue == opt.truncationChar) {
        elem.lastChild.parentNode.removeChild(elem.lastChild);
        return getLastChild(element);
      }
      //This is the last child we want, return it
      else {
        return elem.lastChild;
      }
    }

    /**
     * Removes one character at a time from the text until its width or
     * height is beneath the passed-in max param.
     */
    function truncate(target, maxHeight) {
      if (!maxHeight) {return;}

      /**
       * Resets global variables.
       */
      function reset() {
        splitOnChars = opt.splitOnChars.slice(0);
        splitChar = splitOnChars[0];
        chunks = null;
        lastChunk = null;
      }

      var nodeValue = target.nodeValue.replace(opt.truncationChar, '');

      //Grab the next chunks
      if (!chunks) {
        //If there are more characters to try, grab the next one
        if (splitOnChars.length > 0) {
          splitChar = splitOnChars.shift();
        }
        //No characters to chunk by. Go character-by-character
        else {
          splitChar = '';
        }

        chunks = nodeValue.split(splitChar);
      }

      //If there are chunks left to remove, remove the last one and see if
      // the nodeValue fits.
      if (chunks.length > 1) {
        // console.log('chunks', chunks);
        lastChunk = chunks.pop();
        // console.log('lastChunk', lastChunk);
        applyEllipsis(target, chunks.join(splitChar));
      }
      //No more chunks can be removed using this character
      else {
        chunks = null;
      }

      //Insert the custom HTML before the truncation character
      if (truncationHTMLContainer) {
        target.nodeValue = target.nodeValue.replace(opt.truncationChar, '');
        element.innerHTML = target.nodeValue + ' ' + truncationHTMLContainer.innerHTML + opt.truncationChar;
      }

      //Search produced valid chunks
      if (chunks) {
        //It fits
        if (element.clientHeight <= maxHeight) {
          //There's still more characters to try splitting on, not quite done yet
          if (splitOnChars.length >= 0 && splitChar != '') {
            applyEllipsis(target, chunks.join(splitChar) + splitChar + lastChunk);
            chunks = null;
          }
          //Finished!
          else {
            return element.innerHTML;
          }
        }
      }
      //No valid chunks produced
      else {
        //No valid chunks even when splitting by letter, time to move
        //on to the next node
        if (splitChar == '') {
          applyEllipsis(target, '');
          target = getLastChild(element);

          reset();
        }
      }

      //If you get here it means still too big, let's keep truncating
      if (opt.animate) {
        setTimeout(function() {
          truncate(target, maxHeight);
        }, opt.animate === true ? 10 : opt.animate);
      }
      else {
        return truncate(target, maxHeight);
      }
    }

    function applyEllipsis(elem, str) {
      elem.nodeValue = str + opt.truncationChar;
    }


// CONSTRUCTOR ________________________________________________________________

    if (clampValue == 'auto') {
      clampValue = getMaxLines();
    }
    else if (isCSSValue) {
      clampValue = getMaxLines(parseInt(clampValue));
    }

    var clampedText;
    if (supportsNativeClamp && opt.useNativeClamp) {
      sty.overflow = 'hidden';
      sty.textOverflow = 'ellipsis';
      sty.webkitBoxOrient = 'vertical';
      sty.display = '-webkit-box';
      sty.webkitLineClamp = clampValue;

      if (isCSSValue) {
        sty.height = opt.clamp + 'px';
      }
    }
    else {
      var height = getMaxHeight(clampValue);
      if (height <= element.clientHeight) {
        clampedText = truncate(getLastChild(element), height);
      }
    }

    return {
      'original': originalText,
      'clamped': clampedText
    }
  }

  window.$clamp = clamp;
})();

var DSTAPI2     = DSTAPI2         || {};
/**
 * DSTAPI is an interface to the various stats tracking packages out there,
 * it provides its flexibility by allowing you to plug multiple engines
 * into the interface to provide multiple tracking engines by one call
 * it also provides flexibility by allowing you to swap out all your
 * tracking code for newer versions if a provider changes their interface.
 */
DSTAPI2.Core = (function() {
	var bDebug = false;
	/**
	 * Contains all the engines that are called when a call command is made.
	 *
	 * To add an engine to this list please use addEngine after you have
	 * included the DSTAPI library, there is no need to modify this code
	 * anymore.
	 *
	 * @type {Array}
	 */
	var aEngines = [];
	/**
	 * Adds an engine to the callable list, see example above for creating
	 * an engine to be passed in.
	 *
	 * @param Engine
	 * @param oOptions
	 */
	function addEngine( Engine , oOptions ){
		if( typeof Engine == 'function' ) {
			aEngines.push( Engine( oOptions ) );
		}
		else {
			error('Engine must be a callable function, please check documentation for an example.');
		}
	}

	/**
	 * Adds a plugin to the system, please see the documentation for the
	 * format to follow for this plugin.
	 *
	 * @param Plugin
	 */
	function addPlugin( Plugin ) {
		if( typeof Plugin == 'object' ) {
			if( Plugin.init ) {
				Plugin.init();
			}
			else {
				error('Plugin does not have an init function.');
			}
		}
		else {
			error('Plugins consist of an object with an init property, please check documentation for more information.');
		}
	}

	/**
	 * Generic call that calls the various actions from within an engine,
	 * if the engine does not support an action the call is not made, if
	 * this class is in development mode then it outputs an error to say
	 * that the action does not exist.
	 *
	 * @param sAction
	 * @param oOptions
	 */
	function call( sAction , oOptions ) {
		sAction = sAction || 'page'; // page is the default action.

		var k;
		if( aEngines.length > 0 ) {
			for( k in aEngines ) {
				if( aEngines[k][sAction] ) {
					aEngines[k][sAction]( oOptions );
				}
			}
		}
		else {
			error('No engines were defined, you must specify an engine.');
		}
	}

	/**
	 * Sets the debug status, by default debugging is set to false.
	 *
	 * @param bStatus
	 */
	function debug( bStatus ) {
		bDebug = bStatus;
	}

	/**
	 * Logs a message to the console if it exists.
	 *
	 * @param sMessage
	 */
	function log( sMessage ) {
		if( bDebug && console && console.log ) {
			console.log( sMessage );
		}
	}

	/**
	 * Logs an error to the console if it exists.
	 *
	 * @param sMessage
	 */
	function error( sMessage ) {
		if( bDebug && console && console.error ) {
			console.error( sMessage );
		}
	}

	/**
	 * Returns the publicly accessible methods.
	 */
	return {
		"addEngine": addEngine,
		"addPlugin": addPlugin,
		"call": call,
		"debug": debug
	};
})();

/**
 * Below are the helper aliases for the DSTAPI2 Library, this helps to ensure
 * that the developers using this library do not have to call DSTAPI2.Core.*
 * as it is a little inconvenient.
 */
DSTAPI2.addEngine     = DSTAPI2.Core.addEngine;
DSTAPI2.addPlugin     = DSTAPI2.Core.addPlugin;
DSTAPI2.call          = DSTAPI2.Core.call;
DSTAPI2.debug         = DSTAPI2.Core.debug;

function initCommunityPromos($, parentElem) {
    try {
        console.log('init Community Promos');

        parentElem.each(function () {

            $(this).flowtype({
                minimum: 00,
                maximum: 480,
                minFont: 13,
                maxFont: 16,
                fontRatio: 30
            });
        });
    } catch (err) {
        console.log('[ERROR]', err);
    }
};
function initGolfBookingRequestForm($) {
    try {
        console.log('golf booking request form - init');

        function GetUrlParameters() {
            var match,
                pl     = /\+/g,  // Regex for replacing addition symbol with a space
                search = /([^&=]+)=?([^&]*)/g,
                decode = function (s) { return decodeURIComponent(s.replace(pl, " ")); },
                query  = window.location.search.substring(1);

            urlParams = {};
            while (match = search.exec(query))
               urlParams[decode(match[1])] = decode(match[2]);        
        
            return urlParams;
        }
        
        function AssignDefaultValues() {
            var urlParams = GetUrlParameters();
            //console.log('urlParams', urlParams);
            
            // Holes
            if(urlParams["holes"] != undefined) {
                var defaultHoles = urlParams["holes"]; // Sanitize
                //console.log('defaultHoles', defaultHoles);
                $('#Holes input[value="'+defaultHoles+'"]').prop('checked', true);
                $("#Holes input").trigger('change');
            }
                
            // Play Date
            if(urlParams["playdate"] != undefined) {
                var defaultPlaydate = urlParams["playdate"]; // Sanitize
                //console.log('defaultPlaydate', defaultPlaydate);
                $('#PlayDate input').val(defaultPlaydate);
            }
            
            // Tee Off Time
            if(urlParams["time"] != undefined) {
                var defaultTime = urlParams["time"]; // Sanitize
                //console.log('defaultTime', defaultTime);
                $('#TeeOffTime select').val(defaultTime);
            }

            // Players
            if(urlParams["players"] != undefined) {
                var defaultPlayers = urlParams["players"]; // Sanitize
                //console.log('defaultPlayers', defaultPlayers);
                $('#Players select').val(defaultPlayers);
            }
        }
        
        function ResetTeeOffTimeOptionsVisibility() {
            $('#TeeOffTime select option').show();
            $('.teeoff-col .dropdown-menu li').show(); // also hook up for tee off booking widget
            $('.eighteenhole-teetime-note').hide();
        }
        
        function HideTeeOffTimeOptions(times) {
            //console.log('times', times);
            $('.eighteenhole-teetime-note').show();
            $('#TeeOffTime select option').each(function() {
                //console.log("$(this).val()", $(this).val());
                
                if ($.inArray($(this).val(), times) != -1) {
                    if ($(this).is(':selected')) {
                        $('#TeeOffTime select').val("12:30pm");
                    }
                    $(this).hide();
                }
            });

            // also hook up for tee off booking widget
            $('.teeoff-col .dropdown-menu li a').each(function() {
                if($.inArray($(this).data('val'), times) != -1) {
                    $(this).parent().hide();
                }
            });
        }
        
        function BindHolesChangeEvent() {
            $("#Holes input").change(function() {
                if($('#Holes input:checked').val() == 18) {
                    //console.log('hide holes!');
                    HideTeeOffTimeOptions(['01:00pm', '01:30pm', '02:00pm', '02:30pm']);
                } else {
                    //console.log('reset holes!');
                    ResetTeeOffTimeOptionsVisibility();
                }
            });
            
            // also hook up for tee off booking widget
            $(".holes-col .copy").on('DOMSubtreeModified', function() {
                if($(".holes-col .copy").text() == "18 Holes") {
                    //console.log('hide holes!', $(".holes-col .copy").text());
                    HideTeeOffTimeOptions(['01:00pm', '01:30pm', '02:00pm', '02:30pm']);
                } else {
                    //console.log('reset holes!', $(".holes-col .copy").text());
                    ResetTeeOffTimeOptionsVisibility();
                }
            });
        }
        
        function BindAccommodationValueEvent() {
            // Hide field by default
            $("#AccommodationValue").hide();
            
            // Update text field upon changes of Drop Down List
            $("#AccommodationOption select").change(function() {
                var accommodationValue = $("#AccommodationOption select option:selected").text();
                $("#AccommodationValue input").val(accommodationValue);
            });
        }
        
        //-- INIT
        BindHolesChangeEvent();                     // Set Available Tee Off Time Depends on selected Holes
        if($('.body-booking-request').length > 0) {
            AssignDefaultValues();                  // Set Default Value submitted from Widget
            BindAccommodationValueEvent();          // Set AccommodationValue from another input field
        }
    } catch (err) {
        console.log('[ERROR]', err);
    }
};
function initRaceWeekFAQ($, parentElem) {
    try {
        parentElem.each(function () {

            var accordionTrigger = $('h4', this);
            var accordionTarget = $('p', this);

            //Bind events to triggers
            accordionTrigger.each(function () {

                $(this).click(function () {

                    var target = $(this).next(accordionTarget);

                    if ($(this).hasClass('active')) {

                        $(this).removeClass('active');

                        //CLOSE TARGET SUBNAV
                        target.animate({

                            height: "toggle"

                        }, 250, function () {
                            // Animation complete.
                            target.removeClass('active');
                        });

                    } else {
                        $('h4.active').removeClass('active');
                        $(this).addClass('active');

                        //CLOSE THE ACTIVE SUBNAV
                        var activeTarget = parentElem.find('p.active');
                        activeTarget.animate({

                            height: "toggle"

                        }, 250, function () {
                            // Animation complete.
                            activeTarget.removeClass('active');
                        });

                        //OPEN TARGET SUBNAV
                        target.animate({
                            height: "toggle"

                        }, 250, function () {
                            // Animation complete.
                            target.addClass('active');
                        });

                    }

                    return false;

                });
            });
        });

    } catch (err) {
        console.log('[ERROR]', err);
    }
};
+function ($) {
    //Use this helper to take the content message and wrap
    //mentions, hashtags and URLs in a <span> for styling
    //purposes - also trims string to char limit
    var charLimit = 120;
    Handlebars.registerHelper("textWrap", function (message) {
        /*
        //Trim the message string first
        messageLength = message.length;
        if (  messageLength >  charLimit ){
            var stripAmount = messageLength - charLimit;
            trimContent = message.substring(0, (message.length - stripAmount))+'...';
        } else {
            trimContent = message;
        }
        */
        var trimContent = message;

        //Wrapt hash tags and @ symbols in spans for styling
        var combinedRegex = /([@#][a-z0-9_]+)/gi;
        var output = trimContent.replace(combinedRegex, '<span>$1</span>')

        return output;
    });

    Handlebars.registerHelper("textTrim", function (text) {

        //Trim the message string first
        originalLength = text.length;

        if (originalLength > 64) {

            var stripAmount = originalLength - 64;

            trimmedText = text.substring(0, (text.length - stripAmount)) + '...';

        } else {
            trimmedText = text;
        }

        return trimmedText;
    });

    //Returns a class based on simple count
    //colour classes do not match count - intentionally
    var colorCount = 1;

    Handlebars.registerHelper("instagramColourClass", function (message) {
        if (colorCount == 1) {

            colorCount++;
            return 'secondary-two';

        } else if (colorCount == 2) {

            colorCount++;
            return 'secondary-three';

        } else {

            colorCount = 1;
            return 'secondary-four';
        }
    });

    var themeCount = 1;

    Handlebars.registerHelper("instagramThemeClass", function (message) {
        if (themeCount++ % 2 == 0)
            return 'img-top';
        return 'img-bottom';
    });

    // Mimic the above code for similar effect for community items
    var communityColorCount = 0;

    Handlebars.registerHelper("communityColourClass", function (message) {
        var colourClass = "";
        /*** Item colour changer similar to Instagram. This is currently disabled and can be toggled on when ready to use it.
        if(communityColorCount % 4 == 0) {
            colourClass = '';
        } else if(communityColorCount % 4 == 1) {
            colourClass = 'secondary-two';
        } else if(communityColorCount % 4 == 2) {
            colourClass = 'secondary-three';
        } else if(communityColorCount % 4 == 3) {
            colourClass = 'secondary-four';
        }
        communityColorCount++;
        */
        return colourClass;
    });

    var MapTemplates = function (level) {

        var buffer = buffer || {};

        $.map(level, function (data, name) {

            if (typeof data !== "string")
                buffer[name] = MapTemplates(data);
            else
                buffer[name] = Handlebars.compile(data);
        });

        return buffer;
    };

    window.templates = {

        stackla_small: {
            slide:     '<div class="slide col-lg-12 no-pad"></div>',
            instagram: '<div class="social-col">' +
                       '  <div class="social-item instagram {{instagramThemeClass}} {{instagramColourClass}}">' +
                       '    <div class="content">' +
                       '      <span class="icon"></span>' +
                       '      <p class="date">{{source_created_at_label}}</p>' +
                       '      <p class="copy">{{{textWrap message}}}</p>' +
                       '      <div class="author">' +
                       '        <div class="author-img">' +
                       '          <img src="{{avatar}}" alt="{{user}}" />' +
                       '        </div>' +
                       '        <p class="author-name">{{user}}</p>' +
                       '      </div>' +
                       '    </div>' +
                       '    <div class="img">' +
                       '      <img class="img-responsive" src="{{image}}" alt="{{{message}}}">' +
                       '    </div>' +
                       '  </div>' +
                       '</div>',
            twitter:   '<div class="social-col">' +
                       '  <div class="social-item no-img twitter">' +
                       '    <div class="content">' +
                       '      <span class="icon"></span>' +
                       '      <span class="icon"></span>' +
                       '      <p class="date">{{source_created_at_label}}</p>' +
                       '      <p class="copy">{{{textWrap message}}}</p>' +
                       '      <div class="author">' +
                       '        <div class="author-img">' +
                       '          <img src="{{avatar}}" alt="{{{message}}}" />' +
                       '        </div>' +
                       '        <p class="author-name">{{user}}</p>' +
                       '      </div>' +
                       '    </div>' +
                       '  </div>' +
                       '</div>',
        },

        stackla_large: {
            instagram: '<div class="slide col-lg-12 no-pad">' +
                       '  <div class="social-col">' +
                       '    <div class="social-item instagram {{instagramThemeClass}} {{instagramColourClass}}">' +
                       '      <div class="content">' +
                       '        <span class="icon"></span>' +
                       '        <p class="date">{{source_created_at_label}}</p>' +
                       '        <p class="copy">{{textWrap message}}</p>' +
                       '        <div class="author">' +
                       '          <div class="author-img">' +
                       '            <img src="{{avatar}}" alt="{{user}}" />' +
                       '          </div>' +
                       '          <p class="author-name">{{user}}</p>' +
                       '        </div>' +
                       '      </div>' +
                       '      <div class="img">' +
                       '        <img class="img-responsive" src="{{image}}" alt="{{message}}">' +
                       '      </div>' +
                       '    </div>' +
                       '  </div>' +
                       '</div>',
            twitter: '<div class="slide col-lg-12 no-pad">' +
                       '  <div class="social-col">' +
                       '    <div class="social-item no-img twitter">' +
                       '      <div class="content">' +
                       '        <span class="icon"></span>' +
                       '        <span class="icon"></span>' +
                       '        <p class="date">{{source_created_at_label}}</p>' +
                       '        <p class="copy">{{textWrap message}}</p>' +
                       '        <div class="author">' +
                       '          <div class="author-img">' +
                       '            <img src="{{avatar}}" alt="{{message}}" />' +
                       '          </div>' +
                       '          <p class="author-name">{{user}}</p>' +
                       '        </div>' +
                       '      </div>' +
                       '    </div>' +
                       '  </div>' +
                       '</div>',
            sta_feed:  'BLOGPOST',
        },

        socialModules: {

            instaGram: {
                imageTop: '<div class="social-item {{source}} {{instagramColourClass}}">' +
                                    '<div class="inner">' +
                                        '<div class="image">' +
                                            '<img class="img-responsive" src="{{image}}" data-placeholder="800x600">' +
                                        '</div>' +
                                        '<div class="content">' +
                                            '<span class="icon icon-instagram"></span>' +

                                            '<p class="date">{{source_created_at_label}}</p>' +

                                            '<p class="message">{{{textWrap message}}}</p>' +
                                            //'{{message}}'+

                                            '<div class="author">' +
                                                '<div class="author-img">' +
                                                    '<img class="img-responsive" src="{{avatar}}">' +
                                                '</div>' +
                                                '<div class="author-name"><p>{{user}}</p></div>' +
                                            '</div>' +


                                        '</div>' +
                                    '</div>' +
                                '</div>',

                imageBottom: '<div class="social-item {{source}} {{instagramColourClass}}">' +
                                    '<div class="inner">' +
                                        '<div class="content">' +
                                            '<span class="icon icon-instagram"></span>' +

                                            '<p class="date">{{source_created_at_label}}</p>' +

                                            '<p class="message">{{{textWrap message}}}</p>' +
                                            //'{{message}}'+

                                            '<div class="author">' +
                                                '<div class="author-img">' +
                                                    '<img class="img-responsive" src="{{avatar}}">' +
                                                '</div>' +
                                                '<div class="author-name"><p>{{user}}</p></div>' +
                                            '</div>' +

                                        '</div>' +
                                        '<div class="image">' +
                                            '<img class="img-responsive" src="{{image}}" data-placeholder="800x600">' +
                                        '</div>' +
                                    '</div>' +
                                '</div>'
            },

            twitter: '<div class="social-item {{source}}">' +
                                    '<div class="inner">' +
                                        '<div class="content">' +

                                            '<span class="icon icon-twitter"></span>' +

                                            '<p class="date">{{source_created_at_label}}</p>' +

                                            '<p class="message">{{{textWrap message}}}</p>' +

                                            '<div class="author">' +
                                                '<div class="author-img">' +
                                                    '<img class="img-responsive" src="{{avatar}}">' +
                                                '</div>' +
                                                '<div class="author-name"><p>{{user}}</p></div>' +
                                            '</div>' +

                                        '</div>' +
                                    '</div>' +
                                '</div>',

            communityLarge: '<div class="social-item community large {{source}} {{communityColourClass}}" data-date="{{source_created_at_datetime}}">' +
                                    '<div class="inner">' +
                                        '<div class="image">' +
                                            '<img class="img-responsive" src="{{image}}" data-placeholder="800x600">' +
                                        '</div>' +
                                        '<div class="content">' +
                                            '<p class="date">{{source_created_at_label}}</p>' +
                                            '<p class="desc"><a class="primary-link" href="{{original_url}}">{{{textWrap message}}}</a></p>' +
                                            '<div class="author">' +
                                                '<div class="author-img">' +
                                                    '<img class="img-responsive" src="{{avatar}}">' +
                                                '</div>' +
                                                '<div class="author-name"><p>{{user}}</p></div>' +
                                            '</div>' +
                                            '<div class="comments">' +
                                                '<span>&nbsp;</span>' +
                                            '</div>' +
                                        '</div>' +
                                    '</div>' +
                                '</div>',

            communitySmall: '<div class="social-item community small {{source}} {{communityColourClass}}" data-date="{{source_created_at_datetime}}">' +
                                    '<div class="inner">' +
                                        '<div class="image">' +
                                            '<img class="img-responsive" src="{{image}}" data-placeholder="800x600">' +
                                        '</div>' +
                                        '<div class="content">' +
                                            '<p class="date">{{source_created_at_label}}</p>' +
                                            '<p class="desc"><a class="primary-link" href="{{original_url}}">{{{textWrap message}}}</a></p>' +
                                            '<div class="author">' +
                                                '<div class="author-img">' +
                                                    '<img class="img-responsive" src="{{avatar}}">' +
                                                '</div>' +
                                                '<div class="author-name"><p>{{user}}</p></div>' +
                                            '</div>' +
                                            '<div class="comments">' +
                                                '<span>&nbsp;</span>' +
                                            '</div>' +
                                        '</div>' +
                                    '</div>' +
                                '</div>',

            imageFeature: '<div class="social-item image-feature {{source}}" data-date="{{source_created_at_datetime}}">' +
                                    '<div class="inner">' +
                                        '<div class="image">' +
                                            '<a href="{{click_through}}">' +
                                                '<img class="img-responsive" src="{{image}}" data-placeholder="800x600">' +
                                            '</a>' +
                                        '</div>' +
                                    '</div>' +
                                '</div>',

        },

        favouritesModule: {
            listingItem: '<div class="favourite" data-node-id="{{NodeId}}" data-doc-type="{{DocumentType}}">' +
                                    '<div class="thumbnail">' +
                                        '<img class="img-responsive" src="{{ImageUrl}}" data-placeholder="136x120" width="136" height="120">' +
                                    '</div>' +
                                    '<div class="content-column">' +
                                        '<div class="info">' +
                                            '<p class="document-name">{{DocumentName}}</p>' +
                                            '<p class="short-description">{{textTrim ShortDescription}}</p>' +
                                        '</div>' +
                                        '<div class="operators">' +
                                            '<a class="btn {{ButtonClass}}" href="{{ButtonUrl}}">{{ButtonText}}</a>' +
                                            '<a class="remove" data-node-id="{{NodeId}}" href="#">Remove</a>' +
                                        '</div>' +
                                    '</div>' +
                                '</div>'
        },

        aFeature: {
            slide: '<li>' +
                        '<img class="img-responsive" src="{{ResourceUrl}}" alt="">' +
                    '</li>'
        }
    };

    window.compiledTemplates = MapTemplates(templates);
}(jq111);
+function ($) {

    $.namespace('HamiltonIsland', {
        InitAccommodationGallery: function (settings) {
            console.log('HamiltonIsland.WebParts.Accommodation.InitAccommodationGallery', settings);

            this.each(function () {

                var galleryRow = $('.gallery-row', this);

                var imgSlide = $(this).find('.slide');
                if (imgSlide.length > 1) {

                    galleryRow.flexslider({
                        selector: '.slide-wrapper .slide',
                        animation: 'slide',
                        animationSpeed: 800,
                        animationLoop: true,
                        controlNav: true,
                        directionNav: true,
                        slideshow: false,
                        prevText: '',
                        nextText: '',
                        touch: true,
                        pauseOnHover: true,

                        start: function (slider) {
                            galleryRow.animate({ opacity: 1 }, 1000, function () { });
                        }
                    });

                }
            });
        }
    });

    $(document).ready(function () {
        $('.accommodation-gallery').HamiltonIsland().InitAccommodationGallery();
    });

}(jq111);
+function ($) {

    $.namespace('HamiltonIsland', {
        InitActivityGuide: function (settings) {
            console.log('HamiltonIsland.WebParts.ActivityGuide.InitActivityGuide', settings);

            this.each(function () {

                //FlexSlider calls
                var guideSlide = $(this).find('.slide');

                if (guideSlide.length > 1) {

                    $(this).addClass('this');

                    $('.slide-container', $(this)).flexslider({
                        selector: '.slide-wrapper .slide',
                        animation: 'slide',
                        animationLoop: false,
                        directionNav: false,
                        slideshow: false,
                        touch: true
                    });
                }

                //Flowtype init
                $(this).flowtype({
                    minimum: 0,
                    maximum: 480,
                    minFont: 12,
                    maxFont: 16,
                    fontRatio: 18
                });
            });
        }
    });

    $(document).ready(function () {
        $('.activity-guides').HamiltonIsland().InitActivityGuide();
    });

}(jq111);
+function ($) {

    $.namespace('HamiltonIsland', {
        InitBlogPostListing: function (settings) {
            console.log('HamiltonIsland.WebParts.BlogPost.InitBlogPostListing', settings);

            this.each(function () {
                // Arrange
                var blogListingElem = $(this);
                var blogPostsWrapperElem = $(this).find('.posts').first();
                var blogPaginationElem = $(this).find('.pagination');
                var pageSize = blogPostsWrapperElem.data('page-size');
                blogPostsWrapperElem.data('current-page', 1);

                // Binding
                blogPaginationElem.on('click', '.page-item', function () {
                    blogPostsWrapperElem.data('current-page', $(this).data('page-index'));  // Update current page number
                    updatePaginationDisplay(blogPaginationElem, blogPostsWrapperElem.data('current-page')); // Update pagination display
                    displayBlogsPage(blogPostsWrapperElem, blogPostsWrapperElem.data('current-page')); // Update display items
                });

                blogPaginationElem.on('click', '.arrow-item', function () {
                    var currentPage = blogPostsWrapperElem.data('current-page');
                    var targetPage = $(this).hasClass('left-arrow-item') ? currentPage - 1 : currentPage + 1;
                    blogPaginationElem.find('.page-item[data-page-index="' + targetPage + '"]').trigger('click'); // Delegate to another event
                });

                // Init 
                blogPaginationElem.find('.page-item[data-page-index="' + blogPostsWrapperElem.data('current-page') + '"]').trigger('click');
            });
        }
    });

    function displayBlogsPage(blogPostsWrapperElem, currentPage) {
        //blogPostsWrapperElem.hide(); // Hide posts wrapper
        //console.log('hide wrapper');

        blogPostsWrapperElem.find('.post-item').hide(); // Hide all blog post items
        blogPostsWrapperElem.find('.post-item[data-page-index="' + currentPage + '"]').show(); // Show posts that are within the target page
        
        //blogPostsWrapperElem.show(); // Show posts wrapper
        //console.log('show wrapper');
    }

    function updatePaginationDisplay(paginationElem, currentPage) {
        paginationElem.find('.item').removeClass('active').removeClass('disabled');  // Reset markings
        paginationElem.find('.page-item[data-page-index="' + currentPage + '"]').addClass('active'); // Set current page

        if (paginationElem.find('.page-item:first').hasClass('active')) { // Disable left arrow when at first page
            paginationElem.find('.left-arrow-item').addClass('disabled');
        }

        if (paginationElem.find('.page-item:last').hasClass('active')) { // Disable right arrow when at last page
            paginationElem.find('.right-arrow-item').addClass('disabled');
        }
    }

    $(document).ready(function () {
        $('.blog-listing').HamiltonIsland().InitBlogPostListing();
        $('.media-release-listing').HamiltonIsland().InitBlogPostListing(); //TODO: 'Media Release' webparts are piggybacking client side script from 'Blog Post'
    });

}(jq111);
+function ($) {
    Date.prototype.AddDays = function (noOfDays) {
        var buffer = new Date(this);
        buffer.setTime(buffer.getTime() + (noOfDays * (1000 * 60 * 60 * 24)));
        return buffer;
    };

    function parseDate(input, separator) {
        var parts = input.split(separator);

        // new Date(year, month [, day [, hours[, minutes[, seconds[, ms]]]]])
        // Months are 0-based

        if (parts[0].length == 4) // yyyy/mm/dd
            return new Date(parts[0], parts[1] - 1, parts[2]);
        else // dd/mm/yyyy
            return new Date(parts[2], parts[1] - 1, parts[0]);
    }

    Date.prototype.GetDateInputFormat = function () {
        var date = new Date(this);

        var day = date.getDate();
        var month = date.getMonth() + 1;
        var dateInputValue = date.getFullYear() + "-" + (month < 10 ? "0" + month : month) + "-" + (day >= 9 ? day : "0" + day);

        return dateInputValue;
    };

    var monthShortNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    var currentUSPIndex = 0;
    var usps = [
        {
            Text: "Best Price Guarantee!",
            Url: "https://www.hamiltonisland.com.au/accommodation/why-book-direct",
            ShowInAdultsOnlyHotel: true
        },
        {
            Text: "Flexible cancellations",
            Url: "https://www.hamiltonisland.com.au/accommodation/why-book-direct",
            ShowInAdultsOnlyHotel: true
        },
        {
            Text: "Kids stay and eat free*",
            Url: "https://www.hamiltonisland.com.au/things-to-do/kids-eat-free",
            ShowInAdultsOnlyHotel: false
        },
        {
            Text: "Free non-motorised watersports",
            Url: "https://www.hamiltonisland.com.au/water-activities/non-motorised-watersports-equipment",
            ShowInAdultsOnlyHotel: true
        }
    ];

    function UpdateUSP() {

        var adultOnlyHotel = $(".booking-widget-header-dual").attr("data-adults-only") == "1";

        if (!adultOnlyHotel) {
            currentUSPIndex = (++currentUSPIndex) % usps.length;
        }
        else {
            var uspFound = false;
            do {
                currentUSPIndex = (++currentUSPIndex) % usps.length;
                if (usps[currentUSPIndex].ShowInAdultsOnlyHotel) {
                    uspFound = true;
                }
            }
            while (!uspFound);
        }

        $(".custom-col .supporting-text").fadeOut(500, function () {
            $(this).html(usps[currentUSPIndex].Text).attr("href", usps[currentUSPIndex].Url).attr("data-event-value", usps[currentUSPIndex].Text);
            $(".custom-col .supporting-text").fadeIn(500);
        });
    }

    var loadCount = 0;
    $.namespace('HamiltonIsland', {
        InitHolidayHome: function (settings) {
            console.log('HamiltonIsland.WebParts.Booking.InitHolidayHome', settings);

            this.each(function () {
                var parentElem = $(this);
                //Define DOM elements
                //Accordion elements
                var accordionTrigger = parentElem.find('.booking-widget-mobile-trigger');
                var accordionTarget = parentElem.find('.booking-widget-wrap');

                //Inputs and buttons
                var calendarOption = parentElem.find('.option.calendar');
                var arriveInput = parentElem.find('.arrival-date');
                var arriveIcon = arriveInput.next('.add-on');
                var departInput = parentElem.find('.departure-date');
                var departIcon = departInput.next('.add-on');
                var dateInput = calendarOption.find('input[type=date]');
                var textInput = calendarOption.find('input[type=text]');
                var submitBtn = parentElem.find('.booking-submit');

				var arriveDate = parentElem.find('.arrive input').data('default-date');
				var departDate = parentElem.find('.depart input').data('default-date');

				var nightsStay = parentElem.find('.booking-property-nights');
				var guests = parentElem.find('.booking-property-guests');
				var bedrooms = parentElem.find('.booking-property-bedrooms');

                //Property search input - only present in dual view
                var search = false;
                var searchInput = null;

                if (parentElem.find('input.property-search').length > 0){
                    search = true;
                    searchInput = parentElem.find('input.property-search');
                }

                //Dropdown Elems
                var dropdownOption = parentElem.find('.option.dropdown');
                var listLink = dropdownOption.find('.dropdown-menu a');

                var propertyHotel = parentElem.find('.booking-property-hotel');
				var propertyBookingUrl = parentElem.find('.booking-property-url');

                var selectedValues = new Object();
                
                //Bind accordion open / close to trigger
                if (accordionTrigger.length > 0){
                    accordionTrigger.click(function (e) {
                        if (accordionTarget.hasClass('open')) {
                            parentElem.removeClass('open');
                            accordionTarget.hide();
                            accordionTarget.removeClass('open');

                        } else {
                            parentElem.addClass('open');
                            accordionTarget.show();
                            accordionTarget.addClass('open');
                        }
                        e.preventDefault();
                    });
                }

                if (/iPad/i.test(navigator.userAgent)) {
                    $('#holidayHomesCheckInTitleLabel,#holidayHomesCheckInDateDisplay').click(function () {
                        $('#holidayHomesCheckInDate').datepicker("show");
                    });
                    $('#holidayHomesCheckOutTitleLabel,#holidayHomesCheckOutDateDisplay').click(function () {
                        $('#holidayHomesCheckOutDate').datepicker("show");
                    });
                }

                var numberOfCalendarMonths = 2;
                //Detect mobile devices - not checking for touch devices as this will include any device that supports touch.
                if (/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                    numberOfCalendarMonths = 1;
                    /*textInput.remove();
                    dateInput.show();

                    $('#hihhCheckInDateMobile').change(function () {
                        var dateComponents = $('#hihhCheckInDateMobile').val().split('-');
                        var checkInDate = new Date(dateComponents[0], dateComponents[1] - 1, dateComponents[2]);

                        var checkOutDate = checkInDate.AddDays(4);
                        $('#hihhCheckOutDateMobile').val(checkOutDate.GetDateInputFormat());
                    });
                    $('#hihhCheckOutDateMobile').change(function () {
                        var dateComponents = $('#hihhCheckInDateMobile').val().split('-');
                        var checkInDate = new Date(dateComponents[0], dateComponents[1] - 1, dateComponents[2]);

                        dateComponents = $('#hihhCheckOutDateMobile').val().split('-');
                        var checkOutDate = new Date(dateComponents[0], dateComponents[1] - 1, dateComponents[2]);

                        if (checkOutDate <= checkInDate) {
                            var updatedCheckInDate = checkOutDate.AddDays(-4);
                            $('#hihhCheckInDateMobile').val(updatedCheckInDate.GetDateInputFormat());
                        }
                    });
                    */
                }
                //} else {

                    dateInput.remove();
                    textInput.show();

				var defaultCheckInDate = new Date(arriveDate);
				var defaultCheckOutDate = new Date(departDate);

				//var defaultCheckInDate = new Date().AddDays(14);
				
                    var checkInDate = defaultCheckInDate.getDate();
                    $('#holidayHomesCheckInDateDisplay .display-day').html(checkInDate >= 10 ? checkInDate : "0" + checkInDate);
                    $('#holidayHomesCheckInDateDisplay .display-month').html(monthShortNames[defaultCheckInDate.getMonth()]);

                    //var defaultCheckOutDate = defaultCheckInDate.AddDays(5);
                    var checkOutDate = defaultCheckOutDate.getDate();
                    $('#holidayHomesCheckOutDateDisplay .display-day').html(checkOutDate >= 10 ? checkOutDate : "0" + checkOutDate);
                    $('#holidayHomesCheckOutDateDisplay .display-month').html(monthShortNames[defaultCheckOutDate.getMonth()]);

                    arriveInput.datepicker({
                        defaultDate: defaultCheckInDate,
                        numberOfMonths: numberOfCalendarMonths,
                        dateFormat: "dd/mm/yy",
                        showButtonPanel: false,
                        minDate: new Date().AddDays(1),
                        onSelect: function() {

                            var departInputCal = parentElem.find('.departure-date');

                            var selectedDate = arriveInput.datepicker('getDate');
                            var date = selectedDate.getDate();
                            $('#holidayHomesCheckInDateDisplay .display-day').html(date >= 10 ? date : "0" + date);
                            $('#holidayHomesCheckInDateDisplay .display-month').html(monthShortNames[selectedDate.getMonth()]);

							var departureDate = selectedDate.AddDays(nightsStay.val());
                            $('#holidayHomesCheckOutDateDisplay .display-day').html(departureDate.getDate() >= 10 ? departureDate.getDate() : "0" + departureDate.getDate());
                            $('#holidayHomesCheckOutDateDisplay .display-month').html(monthShortNames[departureDate.getMonth()]);

                            setTimeout(function(){

                                departInputCal.datepicker('option', 'minDate', selectedDate.AddDays(1));
                                departInputCal.datepicker('setDate', departureDate);
                                departInputCal.datepicker('show');

                            }, 10);
                        }
                    });

                    departInput.datepicker({
                        defaultDate: defaultCheckOutDate,
                        numberOfMonths: numberOfCalendarMonths,
                        dateFormat: "dd/mm/yy",
                        showButtonPanel: false,
                        minDate: new Date().AddDays(2),
                        onSelect: function () {
                            var selectedDate = departInput.datepicker('getDate');
                            var date = selectedDate.getDate();
                            $('#holidayHomesCheckOutDateDisplay .display-day').html(date >= 10 ? date : "0" + date);
                            $('#holidayHomesCheckOutDateDisplay .display-month').html(monthShortNames[selectedDate.getMonth()]);
                        }
                    });
                //}

                //Bind click events to dropdown list
                //When user clicks the link in dropdown, grab the value
                //and set the toggle text to be equal to that value
                listLink.click(function (e) {

                    selectedText = $(this).html();
                    selectedVal = $(this).data('val');
                    selectedField = $(this).data('field');

                    selectedValues[selectedField] = selectedVal;

                    //Set the parents text
                    $(this).parents('.dropdown').find('.copy').html(selectedText);

                    e.preventDefault();
                });

                submitBtn.click(function (e) {

                    var arriveDate = parentElem.find('.arrive input').val();
                    var departDate = parentElem.find('.depart input').val();

                    var arriveDateParsed = new Date();
                    var departDateParsed = new Date();
                    //if (/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                        arriveDateParsed = parseDate(arriveDate, "-");
                        departDateParsed = parseDate(departDate, "-");
                    //}
                    //else
                    //{
                        arriveDateParsed = parseDate(arriveDate, "/");
                        departDateParsed = parseDate(departDate, "/");
                    //}

                    var currentDate = new Date();
                    var defaultArrivedDate = new Date(2020, 7, 1);
                    var defaultDeptDate = defaultArrivedDate.AddDays(5);

                    if (currentDate >= defaultArrivedDate) {
                        defaultArrivedDate = new Date().AddDays(14);
                        defaultDeptDate = defaultArrivedDate.AddDays(5);
                    }
                    var arriveMoment = moment(defaultArrivedDate);
                    if (arriveDateParsed != 'Invalid Date') {
                        arriveMoment = moment(arriveDateParsed);
                        defaultDeptDate = arriveDateParsed.AddDays(5);
                    }

                    var departMoment = moment(defaultDeptDate);
                    if (departDateParsed != 'Invalid Date')
                        departMoment = moment(departDateParsed);

                    arriveDate = arriveMoment.format('YYYY-MM-DD');
                    departDate = departMoment.format('YYYY-MM-DD');

                    var selectedBedrooms = bedrooms.val();
					if (selectedValues['bedrooms'] != undefined && selectedValues['bedrooms'] !== "") selectedBedrooms = selectedValues['bedrooms'];

                    var selectedGuests = guests.val();
					if (selectedValues['guests'] != undefined && selectedValues['guests'] !== "") selectedGuests = selectedValues['guests'];
					
                    //If search is true, grab the search value from the input
                    //search string or default propertyHotel
                    var searchValue = parentElem.find('input.property-search').val();
                    
                    var BookingUrl = propertyBookingUrl.val() + "?" +
						"Bedrooms=" + parseInt(selectedBedrooms) +
						"&Guests=" + parseInt(selectedGuests) +
                        "&CheckinDate=" + arriveDate +
						"&CheckoutDate=" + departDate;

					if (searchValue !== "") BookingUrl += "&SearchText=" + searchValue;
					
                    //TRACKING IMPLEMENTATION

                    var moduleContainer = $(this).parents(".module");

                    if (
                        moduleContainer.hasClass("booking-widget-header") ||
                        moduleContainer.hasClass("booking-widget-header-dual")
                    ) {
                        DSTAPI2.call('event', {
                            category: 'Purchase Intent',
                            action: 'Accommodation Widget',
                            label: "Top"
                        });
                    }
                    else if (moduleContainer.hasClass("booking-holiday-home-widget")) {
                        DSTAPI2.call('event', {
                            category: 'Purchase Intent',
                            action: 'Holiday Home Widget',
                            label: "Mid-Page"
                        });
                    }

                    //Adding GA cross domain tracking
                    var clientIds = "";
                    ga(function (tracker) {
                        clientIds = tracker.get('linkerParam');
                    });
                    //Appending GA to the url
                    if (clientIds !== "") {
                        BookingUrl = BookingUrl + "&" + clientIds;
                    }
                    //END TRACKING IMPLEMENTATION

                    window.location = BookingUrl;
                    e.preventDefault();
                });
            });
        },
        InitBookingWidget: function (settings) {
            console.log('HamiltonIsland.WebParts.Booking.InitBookingWidget', settings);

            this.each(function () {
                var parentElem = $(this);
                //Define DOM elements
                //Accordion elements
                var accordionTrigger = parentElem.find('.booking-widget-mobile-trigger');
                var accordionTarget = parentElem.find('.booking-widget-wrap');

                //Inputs and buttons
                var calendarOption = parentElem.find('.option.calendar');
                var arriveInput = parentElem.find('.arrival-date');
                var arriveIcon = arriveInput.next('.add-on');
                var departInput = parentElem.find('.departure-date');
                var departIcon = departInput.next('.add-on');
                var dateInput = calendarOption.find('input[type=date]');
                var textInput = calendarOption.find('input[type=text]');
                var submitBtn = parentElem.find('.booking-submit');

                //Dropdown Elems
                var dropdownOption = parentElem.find('.option.dropdown');
                var listLink = dropdownOption.find('.dropdown-menu a');

                var propertyChain = parentElem.find('.booking-property-chain');
                var propertyShell = parentElem.find('.booking-property-shell');
                var propertyStart = parentElem.find('.booking-property-start');
                var propertyLang = parentElem.find('.booking-property-lang');
                var propertyHotel = parentElem.find('.booking-property-hotel');

				var arriveDate = parentElem.find('.arrive input').data('default-date');
				var departDate = parentElem.find('.depart input').data('default-date');

				var propertyBookingUrl = parentElem.find('.booking-property-url');
				var promoCode = parentElem.find('.booking-property-promo');
				var rateCode = parentElem.find('.booking-property-ratecode');
				var nightsStay = parentElem.find('.booking-property-nights');

                var selectedValues = new Object();

                // Default Hotel Value
                var defaultHotelName = parentElem.find('.hotel .dropdown-toggle .copy').text().trim();
                if (defaultHotelName !== undefined) {
                    defaultHotelElem = parentElem.find('.hotel .dropdown-menu li a:contains("' + defaultHotelName + '")').first();
                    if (defaultHotelElem !== undefined) {
                        selectedValues['hotel'] = defaultHotelElem.data('val');
                    }
                }

                //Bind accordion open / close to trigger
                if (accordionTrigger.length > 0) {
                    accordionTrigger.click(function (e) {
                        if (accordionTarget.hasClass('open')) {
                            parentElem.removeClass('open');
                            accordionTarget.hide();
                            accordionTarget.removeClass('open');


                        } else {
                            parentElem.addClass('open');
                            accordionTarget.show();
                            accordionTarget.addClass('open');
                        }

                        e.preventDefault();
                    });
                }

                if (/iPad/i.test(navigator.userAgent)) {
                    $('#hotelCheckInTitleLabel,#hotelCheckInDateDisplay').click(function () {
                        $('#hotelCheckInDate').datepicker("show");
                    });
                    $('#hotelCheckOutTitleLabel,#hotelCheckOutDateDisplay').click(function () {
                        $('#hotelCheckInDate').datepicker("show");
                    });
                }

                var numberOfCalendarMonths = 2;
                //Detect mobile devices - not checking for touch devices as this will include any device that supports touch.
                if (/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                    numberOfCalendarMonths = 1;
                    /*textInput.remove();
                    dateInput.show();

                    $('#hotelCheckInDateMobile').change(function () {
                        var dateComponents = $('#hotelCheckInDateMobile').val().split('-');
                        var checkInDate = new Date(dateComponents[0], dateComponents[1] - 1, dateComponents[2]);

                        var checkOutDate = checkInDate.AddDays(4);
                        $('#hotelCheckOutDateMobile').val(checkOutDate.GetDateInputFormat());
                    });
                    $('#hotelCheckOutDateMobile').change(function () {
                        var dateComponents = $('#hotelCheckInDateMobile').val().split('-');
                        var checkInDate = new Date(dateComponents[0], dateComponents[1] - 1, dateComponents[2]);

                        dateComponents = $('#hotelCheckOutDateMobile').val().split('-');
                        var checkOutDate = new Date(dateComponents[0], dateComponents[1] - 1, dateComponents[2]);

                        if (checkOutDate <= checkInDate) {
                            var updatedCheckInDate = checkOutDate.AddDays(-4);
                            $('#hotelCheckInDateMobile').val(updatedCheckInDate.GetDateInputFormat());
                        }
                    });
                */
            }
                //} else {

                    dateInput.remove();
                    textInput.show();
				
				//var now = new Date();
				//var dateCheck = new Date(2021, 2, 1);
				//var defaultCheckInDate = new Date(2021, 2, 17); // March 17 2021
				//if (now >= dateCheck)
                //    defaultCheckInDate = new Date().AddDays(14);

				var defaultCheckInDate = new Date(arriveDate);
				var defaultCheckOutDate = new Date(departDate);

                    //var defaultCheckInDate = new Date().AddDays(30);
                    var checkInDate = defaultCheckInDate.getDate();
                    $('#hotelCheckInDateDisplay .display-day').html(checkInDate >= 10 ? checkInDate : "0" + checkInDate);
                    $('#hotelCheckInDateDisplay .display-month').html(monthShortNames[defaultCheckInDate.getMonth()]);

                    //var defaultCheckOutDate = defaultCheckInDate.AddDays(4);
                    var checkOutDate = defaultCheckOutDate.getDate();
                    $('#hotelCheckOutDateDisplay .display-day').html(checkOutDate >= 10 ? checkOutDate : "0" + checkOutDate);
                    $('#hotelCheckOutDateDisplay .display-month').html(monthShortNames[defaultCheckOutDate.getMonth()]);

                    arriveInput.datepicker({
                        defaultDate: defaultCheckInDate,
                        numberOfMonths: numberOfCalendarMonths,
                        dateFormat: "dd/mm/yy",
                        showButtonPanel: false,
                        minDate: new Date().AddDays(1),
                        onSelect: function() {

                            var departInputCal = parentElem.find('.departure-date');

                            var selectedDate = arriveInput.datepicker('getDate');
                            var date = selectedDate.getDate();
                            $('#hotelCheckInDateDisplay .display-day').html(date >= 10 ? date : "0" + date);
                            $('#hotelCheckInDateDisplay .display-month').html(monthShortNames[selectedDate.getMonth()]);

							var departureDate = selectedDate.AddDays(nightsStay.val());
                            $('#hotelCheckOutDateDisplay .display-day').html(departureDate.getDate() >= 10 ? departureDate.getDate() : "0" + departureDate.getDate());
                            $('#hotelCheckOutDateDisplay .display-month').html(monthShortNames[departureDate.getMonth()]);

                            setTimeout(function(){

                                departInputCal.datepicker('option', 'minDate', selectedDate.AddDays(1));
                                departInputCal.datepicker('setDate', departureDate);
                                departInputCal.datepicker('show');

                            }, 10);
                        }
                    });

                    departInput.datepicker({
                        defaultDate: defaultCheckOutDate,
                        numberOfMonths: numberOfCalendarMonths,
                        dateFormat: "dd/mm/yy",
                        showButtonPanel: false,
                        minDate: new Date().AddDays(2),
                        onSelect: function () {

                            var selectedDate = departInput.datepicker('getDate');
                            var date = selectedDate.getDate();
                            $('#hotelCheckOutDateDisplay .display-day').html(date >= 10 ? date : "0" + date);
                            $('#hotelCheckOutDateDisplay .display-month').html(monthShortNames[selectedDate.getMonth()]);
                        }
                    });
                //}

                //Bind click events to dropdown list
                //When user clicks the link in dropdown, grab the value
                //and set the toggle text to be equal to that value
                listLink.click(function (e) {

                    selectedText = $(this).html();
                    selectedVal = $(this).data('val');
                    selectedField = $(this).data('field');

                    selectedValues[selectedField] = selectedVal;

                    //Set the parents text
                    $(this).parents('.dropdown').find('.copy').html(selectedText);

                    e.preventDefault();
                });


                submitBtn.click(function (e) {
                    // [ START: Ensure we always get a valid stay ] //

                    var nights = "";
                    var arriveDate = parentElem.find('.arrive input').val();
                    var departDate = parentElem.find('.depart input').val();

                    var arriveDateParsed = new Date();
                    var departDateParsed = new Date();
                    //if (/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                    //    arriveDateParsed = parseDate(arriveDate, "-");
                    //    departDateParsed = parseDate(departDate, "-");
                    //}
                    //else {
                        arriveDateParsed = parseDate(arriveDate, "/");
                        departDateParsed = parseDate(departDate, "/");
                    //}

					//var currentDate = new Date();
					//var defaultArrivedDate = new Date(2021, 2, 17);
                    //var dateCheck = new Date(2021, 1, 17);
                    //var defaultDeptDate = defaultArrivedDate.AddDays(4);

					//if (currentDate >= dateCheck) {
                    //    defaultArrivedDate = new Date().AddDays(30);
                    //    defaultDeptDate = defaultArrivedDate.AddDays(4);
                    //}

                    //var arriveMoment = moment(defaultArrivedDate);
					var arriveMoment;
					if (arriveDateParsed != 'Invalid Date') {
                        arriveMoment = moment(arriveDateParsed);
                        //defaultDeptDate = arriveDateParsed.AddDays(4);
                    }

                    //var departMoment = moment(defaultDeptDate);
					var departMoment;
                    if (departDateParsed != 'Invalid Date')
                        departMoment = moment(departDateParsed);

                    nights = departMoment.diff(arriveMoment, 'days');
                    arriveDate = arriveMoment.format('YYYY-MM-DD');
                    // [ END: Ensure we always get a valid stay ] //


                    // [ START: Ensure we always get a valid hotel ] //

                    // Load system default
                    var hotelCode = 'Hotel=AllProperties';
                  
                    // Load configured default
                    if (propertyHotel.val() != undefined)
                        hotelCode = 'Hotel=' + propertyHotel.val();

                    // Load dropdown value
                    //console.log('selectedValues', selectedValues);
                    if ((selectedValues['hotel'] != undefined)) {
                        hotelCode = "Hotel=" + selectedValues['hotel'];
                    }

                    // [ END: Ensure we always get a valid hotel ] //

                    var BookingUrl = propertyBookingUrl.val();
                    BookingUrl += (BookingUrl.indexOf('?') > -1) ? '&' : '?';
                    BookingUrl += (propertyChain.val()) ? "chain=" + propertyChain.val() + "&" : '';
                    BookingUrl += (propertyShell.val()) ? "shell=" + propertyShell.val() + "&" : '';
                    BookingUrl += (propertyStart.val()) ? "start=" + propertyStart.val() + "&" : '';
                    BookingUrl += (propertyLang.val()) ? "lang=" + propertyLang.val() + "&" : '';
                    BookingUrl += "arrive=" + arriveDate + "&";
                    BookingUrl += "nights=" + nights + "&";
                    BookingUrl += "adult=" + ((selectedValues['adults'] != undefined) ? selectedValues['adults'] : "2") + "&";
                    BookingUrl += "child=" + ((selectedValues['kids'] != undefined) ? selectedValues['kids'] : "0") + "&";
                    BookingUrl += "infants=" + ((selectedValues['infants'] != undefined) ? selectedValues['infants'] : "0") + "&";

					if (promoCode.val() !== "") {
						BookingUrl += "promo=" + promoCode.val() + "&";
					}

					if (rateCode.val() !== "") {
						BookingUrl += "rate=" + rateCode.val() + "&";
					}

                    // add hotelcode value only if its not already added in BookingUrl from Kentico Admin
                    if (BookingUrl.indexOf("Hotel") == -1) {
                        BookingUrl += hotelCode;
                    }
                   // console.log('BookingUrl', BookingUrl);
                    //Adding GA cross domain tracking
                    var clientIds = "";
                    ga(function (tracker) {
                        clientIds = tracker.get('linkerParam');
                    });
                    //Appending GA to the url
                    if (clientIds !== "") {
                        BookingUrl = BookingUrl + "&" + clientIds;
                    }

                    //TRACKING IMPLEMENTATION

                    var moduleContainer = $(this).parents(".module");

                    if (
                        moduleContainer.hasClass("booking-widget-header-dual") ||
                        moduleContainer.hasClass("booking-widget-header")
                    ) {
                        DSTAPI2.call('event', {
                            category: 'Purchase Intent',
                            action: 'Accommodation Widget',
                            label: "Top"
                        });
                    }
                    else if (
                        moduleContainer.hasClass("booking-widget-in-page") ||
                        moduleContainer.hasClass("booking-widget-in-page-med") ||
                        moduleContainer.hasClass("booking-widget-in-page-large")
                    ) {
                        DSTAPI2.call('event', {
                            category: 'Purchase Intent',
                            action: 'Accommodation Widget',
                            label: "Mid-Page"
                        });
                    }

                    window.location = BookingUrl;

                    e.preventDefault();

                });
            });
        },
        InitBookingWidgetDual: function (settings) {

            this.each(function () {
                console.log('HamiltonIsland.WebParts.Booking.InitBookingWidgetDual', settings);

                //Define elemes
                var parentElem = $(this);
                var toggleTrigger = parentElem.find('.toggle-block .arrows-block');
                var hotelBookingWidget = parentElem.find('.booking-tools.hotels');
                var holidayHomesBookingWidget = parentElem.find('.booking-tools.holiday-homes');

                //Mobile tab triggers
                var mobileTabHotelsTrigger = parentElem.find('.tab.hotels');
                var mobileHolidayHomesTabTrigger = parentElem.find('.tab.holiday-homes');

                //Accordion elements
                var accordionTrigger = parentElem.find('.booking-widget-mobile-trigger');
                var accordionTarget = parentElem.find('.booking-widgets-block');

                //Implement desktop toggle functions
                //toggleTrigger.click(function(){

                //    if (parentElem.attr('data-role') == 'hotels'){
                //        parentElem.attr('data-role', 'holiday-homes');
                //    } else {
                //        parentElem.attr('data-role', 'hotels');
                //    }
                //});

                $(".booking-widget-header-dual .hotels").click(function () {
                    var parentElem = $(this);
                    parentElem.addClass("active-tab");
                    $(".booking-widget-header-dual .holiday-homes").removeClass("active-tab");
                    $(".activetab-hotels").attr('data-role', 'hotels');
                });

                $(".booking-widget-header-dual .holiday-homes").click(function () {
                    var parentElem = $(this);
                    $(".booking-widget-header-dual .hotels").removeClass("active-tab");
                    parentElem.addClass("active-tab");
                    $(".activetab-hotels").attr('data-role', 'holiday-homes');
                });

                //Implement mobile tab functions
                mobileTabHotelsTrigger.click(function(){
                    if ( !mobileTabHotelsTrigger.hasClass('active')){

                        mobileTabHotelsTrigger.addClass('active');
                        mobileHolidayHomesTabTrigger.removeClass('active');
                        parentElem.attr('data-role', 'hotels');

                        parentElem.removeClass('activetab-holiday-homes');
                        parentElem.addClass('activetab-hotels');
                    }

                    return false;
                });

                //Implement mobile tab functions
                mobileHolidayHomesTabTrigger.click(function(){
                    if ( !mobileHolidayHomesTabTrigger.hasClass('active')){

                        mobileHolidayHomesTabTrigger.addClass('active');
                        mobileTabHotelsTrigger.removeClass('active');
                        parentElem.attr('data-role', 'holiday-homes');

                        parentElem.removeClass('activetab-hotels');
                        parentElem.addClass('activetab-holiday-homes');
                    }

                    return false;
                });

                //Init the standard bookwidget (hotels) for child elements in Dual view
                hotelBookingWidget.HamiltonIsland().InitBookingWidget();
                holidayHomesBookingWidget.HamiltonIsland().InitHolidayHome();
                //Bind mobile toggle button
                if (++loadCount <= 1) {
                    accordionTrigger.click(function (e) {
                        if (accordionTarget.hasClass('open')) {
                            parentElem.removeClass('open');
                            accordionTarget.hide();
                            accordionTarget.removeClass('open');
                        } else {
                            parentElem.addClass('open');
                            accordionTarget.show();
                            accordionTarget.addClass('open');
                        }

                        e.preventDefault();
                    });
                }
            });
        }
    });

    $(document).ready(function () {
        $('.booking-holiday-home-widget').HamiltonIsland().InitHolidayHome();
        $('.booking-widget-header').HamiltonIsland().InitBookingWidget();
        $('.booking-widget-header-dual').HamiltonIsland().InitBookingWidgetDual();
        $('.booking-widget-in-page').HamiltonIsland().InitBookingWidget();
        $('.booking-widget-in-page-med').HamiltonIsland().InitBookingWidget();
        $('.booking-widget-in-page-large').HamiltonIsland().InitBookingWidget();

        setInterval(UpdateUSP, 4000);
    });

}(jq111);
+function ($) {

    $.namespace('HamiltonIsland', {
        InitCallToAction: function (settings) {
            console.log('HamiltonIsland.WebParts.CallToAction.InitCallToAction', settings);

            this.flowtype(settings);
        }
    });

    $(document).ready(function () {
        $('.feature-module.large').HamiltonIsland().InitCallToAction({
            minimum: 320,
            maximum: 480,
            minFont: 16,
            maxFont: 40,
            fontRatio: 30
        });

        $('.feature-module.med').HamiltonIsland().InitCallToAction({
            minimum: 320,
            maximum: 480,
            minFont: 12,
            maxFont: 40,
            fontRatio: 20
        });

        $('.feature-module.small').HamiltonIsland().InitCallToAction({
            minimum: 320,
            maximum: 480,
            minFont: 12,
            maxFont: 60,
            fontRatio: 30
        });

        $('.feature-price-module').HamiltonIsland().InitCallToAction({
            minimum: 0,
            maximum: 480,
            minFont: 12,
            maxFont: 16,
            fontRatio: 20
        });
    });

}(jq111);
(function($) {

    $.FavouriteCookie = function() {
    };

    $.FavouriteCookie.prototype = {
        //-- Properties
        userFavouritePref: { dateCreated: Date.now(), favouritedNodeIds: [] },

        //-- Methods
        InitEvents: function() {
            //console.log("$.Lorem.InitEvents triggered");
            this.extract();
        },

        add: function (nodeId) {

            var nodeIdNumber = Number(nodeId);
            var targetNodeIndex = this.userFavouritePref.favouritedNodeIds.indexOf(nodeIdNumber);

            if (targetNodeIndex == -1) {
                this.userFavouritePref.favouritedNodeIds.push(nodeIdNumber);
            }
        },

        remove: function (nodeId) {

            var nodeIdNumber = Number(nodeId);
            var targetNodeIndex = this.userFavouritePref.favouritedNodeIds.indexOf(nodeIdNumber);

            if (targetNodeIndex > -1) {
                this.userFavouritePref.favouritedNodeIds.splice(targetNodeIndex, 1);
            }

        },

        isFavourited: function(nodeId) {
            return (this.userFavouritePref.favouritedNodeIds.indexOf(nodeId) > -1);
        },

        extract: function() {
            $.cookie.json = true;
            var hamiltonIslandUserFavouriteJson = $.cookie('hamiltonisland.user.favourite');
            if(typeof hamiltonIslandUserFavouriteJson !== "undefined") {
                var storedPreference = JSON.parse(hamiltonIslandUserFavouriteJson);
                this.userFavouritePref.dateCreated = storedPreference.dateCreated;
                this.userFavouritePref.favouritedNodeIds = (typeof storedPreference.favouritedNodeIds !== "undefined") ? storedPreference.favouritedNodeIds : this.userFavouritePref.favouritedNodeIds;
            }
        },

        save: function() {
            $.cookie('hamiltonisland.user.favourite', JSON.stringify(this.userFavouritePref), { expires: 1, path: '/' });
        },

        getFavouriteCount: function() {
            return this.userFavouritePref.favouritedNodeIds.length;
        },

        getFavouriteNodes: function() {
            return this.userFavouritePref.favouritedNodeIds;
        }
    };

})(jq111);
function initMyFavouritesWidget($, moduleElem) {
    try {
        console.log('init MyFavouritesWidget');

        //Define handlesbars templates
        var favouriteItemTemplate = templates.favouritesModule.listingItem;
        var favouriteItem = Handlebars.compile(favouriteItemTemplate);

        function loadFavouriteDataFromApi() {
            var nodeIdsString = favouriteCookieModule.userFavouritePref.favouritedNodeIds.join();
            //console.log('nodeIdsString', nodeIdsString);
            var targetUrl = "/api/Favourite"; // MOVE this to global

            return $.ajax({
                type: "GET",
                url: targetUrl,
                data: { 'ids': nodeIdsString },
                dataType: "json"
            })
            .done(function (data) {
                favouriteData = data;
                //console.log('favouriteData (in $.ajax)', favouriteData);

            });
        }

        function loadFavouriteDataToHtml(moduleElem) {
            //console.log('favouriteData.length', favouriteData.length);
            if (favouriteData.length == 0) {
                $('.no-contents', moduleElem).show();
                $('.favourites', moduleElem).hide();
                $('.nav-row', moduleElem).hide();
                $('.operators', moduleElem).hide();
                return;
            }

            $('.no-contents', moduleElem).hide();
            $('.favourites', moduleElem).empty().show();
            $('.nav-row', moduleElem).show();
            $('.operators', moduleElem).show();

            $.each(favouriteData, function (index, item) {

                var itemOout = favouriteItem(item);
                $('.favourites').append(itemOout);
            });

            //Find all the 'remove' buttons and bind 'remove events'
            var removeBtn = $('.favourites').find('a.remove');
            removeBtn.click(function() {

                //Get the items node ID
                var nodeID = $(this).attr('data-node-id');
                var parentDOMElem = $(this).parents('.favourite');

                //Remove that node from the favourties cookie
                favouriteCookieModule.remove(nodeID);
                favouriteCookieModule.save();

                //Fade out and destroy the item in the favourites widget
                parentDOMElem.animate({
                    opacity: 0,

                    }, 350, function() {
                        //Animation complete, remove the favourite element
                        parentDOMElem.remove();

                        //Count the remaining favourite elements
                        //If none left, show the default 'no favourites view
                        var remainingFavourites = $('.favourite', moduleElem).length;
                        if(remainingFavourites <= 0){
                            $('.no-contents', moduleElem).show();
                        }
                });

                //Check if the content module that matches the same ID exists on the page
                var contentModule = $('div[data-node-id="'+nodeID+'"]');

                //console.log(pageElem);

                $.each( contentModule, function() {
                    $(this).find('a.trigger.favourite').removeClass('is-favourite');
                    $(this).find('a.trigger.favourite').addClass('not-favourite');

                    $(this).find('.favourite-action-layer').removeClass('is-favourite');
                    $(this).find('.favourite-action-layer').addClass('not-favourite');
                })


                return false;

            });

        }

        function updateFavouriteModuleContent(moduleElem) {
            $.when(loadFavouriteDataFromApi()).done(function () {    // Ensure AJAX complete before performing following
                //console.log('favouriteData (outside)', favouriteData);
                loadFavouriteDataToHtml(moduleElem);                // Append Data

                moduleElem.each(function () {                       // For everyone favourite widget
                    if ($(this).hasClass('small')) {
                        
                        /*$(this).find(".favourites-container").mCustomScrollbar({ 
                            theme: 'hamiltonCustom'
                        });*/

                    }
                });
            });
        }

        //-------------- Execute --------------

        var favouriteCookieModule = new $.FavouriteCookie();    // Initialise FavouriteCookie plugin
        favouriteCookieModule.InitEvents();

        updateFavouriteModuleContent(moduleElem);
        $('body').on('Hamilton.Favourite.UpdateList', function() {
            updateFavouriteModuleContent(moduleElem);
        });




        // and we are done!

    } catch (err) {
        console.log('[ERROR]', err);
    }
};
(function($) {

    var favouriteCookieModule = new $.FavouriteCookie();
    favouriteCookieModule.InitEvents();
    //console.log('init favourite count', favouriteCookieModule.getFavouriteCount(), 'nodes', favouriteCookieModule.getFavouriteNodes());

    $.fn.HamiltonIslandSocial = function (args) {

 		var options = {

            //TOGGLE
            isFavourable: false,
            isShareable: false,

 			//CSS / DOM selectors
			selectors: {
                favouriteTrigger: '.trigger.favourite', 			//The favourite button that triggers share event
                favouriteActionLayer: '.favourite-action-layer',	//The action layer that provides action feedback
                shareTrigger: '.trigger.share', 					//The share button that triggers the menu
                shareMenu: '.share-menu',							//The menu itself
                socialFavourable: '.social-favourable',
                socialShareable: '.social-shareable',
            },

            //FAVOURITE STATUS
            favouriteStatus: false,
            favouriteClass: 'is-favourite',
            notFavouriteClass: 'not-favourite',

            //SHARING CONTENT
            shareContent : {
				docTitle: 'Not Found',
        		docUrl: '',
        		docDesc: 'Not Found',
                docTitleSelector: '.share-title',
                docUrlSelector: '.share-url',
                docDescSelector: '.share-desc',
            }
        };


		$.extend(options, args);

        // Attempt to fetch from 'data' attribute first, if not found, then fall back to 'class selector' and finalise to default value.
        function populateShareData(parentElem) {
            options.shareContent.docTitle = fetchShareData(parentElem, 'share-title', options.shareContent.docTitleSelector, options.shareContent.docTitle);
            options.shareContent.docUrl = fetchShareData(parentElem, 'share-url', options.shareContent.docUrlSelector, options.shareContent.docUrl);
            options.shareContent.docDesc = fetchShareData(parentElem, 'share-desc', options.shareContent.docDescSelector, options.shareContent.docDesc);

            if (options.shareContent.docUrl == '' ||  options.shareContent.docUrl == null){

                //Set the URL to be the current page - useful when the sharing content is sharing the current page
                options.shareContent.docUrl = window.location.href;
            }

        }

        function fetchShareData(parentElem, targetDataAttribute, targetClassSelector, defaultValue) {
            // Attempt to find value from data attribute
            var value = parentElem.data(targetDataAttribute);
            if(value) {
                //If relative transform to absolute
                if(value[0] == '/'){
                    value = location.host + value;
                }
                return value;
            }
            // Attempt to find value from designated selector
            value = parentElem.find(targetClassSelector).text();
            if(value) {
                if(value[0] == '/'){
                    value = location.host + value;
                }
                return value;
            }
            // Fallback to default value
            return defaultValue;
        }

		/******************************
		Append the required elements
		******************************/
        function appendSocialModule(parentElem, docTitle, docUrl, docDesc, favouriteStatus) {
        	var favouriteStatusClass = (favouriteStatus == true) ? options.favouriteClass : options.notFavouriteClass;
            var socialPluginMarkup ='<div class="social-plugin">'+
                                        '<div class="share-triggers">'+
                                            '<a href="#" class="trigger favourite ' + favouriteStatusClass + '">'+
                                                '<span class="safe-font">Favourites</span>'+
                                                '<span class="icon icon-add"></span>'+
                                                '<span class="icon icon-remove"></span>'+
                                            '</a>'+
                                            '<a href="#" class="trigger share">'+
                                                '<span class="safe-font">Share</span>'+
                                                '<span class="icon icon-share"></span>'+
                                            '</a>'+
                                        '</div>'+
                                        '<div class="share-menu">'+
                                            '<div class="text-row">'+
                                                '<p>Share This</p>'+
                                            '</div>'+
                                            '<div class="share-links">'+

                                                '<div class="addthis_toolbox" addthis:url="'+docUrl+'" addthis:title="'+docTitle+'" addthis:description="'+docDesc+'">'+
                                                    '<a class="addthis_button_facebook"></a>'+
                                                    '<a class="addthis_button_twitter"></a>'+
                                                '</div>'+
                                            '</div>'+
                                        '</div>'+
                                    '</div>';
            var favouriteActionMarkup = '<div class="favourite-action-layer ' +favouriteStatusClass+'">'+
                                            '<div class="outer">'+
                                                '<div class="inner">'+
                                                    '<span class="icon icon-add"></span>'+
                                                    '<span class="icon icon-remove"></span>'+
                                                '</div>'+
                                            '</div>'+
                                        '</div>';

            parentElem.append(socialPluginMarkup);
            parentElem.append(favouriteActionMarkup);

            //-- Toggle Visibility
            if(!options.isFavourable) {
                parentElem.find(options.selectors.favouriteTrigger).hide();
            }
            if(!options.isShareable) {
                parentElem.find(options.selectors.shareTrigger).hide();
            }
        }

		/******************************
		Show / Hide  the share popup menu
		******************************/
		//Basic animate functions

		function animateMenuIn(targetMenu){
			targetMenu.css('display','block');
			targetMenu.animate({

				opacity: 1

			}, 250, function() {
				// Animation complete.
				targetMenu.addClass('active');
			});
		}

		function animateMenuOut(targetMenu){
			targetMenu.animate({

				opacity: 0

			}, 250, function() {
				targetMenu.css('display','none');
				targetMenu.removeClass('active');
			});
		}


        function showMenu(parentElem){
        	targetMenu = parentElem.find(options.selectors.shareMenu);
        	animateMenuIn(targetMenu);

			targetMenu.click(function(e){
				e.stopPropagation();
			});
        }
        function hideMenu(parentElem){

        	targetMenu = parentElem.find(options.selectors.shareMenu);
        	animateMenuOut(targetMenu);

        }

        function hideAllMenus(){
        	otherMenus = $(document).find(options.selectors.shareMenu+'.active');
			animateMenuOut(otherMenus);
        }


		/******************************
		Show / Hide favourite action layers
		******************************/
		function animateActionLayer(targetLayer){
			targetLayer.css('display','block');
			targetLayer.animate({

				opacity: 1

			}, 450, function() {

				// Animation complete.
				targetLayer.delay(250).animate({

					opacity: 0

				}, 600, function() {
					targetLayer.css('display','none');
					changeFavouriteClass(targetLayer);
				});
			});
		}

		/******************************
		Change classes on favourite related DOM elements
		******************************/
		function changeFavouriteClass(targetElem){
            //console.log('targetElem', targetElem);

			//targetElem.removeClass(currentClass);
			if (targetElem.hasClass(options.favouriteClass)){

				targetElem.removeClass(options.favouriteClass);
				targetElem.addClass(options.notFavouriteClass);

			} else {

				targetElem.removeClass(options.notFavouriteClass);
				targetElem.addClass(options.favouriteClass);
			}
		}

		/******************************
		Core add / remove from favourites functions
		******************************/
		/*TODO - wire into presumed API calls*/
		function APIadd(nodeId){
			console.log('++ API ++ ADD to favourites');
            favouriteCookieModule.add(nodeId);
            favouriteCookieModule.save();
            //console.log('favourite count', favouriteCookieModule.getFavouriteCount(), 'nodes', favouriteCookieModule.getFavouriteNodes());
		}
		function APIremove(nodeId){
			console.log('++ API ++ REMOVE from favourites');
            favouriteCookieModule.remove(nodeId);
            favouriteCookieModule.save();
            //console.log('favourite count', favouriteCookieModule.getFavouriteCount(), 'nodes', favouriteCookieModule.getFavouriteNodes());
        }

		/******************************
		Bind the triggers to respective events
		******************************/
		function bindTriggers(parentElem, favouriteStatus){
			menuTriggerBtn = parentElem.find(options.selectors.shareTrigger);
            //console.log('parentElem', parentElem, 'favouriteStatus', favouriteStatus);
            //console.log('parentElm NodeID', parentElem.data('node-id'));

            favouriteTriggerBtn = parentElem.find(options.selectors.favouriteTrigger);
            favouriteTriggerBtn.click(function() {
                //console.log('parentElem NodeID: ', parentElem.data('node-id'));

                //Feedback / presentation functions
                changeFavouriteClass($(this));
                animateActionLayer( parentElem.find(options.selectors.favouriteActionLayer) );

                //Set favourite status
                if(favouriteStatus == true){
                    favouriteStatus = false;
                    APIremove(parentElem.data('node-id'));
                } else {
                    favouriteStatus = true;
                    APIadd(parentElem.data('node-id'));
                }

                //-- Trigger dependent actions
                //console.log('Favourite count: ', favouriteCookieModule.getFavouriteCount());
                $('body').trigger('Hamilton.Favourite.UpdateCount');
                $('body').trigger('Hamilton.Favourite.UpdateList');

                return false;
            });

			//Bind the social triggers
			menuTriggerBtn.click(function(e) {
				hideAllMenus();
				showMenu(parentElem);
				e.preventDefault();
				e.stopPropagation();
			});

			//Bind close event to the document, in order to hide menu
      		$(document).click(function(){
          		hideMenu(parentElem);
      		});
		}

		/******************************
		Init function on each chosen selector
		******************************/
		this.each(function () {
            // Check available sociability
            options.isFavourable = $(this).is(options.selectors.socialFavourable);
            options.isShareable = $(this).is(options.selectors.socialShareable);
            //console.log('node id: ', base.data('node-id'), '; favourable: ', options.isFavourable, '; shareable: ', options.isShareable, '; classes: ', base.attr('class'));

            // Check if element is favourited
            var favStatus = favouriteCookieModule.isFavourited($(this).data('node-id'));

            // Fetch data for share function
            populateShareData($(this));

			//Append the markup - elem, docTitle, docUrl, docDesc, imgUrl, favouriteStatus *optional*)
            appendSocialModule($(this), options.shareContent.docTitle, options.shareContent.docUrl, options.shareContent.docDesc, favStatus);

			//Bind trigger events
			bindTriggers($(this), favStatus);
        });

	};
})(jq111);
+function ($) {
    
    function applyFilter(filterString) {
        DSTAPI2.call('event', {
            category: 'Filter Interaction',
            action: 'Apply Filter',
            label: filterString
        });

        var shuffleIndex = 0;

        $('.wp_HamiltonIsland_WebParts_CallToAction').Deepend().UpdateWebPart({ 'success': function () { window.picturefill() }, '+itemFilter': '|' + filterString, '_featuredItem': 'null', 'shuffleIndex': function () { return shuffleIndex++ } });
    }

    function showAll() {
        DSTAPI2.call('event', {
            category: 'Filter Interaction',
            action: 'Apply Filter',
            label: 'all'
        });

        $('.wp_HamiltonIsland_WebParts_CallToAction').Deepend().UpdateWebPart({ 'success': function () { window.picturefill() } });
    }

    $.namespace('HamiltonIsland', {
        InitFilter: function (settings) {
            console.log('HamiltonIsland.WebParts.Filter.InitFilter', settings);

            this.each(function () {
                var filterRow = $('.filter-row', this)
                var filterBtn = $('.filter-item', filterRow);

                filterBtn.click(function (e) {
                
                    e.preventDefault();

                    var filterString = $(this).attr('data-filter');

                    if (($(this)).hasClass('active')) {
                        filterBtn.removeClass('active');
                        showAll();
                    } else {
                        filterBtn.removeClass('active');
                        $(this).addClass('active');
                        applyFilter(filterString);
                    }
                
                });

                $(this).flowtype({
                    minimum: 00,
                    maximum: 480,
                    minFont: 12,
                    maxFont: 16,
                    fontRatio: 25
                });
            });
        }
    });

    $(document).ready(function () {
        $('.filter').HamiltonIsland().InitFilter();
    });

}(jq111);

function initFlightModule($, parentElem) {

    try {
        console.log('flight module - init');

        var accordionTrigger = parentElem.find('.flight-widget-mobile-trigger');
        var accordionTarget = parentElem.find('.flight-widget-wrap');

        var calendarOption = parentElem.find('.option.calendar');
        var dateInput = calendarOption.find('input[type=date]');
        var textInput = calendarOption.find('input[type=text]');

        var arriveInput = parentElem.find('.arrival-date');
        var arriveIcon = arriveInput.next('.add-on');
        var departInput = parentElem.find('.departure-date');
        var departIcon = departInput.next('.add-on');


        var dropdownOption = parentElem.find('.option.dropdown');
        var listLink = dropdownOption.find('.dropdown-menu a');

        var flightSubmit = parentElem.find('.flight-submit');

        var selectedValues = new Object();

        $('.flight-module .dropdown-toggle').dropdown();

        //Bind accordion open / close to trigger
        accordionTrigger.click(function (e) {

            if (accordionTarget.hasClass('open')) {
                parentElem.removeClass('open');
                accordionTarget.hide();
                accordionTarget.removeClass('open');

            } else {
                parentElem.addClass('open');
                accordionTarget.show();
                accordionTarget.addClass('open');
            }

            e.preventDefault();
        });


        //Check touch support and destroy the secondary input
        //if touch supported. This is PURELY to prevent wierd
        //display issues and conflicts with the calendar in browsers
        //like Chrome that aren't touch, but support date inputs

        if ((Modernizr.touch)) {

            textInput.remove();
            dateInput.show();

        } else {

            dateInput.remove();
            textInput.show();

            arriveInput.datepicker({
                numberOfMonths: 2,
                showButtonPanel: false,
                dateFormat: "dd-mm-yy",

                onSelect: function() {

                    var selectedDate = arriveInput.datepicker('getDate');
                    departInput.datepicker( 'option', 'defaultDate', selectedDate );

                    setTimeout(function(){

                        departInput.datepicker('show');

                    }, 10);
                }
            });

            departInput.datepicker({
                numberOfMonths: 2,
                showButtonPanel: false,
                dateFormat: "dd-mm-yy"
            });

            //Bind icons
            arriveIcon.click(function(){
                arriveInput.datepicker('show');
            });
            departIcon.click(function(){
                departInput.datepicker('show');
            });


            /*
            textInput.click(function () {
                $(this).val("");
            });

            parentElem.find('.add-on').click(function(){
                //Clearing the text input
                $(this).prev().val("");
            });
            */
        }

        //Bind click events to dropdown list
        //When user clicks the link in dropdown, grab the value
        //and set the toggle text to be equal to that value
        listLink.click(function (e) {

            selectedText = $(this).html();
            selectedVal = $(this).data('val');
            selectedField = $(this).data('field');

            selectedValues[selectedField] = selectedVal;

            //Set the parents text
            $(this).parents('.dropdown').find('.copy').html(selectedText);

            e.preventDefault();
        });

        flightSubmit.click(function (e) {

            var departDate = parentElem.find('.depart input').val();
            var arriveDate = parentElem.find('.arrive input').val();

            var ddep = new Date(parseDate(arriveDate));
            var mret = new Date(parseDate(departDate));

            var submitUrl = "http://www.virginaustralia.com/flightsearch/" +
                "?from=" + ((selectedValues['departure'] != undefined) ? selectedValues['departure'] : "") +
                "&to=" + ((selectedValues['arrival'] != undefined) ? selectedValues['arrival'] : "HTI") +
                "&pos=" + "en-AU" +
                "&t_type=" + "1" +
                "&d_dep=" + ddep.getDate() +
                "&m_dep=" + ddep.getFullYear() + (((ddep.getMonth() + 1) < 10) ? "0" + (ddep.getMonth() + 1) : (ddep.getMonth() + 1)) +
                "&d_ret=" + mret.getDate() +
                "&m_ret=" + mret.getFullYear() + (((mret.getMonth() + 1) < 10) ? "0" + (mret.getMonth() + 1) : (mret.getMonth() + 1)) +
                "&p_adult=" + ((selectedValues['adult'] != undefined) ? selectedValues['adult'] : "") +
                "&p_child=" + ((selectedValues['child'] != undefined) ? selectedValues['child'] : "");

            $(this).attr("href", submitUrl);

        });

    } catch (err) {
        console.log('[ERROR]', err);
    }
};

function parseDate(input) {
    var parts = input.split('-');

    // new Date(year, month [, day [, hours[, minutes[, seconds[, ms]]]]])
    // Months are 0-based

    if (parts[0].length == 4)
        return new Date(parts[0], parts[1] - 1, parts[2]);
    else
        return new Date(parts[2], parts[1] - 1, parts[0]);
}

function initFlightFrameModule($, parentElem){

	console.log('flight frame module - init');

	//var iframe = parentElem.find('iframe');

}

function initGolfClubTeeTimeModule($, parentElem) {
    try {
        console.log('golf club tee time module - init');

        //Inputs and buttons
        var calendarOption = parentElem.find('.option.calendar');
        var dateInput = calendarOption.find('input[type=date]');
        var textInput = calendarOption.find('input[type=text]');
        var inputIcon = textInput.next('.add-on');
        var submitBtn = parentElem.find('.booking-submit');

        //Dropdown Elems
        var dropdownOption = parentElem.find('.option.dropdown');
        var listLink = dropdownOption.find('.dropdown-menu a');
        var holesListLink = parentElem.find('.option.dropdown.holes .dropdown-menu a');
        var teeTimesListLink = parentElem.find('.option.dropdown.teeoff .dropdown-menu a');

        var formUrl = parentElem.find('.form-url');

        var selectedValues = new Object();

        //DROPDOWN // NEEDED???
        parentElem.find('.dropdown-toggle').dropdown();


        //Check touch support and destroy the secondary input
        //if touch supported. This is PURELY to prevent wierd
        //display issues and conflicts with the calendar in browsers
        //like Chrome that aren't touch, but support date inputs

        if ((Modernizr.touch)) {

            textInput.remove();
            dateInput.show();

        } else {

            dateInput.remove();
            textInput.show();

            textInput.datepicker({
                numberOfMonths: 2,
                showButtonPanel: false,
                dateFormat: "dd-mm-yy"
            });

            //Bind icons
            inputIcon.click(function(){
                textInput.datepicker('show');
            });
        }

        //Bind click events to dropdown list
        //When user clicks the link in dropdown, grab the value
        //and set the toggle text to be equal to that value
        listLink.click(function (e) {

            selectedText = $(this).html();
            selectedVal = $(this).data('val');
            selectedField = $(this).data('field');

            selectedValues[selectedField] = selectedVal;

            //Set the parents text
            $(this).parents('.dropdown').find('.copy').html(selectedText);

            e.preventDefault();
        });

        holesListLink.click(function (e) {
            selectedText = $(this).html();
            selectedHole = $(this).data('val');
            selectedField = $(this).data('field');

            selectedValues[selectedField] = selectedHole;

            //Set the parents text
            $(this).parents('.dropdown').find('.copy').html(selectedText);

            if (selectedHole == "18") {

                var selectedTime = selectedValues["teeoff"];
                var times = ['01:00pm', '01:30pm', '02:00pm', '02:30pm'];
                if ($.inArray(selectedTime, times) != -1) {
                    var min18HoleTime = "12:30pm";
                    selectedValues["teeoff"] = min18HoleTime;
                    //Set the display text
                    $(teeTimesListLink).parents('.dropdown.teeoff').find('.copy').html(min18HoleTime);
                }
            }

            e.preventDefault();
        });

        submitBtn.click(function (e) {

            var playDate = parentElem.find('.play input').val();

            var redirUrl = formUrl.val() + "?" +
                "&playdate=" + playDate +
                "&time=" + ((selectedValues['teeoff'] != undefined) ? selectedValues['teeoff'] : "") +
                "&holes=" + ((selectedValues['holes'] != undefined) ? selectedValues['holes'] : "") +
                "&players=" + ((selectedValues['players'] != undefined) ? selectedValues['players'] : "");

            window.location = redirUrl;

            e.preventDefault();
        });

    } catch (err) {
        console.log('[ERROR]', err);
    }
};
function showPanel(targetMap) {
    targetMap.css('display', 'block');
    targetMap.animate({
        opacity: 1,
    }, 250, function () {
        // Animation complete.
    });
}

function hidePanel(targetMap) {
    targetMap.animate({
        opacity: 0,
    }, 250, function () {
        // Animation complete.
        targetMap.css('display', 'none');
    });
}

//Golf course module
function initGolfCourse($, parentElem, sizeVarient) {
    debugger
    try {
        parentElem.each(function () {
            var primarySlider = $('.primary-slider', parentElem);
            var thumbSlider = $('.secondary-slider', parentElem);
            var holeTextDesc = primarySlider.find('.hole-description');

            if (sizeVarient == 'large') {
                holeTextDesc.mCustomScrollbar({
                    theme: 'hamiltonCustom'
                });
            }

            /******************************
            INIT SLIDERS
            ******************************/

            //Init the thumbnail slider
            thumbSlider.flexslider({
                selector: '.slide-wrapper .slide',
                animation: 'slide',
                controlNav: false,
                directionNav: true,
                animationLoop: false,
                slideshow: false,
                itemWidth: 82,
                itemMargin: 0,
                prevText: '',
                nextText: '',
                touch: true,
                asNavFor: primarySlider

            });

            //Init the main image slider
            primarySlider.flexslider({
                selector: '.slide-wrapper .slide',
                animation: 'slide',
                animationSpeed: 800,
                animationLoop: false,
                controlNav: true,
                directionNav: true,
                slideshow: false,
                prevText: '',
                nextText: '',
                touch: true,
                pauseOnHover: true,

                start: function (slider) {

                    //Fade in on start
                    $(parentElem).animate({
                        opacity: 1
                    }, 1000, function () {
                        // Animation complete.
                    });
                },

                before: function (slider) {
                    let currentSlide = slider.find('.flex-active-slide');
                    let currentIndex = currentSlide.index() + 2; //index is 0 based

                    //Remove the currently active thumb class
                    thumbSlider.find('.slide-wrapper .flex-active-slide').removeClass('flex-active-slide');

                    //Add active class to the new active thumb
                    let activeThumb = thumbSlider.find('.slide-wrapper .slide:nth-child(' + currentIndex + ')');
                    activeThumb.addClass('flex-active-slide');

                }
            });

            let primarySlide = primarySlider.find('.slide');

            /******************************
            BIND MAP OPEN BUTTONS
            ******************************/
            $('.primary-slider', parentElem).find('.slide').each(function (i, e) {
                let mapWrapper = $(this).find('.hole-map-wrapper');
                let mapTriggerBtn = $(this).find('.show-map');
                let mapCloseBtn = $(this).find('.hole-map-wrapper .square-close');
                let readMoreBtn = $(this).find('.read-more');
                let mobileMap = $(this).find('.mobile-map');

                let videoTriggerBtn = $(this).find('.show-video');
                let videoMobileTriggerBtn = $(this).find('.mobile-video');
                let videoWrapper = $(this).find('.hole-video-wrapper');
                let videoCloseBtn = $(this).find('.hole-video-wrapper .square-close');

                // Unbind first, to prevent double binding issues
                // after window resize events
                mapTriggerBtn.unbind("click").click(function () {

                    videoTriggerBtn.removeClass('active');
                    hidePanel(videoWrapper);

                    if ($(this).hasClass('active')) {
                        $(this).removeClass('active');
                        hidePanel(mapWrapper);

                    } else {
                        $(this).addClass('active');
                        showPanel(mapWrapper);
                    }
                    return false;
                });

                // Unbind first, to prevent double binding issues
                // after window resize events
                mapCloseBtn.unbind("click").click(function () {
                    mapTriggerBtn.removeClass('active');
                    hidePanel(mapWrapper);
                    return false;
                });

                readMoreBtn.unbind("click").click(function () {

                    let targetContent = $(this).parents('.hole-detail-block').find('.hole-description'); //.prev('.hole-description');
                    let openText = 'Close...';
                    let defaultText = 'Read more';

                    if ($(this).hasClass('active')) {
                        $(this).removeClass('active');
                        $(this).html(defaultText);
                        targetContent.removeClass('open');

                    } else {
                        $(this).addClass('active');
                        $(this).html(openText);
                        targetContent.addClass('open');
                    }
                    return false;
                });

                if (mobileMap.length > 0) {
                    mobileMap.magnificPopup({
                        type: 'image',
                        closeOnContentClick: true,
                        mainClass: 'mfp-img-mobile',
                        image: {
                            verticalFit: true
                        }
                    });
                }


                // Unbind first, to prevent double binding issues
                // after window resize events
                videoTriggerBtn.unbind("click").click(function () {

                    mapTriggerBtn.removeClass('active');
                    hidePanel(mapWrapper);

                    if ($(this).hasClass('active')) {
                        $(this).removeClass('active');
                        hidePanel(videoWrapper);

                    } else {
                        $(this).addClass('active');
                        showPanel(videoWrapper);
                    }
                    return false;
                });

                // Unbind first, to prevent double binding issues
                // after window resize events
                videoCloseBtn.unbind("click").click(function () {
                    videoTriggerBtn.removeClass('active');
                    hidePanel(videoWrapper);
                    return false;
                });


                if (videoMobileTriggerBtn.length > 0) {
                    var overlayMarkup = '<div class="mfp-iframe-scaler no-overflow">' +
                        '<div class="mfp-close"></div>' +
                        '<iframe class="mfp-iframe" frameborder="0" allowfullscreen="" style="width: 100%;height: 100%;"></iframe>' +
                        '<div class="mfp-bottom-link-row">' +
                        '</div>' +
                        '</div>';
                    videoMobileTriggerBtn.magnificPopup({
                        alignTop: true,
                        type: 'iframe',
                        mainClass: 'mfp-fade',
                        iframe: {
                            markup: overlayMarkup
                        }
                    });
                }

            })
        });

    } catch (err) {
        console.log('[ERROR]', err);
    }
};
+function ($) {

    $.namespace('HamiltonIsland', {
        InitHero: function (settings) {
            console.log('HamiltonIsland.WebParts.Hero.InitHero', settings);

            this.each(function () {

                // Global Variables
                var AFeatureElem = $(this);
                var FeatureSlideElems = $(this).find('.slide');
                var ImageGalleryBottonElems = AFeatureElem.find('.btn-gallery');
                var VideoGalleryBottonElems = AFeatureElem.find('.btn-video');

                var ImageGalleryApiBaseUrl = '/api/ImageGallery?type=or&size=Gallery:800x460';
                var imageSlideItemTemplate = templates.aFeature.slide;
                var imageSlideItem = Handlebars.compile(imageSlideItemTemplate);

                // Methods
                function initFeatureSlides() {
                    if (FeatureSlideElems.length > 1) {
                        AFeatureElem.flexslider({
                            selector: '.slide-wrapper .slide',
                            animation: 'slide',
                            animationSpeed: 800,
                            animationLoop: true,
                            controlNav: true,
                            directionNav: true,
                            slideshow: false,
                            prevText: '',
                            nextText: '',
                            touch: true,
                            pauseOnHover: true,
                            //useCSS: false,

                            start: function (slider) {
                                FeatureSlideElems.on('click', '.btn-video', function () {
                                    slider.flexslider('stop');
                                });
                                FeatureSlideElems.on('click', '.btn-gallery', function () {
                                    slider.flexslider('stop');
                                });

                                //Fade in on start
                                AFeatureElem.animate({
                                    opacity: 1
                                }, 1000, function () {
                                    // Animation complete.
                                });
                            }
                        });
                    } else {
                        //Fade in on start
                        AFeatureElem.animate({
                            opacity: 1
                        }, 1000, function () {
                            // Animation complete.
                        });
                    }
                }

                function initFlowtype() {
                    AFeatureElem.flowtype({
                        minimum: 0,
                        maximum: 960,
                        minFont: 9,
                        maxFont: 16,
                        fontRatio: 36
                    });
                }

                function initVideoButtonBindings() {
                    var videoGalleryURL = VideoGalleryBottonElems.attr('data-viewall-url');
                    var overlayMarkup = '<div class="mfp-iframe-scaler no-overflow">' +
                                            '<div class="mfp-close"></div>' +
                                            '<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>' +
                                            '<div class="mfp-bottom-link-row">' +
                                                '<a href="' + videoGalleryURL + '">View all videos</a>' +
                                            '</div>' +
                                        '</div>';
                    if (VideoGalleryBottonElems.length > 0) {
                        VideoGalleryBottonElems.magnificPopup({
                            alignTop: true,
                            type: 'iframe',
                            mainClass: 'mfp-fade',
                            iframe: {
                                markup: overlayMarkup
                            }
                        });
                    }
                }

                function bindImageButton(galleryId) {
                    galleryId = galleryId || false;

                    $.magnificPopup.open({
                        alignTop: true,
                        items: {
                            type: 'inline',
                            src: $(galleryId)
                        },
                        mainClass: 'mfp-fade',
                        callbacks: {
                            beforeOpen: function (slider) {
                                // console.log('Start of popup initialization');
                            },

                            elementParse: function (item) {

                                //item.src is the target DOM element
                                 console.log( $(item.src));
                                $(item.src).addClass('PARSE');

                                galleryWrapper = $(item.src);
                                //setTimeout(function () { // NOTE: Purpose set time delay to workaround race condition by flexslider attempt to initiates before *something* is ready.
                                    galleryWrapper.flexslider({
                                        //selector: 'img',
                                        animation: 'slide',
                                        animationSpeed: 800,
                                        animationLoop: true,
                                        directionNav: true,
                                        controlNav: false,
                                        slideshow: false,
                                        prevText: '',
                                        nextText: '',
                                        touch: true,
                                        start: function (slider) {
                                            // Fix for starting at the last image and 
                                            // skipping to the 3rd image when sliding.
                                            // @see https://github.com/woothemes/FlexSlider/issues/292
                                            // I modified it to allow for no animation 
                                            // speed to stop the animation from appearing
                                            // when the modal was loading.
                                            this.animationSpeed = 0;
                                            slider.flexslider(-1);
                                            slider.flexslider(0);
                                            this.animationSpeed = 800;

                                            galleryWrapper.animate({
                                                opacity: 1
                                            }, 1000, function () {
                                                // Animation complete.
                                            });
                                        }
                                    });

                                    var imageGalleryURL = ImageGalleryBottonElems.attr('data-viewall-url');
                                    var overlayMarkup = '<div style="position:relative">' +
                                        '<div class="mfp-bottom-link-row">' +
                                        '<a href="' + imageGalleryURL + '">View all images</a>' +
                                        '</div>' +
                                        '</div>';
                                    $(item.src).append(overlayMarkup);

                                //}, 2000);
                            }
                        }

                    });

                    // Google Analytic Event Tracker
                    var slideTitle = $('.flex-active-slide').find('.primary-copy').text();
                    DSTAPI2.call('event', {
                        category: 'A feature Interaction',
                        action: 'Image',
                        label: slideTitle
                    });
                }

                function initImageEventTrackingBindings() {
                    //Tracking a feature interactions
                    var prev = $('.flex-prev');
                    var next = $('.flex-next');

                    //Next
                    if (prev.length > 0) {
                        prev.click(function () {
                            //Prev because active has already moved by the time this is hit
                            var slideTitle = $('.flex-active-slide').prev().find('.primary-copy').text();
                            DSTAPI2.call('event', {
                                category: 'A feature Interaction',
                                action: 'Previous',
                                label: slideTitle
                            });
                        });
                    }

                    //Previous
                    if (next.length > 0) {
                        next.click(function () {
                            //Prev because active has already moved by the time this is hit
                            var slideTitle = $('.flex-active-slide').prev().find('.primary-copy').text();
                            DSTAPI2.call('event', {
                                category: 'A feature Interaction',
                                action: 'Next',
                                label: slideTitle
                            });
                        });
                    }
                }

                function renderImageGallery(galleryElem, data) {

                    galleryElem.find('.slides').empty(); // Just in case, empty any existing content before proceed.
                    $.each(data, function (index, item) {
                        if (item.FileType == 'image') {
                            var itemHtml = imageSlideItem(item);
                            galleryElem.find('.slides').append(itemHtml);
                        }
                    });
                    /*
                    var $galleryWrapper = $(galleryElem);

                    $galleryWrapper.flexslider({
                        //selector: 'img',
                        animation: 'slide',
                        animationSpeed: 800,
                        animationLoop: true,
                        directionNav: true,
                        controlNav: false,
                        slideshow: false,
                        prevText: '',
                        nextText: '',
                        touch: true,
                        start: function (slider) {
                            // Fix for starting at the last image and
                            // skipping to the 3rd image when sliding.
                            // @see https://github.com/woothemes/FlexSlider/issues/292
                            // I modified it to allow for no animation
                            // speed to stop the animation from appearing
                            // when the modal was loading.
                            this.animationSpeed = 0;
                            slider.flexslider(-1);
                            slider.flexslider(0);
                            this.animationSpeed = 800;

                            $galleryWrapper.animate({
                                opacity: 1
                            }, 1000, function () {
                                // Animation complete.
                            });
                          }
                      });

                      var imageGalleryURL = ImageGalleryBottonElems.attr('data-viewall-url');
                      var overlayMarkup = '<div style="position:relative">' +
                                          '<div class="mfp-bottom-link-row">' +
                                          '<a href="' + imageGalleryURL + '">View all images</a>' +
                                          '</div>' +
                                          '</div>';
                      $galleryWrapper.append(overlayMarkup);
                      */
                }

                function populateImageGallery(galleryElem) {
                    var url = ImageGalleryApiBaseUrl + '&tags=' + galleryElem.data('tags');

                    $.getJSON(url, function (data) {
                    })
                    .done(function (data) {
                        renderImageGallery(galleryElem, data);
                    })
                    .fail(function (data) {
                        console.log('Alerts are bad and you should feel bad', 'Image gallery not found');
                        });
                }

                function InitGallery() {

                    $('.btn-gallery').each(function (e) {

                        var targetGalleryButtonElem = $(this);
                        var targetGalleryId = targetGalleryButtonElem.data('target-gallery-id');
                      
                        var targetGalleryElem = $('.a-feature-gallery-wrapper #' + targetGalleryId).first();

                        var isGalleryPopulated = (targetGalleryElem.find('.slides li').length > 0);

                        if (!isGalleryPopulated) {
                            populateImageGallery(targetGalleryElem);
                        }

                    })

                }

                InitGallery();

                // Binding
                ImageGalleryBottonElems.on('click', function () {

                    var targetGalleryButtonElem = $(this);
                    var targetGalleryId = targetGalleryButtonElem.data('target-gallery-id');
                    var galleryHref = targetGalleryButtonElem.attr('href');
                    bindImageButton(galleryHref);
                    event.preventDefault();
                });

                VideoGalleryBottonElems.click(function () { //Video event
                    // Google Analytic Event Tracker
                    var slideTitle = $('.flex-active-slide').find('.primary-copy').text();
                    DSTAPI2.call('event', {
                        category: 'A feature Interaction',
                        action: 'Video',
                        label: slideTitle
                    });
                });

                // Init
                initFeatureSlides();
                initFlowtype();
                initVideoButtonBindings();
                initImageEventTrackingBindings();
            });
        }
    });

    $(document).ready(function () {
        $('.a-feature').HamiltonIsland().InitHero();
    });

}(jq111);

function initImageGallery($, parentElem) {
    try {
        console.log('image gallery module - init');

        var GalleryTags = "";
        parentElem.find('a.filter-toggle').each(function () {
            GalleryTags += $(this).attr('data-filter-type').trim() + "|";
        });
        if (GalleryTags.length > 0) {
            GalleryTags = "&tags=" + GalleryTags.substring(0, GalleryTags.length - 1);
        }

        var Folder = parentElem.attr('data-image-folder');

        //var TEMPdataUrl = '/static/js/data/image-gallery-sample-data.json';
        var DEVdataUrl = '';
        
        if (Folder == null || Folder == '') {
            DEVdataUrl = '/api/ImageGallery?type=or' + GalleryTags;
        } else {
            DEVdataUrl = '/api/ImageGallery?folder=' + escape(Folder);
        }
        //var LIVEdataUrl = '/api/ImageGallery?type=or' + GalleryTags;
        var dataUrl = DEVdataUrl;

        //Elements
        var filterRow = $('.filter-row', parentElem);
        var galleryWrapper = $('.gallery-wrapper', parentElem);
        var primaryImgContainer = $('.primary-img-row', parentElem);
        var thumbImgContainer = $('.thumb-img-row', parentElem);

        //Data sets
        var galleryData;
        var currentFilters = [];

        /******************************
        LOAD THE DATA
        ******************************/
        var jqxhr = $.getJSON(dataUrl, function (data) {

        })
        .done(function (data) {
            console.log('Loading gallery data.');
            galleryRenderAll(data);
            galleryData = data;

            parentElem.find('a.filter-toggle').first().click();
        })
        .fail(function (data) {
            console.log('Alerts are bad and you should feel bad', 'Image gallery not found');
        });



        /******************************
        DATA MANIPULATION FUNCTIONS
        ******************************/

        //Add tags to the current filters array
        function addFilter(tag) {
            currentFilters.push(tag);
        }

        //Remove tags from the current filters array
        function removeFilter(tag) {
            var index = $.inArray(tag, currentFilters);
            if (index != -1) {
                currentFilters.splice(index, 1);
            }
        }

        /******************************
        RENDER FUNCTIONS
        ******************************/

        function renderItem(item) {
            if(item.FileType == 'image') {
                //Render the Main Images
                var imageUrl = (item.ResourceUrl.trim()) ? item.ResourceUrl.trim() : "http://placehold.it/800x600.gif&text=.";
                primaryImgContainer.find('.slider-wrapper').append(
                    '<div class="slide">' +
                        '<img src=' + imageUrl + ' alt="' + item.Description + '">' +
                        '<div class="img-desc">' + item.Description + '</div>' +
                    '</div>'
                );
            } else if (item.FileType == 'video') {
                //Render the Main Images
                primaryImgContainer.find('.slider-wrapper').append(
                    '<div class="slide">' +
                        '<iframe src="' + item.ResourceUrl + '?title=0&byline=0&portrait=0" width="800" height="600" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>' +
                        '<div class="img-desc">' + item.Description + '</div>' +
                    '</div>'
                );
            }

            //Render Thumb Images
            var thumbnailClass = item.FileType + '-thumbnail';
            var thumbnailUrl = (item.ThumbnailUrl.trim()) ? item.ThumbnailUrl.trim() : "http://placehold.it/150x100.gif&text=.";
            thumbImgContainer.find('.slider-wrapper').append(
                '<div class="slide">' +
                    '<img class="' + thumbnailClass + '" src="' + thumbnailUrl + '" alt="' + item.Description + '">' +
                '</div>'
            );
        }

        //Render ALL images
        function galleryRenderAll(data) {
            //Render the slide wrappers first
            primaryImgContainer.append('<div class="slider-wrapper"></div>');
            thumbImgContainer.append('<div class="slider-wrapper"></div>');

            for (var i = 0; i < data.length; i++) {
                renderItem(data[i]);
            }

            initSlider();
        }

        function galleryRenderFilters() {

            //Render the slide wrappers first
            primaryImgContainer.append('<div class="slider-wrapper"></div>');
            thumbImgContainer.append('<div class="slider-wrapper"></div>');

            for (var i = 0; i < galleryData.length; i++) {

                var itemTags = galleryData[i].ItemTags;
                var itemTagsLength = galleryData[i].ItemTags.length;

                //For Each Tag in each item
                for (var j = 0; j < itemTagsLength; j++) {
                    /*
                    console.log('===============================================');
                    console.log('CURRENT FILTERS ' + currentFilters);
                    console.log('ITEM TAGS ' + galleryData[i].ItemTags[j]);
                    */

                    //Check if the tags of each item match the currrent filters array
                    if (currentFilters.indexOf(galleryData[i].ItemTags[j]) != -1) {
                        renderItem(galleryData[i]);
                    }
                }
            }

            initSlider();
        }

        /******************************
        DESTRUCTION FUNCTIONS
        ******************************/
        //Destroy ALL gallery items
        function galleryDestroy(newFilter) {

            galleryWrapper.animate({
                opacity: 0,
            }, 250, function () {

                // Animation complete.
                primaryImgContainer.empty();
                thumbImgContainer.empty();
                $('.primary-img-row').removeData("flexslider"); //Need to empty the data also
                $('.thumb-img-row').removeData("flexslider"); //Need to empty the data also

                if (newFilter) {

                    if (newFilter == 'all') {
                        galleryRenderAll(galleryData);
                    } else {
                        galleryRenderFilters();
                    }
                }
            });
        }

        /******************************
        BIND FILTER CLICK EVENTS
        ******************************/
        //Based on data tags, add those tags to the
        //current filter array

        filterRow.find('a.filter-toggle').click(function () {
            var filterName = $(this).attr('data-filter-type');
            if (filterName == "") {
                galleryDestroy('all');
                return;
            }

            //Remove the active filter-all button state
            filterRow.find('a.filter-all').removeClass('active');

            if ($(this).hasClass('active')) {

                $(this).removeClass('active');
                removeFilter(filterName);

            } else {

                //Active filter
                activeBtn = filterRow.find('a.active');
                activeFilter = activeBtn.attr('data-filter-type');

                //Remove active state and filter
                activeBtn.removeClass('active');
                removeFilter(activeFilter);

                //Set this as active
                $(this).addClass('active');
                addFilter(filterName);
            }


            galleryDestroy(filterName);
            return false;
        });

        filterRow.find('a.filter-all').click(function () {
            if ($(this).hasClass('active')) {

                //Do nothing

            } else {

                //Remove all OTHER active filter button states
                filterRow.find('a.filter-toggle').removeClass('active');
                $(this).addClass('active');
                galleryDestroy('all');
            }

            return false;

        });

        /******************************
        INIT THE SLIDER
        ******************************/
        function initSlider() {

            //Init the thumbnail slider
            $('.thumb-img-row', parentElem).flexslider({
                selector: '.slider-wrapper .slide',
                animation: 'slide',
                controlNav: false,
                animationLoop: false,
                slideshow: false,
                itemWidth: 150,
                itemMargin: 2,
                prevText: '',
                nextText: '',
                asNavFor: '.primary-img-row'
            });

            //Init the main image slider
            $('.primary-img-row', parentElem).flexslider({
                selector: '.slider-wrapper .slide',
                animation: 'slide',
                animationSpeed: 800,
                animationLoop: true,
                controlNav: false,
                //directionNav: false,
                slideshow: false,
                prevText: '',
                nextText: '',
                touch: true,
                pauseOnHover: true,
                itemMargin: 0,
                allowOneSlide: true,
                sync: ".thumb-img-row",

                start: function (slider) {
                    //Fade in on start
                    galleryWrapper.animate({
                        opacity: 1
                    }, 1000, function () {
                        // Animation complete.
                    });
                }
            });
        }

    } catch (err) {
        console.log('[ERROR]', err);
    }
};
function initIslandStories($, parentElem) {
    try {

        /******************************
        PROPERTIES
        ******************************/
        var BaseFeedUrl = '/api/Stackla';
        var TilesPerPage = 32;
        var CurrentPage = 1;
        var CurrentTileCount = 0;
        var DefaultFeedUrl = BaseFeedUrl + '?pageNo=' + CurrentPage;
        var ActiveFilter = null;
        var DataPendingRepo = [];
        var JQXHR = null;
        
        
        
        /******************************
        TEMPLATE REFERENCES
        ******************************/
        //Instagram
        var instagramTopTemplate = templates.socialModules.instaGram.imageTop;
        var instagramTopItem = Handlebars.compile(instagramTopTemplate);
        var instagramBottomTemplate = templates.socialModules.instaGram.imageBottom;
        var instagramBottomItem = Handlebars.compile(instagramBottomTemplate);

        //Twitter
        var twitterTemplate = templates.socialModules.twitter;
        var twitterItem = Handlebars.compile(twitterTemplate);

        //Community blog templates
        var communityLargeTemplate = templates.socialModules.communityLarge;
        var communityLargeItem = Handlebars.compile(communityLargeTemplate);
        var communitySmallTemplate = templates.socialModules.communitySmall;
        var communitySmallItem = Handlebars.compile(communitySmallTemplate);
        
        //Custom Tile
        var imageFeatureTemplate = templates.socialModules.imageFeature;
        var imageFeatureItem = Handlebars.compile(imageFeatureTemplate);
        
        
        
        /******************************
        DOM ELEMENTS
        ******************************/
        var filterRowElem = $('.filter-row', parentElem);
        var feedWrapperElem = $('.feed-row .feed-wrapper', parentElem);
        var loadMoreElem = $('.load-more', parentElem);

        
        
        /******************************
        OPERATORS
        ******************************/
        
        function GetRequestUrl() {
            if (ActiveFilter !== null) {
                var pageUrl = BaseFeedUrl + '?pageNo=' + CurrentPage + '&tags=' + ActiveFilter; //WITH TAGS
            } else {
                var pageUrl = BaseFeedUrl + '?pageNo=' + CurrentPage;
            }
            return pageUrl;
        }

        function UpdateActiveFilter(currentActiveFilterElem) {
            filterRowElem.find('.active').removeClass('active');
            currentActiveFilterElem.addClass('active');
            loadMoreElem.trigger('ShowLoadMore');
        }
        
        function SetFontFlowType() {
            parentElem.flowtype({
                minimum: 320,
                maximum: 960,
                minFont: 14,
                maxFont: 16,
                fontRatio: 40
            });
        }
        
        function ShiftDataPendingRepo(count) {
            DataPendingRepo = DataPendingRepo.slice(count, DataPendingRepo.length);
        }
        
        function ResetFeed() {
            feedWrapperElem.animate({
                opacity: 0
            }, 350, function () {
                feedWrapperElem.empty();    // Empty the contents after the wrapper is hidden
                GetContent(true);
            });
        }
        
        function PopulateDataPendingRepo() {
            var dataUrl = GetRequestUrl();
            //console.log('FetchData dataUrl: ', dataUrl);
            JQXHR = $.getJSON(dataUrl, function(data) {})
                        .done(function(data) {
                            CurrentPage++;
                            DataPendingRepo = $.merge(DataPendingRepo, data);
                            //console.log('DataPendingRepo.length', DataPendingRepo.length, ', next page', CurrentPage);
                            
                            if (data.length == 0) { // Hide 'Load More' button if AJAX returns no data
                                loadMoreElem.trigger('HideLoadMore');
                            }
                        })
                        .fail( function(d, textStatus, error) {
                            console.log("getJSON failed, status: " + textStatus + ", error: "+error)
                        });
        }
        
        function GetContent(renderContent) {
            if(DataPendingRepo.length < TilesPerPage) { // Fetch only when there's not enough items in the jar
                
                PopulateDataPendingRepo();
                
                // Do a 2nd check to see if we have enough item in the jar
                // Hard code to do strictly 2 runs, instead of loop to avoid edge case where this logic somehow stuck in a loop
                $.when(JQXHR).then(function() {
                    //console.log('// Do a 2nd check to see if we have enough item in the jar');
                    if(DataPendingRepo.length < TilesPerPage) {
                        PopulateDataPendingRepo();
                    }
                });
                
                
                // Check for need to render the content
                $.when(JQXHR).then(function() {
                    //console.log('// Check for need to render the content');
                    if(renderContent) {
                        RenderPendingContent();
                        loadMoreElem.trigger('ExitLoadingState');
                    }
                });
                
            } else {
                if(renderContent) {
                    RenderPendingContent();
                    loadMoreElem.trigger('ExitLoadingState');
                }
            }
        }
        
        function RenderPendingContent() {
            var instagramItemCount = 0;
            var itemTookCount = 0;
            var firstItem = true;
            $.each(DataPendingRepo, function(index, item) {
                if(firstItem || CurrentTileCount % TilesPerPage > 0) {
                    
                    if(item.source == 'instagram') {
                    
                        instagramItemCount++;
                        if ((instagramItemCount) % 2 == 0) { //Alternate between image top and bottom templates
                            var output = instagramTopItem(item);
                        } else {
                            var output = instagramBottomItem(item);
                        }
                        feedWrapperElem.append(output);
                        CurrentTileCount++;    
                        
                    } else if (item.source == 'twitter') {
                    
                        var output = twitterItem(item);
                        feedWrapperElem.append(output);
                        CurrentTileCount++;

                    } else if (item.source == 'sta_feed') { // Generic Stackla Feed such as Blog, Media Release etc.
                        var output = "";
                        if( CurrentTileCount % 4 == 0) { // Hard code to use large module display when it is the first item in a row
                            output = communityLargeItem(item);
                            CurrentTileCount += 2;
                        } else {
                            output = communitySmallItem(item);
                            CurrentTileCount++;
                        }
                        feedWrapperElem.append(output);
                        
                    } else if (item.source == 'stackla') { // Static Stackla item (known as "Custom Tile")
                    
                        var output = imageFeatureItem(item);
                        CurrentTileCount++;
                        feedWrapperElem.append(output);
                        
                    }                    
                    
                    // Manage Counters
                    itemTookCount++;
                    firstItem = false;
                }
            });
            
            //console.log('itemTookCount', itemTookCount);
            ShiftDataPendingRepo(itemTookCount);
            //console.log('remain DataPendingRepo.length', DataPendingRepo.length);
            
            // Debug: Populate empty images with placeholders
            feedWrapperElem.trigger('CheckInvalidImage');
            
            feedWrapperElem.animate({
                opacity: 1
            }, 350, function () {
                // Animation complete.
            });        
        }

        
        
        /******************************
        ELEMENT BINDING
        ******************************/
        loadMoreElem.on('click', function() {
            loadMoreElem.trigger('EnterLoadingState');
            var url = GetRequestUrl();
            GetContent(true);
            return false;
        });
        
        loadMoreElem.on('EnterLoadingState', function() {
            loadMoreElem.addClass('loading');
        });
        
        loadMoreElem.on('ExitLoadingState', function() {
            loadMoreElem.removeClass('loading');
        });
        
        loadMoreElem.on('HideLoadMore', function() {
            loadMoreElem.hide();
        });
        
        loadMoreElem.on('ShowLoadMore', function() {
            loadMoreElem.show();
        });
        
        filterRowElem.on('click', '.filter-toggle', function() {
            if ($(this).hasClass('active'))
                return false;
            
            UpdateActiveFilter($(this));

            DataPendingRepo = [];
            CurrentTileCount = 0;
            CurrentPage = 1;
            ActiveFilter = $(this).attr('data-filter-type');
            ResetFeed();
            
            return false;
        });

        // This doesn't work - what's it meant to do?
        feedWrapperElem.on('CheckInvalidImage', function() {
            $(this).find('.social-item .image img').each(function() {
                if($(this).attr('src') == '') {
                    $(this).attr('src', 'http://placehold.it/600x600.gif&text=.');
                }
            });
        });

        

        /******************************
        INIT
        ******************************/
        parentElem.find('.filter-toggle:first-child').addClass('active');   // Set first item as active
        ActiveFilter = parentElem.find('.filter-toggle.active').data('filter-type');
        GetContent(true);
        SetFontFlowType();

    } catch (err) {
        console.log('[ERROR]', err);
    }
};
(function ($) {
    $(document).ready(function () {
        try {
            // Early exit if we have no live chat modules on the page
            if ($('.btn-livechat').length == 0)
                return;

            var markup = {
                regional:
                    '<!-- BEGIN Zopim Button Code -->' +
                    '<a href="javascript:$zopim.livechat.window.show()" class="btn primary small live-chat">' +
                    '    <span class="icon icon-chat"></span>' +
                    '    <span class="copy">Live Chat</span' +
                    '</a>' +
                    '<!-- END Zopim Button code -->' +
                    '<!--Start of Zopim Live Chat Script-->' +
                    '<script type="text/javascript">' +
                    'window.$zopim||(function(d,s){var z=$zopim=function(c){z._.push(c)},$=z.s=' +
                    'd.createElement(s),e=d.getElementsByTagName(s)[0];z.set=function(o){z.set.' +
                    '_.push(o)};z._=[];z.set._=[];$.async=!0;$.setAttribute("charset","utf-8");' +
                    '$.src="//v2.zopim.com/?2FEB6psef8kJIS87gVH27UjIyiCDDuy2";z.t=+new Date;$.' +
                    'type="text/javascript";e.parentNode.insertBefore($,e)})(document,"script");' +
                    '</script>' +
                    '<!--End of Zopim Live Chat Script-->',

                international:
                    '<!-- BEGIN LivePerson Button Code -->' +
                    '<div id="lpButDivID-1407115794211" class="fix-liveperson"></div>' +
                    '<script type="text/javascript" charset="UTF-8" src="https://server.iad.liveperson.net/hc/23502474/?cmd=mTagRepstate&site=23502474&buttonID=15&divID=lpButDivID-1407115794211&bt=1&c=1"></script>' +
                    '<!-- END LivePerson Button code -->' +
                    '<!-- BEGIN LivePerson Monitor. -->' +
                    '<script type="text/javascript">' +
                    'window.lpTag=window.lpTag||{};if(typeof window.lpTag._tagCount==="undefined"){window.lpTag={site:"23502474",section:lpTag.section||"",autoStart:lpTag.autoStart===false?false:true,ovr:lpTag.ovr||{},_v:"1.5.1",_tagCount:1,protocol:location.protocol,events:{bind:function(app,ev,fn){lpTag.defer(function(){lpTag.events.bind(app,ev,fn)},0)},trigger:function(app,ev,json){lpTag.defer(function(){lpTag.events.trigger(app,ev,json)},1)}},defer:function(fn,fnType){if(fnType==0){this._defB=this._defB||[];this._defB.push(fn)}else if(fnType==1){this._defT=this._defT||[];this._defT.push(fn)}else{this._defL=this._defL||[];this._defL.push(fn)}},load:function(src,chr,id){var t=this;setTimeout(function(){t._load(src,chr,id)},0)},_load:function(src,chr,id){var url=src;if(!src){url=this.protocol+"//"+((this.ovr&&this.ovr.domain)?this.ovr.domain:"lptag.liveperson.net")+"/tag/tag.js?site="+this.site}var s=document.createElement("script");s.setAttribute("charset",chr?chr:"UTF-8");if(id){s.setAttribute("id",id)}s.setAttribute("src",url);document.getElementsByTagName("head").item(0).appendChild(s)},init:function(){this._timing=this._timing||{};this._timing.start=(new Date()).getTime();var that=this;if(window.attachEvent){window.attachEvent("onload",function(){that._domReady("domReady")})}else{window.addEventListener("DOMContentLoaded",function(){that._domReady("contReady")},false);window.addEventListener("load",function(){that._domReady("domReady")},false)}if(typeof(window._lptStop)=="undefined"){this.load()}},start:function(){this.autoStart=true},_domReady:function(n){if(!this.isDom){this.isDom=true;this.events.trigger("LPT","DOM_READY",{t:n})}this._timing[n]=(new Date()).getTime()},vars:lpTag.vars||[],dbs:lpTag.dbs||[],ctn:lpTag.ctn||[],sdes:lpTag.sdes||[],ev:lpTag.ev||[]};lpTag.init()}else{window.lpTag._tagCount+=1}' +
                    '</script>' +
                    '<!-- END LivePerson Monitor. -->'
            };

            $.ajax({
                url: '/api/Location/GetByIP?nocache',
                dataType: 'json',
                success: function (data, textStatus, jqXHR) {

                    data = data || { CountryCode: "Unknown" };

                    $('.btn-livechat').each(function () {
                        if (data.CountryCode == "AU" || data.CountryCode == "NZ") {
                            if ($(this).data('regional-enabled') == true) {
                                $(this).replaceWith(markup.regional);
                            }
                        }
                        else if (data.CountryCode != "Unknown") {
                            if ($(this).data('international-enabled') == true) {
                                $(this).replaceWith(markup.international);
                            }
                        }
                    });

                    window.setTimeout(function () {
                        $('.fix-liveperson a, .live-chat').bind('click', function () {
                            DSTAPI2.call('event', {
                                category: 'Contact',
                                action: 'Button click',
                                label: 'LiveChat'
                            });
                        });
                    }, 500)
                },
                error: function (jqXHR, textStatus, errorThrown) { }
            });
        } catch (err) {
            console.log('[ERROR]', err);
        }
    });
})(jq111);
function initLocationWidget($, self) {
    try {
        console.log('init Location Widget');

        var w = window.innerWidth;
        var itemWidth;

        if( w >= 480 && w <= 768 ){
            itemWidth = 125;
        } else {
            itemWidth = 173;
        }

        $.ajax({
            url: '/api/Location/GetAll?nocache',
            dataType: 'json',
            success: function (data, textStatus, jqXHR) {
                
                if (data.length > 0)
                    $('.location-slider-wrap', self).empty();

                for (var i = 0, j = data.length; i < j; i++)
                {
                    $('.location-slider-wrap', self).append(
                        '<div class="location-item">' +
                        '    <div class="icon ' + data[i].IconClass + '"></div>' +
                        '    <div class="copy">' +
                        '        <p>' +
                        '            ' + data[i].ShortDescription + ' <br />' +
                        '            ' + data[i].DocumentName +
                        '        </p>' +
                        '    </div>' +
                        '</div>');
                }

                self.each(function () {

                    navRow = $('.nav-row', this);
                    contentRow = $('.content-block', this);
                    //console.log(contentRow);

                    $('.slider-col', this).flexslider({
                        selector: '.location-slider-wrap .location-item',
                        animation: 'slide',
                        animationSpeed: 800,
                        slideshow: false,
                        animationLoop: false,
                        controlsContainer: navRow,
                        itemWidth: itemWidth,
                        touch: true,
                        directionNav: true,
                        prevText: '',
                        nextText: '',
                        minItems: 2,
                        maxItems: 3,
                        move: 3,

                        start: function (slider) {

                            //Fade in on start
                            slider.animate({
                                opacity: 1
                            }, 1000, function () {
                                // Animation complete.
                            });
                        }
                    });
                });

            },
            error: function (jqXHR, textStatus, errorThrown) { }
        });

    } catch (err) {
        console.log('[ERROR]', err);
    }
};

var markers = [];
var accomMarkers = [];
var foodwineMarkers = [];
var activityMarkers = [];
var wifiMarkers = [];

var markerTypes = [];
var filterMap;

function initMapWidgetFilter($, parentElem, mapMode, zoomLevel){

	console.log('init map widget with filter');

	/******************************
	DEFINE MAP MODE, VERT OR HORIZ
	******************************/
	mapZoom = zoomLevel;

	infoBoxWidth = '490px';		 //Note - total width INCLUDING offset close button
	infoBoxHeight = '350px';

	if (window.screen.width < 600) {
		infoBoxWidth = '300px';
	}

	//if (mapMode == 'horizontal'){

	//	infoBoxWidth = '390px';		 //Note - total width INCLUDING offset close button
	//	infoBoxHeight ='490px';

	//} else {

	//	infoBoxWidth = '390px';		 //Note - total width INCLUDING offset close button
	//	infoBoxHeight = '490px';

	//}

	/******************************
	INITIAL MAP RENDERING AND STYLING
	******************************/

	//Define Map Elements

	var mapElem = document.getElementById('map-render-filter');

	//Location + Data
	var HamiltonLat = -20.356076;
	var HamiltonLong = 148.953340;

	var HamiltonMap = 'custom_style';

	var HamiltonSkin = [{
		"featureType": "all",
		"stylers": [{
			"color": "#FFFFFF"
		}]
		}, {
			"featureType": "all",
			"elementType": "labels.text.fill",
			"stylers": [{
				"color": "#000000"
			}]
		},
		{
			"featureType": "all",
			"elementType": "labels.text.stroke",
			"stylers": [{
				"color": "#FFFFFF"
			}]
		}, {
	    "featureType": "water",
	    "stylers": [{
			"color": "#e2ebf0"
	    }]
		}, {
			"featureType": "water",
			"stylers": [{
				"color": "#e2ebf0"
			}]
		}, {
	    "featureType": "poi",
	    "elementType": "geometry.fill",
	    "stylers": [{
	        "color": "#c0cadc"
	    }]
	}, {
	    "featureType": "road.local",
	    "stylers": [{
	        "visibility": "off"
	    }]
	}, {
	    "featureType": "transit",
	    "stylers": [{
	        "visibility": "off"
	    }]
	}, {
	    "featureType": "poi",
	    "elementType": "labels",
	    "stylers": [{
	        "visibility": "off"
	    }]
	}]

	var myLatlng = new google.maps.LatLng(HamiltonLat, HamiltonLong);

	var mapOptions = {
		zoom: mapZoom,
		center: new google.maps.LatLng(HamiltonLat, HamiltonLong),
		//disableDefaultUI: true,
		mapTypeId: HamiltonMap,
		minZoom: mapZoom,
		panControl: false,
		streetViewControl: false,
		mapTypeControl: false,

	    zoomControlOptions: {
    	    style: google.maps.ZoomControlStyle.SMALL,
        	position: google.maps.ControlPosition.TOP_RIGHT
    	}

	};

	var styledMapOptions = {
		name: 'Hamilton Map Style'
	};

	//Draw the map + set styles
	filterMap = new google.maps.Map(mapElem, mapOptions);
	var customMapType = new google.maps.StyledMapType(HamiltonSkin, styledMapOptions);
	filterMap.mapTypes.set(HamiltonMap, customMapType);

	/******************************
	DEFINE THE MARKER DATA SETS
	******************************/
	var now = new Date();
	var cacheBuster = `${now.getFullYear()}-${(now.getMonth() + 1)}-${now.getDate()}`;
	accomDataUrl = '/static/api/map/hotel.json?d=' + cacheBuster;
	foodWineDataUrl = '/static/api/map/foodandwine.json?d=' + cacheBuster;
	activityDataUrl = '/static/api/map/activity.json?d=' + cacheBuster;
	wifiDataUrl = '/static/api/map/wifihotspot.json?d=' + cacheBuster;
	walkingToursDataUrl = '/static/api/map/walkingtours.json?d=' + cacheBuster;

	$.getJSON(accomDataUrl, function(data) {
	    var i = 0;
    	var dataLength = data.length;
		//Interate over data object, and render markers for each
		while ( i <  dataLength ) {
			accomMarkers.push(data[i]);
			i++;
		}
	});

	$.getJSON(foodWineDataUrl, function(data) {
	    var i = 0;
    	var dataLength = data.length;

		//Interate over data object, and render markers for each
		while ( i <  dataLength ) {
			foodwineMarkers.push(data[i]);
			i++;
		}
	});

	$.getJSON(activityDataUrl, function(data) {
	    var i = 0;
    	var dataLength = data.length;

		//Interate over data object, and render markers for each
		while ( i <  dataLength ) {
			activityMarkers.push(data[i]);
			i++;
		}
	});
	
	$.getJSON(walkingToursDataUrl, function(data) {
		var i = 0;
		var dataLength = data.length;
		//Interate over data object, and render markers for each
		while (i < dataLength) {
			activityMarkers.push(data[i]);
			i++;
		}
	});
	
    $.getJSON(wifiDataUrl, function(data) {
        var i = 0;
        var dataLength = data.length;

        //Interate over data object, and render markers for each
        while (i < dataLength) {
            wifiMarkers.push(data[i]);
            i++;
        }
    });


	/******************************
	MARKER CLEARING AND RENDERING
	******************************/

	//Define buttons
	var filterAccomm = $('a.accommodation', parentElem);
	var filterFoodWine = $('a.food-wine', parentElem);
    var filterActivity = $('a.see-do', parentElem);
    var filterWifi = $('a.wifi-hotspot', parentElem);

    var SetMarkers = function(parentElem, activeElem, targetMarkers) {
        var openInfoBoxElem = $('.infoBox', parentElem);
        openInfoBoxElem.remove();
		markers = markers.concat(targetMarkers);
        renderMarkers($, filterMap, targetMarkers);

        //Toggle button states
        var existingActiveElem = $('.key .active', parentElem);
        existingActiveElem.removeClass('active');
        activeElem.addClass('active');
    };

	filterAccomm.click(function() {
		if($(this).hasClass('active')){
			//Do nothing
		} else {
            SetMarkers(parentElem, $(this), accomMarkers);
		}
		return false;
	});

	filterFoodWine.click(function() {
		if($(this).hasClass('active')){
			//Do nothing
		} else {
            SetMarkers(parentElem, $(this), foodwineMarkers);
		}
		return false;
	});

	filterActivity.click(function() {
		if($(this).hasClass('active')){
			//Do nothing
		} else {			
            SetMarkers(parentElem, $(this), activityMarkers);
		}
		return false;
    });

	filterWifi.click(function() {
        if ($(this).hasClass('active')) {
            //Do nothing
        } else {
            SetMarkers(parentElem, $(this), wifiMarkers);
        }
        return false;
    });

    //-- Initialise first filter
    $( document ).ajaxComplete(function() {
        var initFilter = parentElem.data('filter');
        if( (initFilter == null) || (initFilter == '')) {
            SetMarkers(parentElem, filterAccomm, accomMarkers);
        } else if (initFilter == 'Accommodation') {
            SetMarkers(parentElem, filterAccomm, accomMarkers);
        } else if (initFilter == 'FoodAndWine') {
            SetMarkers(parentElem, filterFoodWine, foodwineMarkers);
        } else if (initFilter == 'SeeAndDo') {
            SetMarkers(parentElem, filterActivity, activityMarkers);
        } else if (initFilter == 'WifiHotspot') {
            SetMarkers(parentElem, filterWifi, wifiMarkers);
        }

    });

    filterAccomm.click();

}
function initMapWidget($, parentElem, mapMode, zoomLevel) {

	console.log('init map widget');

	/******************************
	DEFINE MAP MODE, VERT OR HORIZ
	******************************/
	mapZoom = zoomLevel;

	if (mapMode == 'horizontal') {

		infoBoxWidth = '190px';		 //Note - total width INCLUDING offset close button
		infoBoxHeight = '220px';

	} else {

		infoBoxWidth = '250px';		 //Note - total width INCLUDING offset close button
		infoBoxHeight = '260px';

	}

	/******************************
	INITIAL MAP RENDERING AND STYLING
	******************************/
	var liveURL = '/static/api/map/featured.json';
	var sampleURL = '/static/js/data/map-data-sample_v2.json';

	var dataURL = liveURL;

	//Define Elements
	var defaultMap;
	var mapElem = document.getElementById('map-render');

	//Location + Data
	var HamiltonLat = -20.356076;
	var HamiltonLong = 148.953340;

	var HamiltonMap = 'custom_style';

	var HamiltonSkin = [{
		"featureType": "all",
		"stylers": [{
			"color": "#FFFFFF"
		}]
	}, {
		"featureType": "all",
		"elementType": "labels.text.fill",
		"stylers": [{
			"color": "#000000"
		}]
	}, {
		"featureType": "all",
		"elementType": "labels.text.stroke",
		"stylers": [{
			"color": "#FFFFFF"
		}]
	}, {
		"featureType": "landscape",
		"stylers": [{
			"color": "#ffffff"
		}]
	}, {
		"featureType": "water",
		"stylers": [{
			"color": "#e2ebf0"
		}]
	}, {
		"featureType": "poi",
		"elementType": "geometry.fill",
		"stylers": [{
			"color": "#c0cadc"
		}]
	}, {
		"featureType": "road.local",
		"stylers": [{
			"visibility": "off"
		}]
	}, {
		"featureType": "transit",
		"stylers": [{
			"visibility": "off"
		}]
	}, {
		"featureType": "poi",
		"elementType": "labels",
		"stylers": [{
			"visibility": "off"
		}]
	}]

	var myLatlng = new google.maps.LatLng(HamiltonLat, HamiltonLong);

	var mapOptions = {
		zoom: mapZoom,
		center: new google.maps.LatLng(HamiltonLat, HamiltonLong),
		//disableDefaultUI: true,
		mapTypeId: HamiltonMap,
		minZoom: mapZoom,
		panControl: false,
		streetViewControl: false,
		mapTypeControl: false,

		zoomControlOptions: {
			style: google.maps.ZoomControlStyle.SMALL,
			position: google.maps.ControlPosition.TOP_RIGHT
		}

	};

	var styledMapOptions = {
		name: 'Hamilton Map Style'
	};

	//Draw the map + set styles
	defaultMap = new google.maps.Map(mapElem, mapOptions);
	var customMapType = new google.maps.StyledMapType(HamiltonSkin, styledMapOptions);
	defaultMap.mapTypes.set(HamiltonMap, customMapType);

	//Render appropriate markers
	$.getJSON(dataURL, function (data) {
		//console.log(data);
		renderMarkers($, defaultMap, data);
	});
}
/******************************
DROP MARKERS
******************************/

var renderedMakers = [];

function renderMarkers($, map, data){
	//Define the info box content
	var contentString = function(windowClass, nodeId, docType, docImg, docName, docDesc, docURL){
		var snippet =   '<div class="info-window social-favourable ' +infoWindowClass+'" data-node-id="'+nodeId+'">'+
                            '<div class="img"><img src="'+docImg+'"></div>'+
                            '<div class="content">'+
                                '<p class="title">'+docName+'</p>'+
                                '<div class="desc">'+docDesc+'</div>'+
                                '<a class="more-link" href="'+docURL+'">Find out more</a>'+
                            '</div>'+
                            '<div class="social-plugin">'+
                                '<div class="share-triggers">'+
                                    '<a href="#" class="trigger favourite not-favourite">'+
                                        '<span class="safe-font">Favourites</span><span class="icon icon-add"></span><span class="icon icon-remove"></span>'+
                                    '</a>'+
                                '</div>'+
                            '</div>'+
                        '</div>';
        return snippet;
	}

	//Info Box options
	//API REF: https://google-maps-utility-library-v3.googlecode.com/svn/trunk/infobox/docs/examples.html
	var myOptions = {
		content: contentString,
		boxStyle: {
			width: infoBoxWidth,
			height: infoBoxHeight
		},
		pixelOffset: new google.maps.Size(20, -50),
		closeBoxURL: "/static/img/modules/map-widget/info-close-btn.png'",
		enableEventPropagation: true
	};

	var ibLabel = new InfoBox(myOptions);

	//Delete rendered markers and empty array
	for( var k in renderedMakers ) {
		renderedMakers[k].setMap(null);
	}


	renderedMakers = [];

	if(data){
	    var i = 0;
	    var dataLength = data.length;
		var iconBase = '/static/img/modules/map-widget/';
		var latitude = 0;
		var longitude = 0;

		//Interate over data object, and render markers for each
		while ( i <  dataLength ) {

			//console.log(data[i].DocumentUrl);

			//Define the pin type, based on data
		    if (data[i].DocumentType == 'HamiltonIsland.Hotel') {

				iconString = iconBase + 'Map-Pin_Accommodation.png'

			} else if (data[i].DocumentType == 'HamiltonIsland.Activity' || (data[i].Details != null && data[i].Details.PrimaryCategory == 'Audio Tours')){
				
				iconString = iconBase + 'Map-Pin_Activity.png'

			} else {

				iconString = iconBase + 'Map-Pin_FoodAndWine.png'
			}

			latitude = (data[i].Details != null && data[i].Details.PrimaryCategory == 'Audio Tours') ? data[i].Location.Latitude : data[i].Latitude;
			longitude = (data[i].Details != null && data[i].Details.PrimaryCategory == 'Audio Tours') ? data[i].Location.Longitude : data[i].Longitude;
			
			//Append the markers to the map
			renderedMakers[i] = new google.maps.Marker({
				position: new google.maps.LatLng(latitude, longitude),
			 	icon: iconString,
				map: map,
				id: i,
				title: (data[i].Details != null && data[i].Details.PrimaryCategory == 'Audio Tours') ? data[i].Details.Title : data[i].DocumentName
			});

			renderedMakers[i].setMap(map);

			//Add event listeners to render
			//new content in the info box
			google.maps.event.addListener(renderedMakers[i], 'click', function() {

				if(data[this.id].DocumentType == 'HamiltonIsland.Hotel'){

					infoWindowClass = 'accomodation'

				} else if (data[this.id].DocumentType == 'HamiltonIsland.Activity' || (data[this.id].Details != null && data[this.id].Details.PrimaryCategory == 'Audio Tours')){

					infoWindowClass = 'activity'

				} else {

					infoWindowClass = 'food-wine'
				};

				//Pass data content through to content string func and
				//get markup back
				ibLabel.setContent(contentString(
					infoWindowClass,
					(data[this.id].Details != null && data[this.id].Details.PrimaryCategory == 'Audio Tours') ? data[this.id].Details.ID : data[this.id].ID,
					data[this.id].DocumentType,
					(data[this.id].Details != null && data[this.id].Details.PrimaryCategory == 'Audio Tours') ? data[this.id].Details.Image : data[this.id].ImageUrl,
					(data[this.id].Details != null && data[this.id].Details.PrimaryCategory == 'Audio Tours') ? data[this.id].Details.Title : data[this.id].DocumentName,
					(data[this.id].Details != null && data[this.id].Details.PrimaryCategory == 'Audio Tours') ? data[this.id].Content[0].Content : (data[this.id].ShortDescription != null ? data[this.id].ShortDescription : ''),
					(data[this.id].Details != null && data[this.id].Details.PrimaryCategory == 'Audio Tours') ? data[this.id].Details.PageUrl : (data[this.id].AbsoluteURL != null ? data[this.id].AbsoluteURL : '')
				));

				ibLabel.open(map, this);
                
                //-- Bind to Social Plugin
                google.maps.event.addListener(ibLabel, 'domready', function() { 
                    //console.log("div_", this.div_, ibLabel.div_);
                    $('.social-favourable', this.div_).HamiltonIslandSocial();
                });
			});

			i++;
		}
	} else {

	}
}
+function ($) {

    $.namespace('HamiltonIsland', {
        InitMobileNav: function (settings) {
            console.log('HamiltonIsland.WebParts.Navigation.MobileNav.InitMobileNav', settings);

            this.each(function () {
                $('.dropdown-toggle', this).dropdown();
            });
        }
    });

    $(document).ready(function () {
        $('.subnav-mobile').HamiltonIsland().InitMobileNav();
    });

}(jq111);
+function ($) {

    $.namespace('HamiltonIsland', {
        InitPrimaryNav: function (settings) {
            console.log('HamiltonIsland.WebParts.Navigation.InitPrimaryNav', settings);

            this.each(function () {
                var navTriggerElem = $('.sub-nav-parent', this);
                var subNavSelector = '.sub-nav';

                //Unbind events, to prevent mobile conflicts
                function unbindPrimaryNav() { $(navTriggerElem).unbind('mouseenter').unbind('mouseleave'); };
                function bindPrimaryNav() {
                    navTriggerElem.hoverIntent({

                        interval: 50,

                        over: function () {
                            $(this).addClass('active');

                            //Animate the hover state element only
                            var targetHoverElem = $(this).children('a').children('.hover-state');
                            targetHoverElem.css('display', 'block');
                            targetHoverElem.animate({ opacity: 1 }, 150, function () { });

                            //Animate the subnav
                            var targetSubnav = $(this).find(subNavSelector);
                            targetSubnav.css('display', 'block');
                            targetSubnav.animate({ opacity: 1 }, 150, function () { });
                        },
                        out: function () {
                            $(this).removeClass('active');

                            //Animate the hover state element only
                            var targetHoverElem = $(this).children('a').children('.hover-state');
                            targetHoverElem.animate({ opacity: 0 }, 150, function () { targetHoverElem.css('display', 'none'); });

                            //Animate the subnav
                            var targetSubnav = $(this).find(subNavSelector);
                            targetSubnav.animate({ opacity: 0 }, 150, function () { targetSubnav.css('display', 'none'); });
                        }
                    });
                };

                $(this).bind({
                    'sm': function () { unbindPrimaryNav(); },
                    'md': function () { unbindPrimaryNav(); },
                    'lg': function () { bindPrimaryNav(); },
                    'xlg': function () { bindPrimaryNav(); }
                });

                bindPrimaryNav();
            });
        }
    });

    $(document).ready(function () {
        $('#primary-nav').HamiltonIsland().InitPrimaryNav();
    });

}(jq111);
+function ($) {

    function formSubmission(action, method, input) {
        "use strict";
        var form;
        form = $('<form />', {
            action: action,
            method: method,
            style: 'display: none;'
        });
        if (typeof input !== 'undefined') {
            $.each(input, function (name, value) {
                $('<input />', {
                    type: 'hidden',
                    name: name,
                    value: value
                }).appendTo(form);
            });
        }

        DSTAPI2.call('page', { url: '/e-news/complete' });

        form.appendTo('body').submit();
    }

    $.namespace('HamiltonIsland', {
        InitNewsletter: function (settings) {
            console.log('HamiltonIsland.WebParts.Newsletter.InitNewsletter', settings);

            this.each(function () {
                var form = $(this);

                // REF: http://stackoverflow.com/a/13937065/174774
                $('.submit-button', this).click(function (e) {
                    e.preventDefault();

                    var context = {
                        'thx': $('input[name="thx"]', form).val(),
                        'err': $('input[name="err"]', form).val(),
                        'SubAction': 'sub_add',
                        'MID': 6012536,
                        'lid': $('input[name="lid"]', form).val(),
                        'Email Address': $('input[name="Email Address"]', form).val(),
                        'Australian': true
                    };

                    switch (form.data('site-name')) {
                        case 'HamiltonIsland.GolfClub':
                            context.lid = 12936;
                            break;
                        case 'HamiltonIsland.RaceWeek':
                            context.lid = 12937;
                            break;
                        case 'HamiltonIsland':
                        default:
                            context.lid = 3958;
                            break;
                    }

                    $.ajax({
                        url: '/api/OnlineMarketing/Contact?nocache',
                        dataType: 'json',
                        method: 'POST',
                        data: { 'ContactEmail': context['Email Address'] },
                        success: function (data, textStatus, jqXHR) { },
                        error: function (jqXHR, textStatus, errorThrown) { }
                    });

                    $.ajax({
                        url: '/api/Location/GetByIP?nocache',
                        dataType: 'json',
                        success: function (data, textStatus, jqXHR) {
                            data = data || { CountryCode: 'AU' };
                            context.Australian = data.CountryCode == 'AU';

                            switch (form.data('site-name')) {
                                case 'HamiltonIsland':
                                    $.ajax({
                                        url: '/api/OnlineMarketing/Persona?nocache',
                                        dataType: 'json',
                                        success: function (data, textStatus, jqXHR) {

                                            data = data || { PersonaName: 'Couples' };

                                            switch (data.PersonaName) {
                                                case 'Couples':
                                                    context.lid = 3958;
                                                    break;
                                                case 'Family':
                                                    context.lid = 3959;
                                                    break;
                                                case 'Luxury':
                                                    context.lid = 3960;
                                                    break;
                                            }

                                            formSubmission(form.data('action'), 'POST', context);
                                        },
                                        error: function (jqXHR, textStatus, errorThrown) {
                                            formSubmission(form.data('action'), 'POST', context);
                                        }
                                    });
                                    break;
                                case 'HamiltonIsland.GolfClub':
                                case 'HamiltonIsland.RaceWeek':
                                default:
                                    formSubmission(form.data('action'), 'POST', context);
                                    break;
                            }
                        },
                        error: function (jqXHR, textStatus, errorThrown) {
                            formSubmission(form.data('action'), 'POST', context);
                        }
                    });
                });
            });
        }
    });

    $(document).ready(function () {
        $('.newsletter-signup-form').HamiltonIsland().InitNewsletter();
        $('.signup-form').HamiltonIsland().InitNewsletter();
    });

}(jq111);
function initPackageListingWidget($, webParts) {
    try {
        webParts.each(function () {
            console.log('package widget - init');
            
            // Properties
            var parentElem = $(this);
            var dropdownOption = parentElem.find('.option.dropdown');
            var listLink = dropdownOption.find('.dropdown-menu a');
            var resetButton = parentElem.find('.reset-button');
            
            var calendarOption = parentElem.find('.option.calendar');
            var travelInput = parentElem.find('.travel-date');
            var travelIcon = travelInput.next('.add-on');
            var dateInput = calendarOption.find('input[type=date]');
            var textInput = calendarOption.find('input[type=text]');
            
            
            // Methods
            function SetPackageVisibility(targetPackageElem, selectedHotelNodeId, selectedTravelDate) {
                var toShow = true;
                
                // Filter by Hotel
                if(selectedHotelNodeId != '') {
                    var availableHotelNodeIds = targetPackageElem.data('hotel-node-ids').toString().split(','); // toString is needed to prevent number value been interpreted as Int32 type and then triggers error with .split() method.
                    if($.inArray(selectedHotelNodeId, availableHotelNodeIds) == -1) {
                        toShow = false;
                    }
                }
                
                // Filter by From Date
                if (selectedTravelDate != '' && selectedTravelDate != undefined && selectedTravelDate != "Travel Date") {
                    var selectedTravelDateModel = moment(selectedTravelDate, 'DD/MM/YYYY');
                    var targetFromModel = moment(targetPackageElem.data('from-date'), 'YYYY-MM-DD');
                    var targetTillModel = moment(targetPackageElem.data('to-date'), 'YYYY-MM-DD');
                    if(selectedTravelDateModel < targetFromModel || selectedTravelDateModel > targetTillModel) {
                        toShow = false;
                    }
                }
                
                // Determine visibility
                if(toShow) {
                    if(targetPackageElem.not(':visible')) {
                        targetPackageElem.fadeIn(400);
                    }
                } else {
                    if(targetPackageElem.is(':visible')) {
                        targetPackageElem.fadeOut(400);
                    }
                }
            }
            
            function InitCalendar() {

                if ((Modernizr.touch)) {

                    textInput.remove();
                    dateInput.show();


                } else {

                    dateInput.remove();
                    textInput.show();

                    travelInput.datepicker({
                        numberOfMonths: 1,
                        showButtonPanel: false,
                        pickTime: false,
                        dateFormat: "dd/mm/yy",
                        defaultDate: "",
                        minDate: new Date(),
                        onSelect: function () {
                            parentElem.trigger('FilterPackageList');
                        }
                    });
                    
                    //Bind icons
                    travelIcon.click(function () {
                        travelInput.datepicker('show');
                    });

                }

            }
            
            // Bindings
            listLink.click(function (e) {
                var selectedText = $(this).html();
                var selectedVal = $(this).data('val');
                var targetDropdownElem = $(this).closest('.dropdown');
                
                targetDropdownElem.find('.copy').html(selectedText);
                targetDropdownElem.data('selected-val', selectedVal);
                //targetDropdownElem.attr('data-selected-val', selectedVal);
                
                parentElem.trigger('FilterPackageList');
                
                e.preventDefault();
            });
            
            resetButton.click(function(e) {
                //console.log('reset button clicked');
                parentElem.find('.custom-col .option').each(function() {
                    //console.log('boom, ', $(this));
                    $(this).data('selected-val', '');
                    var defaultVal = $(this).data('default-val');
                    
                    $(this).find('input[type=date]').val(moment().format('YYYY-MM-DD'));

                    if($(this).find('.copy').length > 0) {
                        $(this).find('.copy').html(defaultVal);
                    } else if($(this).find('input[type=text]').length > 0) {
                        $(this).find('input[type=text]').val(defaultVal);
                    }
                });

                parentElem.trigger('FilterPackageList');
                e.preventDefault();
            });

            dateInput.change(function () {
                console.log('dateInput changed');
                parentElem.trigger('FilterPackageList');
            });

            travelInput.change(function () {
                console.log('travelInput changed');
                parentElem.trigger('FilterPackageList');
            });
            
            parentElem.on('FilterPackageList', function (e) {
                var selectedHotelVal = String(parentElem.find('.operators .option.hotel').data('selected-val'));

                var selectedTravelDateVal;
                
                if ((Modernizr.touch)) {
                    console.log('input[type=date]');
                    selectedTravelDateVal = parentElem.find('input[type=date]').val();
                    selectedTravelDateVal = moment(selectedTravelDateVal, 'YYYY-MM-DD').format('DD/MM/YYYY');
                }
                else {
                    console.log('.travel-date');
                    selectedTravelDateVal = parentElem.find('.travel-date').val();
                }
                
                console.log('selectedHotelVal: [', selectedHotelVal, '], selectedTravelDateVal: [', selectedTravelDateVal, ']');
                
                parentElem.find('.package-thumbnail-item').each(function() {
                    SetPackageVisibility($(this), selectedHotelVal, selectedTravelDateVal);
                });
                
                e.preventDefault();
            });
            
            
            
            // Init
            parentElem.find('.operators .dropdown-toggle').dropdown();
            InitCalendar();
        });
    } catch (err) {
        console.log('[ERROR]', err);
    }
};
function initRaceWeekSponsors($, parentElem) {
    try {
        console.log('init Race Week Sponsors');

        parentElem.each(function () {

            $('.sponsors-slider', this).flexslider({
                selector: '.slide-wrap .slide',
                animation: 'slide',
                animationSpeed: 800,
                slideshow: false,
                animationLoop: false,
                itemWidth: 160,
                touch: true,
                directionNav: false,
                minItems: 2,
                maxItems: 6,
                move: 6,

                start: function (slider) {

                    //Fade in on start
                    slider.animate({
                        opacity: 1
                    }, 1000, function () {
                        // Animation complete.
                    });
                }
            });

            $(this).flowtype({
                minimum: 00,
                maximum: 480,
                minFont: 14,
                maxFont: 16,
                fontRatio: 18
            });
        });

    } catch (err) {
        console.log('[ERROR]', err);
    }
};
function initReviewModule($) {
    try {
        $('.reviews').each(function () {

            //FlexSlider calls
            var reviewSlide = $(this).find('.slide');

            if (reviewSlide.length > 1) {


                $(this).flexslider({
                    selector: '.slide-wrapper .slide',
                    animation: 'slide',
                    animationLoop: false,
                    directionNav: false,
                    slideshow: false,
                    touch: true
                });
            }

            //Flowtype init
            $(this).flowtype({
                minimum: 0,
                maximum: 480,
                minFont: 16,
                maxFont: 16,
                fontRatio: 24
            });
        });

    } catch (err) {
        console.log('[ERROR]', err);
    }
};
function initGenericSearchModule($, parentElem) {

    var globalSearchInput = $('input.search-box');
    var searchActive = false;

    //Bind search input
    globalSearchInput.focus(function () {
        $(this).val('');
        $(this).addClass('active-search');
        searchActive = true;
    });

    $(window).keydown(function(event){

        if(event.keyCode == 13) {

            if (searchActive == true){

                /*var activeSearchInput = $('.search-box.active-search')
                var searchQuery = activeSearchInput.val();
                var searchResultsUrl = 'http://' + searchURL + searchQuery;
                window.location = searchResultsUrl;
                */
                var parentContainer = $('.search-box.active-search').closest(parentElem);
                var searchButton = $(parentContainer).find('.search-btn');
                $(searchButton).click();

                event.preventDefault();
                return false;

            } else {

                event.preventDefault();
                return false;

            }

            event.preventDefault();
            return false;

        }
    });


    try {
        console.log('generic search module - init');

        parentElem.each(function() {
            // Selectors
            searchSubmitBtn = $('.search-btn', $(this));

            // Search vars
            defaultURL = window.location.host;
            var checkCulture = ['/chs', '/cht', '/de', '/es', '/fr', '/it', '/jp', '/kr'];
            for (var i = 0; i < checkCulture.length; i++) {
                if (window.location.href.indexOf(checkCulture[i]) > -1) {
                    defaultURL = defaultURL + checkCulture[i];
                }
            }
            searchURL = defaultURL + '/search?searchmode=allwords&searchtext=';
            searchQuery = '';

            /******************************
            BIND SEARCH INPUT AND SUBMITS
            ******************************/

            searchSubmitBtn.click(function () {
                var searchInput = $(this).closest('.search-engine').find('.search-box').first();
                var searchQuery = searchInput.val();
                var searchResultsUrl = 'http://' + searchURL + searchQuery;

                dataLayer.push({ 'SearchTerm': searchQuery });

                window.location = searchResultsUrl;
            });
        });
    } catch (err) {
        console.log('[ERROR]', err);
    }
};
function initSearchModule($, parentElem) {
    try {
        console.log('search module - init');

        var searchInput = parentElem.find('.gsc-input');
        var searchTermDisplay = parentElem.find('.search-term');

        var searchParam = location.search.split('searchtext=')[1] ? location.search.split('searchtext=')[1] : '';

        if (searchParam.split('&')[0]) {
            searchParam = searchParam.split('&')[0];
        }

        searchTermDisplay.text((decodeURIComponent(searchParam)));

    } catch (err) {
        console.log('[ERROR]', err);
    }
};
+function ($) {

    var RenderItem = function (parent, settings, data) {
        var template = compiledTemplates[settings.template][data.source];

        if (template == undefined) return null;

        return parent.append(template(data));
    };

    var RenderRow = function (parent, settings, data, startIndex) {
        var template = compiledTemplates[settings.template][settings.rowTemplate];
        if (template == undefined) return;

        var i = startIndex, j = 0, row = $(template(null));

        while (j < settings.rowItems && i < data.length) {
            if (RenderItem(row, settings, data[i++]) != null)
                j++;
        }

        parent.append(row);

        return i;
    };

    $.namespace('HamiltonIsland', {
        InitSocialSupport: function (settings) {
            console.log('HamiltonIsland.WebParts.Social.InitSocialSupport', settings);

            this.each(function () {
                var nodeId = parseInt($(this).data('node-id'));

                if (nodeId > 0) { // Validate data-node-id of module
                    $(this).HamiltonIslandSocial();
                }
            });
        },
        LoadFeed: function (settings) {
            console.log('HamiltonIsland.WebParts.Social.LoadFeed', settings);

            settings = settings || {};
            settings.template = settings.template || 'stackla_small';
            settings.rowTemplate = settings.rowTemplate || 'slide';
            settings.rowItems = settings.rowItems || 4;

            this.each(function () {

                var data = {};
                data.tags = settings.tags || $(this).data('stackla-tags');
                data.pageNo = settings.pageNo || $(this).data('stackla-pageno');
                data.pageCount = settings.pageCount || $(this).data('stackla-pagecount');

                var self = this;

                $.ajax({
                    url: '/api/Stackla',
                    data: data,
                    dataType: 'JSON',
                    method: 'GET',
                    success: function (data, textStatus, jqXHR) {
                        var target = self;

                        if (settings.rowSelector != undefined)
                            target = $(settings.rowSelector, self);
                        
                        // Option to remove old elements - used when changing filter
                        if (settings.clear)
                            target.empty();

                        var i = 0;
                        while (i < data.length) {
                            i = RenderRow(target, settings, data, i);
                        }

                        if (typeof settings.success == "function")
                            $.proxy(settings.success, self)(settings);
                    },
                    error: function (jqXHR, textStatus, errorThrown) { }
                });
            });
        }
    });

    $(document).ready(function () {
        $('.social-module').HamiltonIsland().LoadFeed({
            pageCount: 8 * 4, // Try to retrieve 8 pages of 4 items maximum
            rowSelector: '.slide-wrapper',
            success: function (settings) {
                var socialSlide = $(this).find('.slide');

                if (socialSlide.length > 1) {
                    $(this).flexslider({
                        selector: '.slide-wrapper .slide',
                        animation: 'slide',
                        controlsContainer: '.controls-row',
                        animationLoop: false,
                        directionNav: false,
                        slideshow: false,
                        touch: true,
                        start: function (slider) { $('.social-module').animate({ opacity: 1 }, 1000, function () { }); }
                    });
                } else {
                    //Only one slide, so fade in anyway
                    $('.social-module').animate({ opacity: 1 }, 1000, function () { });
                }

                //Flowtype init
                $(this).flowtype({
                    minimum: 0,
                    maximum: 960,
                    minFont: 14,
                    maxFont: 16,
                    fontRatio: 36
                });
            }
        })
        $('.social-favourable, .social-shareable').HamiltonIsland().InitSocialSupport();
    });

}(jq111);
+function ($) {

    $.namespace('HamiltonIsland', {
        InitSocialHeader: function (settings) {
            console.log('HamiltonIsland.WebParts.SocialHeader.InitSocialHeader', settings);
            console.log("UDPATED 1");

            var masterContent = $('#master-content');
            var navLinks = $('.nav-links-wrapper');
            var heightIncrease = 450;

            var adminMode = $('body').hasClass('EditMode');
            var scrollPosition = 0;
            var headerAnimating = false;

            var bNavOpen = false;

            //Selectors
            var header = $('#master-header');
            var headerCloseBtn = $('.square-close', header);
            var socialNavTriggerElem = $('.social-header-trigger');
            var searchHeaderTriggerElem = $('.global-search-btn');
            var searchRowElem = $('.header-search')
            var headerSearchInput = $('.search-box', searchRowElem);

            //Nav states
            var socialNavOpen = false;
            var searchNavOpen = false;

            // Favourite Cookie and Count
            var favouriteCookieModule = new $.FavouriteCookie();                        // Initialise FavouriteCookie plugin
            favouriteCookieModule.InitEvents();
            updateFavouriteCountDisplay(favouriteCookieModule.getFavouriteCount());     // Init display favourite count

            var w = window.innerWidth;

            function setNavHeightOpen() {
                var masterContent = $('#master-content');
                var navLinks = $('.nav-links-wrapper');
                //var minNavHeight = 491;
                var minNavHeight = $('.nav-links-wrapper-inner').height();
                //console.log("$('.nav-links-wrapper-inner').height()", $('.nav-links-wrapper-inner').height());

                var h = window.innerHeight;
                var newHeight;

                if (h > minNavHeight) {

                    newHeight = h;
                    masterContent.css('height', newHeight - 120);
                    navLinks.css('height', newHeight);

                } else {

                    newHeight = minNavHeight;
                    masterContent.css('height', newHeight - 120);
                    navLinks.css('height', newHeight);

                }
            }

            function setNavHeightClose() {
                var masterContent = $('#master-content');
                var navLinks = $('.nav-links-wrapper');
                var minNavHeight = 491;
                var h = window.innerHeight;

                masterContent.css('height', '');
                navLinks.css('height', '');
            }

            function openSocialHeader() {

                //Add class to header, to control positioning
                header.addClass('open');
                socialNavOpen = true;
                searchNavOpen = false;
                socialNavTriggerElem.addClass('active');
                searchHeaderTriggerElem.removeClass('active');

                headerCloseBtn.css('top', '0px');

                searchRowElem.animate({
                    opacity: '0'
                }, 250, function () {
                    searchRowElem.css('display', 'none');
                });

                header.animate({
                    top: '0'
                }, 250, function () {
                });
            };

            function closeSocialHeader(optionalX) {
                if (headerAnimating == true) {

                    return false;

                } else {

                    headerAnimating = true;

                    //Add class to header, to control positioning
                    header.removeClass('open');

                    searchNavOpen = false;
                    socialNavOpen = false;
                    socialNavTriggerElem.removeClass('active');
                    searchHeaderTriggerElem.removeClass('active');

                    var headerCloseX;

                    if (optionalX) {

                        headerCloseX = optionalX;


                    } else {

                        headerCloseX = '-80';
                    }

                    header.animate({
                        top: headerCloseX
                    }, 250, function () {
                        headerAnimating = false;

                        if (optionalX) {
                            header.css('position', 'fixed');
                        }
                    });
                }
            }

            function openSearchHeader() {
                //Add class to header, to control positioning
                header.addClass('open');

                searchNavOpen = true;
                socialNavOpen = false;
                searchHeaderTriggerElem.addClass('active');
                socialNavTriggerElem.removeClass('active');

                searchRowElem.css('display', 'block');
                searchRowElem.animate({
                    opacity: '1'
                }, 250, function () {
                });

                //Animate the header
                header.animate({
                    top: '0'
                }, 250, function () {
                    //headerCloseBtn.css('top', '196px');
                });


                headerSearchInput.focus();
            }

            function closeSearchHeader(optionalX) {
                if (headerAnimating == true) {

                    return false;

                } else {

                    headerAnimating = true;

                    //Add class to header, to control positioning
                    header.removeClass('open');

                    searchNavOpen = false;
                    socialNavOpen = false;
                    searchHeaderTriggerElem.removeClass('active');
                    socialNavTriggerElem.removeClass('active');

                    searchRowElem.animate({
                        opacity: '0'
                    }, 250, function () {
                        searchRowElem.css('display', 'none');
                    });

                    var headerCloseX;

                    if (optionalX) {

                        headerCloseX = optionalX;


                    } else {

                        headerCloseX = '-80';
                    }

                    header.animate({

                        top: headerCloseX

                    }, 250, function () {
                        //Add / remove class names
                        searchRowElem.css('display', 'none');
                        headerCloseBtn.css('top', '0px');
                        headerAnimating = false;

                        if (optionalX) {
                            header.css('position', 'fixed');
                        }
                    });
                }
            }

            function updateFavouriteCountDisplay(favCookieCount) {
                if (favCookieCount > 0) {
                    header.find('.my-favourites .count .value').text(favouriteCookieModule.getFavouriteCount());
                }
            }

            //Language Dropdown
            $('.language-select .dropdown-trigger').dropdown();

            //Increase content height on dropdown expand
            $('.language-select').on('show.bs.dropdown', function () {
                masterContent.css('height', '+=' + heightIncrease + '');
                navLinks.css('height', '+=' + heightIncrease + '');
            })

            $('.language-select').on('hide.bs.dropdown', function () {
                masterContent.css('height', '-=' + heightIncrease + '');
                navLinks.css('height', '-=' + heightIncrease + '');
            })

            // Refactored mobile nav
            $('.menu-btn').click(function () {

                var margin = 240;

                if (bNavOpen) {

                    bNavOpen = false;

                    $('#master-header').animate({

                        'left': "0"  //TODO  -- ADD CSS TRANSFORMS
                    }, 250);

                    $('#master-container').animate({

                        'margin-right': "0px"  //TODO  -- ADD CSS TRANSFORMS

                    }, 250, function () {
                        //Done
                        $('body').removeClass('nav-active');
                        $('.nav-links-wrapper').css('display', 'none');
                        $('.menu-btn .closed').css('display', 'block');
                        $('.menu-btn .open').css('display', 'none');

                        //Close nav
                        setNavHeightClose($);

                    });


                } else {  
                    
                    //Open Nav
                    $('.nav-links-wrapper').css('display', 'block');                    
                    $('.menu-btn .closed').css('display', 'none');
                    $('.menu-btn .open').css('display', 'block');
                    setNavHeightOpen($);
                    bNavOpen = true;

                    $('#master-header').animate({

                        'left': margin + "px"  //TODO  -- ADD CSS TRANSFORMS
                    }, 250);

                    $('#master-container').animate({

                        'margin-right': "-" + margin + "px"  //TODO  -- ADD CSS TRANSFORMS

                    }, 250, function () {
                        //Done
                        $('body').addClass('nav-active');
                    });
                }
            });

            //Bind close nav to site overlay
            $('.site-overlay').click(function () {
                //Close nav
                bNavOpen = false;
                marginLeft = '0px';


                $('#master-container').animate({

                    'margin-left': marginLeft  //TODO  -- ADD CSS TRANSFORMS

                }, 250, function () {
                    //Done
                    $('body').removeClass('nav-active');
                    $('.nav-links-wrapper').css('display', 'none');

                    //Close nav
                    setNavHeightClose($);

                });
            });

            $('body').on('Hamilton.Favourite.UpdateCount', function () {                // bound custom event to favourite count change
                updateFavouriteCountDisplay(favouriteCookieModule.getFavouriteCount());
            });

            //Close navs on scroll and fix header
            $(window).scroll(function () {

                if (adminMode == false) {

                    ///If scroll is 40, fix the header - 40 is height of the secondary nav (with social and search triggers)
                    scrollPosition = $(this).scrollTop();

                    //Only fix the header for tablet and up devices AND header is closee
                    if (w > 768 && !header.hasClass('open')) {

                        if (scrollPosition >= 40) {

                            //FIX THE HEADER
                            header.css('position', 'fixed');
                            header.css('top', '-80px');

                        } else {

                            //RESET THE HEADER
                            header.css('position', 'fixed');
                            header.css('top', '-80px');
                        }
                    }
                    else {
                        header.css('top', '0');

                        var mobileLogo = $('#mobileLogo');
                        var mobileBook = $('#mobileBook');

                        if (scrollPosition >= 100) {
                            mobileLogo.addClass("fade-out");
                            mobileBook.removeClass("fade-out");
                        }
                        else {
                            mobileBook.addClass("fade-out");
                            mobileLogo.removeClass("fade-out");
						}
					}

                    /*if (header.hasClass('open')) {

                        if (searchNavOpen == true) {
                            closeSearchHeader('0');
                        }

                        if (socialNavOpen == true) {
                            closeSocialHeader('-315');
                        }

                    }*/
                }
            });

            /******************************
            HEADER CLOSE BUTTON
            ******************************/
            $('.social-header-wrapper .square-close').click(function () {
                closeSocialHeader();
                closeSearchHeader();
                return false;
            });

            /******************************
            BIND SOCIAL HEADER CLICK EVENTS
            ******************************/
            socialNavTriggerElem.click(function () {

                if (socialNavOpen == false) {

                    openSocialHeader();

                } else if (socialNavOpen == true) {

                    closeSocialHeader();

                }

                return false;

            });

            /******************************
            BIND SEARCH HEADER CLICK EVENTS
            ******************************/
            searchHeaderTriggerElem.click(function () {
                console.log("SEARCH CLICK");
                if (searchNavOpen == false) {

                    openSearchHeader();

                } else if (searchNavOpen == true) {

                    closeSearchHeader();

                }

                return false;
            });
        }
    });

    $(document).ready(function () {
        $(document).HamiltonIsland().InitSocialHeader();
    });

}(jq111);
function initTempWidget($, parentElem) {
    try {
        console.log('init Temperature Widget');

        parentElem.each(function () {

            navRow = $('.nav-row', this);
            contentRow = $('.content-block', this);
            //console.log(contentRow);

            $('.slider-col', this).flexslider({
                selector: '.value-slider-wrap .val-col',
                animation: 'slide',
                animationSpeed: 800,
                slideshow: false,
                animationLoop: false,
                controlsContainer: navRow,
                itemWidth: 68,
                touch: true,
                directionNav: true,
                prevText: '',
                nextText: '',
                minItems: 4,
                maxItems: 6,
                move: 6,

                start: function (slider) {

                    //Fade in on start
                    slider.animate({
                        opacity: 1
                    }, 1000, function () {
                        // Animation complete.
                    });
                }
            });
        });

    } catch (err) {
        console.log('[ERROR]', err);
    }
};
function initTransportWidget($, parentElem) {
    try {
        console.log('init Transport Widget');
        var w = window.innerWidth;
        parentElem.each(function () {

            navRow = $('.nav-row', this);

            if(w <= 480){

                $('.transport-row', this).flexslider({
                    selector: '.transport-slider-wrap .transport-item',
                    animation: 'slide',
                    animationSpeed: 800,
                    slideshow: false,
                    animationLoop: false,
                    controlsContainer: navRow,
                    touch: true,
                    directionNav: false
                });
            }
        });

    } catch (err) {
        console.log('[ERROR]', err);
    }
};
"use strict";
let temporarySignUpbarHide = false;
(function() {

    const cookieCheckName = "signupdismissed";
    const hiddenClassName = "suppress";
    var doCheck = true;
    var previousScrollY = window.scrollY;

    const getOffsetTop = function(element) {
        if (!element) return 0;
        return getOffsetTop(element.offsetParent) + element.offsetTop;
    };

    function setCookie(cname, cvalue, exdays) {
        var expires = "";
        if (exdays !== "") {
            var d = new Date();
            d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
            expires = "expires=" + d.toUTCString();
        }

        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    function getCookie(cname) {
        var name = cname + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1);
            if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
        }
        return "";
    }

    function scrollEvent() {
		
		if (temporarySignUpbarHide && window.innerHeight < 992)
		{
            signUpBar.classList.add(hiddenClassName);
		}
		
        if (doCheck && !temporarySignUpbarHide)
        {
        let widget = document.getElementById("signUpWidget");

        var pastWidget = window.scrollY + window.innerHeight > getOffsetTop(widget);

        var menuHideDepth = 500;
        if (window.scrollY >= menuHideDepth) {

            if (pastWidget)
            {
                signUpBar.classList.add(hiddenClassName);
            }
            else {
                signUpBar.classList.remove(hiddenClassName);
            }
        }
        else {
            signUpBar.classList.add(hiddenClassName);
        }

        previousScrollY = window.scrollY;
        }
		else {
			temporarySignUpbarHide = false;
		}
    }

    let signUpBar = document.getElementById("signUpBar");
    if (signUpBar) {
        var closeButton = signUpBar.querySelector(".close");

		let cookie = getCookie(cookieCheckName);
		
		if (cookie !== "1")
		{
			window.addEventListener("scroll", scrollEvent);

			closeButton.addEventListener("click", (event) => {
				event.preventDefault();
				doCheck = false;
				window.removeEventListener("scroll", scrollEvent);
                signUpBar.classList.add(hiddenClassName);
				setCookie(cookieCheckName, "1");
			});
			
			scrollEvent();
		}
    }
})();
(function (window, $, ipLocationAPIUrl) {

	console.log('Web Chat: Self executing');

	window.PURECLOUD_WEBCHAT_FRAME_CONFIG = {
		containerEl: 'chatContainer'
	};
	var chatConfig = {
		"webchatAppUrl": "https://apps.mypurecloud.com.au/webchat",
		"webchatServiceUrl": "https://realtime.mypurecloud.com.au:443",
		"orgId": "10061",
		"orgName": "n2006102rhamiltonislandenterprisesltd",
		"queueName": $('#webChat').data("chat-queue"),
		//"agentEmail": "danny@sylasoft.com.au",
		"logLevel": "DEBUG",
		"locale": "en",
		"data": {
			"firstName": "",
			"lastName": "",
			"addressStreet": "",
			"addressCity": "",
			"addressPostalCode": "",
			"addressState": "",
			"phoneNumber": "",
			"customField1Label": "",
			"customField1": "",
			"customField2Label": "",
			"customField2": "",
			"customField3Label": "",
			"customField3": "",
			"email": ""
		},
		"companyLogo": {
			"width": 600,
			"height": 149,
			"url": "https://staging.hamiltonisland.com.au/static/img/webchat/logo-small.png"
		},
		"companyLogoSmall": {
			"width": 25,
			"height": 25,
			"url": "https://staging.hamiltonisland.com.au/static/img/webchat/logo-small.png"
		},
		"agentAvatar": {
			"width": 462,
			"height": 462,
			"url": "https://staging.hamiltonisland.com.au/static/img/webchat/logo-128x128.jpg"
		},
		"welcomeMessage": $('#webChat').data("welcome-message"),
		"cssClass": "webchat-frame",
		"css": {
			"width": "100%",
			"height": "100%"
		},
		"onlineSchedules": [{
			day: 'Monday-Friday',
			time: '1000-1700',
			city: 'Australia/Sydney'
		}]
	};

	function getFieldValue(fieldId) {
		if ($('#' + fieldId).length > 0) {
			return $.trim(document.getElementById(fieldId).value);
		}

		return "";
	}

	function isChatOpen(elementIdWithHash) {
		var isDisabled = $(elementIdWithHash).data('is-disabled') == "1";
		var disabledFrom = $(elementIdWithHash).data('disabled-from');
		var disabledTo = $(elementIdWithHash).data('disabled-to');

		var proceed = true;
		var nowSydneyTime = new Date();
		try {
			var nowSydneyTimeString = new Date().toLocaleString("en-US", { timeZone: "Australia/Sydney" });
			nowSydneyTime = new Date(nowSydneyTimeString);

			if (isDisabled) {
				if (disabledFrom === "" && disabledTo === "") {
					proceed = false;
				}
				else if (disabledFrom !== "" && disabledTo !== "") {
					var disabledFromDateTime = Date.parse(disabledFrom);
					var disabledToDateTime = Date.parse(disabledTo);

					if (nowSydneyTime >= disabledFromDateTime && nowSydneyTime <= disabledToDateTime)
						proceed = false;
				}
				else if (disabledFrom !== "") {
					var disabledFromDateTime = Date.parse(disabledFrom);

					if (nowSydneyTime >= disabledFromDateTime)
						proceed = false;
				}
				else if (disabledTo !== "") {
					var disabledToDateTime = Date.parse(disabledTo);

					if (nowSydneyTime <= disabledToDateTime)
						proceed = false;
				}
			}
		}
		catch (error) {
			proceed = false;
		}

		if (proceed) {
			var chatId = $(elementIdWithHash).data('web-chat');
			var openTime = $(elementIdWithHash).data('chat-opens');
			var closeTime = $(elementIdWithHash).data('chat-closes');

			var currentDate = nowSydneyTime.getFullYear() + '/' + (nowSydneyTime.getMonth() + 1) + '/' + nowSydneyTime.getDate();
			var openDateTime = Date.parse(currentDate + ' ' + openTime + ':00');
			var closeDateTime = Date.parse(currentDate + ' ' + closeTime + ':00');

			console.log('Chat opens: ' + new Date(openDateTime));
			console.log('Chat closes: ' + new Date(closeDateTime));

			return nowSydneyTime.getDay() != 0 && nowSydneyTime.getDay() != 6 && (nowSydneyTime >= openDateTime && nowSydneyTime <= closeDateTime); // && !(chatId != "5");
		}

		return false;
	}

	var initialiseChat = function (webchat) {
		if (isChatOpen('#webChat')) {
			var clientFirstName = getFieldValue('firstName');
			var clientEmail = getFieldValue('email');
			var clientLastName = getFieldValue('lastName');
			var clientAddressStreet = getFieldValue('addressStreet');
			var clientAddressCity = getFieldValue('addressCity');
			var clientAddressPostalCode = getFieldValue('addressPostalCode');
			var clientAddressState = getFieldValue('addressState');
			var clientPhoneNumber = getFieldValue('phoneNumber');
			var clientAgency = getFieldValue('agency');

			// Use getConfig.setConfigProperty() for any web chat configuration property to dynamically set config values.
			webchat.getConfig().setData({
				firstName: clientFirstName,
				lastName: clientLastName,
				addressStreet: clientAddressStreet,
				addressCity: clientAddressCity,
				addressPostalCode: clientAddressPostalCode,
				addressState: clientAddressState,
				phoneNumber: clientPhoneNumber,
				//phoneType: 'Cell',
				email: clientEmail,
				customField1Label: $('#webChat').data("custom-field-1-label"),
				customField1: $('#webChat').data("source"),
				customField2Label: $('#webChat').data("custom-field-2-label"),
				customField2: clientAgency,
			});

			var chatSource = getFieldValue('enquiryType');
			if (chatSource != "") {
				//Use the updateConfig function to update batches of properties by passing in a partially filled chatConfig object
				webchat.updateConfig({
					queueName: chatSource
				});
			}

			webchat.chatEnded = function () {
				console.log("Web Chat: Ending chat");
				//Code to run when chat ends.
				var action = $('#webChat').data("post-chat");
				if (action == "content") {
					$('#chatWrapper').hide();
					$('#postChatWrapper').show();
				}
				else if (action == "redirect")
					window.location = $('#webChat').data("post-chat-redirect-url");
				else {
					// show something generic if there is a setup error.
					console.log("Web Chat: Finish setup error: " + action);
				}
			};

			// show the section containing the chat window
			$('#chatWrapper').show();
			$('#chatContainer').css("height", $('#webChat').data("chat-window-height") + "px");

			return webchat.renderFrame({
				containerEl: 'chatContainer'
			}).catch(function (error) {
				console.error('Error starting chat');
				console.error(error);
			});
		}
		else {
			$('#chatUnavailable').show();
		}
	};

	function configureChat() {

		console.log('Web Chat: Configuring web chat');

		document.title = $('#webChat').data("chat-window-title");

		window.ININ.webchat.create(chatConfig).then(function (webchat) {

			console.log('Web Chat: Web chat config created');

			var privacyPolicyAction = $('#webChat').data("privacy-policy");
			var questionnaireAction = $('#webChat').data("pre-chat-questionnaire");

			console.log('Web Chat: Privacy = ' + privacyPolicyAction);
			console.log('Web Chat: Questionnaire = ' + questionnaireAction);

			if (questionnaireAction == "0") // start chat immediately
				initialiseChat(webchat);
			else {
				console.log('Web Chat: Configuring options');

				if (privacyPolicyAction == "1") {
					$('#privacyPolicyControl').show();
				}

				if (questionnaireAction == "1") {
					$('#btnSubmitQuestionnaire').click(function () {
						var fieldDataIsValid = true; //assume valid
						$('[data-is-required="true"]').each(function () {
							var fieldType = "text";
							if ($(this).is("select"))
								fieldType = "select";
							else if ($(this).is("input") && $(this).prop("type") == "checkbox")
								fieldType = "checkbox";
							var fieldValue = $.trim(document.getElementById($(this).attr("id")).value);
							if ((fieldType == "text" && fieldValue == "")
								|| (fieldType == "select" && fieldValue == "-1")
								|| (fieldType == "checkbox" && !$(this).is(":checked"))) {
								fieldDataIsValid = false;
							}
						});

						if (fieldDataIsValid) {
							$('#validationMessage,#preChatQuestionnaireWrapper').hide();

							initialiseChat(webchat);
						}
						else {
							$('#validationMessage').show();
						}
					});
				}

				if ($('#btnRestartChat').length > 0) {
					$('#btnRestartChat').click(function () {
						$('#postChatWrapper').hide();
						$('#chatContainer').empty();
						initialiseChat(webchat);
					});
				}
			}
		}).catch(function (error) {
			console.error('Error initializing chat');
			console.error(error);
		});
	}

	function checkChat() {
		var countryCode = getCookie("ipcountry");
		var recheckChat = false;
		console.log("CHAT COUNTRY: " + countryCode);
		if (countryCode === "AU" || countryCode === "NZ") {
			var now = new Date();
			var reactivated = new Date(2030, 1, 1);
			if (now >= reactivated) {
				if ($('#chatButton').length > 0) {
					var proceed = false;

					if (!proceed) {
						if ($('#chatButton').length > 0) {
							if (!(window.location.pathname.startsWith("/hotels-and-accommodation")
								|| window.location.pathname.startsWith("/accommodation")
								|| window.location.pathname.startsWith("/deals-and-packages")
								|| window.location.pathname.startsWith("/gift-vouchers")
								|| window.location.pathname.startsWith("/reef-view-hotel")
								|| window.location.pathname.startsWith("/palm-bungalows")
								|| window.location.pathname.startsWith("/beach-club-hotel")
								|| window.location.pathname.startsWith("/qualia-resort")
								|| window.location.pathname.startsWith("/holiday-homes")
								|| window.location.pathname.startsWith("/yacht-club-villas")
								|| window.location.pathname.startsWith("/babys-first-holiday")
								|| window.location.pathname.startsWith("/trade"))) {
								proceed = false;
							}
							else {
								proceed = true;
							}
						}
					}

					if (proceed) {

						var chatButtonId = '';
						if ($('#chatButton').length > 0) {
							if (chatButtonId.length > 0) chatButtonId += ',';
							chatButtonId += '#chatButton,#chatButtonMobile';
						}

						if (isChatOpen(chatButtonId)) {
							var buttonId = '';
							if ($('#chatButton').length > 0) {
								if (buttonId.length > 0) buttonId += ',';
								buttonId += '#chatButton,#chatButtonMobile';
							}

							$(buttonId).show();

							if ($('#chatToaster').length > 0) {
								if (window.location.pathname.startsWith("/hotels-and-accommodation")
									|| window.location.pathname.startsWith("/accommodation")
									|| window.location.pathname.startsWith("/deals-and-packages")
									|| window.location.pathname.startsWith("/gift-vouchers")
									|| window.location.pathname.startsWith("/reef-view-hotel")
									|| window.location.pathname.startsWith("/palm-bungalows")
									|| window.location.pathname.startsWith("/beach-club-hotel")
									|| window.location.pathname.startsWith("/qualia-resort")
									|| window.location.pathname.startsWith("/holiday-homes")
									|| window.location.pathname.startsWith("/yacht-club-villas")
									|| window.location.pathname.startsWith("/babys-first-holiday")
									|| window.location.pathname.startsWith("/trade")) {
									$('#chatToaster a').html("Chat to Reservations");
									$('#chatToaster').show();
								}
							}
							$('#chatButton,#chatButtonMobile,#chatToaster').click(function () {
								var windowWidth = $(buttonId).data('window-width');
								var windowHeight = $(buttonId).data('window-height');
								var chatUrl = $(buttonId).data('chat-url');
								var webChatId = $(buttonId).data('web-chat');
								if (chatUrl.indexOf('$') >= 0)
									chatUrl += "&";
								else
									chatUrl += "?";

								chatUrl += "source=" + window.location.href + "&webchat=" + webChatId;

								window.open(chatUrl
									, "Hamilton Island Chat",
									"status=no,location=no,toolbar=no,menubar=no,width=" + windowWidth + ",height=" + windowHeight + ",left=-" + windowWidth + ",top=-" + windowHeight + "");

								return false;
							});

						} else {
							$(chatButtonId).hide();
						}

						recheckChat = true;
					}
					else {
						$('#chatButton,#chatButtonMobile').hide();
					}
				}

				var chatButtonClass = '.res-chat';
				if ($(chatButtonClass).length > 0) {
					console.log('Chat: Button found');

					if (isChatOpen(chatButtonClass)) {
						console.log('Chat: chat is open, show the button');
						$(chatButtonClass).show();

						$('.res-chat .open-chat').click(function () {
							console.log('Chat: button clicked');

							var windowWidth = $(chatButtonClass).data('window-width');
							var windowHeight = $(chatButtonClass).data('window-height');
							var chatUrl = $(chatButtonClass).data('chat-url');
							var webChatId = $(chatButtonClass).data('web-chat');
							if (chatUrl.indexOf('$') >= 0)
								chatUrl += "&";
							else
								chatUrl += "?";

							chatUrl += "source=" + window.location.href + "&webchat=" + webChatId;

							window.open(chatUrl
								, "Hamilton Island Chat",
								"status=no,location=no,toolbar=no,menubar=no,width=" + windowWidth + ",height=" + windowHeight + ",left=-" + windowWidth + ",top=-" + windowHeight + "");

							return false;
						});

						recheckChat = true;

					} else {
						console.log('Chat: chat not active, hide chat button');
						$(chatButtonClass).hide();
					}
				}
			}
			else {
				$('.res-chat').hide();
			}

			if (now >= reactivated) {
				if (window.location.pathname.startsWith("/trade")) {

					if ($('.res-chat,#chatButton').length > 0) {
						var proceedTrade = false;
						if ($('.res-chat').length > 0) {
							proceedTrade = true;
						}

						if (!proceedTrade) {
							if ($('#chatButton').length > 0) {
								proceedTrade = true;
							}
						}

						if (proceedTrade) {

							var chatTradeButtonId = '';
							if ($('.res-chat').length > 0) {
								chatTradeButtonId = '.res-chat';
							}
							if ($('#chatButton').length > 0) {
								if (chatTradeButtonId.length > 0) chatTradeButtonId += ',';
								chatTradeButtonId += '#chatButton,#chatButtonMobile';
							}

							if (isChatOpen(chatTradeButtonId)) {
								var tradeButtonId = '';
								if ($('.res-chat').length > 0) {
									tradeButtonId = '.res-chat';
								}
								if ($('#chatButton').length > 0) {
									if (tradeButtonId.length > 0) tradeButtonId += ',';
									tradeButtonId += '#chatButton,#chatButtonMobile';
								}

								$(tradeButtonId).show();

								if ($('#chatToaster').length > 0) {
									if (window.location.pathname.startsWith("/trade")) {
										$('#chatToaster a').html("Chat to Reservations");
										$('#chatToaster').show();
									}
								}
								$('.res-chat .open-chat,#chatButton,#chatButtonMobile,#chatToaster').click(function () {
									var windowWidth = $(tradeButtonId).data('window-width');
									var windowHeight = $(tradeButtonId).data('window-height');
									var chatUrl = $(tradeButtonId).data('chat-url');
									var webChatId = $(tradeButtonId).data('web-chat');
									if (chatUrl.indexOf('$') >= 0)
										chatUrl += "&";
									else
										chatUrl += "?";

									chatUrl += "source=" + window.location.href + "&webchat=" + webChatId;

									window.open(chatUrl
										, "Hamilton Island Chat",
										"status=no,location=no,toolbar=no,menubar=no,width=" + windowWidth + ",height=" + windowHeight + ",left=-" + windowWidth + ",top=-" + windowHeight + "");

									return false;
								});
							} else {
								$(chatTradeButtonId).hide();
							}

							recheckChat = true;
						}
						else {
							$('#chatButton,#chatButtonMobile').hide();
						}
					}
				}
			}
			else {
				$('.res-chat').hide();
			}

			if (recheckChat) {
				setTimeout(checkChat, 60000);
			}
		}
		else {
			$(tradeButtonId).hide();
			$(buttonId).hide();

			if (countryCode !== "-" && countryCode !== "") {
				LoadInternationalChat();
			}
		}
	}

	function getCookie(cname) {
		var name = cname + "=";
		var decodedCookie = decodeURIComponent(document.cookie);
		var ca = decodedCookie.split(';');
		for (var i = 0; i < ca.length; i++) {
			var c = ca[i];
			while (c.charAt(0) == ' ') {
				c = c.substring(1);
			}
			if (c.indexOf(name) == 0) {
				return c.substring(name.length, c.length);
			}
		}
		return "";
	}

	function setCookie(cname, cvalue, exdays) {
		var expires = "";
		if (exdays > 0) {
			var d = new Date();
			d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
			expires = "expires=" + d.toUTCString() + ";";
		}
		document.cookie = cname + "=" + cvalue + ";" + expires + "path=/";
	}

	function ActivateChat() {
		checkChat();

		if ($('#webChat').length > 0) {
			var countryCode = getCookie("ipcountry");
			if ((countryCode == "AU") || (countryCode == "NZ")) {
				configureChat();
			}
		}
	}

	// International chat
	function initFreshChat() {
		window.fcWidget.init({
			token: "16654096-30b7-42c1-8a1b-8d2cba1ee6a8",
			host: "https://wchat.freshchat.com",
			siteId: "1070",
			"config": {
				"headerProperty": {
					"hideChatButton": true,
					appName: 'Hamilton Is Reservations',
					backgroundColor: '#1B365D',
					foregroundColor: '#7e8c8d',

				}
			}
		});
		window.fcWidget.on("widget:opened", function (resp) {
			console.log('Widget Opened');
			document.getElementById('custom_chat_button').style.visibility = "hidden"
		});
		window.fcWidget.on("widget:closed", function (resp) {
			console.log('Widget Closed');
			document.getElementById('custom_chat_button').style.visibility = "visible"
		});
	}
	function initialize(i, t) { var e; i.getElementById(t) ? initFreshChat() : ((e = i.createElement("script")).id = t, e.async = !0, e.src = "https://wchat.freshchat.com/js/widget.js", e.onload = initFreshChat, i.head.appendChild(e)) }
	function initiateCall() { initialize(document, "freshchat-js-sdk") }
	function LoadInternationalChat() {
		console.log("Loading international chat");

		$("#internationalChat").replaceWith('<div id="custom_chat_button" onClick="window.fcWidget.open();"></div>');

		window.addEventListener ? window.addEventListener("load", initiateCall, !1) : window.attachEvent("load", initiateCall, !1);
	}

	function LocationObtained(response) {
		setCookie("ipcountry", response.country, 0); //session based cookie
		ActivateChat();
	}

	$(document).ready(function () {

		var ipLocation = getCookie("ipcountry");

		if (!ipLocation || ipLocation.length === 0) {
			$.get(ipLocationAPIUrl, LocationObtained, "jsonp");
		}
		else {
			ActivateChat();
		}
	});

})(window, jq111, ipAddressLookupAPIUrl);
(function ($) {

    function debounce(func, wait, immediate) {
        var timeout;
        return function () {
            var context = this, args = arguments;
            var later = function () {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    };

    var mapLoaded = false;
    var mapFilterLoaded = false;

    $(function () {
        try {
            //FLowtype Init
            $('article').flowtype({
                minimum: 320,
                maximum: 480,
                minFont: 16,
                maxFont: 40,
                fontRatio: 30
            });

            $('.inventory-module').flowtype({
                minimum: 00,
                maximum: 480,
                minFont: 16,
                maxFont: 16,
                fontRatio: 18
            });

            /******************************
            INIT INDIVIDUAL MODULES
            ******************************/
            if ($('.reviews').length > 0) {
                initReviewModule($);
            }

            /******************************
            INIT TEMPERATURE WIDGET
            ******************************/
            if ($('.temperature-widget').length > 0) {
                initTempWidget($, $('.temperature-widget'));
            }

            /******************************
            INIT TRANSPORT WIDGET
            ******************************/
            if ($('.transport-widget').length > 0) {
                initTransportWidget($, $('.transport-widget'));
            }

            /******************************
            INIT MAP WIDGET
            ******************************/
            if ($('.map-widget').length > 0) {

               var mapMonitor = debounce(function () {

                    if ($('.map-widget').length > 0) {

                        console.log('CHECKING MAP');

                        var mapPosition = $('.map-widget').offset().top;
                        var currentPosition = $(document).scrollTop();
                        if (currentPosition >= (mapPosition - $(window).height() + ($('.map-widget').height() / 2)) && !mapLoaded) // add buffer so the map loads a little higher up when scrolling
                        {
                            mapLoaded = true;
                            console.log('LOADING MAP');

                            $('.map-widget').bind({
                                'sm': function () {
                                    initMapWidget($, $('.map-widget'), 'vertical', 13);
                                },
                                'md': function () {
                                    initMapWidget($, $('.map-widget'), 'horizontal', 13);
                                },
                                'lg': function () {
                                    initMapWidget($, $('.map-widget'), 'horizontal', 14);
                                },
                                'xlg': function () {
                                    initMapWidget($, $('.map-widget'), 'horizontal', 14);
                                }
                            });

                        }

                    }
                }, 250);

               window.addEventListener('scroll', mapMonitor);
               mapMonitor();
            }

            /******************************
            INIT MAP WIDGET
            ******************************/
            if ($('.map-widget-filter').length > 0) {
                var mapFilterMonitor = debounce(function () {

                    if ($('.map-widget-filter').length > 0) {

                        console.log('CHECKING MAP FILTER');

                        var mapPosition = $('.map-widget-filter').offset().top;
                        var currentPosition = $(document).scrollTop();
                        if (currentPosition >= (mapPosition - $(window).height() + ($('.map-widget-filter').height() / 2)) && !mapFilterLoaded) // add buffer so the map loads a little higher up when scrolling
                        {
                            mapFilterLoaded = true;
                            console.log('LOADING MAP FILTER');

                            initMapWidgetFilter($, $('.map-widget-filter'), 'horizontal', 14);

                            $('.map-widget.filter').bind({
                                'sm': function () {
                                    initMapWidgetFilter($, $('.map-widget-filter'), 'vertical', 13);
                                },
                                'md': function () {
                                    initMapWidgetFilter($, $('.map-widget-filter'), 'horizontal', 13);
                                },
                                'lg': function () {
                                    initMapWidgetFilter($, $('.map-widget-filter'), 'horizontal', 14);
                                },
                                'xlg': function () {
                                    initMapWidgetFilter($, $('.map-widget-filter'), 'horizontal', 14);
                                }
                            });
                        }

                    }
                }, 250);

                window.addEventListener('scroll', mapFilterMonitor);
                mapFilterMonitor();
            }

            /******************************
            INIT IMAGE GALLERY
            ******************************/
            if ($('.image-gallery').length > 0) {
                initImageGallery($, $('.image-gallery'));
            }

            /******************************
            INIT SITE SEARCH
            ******************************/
            if ($('.siteSearch').length > 0) {
                initSearchModule($, $('.siteSearch'));
            }

            /******************************
            INIT GENERIC SEARCH
            ******************************/
            if ($('.search-engine').length > 0) {
                initGenericSearchModule($, $('.search-engine'));
            }

            /******************************
            INIT LOCATION WIDGET
            ******************************/
            if ($('.location-widget').length > 0) {
                initLocationWidget($, $('.location-widget'));
            }

            /******************************
            INIT FLIGHT WIDGET
            ******************************/
            if ($('.flight-module').length > 0) {
                initFlightModule($, $('.flight-module'));
            }

            /******************************
            INIT MY FAVOURITE WIDGET
            ******************************/
            if ($('.my-favourites-widget').length > 0) {
                initMyFavouritesWidget($, $('.my-favourites-widget'));
            }

            /******************************
            INIT ISLAND STORIES
            ******************************/
            if ($('.island-stories').length > 0) {
                initIslandStories($, $('.island-stories'));
            }

            /******************************
            INIT GOLF COURSE
            ******************************/
            if ($('.golf-course').length > 0) {

                $('.golf-course').bind({
                    'sm': function () {
                        initGolfCourse($, $('.golf-course'), 'small');
                    },
                    'md': function () {
                        initGolfCourse($, $('.golf-course'), 'small');
                    },
                    'lg': function () {
                        initGolfCourse($, $('.golf-course'), 'large');
                    },
                    'xlg': function () {
                        initGolfCourse($, $('.golf-course'), 'large');
                    }
                });

            }

            /******************************
            RACE WEEK SPONSORS
            ******************************/
            if ($('.race-week-sponsors').length > 0) {
                initRaceWeekSponsors($, $('.race-week-sponsors'));
            }

            /******************************
            RACE WEEK FAQS
            ******************************/
            if ($('.race-week-faqs').length > 0) {
                initRaceWeekFAQ($, $('.race-week-faqs'));
            }

            /******************************
            COMMUNITY PROMOS
            ******************************/
            if ($('.community-promos').length > 0) {
                initCommunityPromos($, $('.community-promos'));
            }

            /******************************
            FLIGHT FRAME MODULE
            ******************************/
            if ($('.flight-frame').length > 0) {
                //initFlightFrameModule($, $('.flight-frame'));
            }

            /******************************
            PACKAGE THUMBNAIL LIST MODULE
            ******************************/
            if($('.package-thumbnail-list').length > 0) {
                initPackageListingWidget($, $('.package-thumbnail-list'));
            }

            /******************************
            GOLF CLUB TEE TIME MODULE
            ******************************/
            if ($('.golfclub-teetime-header').length > 0) {
                initGolfClubTeeTimeModule($, $('.golfclub-teetime-header'));
            }

            if ($('.golfclub-teetime-body').length > 0) {
                initGolfClubTeeTimeModule($, $('.golfclub-teetime-body'));
            }

            /******************************
            BIND IMAGE POPUPS TO PLUGIN
            ******************************/
            if ($('a.img-modal').length > 0) {
                $('a.img-modal').magnificPopup({
                  type: 'image'
                    // other options
                });

            }

            if ($('a.multiple-imgs-modal').length > 0) {
                var imgvalue = $('a.multiple-imgs-modal').attr("data-floorplans");
                var imgUrls = imgvalue.split(",");
                var items = [];
                $.each(imgUrls, function (i) {
                    var itemData = {};
                    itemData.src = imgUrls[i];                    
                    items.push(itemData);
                });
                $('a.multiple-imgs-modal').magnificPopup({
                    items: items,                    
                    gallery: {
                        enabled: true
                    },
                    type: 'image'
                    // other options
                });

            }
            
            /******************************
            BIND POPUPS FOR ROOMTYPE
            ******************************/
            if ($('.getRoomTypeDetails').length > 0) {
                $(".getRoomTypeDetails").on("click", function (e) {
                    
                    $.get("/api/RoomType/get?format=json", { id: $(this).data("id") }, function (data) {
                        $("#roomName").html(data.Details.RoomTypeName);
                        $("#roomCount").html(data.Features.NumberOfRooms);
                        $("#roomSize").html(data.Features.RoomSize);
                        $("#roomLocation").html(data.Features.Location);
                        $("#roomView").html(data.Features.View);
                        $("#roomDisabled").html(data.Features.DisableRooms);
                        $("#roomBedding").html(data.Features.Bedding);
                        $("#roomMaxGuests").html(data.Features.MaxGuestsNumeric);
                        if (data.Images.FloorPlans && data.Images.FloorPlans.length > 0) {
                            $("#roomFloorPlan").attr({ "src": data.Images.FloorPlans[0].Image });

                            // Show the floorplan tab
                            $('.tab .floorplan-tab').show();
                        }
                        else
                        {
                            // Hide the floorplan tab
                            $('.tab .floorplan-tab').hide();
                        }
                        var htmlFacilities = "";
                        $.each(data.Features.Facilities, function (index) {
                            htmlFacilities = htmlFacilities + "<div class='col-sm-12 col-md-6 col-lg-6 facility-item'>" + data.Features.Facilities[index] + "</div>";
                        });
                        $("#roomFacilities").html(htmlFacilities);
                        
                        openPopup();
                    });
                    e.preventDefault();
                });
            }
            if ($(".tablinks").length > 0) {
                $(".tablinks").on("click", function (e) {
                    $(".tabcontent").css("display", "none");
                    $(".tablinks").removeClass("active");
                    $(this).addClass("active");
                    $("#" + $(this).data('id')).css("display", "block");
                });
            }
            

            function openPopup() { // get the class name in arguments here
                
                $.magnificPopup
                    .open({
                        items: {
                            src: '#test-modal',
                        },
                        type: 'inline'
                    });
            }
            /******************************
            GOLF BOOKING REQUEST FORM
            ******************************/
            // NOTE: Due to booking widget hack, this module is now available on all pages
            //if ($('body.body-booking-request').length > 0) {
            //    initGolfBookingRequestForm($, $('body.body-booking-request'));
            //}
            initGolfBookingRequestForm($);

            /******************************
            INIT VIEWPORT SETTINGS
            ******************************/
            viewPortDetect();
            picturefill();

            /******************************
            RESPONSIVE TABLES
            ******************************/
            var switched = false;
            var updateTables = function () {
                if (($(window).width() < 767) && !switched) {
                    switched = true;
                    $("table.responsive").each(function (i, element) {
                        splitTable($(element));
                    });
                    return true;
                }
                else if (switched && ($(window).width() > 767)) {
                    switched = false;
                    $("table.responsive").each(function (i, element) {
                        unsplitTable($(element));
                    });
                }
            };

            $(window).load(updateTables);
            $(window).on("redraw", function () { switched = false; updateTables(); }); // An event to listen for
            $(window).on("resize", updateTables);

            function splitTable(original) {
                original.wrap("<div class='table-wrapper' />");

                var copy = original.clone();
                copy.find("td:not(:first-child), th:not(:first-child)").css("display", "none");
                copy.removeClass("responsive");

                original.closest(".table-wrapper").append(copy);
                copy.wrap("<div class='pinned' />");
                original.wrap("<div class='scrollable' />");

                setCellHeights(original, copy);
            }

            function unsplitTable(original) {
                original.closest(".table-wrapper").find(".pinned").remove();
                original.unwrap();
                original.unwrap();
            }

            function setCellHeights(original, copy) {
                var tr = original.find('tr'),
                    tr_copy = copy.find('tr'),
                    heights = [];

                tr.each(function (index) {
                    var self = $(this),
                        tx = self.find('th, td');

                    tx.each(function () {
                        var height = $(this).outerHeight(true);
                        heights[index] = heights[index] || 0;
                        if (height > heights[index]) heights[index] = height;
                    });

                });

                tr_copy.each(function (index) {
                    $(this).height(heights[index]);
                });
            }

        } catch (err) {
            console.log('[ERROR]', err);
        }

        /******************************
		BINDING HOMEPAGE TABS CORRECTLY SHOW TARGET TABS AND SCROLL FUNCTIONS
		******************************/
        function scrollHomepage() {
            var targetScrollElement = $('.content-zone');
            var targetPosition = targetScrollElement.position();
            var targetY = targetPosition.top;
            var offset = $('.primary-nav-wrapper').height() + $('.ajax__tab_header').height();
            var finalY = targetY - offset;

            $('html,body').stop().animate({
                scrollTop: finalY
            }, 250, function () {
                // Animation complete.
            });
        };

        $(document).ready(function () {
            if (document.location.pathname.indexOf("/plan", document.location.pathname.length - 5) !== -1 ||
                document.location.pathname.indexOf("/book", document.location.pathname.length - 5) !== -1 ||
                document.location.hash == "#explore")
                window.setTimeout(scrollHomepage, 500);
        });

        $('.ajax__tab_header > span').click(function () {

            scrollHomepage();

            //Tracking tab interaction
            var text = $(this).find('a').text();

            DSTAPI2.call('event', {
                category:'Tab interaction',
                action: 'Click tab',
                label: text
            });
        });


        /********************************************************
        /*            Global Tracking Selectors                 *
        /********************************************************/
        //For other tracking instances refer to the individual modules

        //Footer links Events
        $('.contact-links .btn').click(function(e){
            var btnAction = "";

            if($(this).hasClass("phone")){
                btnAction = "phone";
            }

            if($(this).hasClass("feedback")){
                btnAction = "feedback";
            }

            if($(this).hasClass("live-chat")){
                btnAction = "live-chat";
            }

            DSTAPI2.call('event', {
                category:'Contact',
                action: 'Button click',
                label: btnAction
            });
        });

        //Compare all accommodation
        $('.compare-all').click(function(e){
            DSTAPI2.call('event', {
                category:'Compare',
                action: 'Text link click',
                label: 'Compare accommodation'
            });
        });


        //Form errors event (ErrorLabel will only exist on load after an error submit)
        if($('.ErrorLabel').length > 0){
            DSTAPI2.call('event', {
                category:'Form Interaction',
                action: 'Click Submit',
                label: 'Submit Error'
            });
        }

        //Form success (InfoLabel will only exist on successful submit)
        if ($('.InfoLabel').length > 0 ||
            $('h1:contains(Thank You)').length > 0 ||
            document.location.href.indexOf('confirm') > 0 ||
            document.location.href.indexOf('completion') > 0 ||
            document.location.href.indexOf('thank') > 0) {
            DSTAPI2.call('event', {
                category:'Form Interaction',
                action: 'Click Submit',
                label: 'Success Submit'
            });
        }

        //Accommodation Listing Tracking
        $('.accommodation .availability-btn .btn').click(function(e){
            //Find Title...So durrrty
            var title = $(this).parent().parent().find(".title").text();
            DSTAPI2.call('event', {
                category:'Purchase Intent',
                action: 'Accommodation Tile',
                label: title
            });
        });

        //Careers - apply
        $('.careers-apply').click(function(e){
            DSTAPI2.call('event', {
                category:'Apply Online',
                action: 'Button Click',
                label: 'Careers Apply Online'
            });
        });



        /********************************************************
        /*                Anchor Target Override                *
        /********************************************************/
        // Case: http://jira.deepend.com.au/browse/HIS-99
        // Override all anchors in page, if they are 'external links'
        // or 'resource links' then place 'target=_blank' to it.
        function IsExternalLink(url) {
            // Arrange
            var currentHost = window.location.host;
            //console.log('currentHost', currentHost);

            // Act
            if (!url) { // Empty or undefined URL
                //console.log('!! undefined url', url);
                return false;
            }
            if (url.indexOf('//') == -1) { // Lack of protocol (ie/ relative URL)
                //console.log('!! Lack of protocol', url);
                return false;
            }
            if (currentHost && (url.indexOf(currentHost) > -1)) { // In current domain
                //console.log('!! In current domain', url);
                return false;
            }
            return true; // Pass all
        }

        function IsResourceLink(url) {
            if (!url) { // Empty or undefined URL
                return false;
            }
            // the file type extension are not necessary at the end of the file.
            var targetFileTypes = ['.pdf', '.doc', '.docx', '.docm', '.xps', '.rtf', '.odt', '.xlsx', '.xls', '.xlsm', '.xml', '.csv'];
            for (var i = 0; i < targetFileTypes.length; i++) {
                if (url.indexOf(targetFileTypes[i]) > -1) {
                    return true;
                }
            }
            return false;
        }

        $('a').each(function () {
            var url = $(this).attr('href');
            var isAlreadyTargetted = $(this).attr('target');
            //console.log('!! Anchor Found: ', url);
            //console.log('!! Is Feature Module: ', isFeatureModule);

            if (!isAlreadyTargetted) {
                if (IsExternalLink(url) || IsResourceLink(url)) {
                    //console.log('!! External Link Detected: ', url);
                    $(this).attr('target', '_blank');
                }
            }
        });

        /********************************************************
        /*                Mute No Link                          *
        /********************************************************/
        // When detecting an anchor with 'no-link' class
        // Verify its 'href' and deactivate its anchor event
        $('body').on('click', 'a.no-link', function () {
            //console.log('you clicked a no-link!');
            var hrefData = $(this).attr('href');
            if (hrefData.length == 0 || hrefData.charAt(0) == '#') {
                event.preventDefault();
            }
        });


        /********************************************************
        /*                Image Placeholders                    *
        /********************************************************/
        // In event where image become unavailable unexpectedly, use
        // place holder image to place the void for the reason
        // a) avoid breaking web styling that are dependent to image
        // dimension and b) clearly identify the missing image that
        // should be rectified immediately.
        /*
        $('img[src=""]').each(function() {
            //console.log('found img element without src', $(this));
            var placeholderData = $(this).data('placeholder');
            if(typeof placeholderData !== "undefined" && placeholderData != '') {
                var targetPlaceholderUrl = 'http://placehold.it/' + placeholderData + '.gif&text=.'; // Assume 'data-placeholder' always provide the correct value format. eg/ "300x200"
                $(this).attr('src', targetPlaceholderUrl);
            }
        });
        $('img').error(function() {
            //console.log('found img element with bad src', $(this));
            var placeholderData = $(this).data('placeholder');
            if(typeof placeholderData !== "undefined" && placeholderData != '') {
                var targetPlaceholderUrl = 'http://placehold.it/' + placeholderData + '.gif&text=.';
                $(this).unbind('error').attr('src', targetPlaceholderUrl);
            }
        });
        */

        /********************************************************
        /* Foregin Language font size overrides
        /********************************************************/
        /*
        Foreign Language body classes (for reference):
            Chinese - Trad: ZHTW
            Chinese - Simple: ZHCN
            French: FRFR
            German: DEDE
            Italian: ITIT
            Korean: KOKR
            Japanese: JAJP
            Spanish: ESES
        */
        //Japanese
        if($('body').hasClass('JAJP')){
            $('.inventory-module .title-row h3').flowtype({
                minimum: 00,
                maximum: 480,
                minFont: 10,
                maxFont: 24,
                fontRatio: 14
            });
        }

        var line = 3;

        //clump.js has bug for FF?
        if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1) {
            line = 4
        }
       
        $('.package-thumbnail-item .auto-truncate').each(function (index, el) {
            $clamp($(el).get(0), { clamp: line });
        });
       


        // this code disables the button before the submit is actually fired
        // commenting it out for now with a view to investigate it later

        //$('.FormButton').bind('click', function () { var self = $(this); window.setTimeout(function () { self.attr('disabled', 'disabled'); }, 250); });

    });

})(jq111);
var define = oldDefine;
oldDefine = null;
delete oldDefine;
var DSTAPI2     = DSTAPI2         || {};
DSTAPI2.Engine  = DSTAPI2.Engine  || {};

// because google requires this to be global.
var _gaq = _gaq || [];

// Define the engine.
DSTAPI2.Engine.Google = function( oEngineOptions ) {
	_gaq.push(['_setAccount', oEngineOptions.account]);
	return {
		page: function( oOptions ) {
			if( oOptions && oOptions.url ) {
				_gaq.push(['_trackPageview', oOptions.url ]);
			}
			else {
				// Google images keyword tracking fix.
				var ref = document.referrer;
				if (ref.search(/(images|www)\.google\.([^\/]+)\/(images|imghp|imgres|imglanding)/) != -1 && ref.search(/prev/) != -1) {
					var regex = new RegExp("google\.([^\/]+)/.*&prev=([^&]+)&");
					var match = regex.exec(ref);
					_gaq.push(['_addOrganic','images.google.'+match[1],'q',true]);
					_gaq.push(['_setReferrerOverride', 'http://images.google.'+match[1]+unescape(match[2])]);
				}
				_gaq.push(['_trackPageview']);
			}
		},
		event: function(oOptions) {
			if( typeof oOptions.category == 'undefined' ) {
				oOptions.category = null;
			}
			if( typeof oOptions.action == 'undefined' ) {
				oOptions.action = null;
			}
			if( typeof oOptions.label == 'undefined' ) {
				oOptions.label = null;
			}
			if( typeof oOptions.value == 'undefined' ) {
				oOptions.value = null;
			}
			else {
				if( typeof oOptions.value != 'number' ) {
					oOptions.value = 0;
				}
				else {
					oOptions.value = parseInt( oOptions.value , 10 );
				}
			}
			_gaq.push(['_trackEvent',oOptions.category,oOptions.action,oOptions.label,oOptions.value]);
		},
        /**
         * Transaction Call
         *
         * <code>
         *   DSTAPI2.call({
         *       orderid: '',
         *       affiliation: '',
         *       total: '',
         *       tax: '',
         *       shipping: '',
         *       city: '',
         *       state: '',
         *       country: '',
         *       items: [
         *        {
         *          sku: '',
         *          product_name: '',
         *          category: '',
         *          unit_price: '10.20',
         *          quanitity: '1'
         *        },
         *        {
         *          sku: '',
         *          product_name: '',
         *          category: '',
         *          unit_price: '10.20',
         *          quantity: '1'
         *        },
         *       ]
         *   });
         * </code>
         */
        transaction: function(oOptions) {
            // Push a transaction to google
            _gaq.push(['_addTrans',
                oOptions.orderid,
                oOptions.affiliation,
                oOptions.total,
                oOptions.tax,
                oOptions.shipping,
                oOptions.city,
                oOptions.state,
                oOptions.country
            ]);

            // Checks if the items in defined and if it is defined it loops through
            // and assigns the items to the order id in google analytics.
            if( typeof oOptions.items != 'undefined' ) {
                var iItemLength = oOptions.items.length;
                var item = {};
                for( var i = 0; i < iItemLength; i++ ) {
                    item = oOptions.items[i];
                    // Push an item to google
                    _gaq.push(['_addItem',
                        oOptions.orderid,
                        item.sku,
                        item.product_name,
                        item.category,
                        item.unit_price,
                        item.quantity
                    ]);
                }
            }
            _gaq.push(['_trackTrans']);
        }
	}
};

// Include the GA js injection
//(function() {
//	var ga = document.createElement('script'); ga.type = 'text/javascript'; ga.async = true;
//	ga.src = ('https:' == document.location.protocol ? 'https://ssl' : 'http://www') + '.google-analytics.com/ga.js';
//	var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(ga, s);
//})();
var DSTAPI2 = DSTAPI2 || {};
DSTAPI2.Engine = DSTAPI2.Engine || {};

DSTAPI2.Engine.SampleEngine = function( oEngineOptions ) {
	oEngineOptions = oEngineOptions || {};

	console.log( 'Engine Options', oEngineOptions );

	return {
		page: function(oOptions) {
			oOptions = oOptions || {};

			// Automatically detect the page path and send it through.
			if( !oOptions.url ) {
				oOptions.url = window.location.pathname.toString();
			}

			console.log( 'Sample Page Tracking: ' , oOptions );
		},
		event: function(oOptions) {
			oOptions = oOptions || {};

			console.log( 'Sample Event Tracking: ' , oOptions );
		}
	}
};
var DSTAPI2 = DSTAPI2 || {};
DSTAPI2.Engine = DSTAPI2.Engine || {};

(function (i, s, o, g, r, a, m) {
    i['GoogleAnalyticsObject'] = r; i[r] = i[r] || function () {
        (i[r].q = i[r].q || []).push(arguments)
    }, i[r].l = 1 * new Date(); a = s.createElement(o),
    m = s.getElementsByTagName(o)[0]; a.async = 1; a.src = g; m.parentNode.insertBefore(a, m)
})(window, document, 'script', '//www.google-analytics.com/analytics.js', 'ga');

// Define the engine.
DSTAPI2.Engine.UniversalAnalytics = function (oEngineOptions) {
    var activeTracker = '';

    var setClientId = function (oOptions) {
        if (typeof oOptions.clientId === 'undefined')
            throw { error: "Invalid Client Id", args: oOptions };

        oEngineOptions.clientId = oOptions.clientId;

        ga('create', oEngineOptions.account, {
            'clientId': oEngineOptions.clientId,
            'name': 'UserTracking'
        });

        activeTracker = 'UserTracking.';
    };

    var initialise = function (oOptions) {
        if (oOptions.initialiseOptions) {
            //init with options
            ga('create', oOptions.account, oOptions.initialiseOptions);
        } else {
            //base init
            ga('create', oOptions.account);
        }

        if (oOptions.autoLinkerDomains) {
            ga('require', 'linker');
            ga('linker:autoLink', oOptions.autoLinkerDomains, false, true);
        }

        if (typeof oOptions.remarketing !== 'undefined' && oOptions.remarketing) {
            ga('require', 'displayfeatures');
        }
    };

    initialise(oEngineOptions);

    return {
        setClientId: setClientId,
        page: function (oOptions) {
            if (oOptions && oOptions.url) {
                ga(activeTracker + 'send', 'pageview', oOptions.url);
            }
            //HitCallbacks for outbound links
            if (oOptions && oOptions.url && oOptions.hitCallback) {
                ga(activeTracker + 'send', 'pageview', {
                    'page': oOptions.url,
                    'hitCallback': oOptions.hitback
                });
            }
            else {
                ga(activeTracker + 'send', 'pageview');
            }
        },
        event: function (oOptions) {
            if (typeof oOptions.category == 'undefined') {
                oOptions.category = null;
            }
            if (typeof oOptions.action == 'undefined') {
                oOptions.action = null;
            }
            if (typeof oOptions.label == 'undefined') {
                oOptions.label = null;
            }
            if (typeof oOptions.value == 'undefined') {
                oOptions.value = null;
            }
            else {
                if (typeof oOptions.value != 'number') {
                    oOptions.value = 0;
                }
                else {
                    oOptions.value = parseInt(oOptions.value, 10);
                }
            }
            ga(activeTracker + 'send', 'event', oOptions.category, oOptions.action, oOptions.label, oOptions.value);
        },
        /**
         * Transaction Call
         *
         * <code>
         *   DSTAPI2.call({
         *       orderid: '',
         *       affiliation: '',
         *       total: '',
         *       tax: '',
         *       shipping: '',
         *       city: '',
         *       state: '',
         *       country: '',
         *       items: [
         *        {
         *          sku: '',
         *          product_name: '',
         *          category: '',
         *          unit_price: '10.20',
         *          quanitity: '1'
         *        },
         *        {
         *          sku: '',
         *          product_name: '',
         *          category: '',
         *          unit_price: '10.20',
         *          quantity: '1'
         *        },
         *       ]
         *   });
         * </code>
         */
        transaction: function (oOptions) {
            // Push a transaction to google
            ga('ecommerce:addTransaction', {
                'id': oOptions.orderid,
                'affiliation': oOptions.affiliation,
                'revenue': oOptions.total,
                'shipping': oOptions.shipping,
                'tax': oOptions.tax
            });

            // Checks if the items in defined and if it is defined it loops through
            // and assigns the items to the order id in google analytics.
            if (typeof oOptions.items != 'undefined') {
                var iItemLength = oOptions.items.length;
                var item = {};
                for (var i = 0; i < iItemLength; i++) {
                    item = oOptions.items[i];
                    // Push an item to google
                    ga(activeTracker + 'ecommerce:addItem', {
                        'id': oOptions.orderid,
                        'name': item.product_name,
                        'sku': item.sku,
                        'category': item.category,
                        'price': item.unit_price,
                        'quantity': item.quantity
                    });
                }
            }
            ga(activeTracker + 'send', 'ecommerce');
        }
    }
};
var DSTAPI2 = DSTAPI2 || {};
DSTAPI2.Plugin = DSTAPI2.Plugin || {};
/**
 * Tracker Plugin for click based events, this allows for addition of click events to
 * the dom in the form of attributes.
 *
 * All DOM nodes firing events should have a property "data-tracking-action"
 * which is the action of the action to be called in the engine.
 *
 * If the action required options to function correctly, they should be
 * defined with properties with the following format data-tracking-option-[optionName]
 */
DSTAPI2.Plugin.JSEvent = (function($){

	/**
	 * Makes the calls to the DSTAPI library based on the properties defined
	 * in the data attributes.
	 *
	 * @param e
	 */
	function callback( e ) {
		var oData = $(this).data();
		if( oData.dstapiAction ) {
			var oOptions = {}; var k; for( k in oData ) {
				if( k.indexOf('dstapiOption') == 0 ) {
					oOptions[k.replace('dstapiOption','' ).toLowerCase()] = oData[k];
				}
			}

			DSTAPI2.call( oData.dstapiAction , oOptions );
		}
	}

	return {
		/**
		 * Binds the events to the various DOM elements, it also sends
		 * the callback options to a private method called callback which
		 * will then parse the options and send them back to DSTAPI2 to
		 * track the events.
		 */
		init: function() {
			$('*[data-dstapi-event="click"]' ).on( 'click', callback );
			$('*[data-dstapi-event="mouseenter"]' ).on( 'mouseenter', callback );
			$('*[data-dstapi-event="mouseleave"]' ).on( 'mouseleave', callback );
			$('*[data-dstapi-event="focus"]' ).on( 'focus', callback );
			$('*[data-dstapi-event="blur"]' ).on( 'blur', callback );
		}
	};
})(jQuery);
var DSTAPI2 = DSTAPI2 || {};
DSTAPI2.Plugin = DSTAPI2.Plugin || {};
/**
 * Tracker Plugin for click based events, this allows for addition of click events to
 * the dom in the form of attributes.
 */
DSTAPI2.Plugin.Scroll = (function($){

	var aElements = [];

	function init( ) {
		bindElements();
		setEvent_OnScroll();
	}

	function bindElements() {
		$('*[data-dstapi-event="scroll"]' ).each(function(){
			var oData = $(this).data();
			var oOptions = {}; var k; for( k in oData ) {
				if( k.indexOf('dstapiOption') == 0 ) {
					oOptions[k.replace('dstapiOption','' ).toLowerCase()] = oData[k];
				}
			}
			aElements.push({
				elem: $(this),
				action: oData.dstapiAction,
				options: oOptions,
				tracked: false
			});
		});
	}

	function setEvent_OnScroll() {
		$(window).on('scroll',function(e){
			// Get the height from the bottom of the screen, this is to ensure
			// the event is captured when it displays on screen.
			var iTop = $(this).scrollTop() + $(window).height();

			// Cycle through the elements and call DSTAPI2.call when the
			// criteria is met.
			var k;
			for( k in aElements ) {
				var iElemTop = aElements[k].elem.position().top;
				if( iTop > iElemTop && !aElements[k].tracked ) {
					aElements[k].tracked = true;
					DSTAPI2.call( aElements[k].action , aElements[k].options );
				}
			}
		});
	}

	return {
		init: init
	};
})(jQuery);